import moment from "moment";
import { Patient, Reference } from "./allTypes";

export const pediatricsChartData: Record<string, {
  month: number;
  y: number;
  name: "mediane" | "-3sd" | "-2sd" | "-1sd" | "+1sd" | "+2sd" | "+3sd" ; 
}[]> = {
  girls_weight: [
    {
      month: 0,
      y: 2,
      name: "-3sd",
    },
    {
      month: 1,
      y: 2.7,
      name: "-3sd",
    },
    {
      month: 2,
      y: 3.4,
      name: "-3sd",
    },
    {
      month: 3,
      y: 4,
      name: "-3sd",
    },
    {
      month: 4,
      y: 4.4,
      name: "-3sd",
    },
    {
      month: 5,
      y: 4.8,
      name: "-3sd",
    },
    {
      month: 6,
      y: 5.1,
      name: "-3sd",
    },
    {
      month: 7,
      y: 5.3,
      name: "-3sd",
    },
    {
      month: 8,
      y: 5.6,
      name: "-3sd",
    },
    {
      month: 9,
      y: 5.8,
      name: "-3sd",
    },
    {
      month: 10,
      y: 5.9,
      name: "-3sd",
    },
    {
      month: 11,
      y: 6.1,
      name: "-3sd",
    },
    {
      month: 12,
      y: 6.3,
      name: "-3sd",
    },
    {
      month: 13,
      y: 6.4,
      name: "-3sd",
    },
    {
      month: 14,
      y: 6.6,
      name: "-3sd",
    },
    {
      month: 15,
      y: 6.7,
      name: "-3sd",
    },
    {
      month: 16,
      y: 6.9,
      name: "-3sd",
    },
    {
      month: 17,
      y: 7,
      name: "-3sd",
    },
    {
      month: 18,
      y: 7.2,
      name: "-3sd",
    },
    {
      month: 19,
      y: 7.3,
      name: "-3sd",
    },
    {
      month: 20,
      y: 7.5,
      name: "-3sd",
    },
    {
      month: 21,
      y: 7.6,
      name: "-3sd",
    },
    {
      month: 22,
      y: 7.8,
      name: "-3sd",
    },
    {
      month: 23,
      y: 7.9,
      name: "-3sd",
    },
    {
      month: 24,
      y: 8.1,
      name: "-3sd",
    },
    {
      month: 25,
      y: 8.2,
      name: "-3sd",
    },
    {
      month: 26,
      y: 8.4,
      name: "-3sd",
    },
    {
      month: 27,
      y: 8.5,
      name: "-3sd",
    },
    {
      month: 28,
      y: 8.6,
      name: "-3sd",
    },
    {
      month: 29,
      y: 8.8,
      name: "-3sd",
    },
    {
      month: 30,
      y: 8.9,
      name: "-3sd",
    },
    {
      month: 31,
      y: 9,
      name: "-3sd",
    },
    {
      month: 32,
      y: 9.1,
      name: "-3sd",
    },
    {
      month: 33,
      y: 9.3,
      name: "-3sd",
    },
    {
      month: 34,
      y: 9.4,
      name: "-3sd",
    },
    {
      month: 35,
      y: 9.5,
      name: "-3sd",
    },
    {
      month: 36,
      y: 9.6,
      name: "-3sd",
    },
    {
      month: 37,
      y: 9.7,
      name: "-3sd",
    },
    {
      month: 38,
      y: 9.8,
      name: "-3sd",
    },
    {
      month: 39,
      y: 9.9,
      name: "-3sd",
    },
    {
      month: 40,
      y: 10.1,
      name: "-3sd",
    },
    {
      month: 41,
      y: 10.2,
      name: "-3sd",
    },
    {
      month: 42,
      y: 10.3,
      name: "-3sd",
    },
    {
      month: 43,
      y: 10.4,
      name: "-3sd",
    },
    {
      month: 44,
      y: 10.5,
      name: "-3sd",
    },
    {
      month: 45,
      y: 10.6,
      name: "-3sd",
    },
    {
      month: 46,
      y: 10.7,
      name: "-3sd",
    },
    {
      month: 47,
      y: 10.8,
      name: "-3sd",
    },
    {
      month: 48,
      y: 10.9,
      name: "-3sd",
    },
    {
      month: 49,
      y: 11,
      name: "-3sd",
    },
    {
      month: 50,
      y: 11.1,
      name: "-3sd",
    },
    {
      month: 51,
      y: 11.2,
      name: "-3sd",
    },
    {
      month: 52,
      y: 11.3,
      name: "-3sd",
    },
    {
      month: 53,
      y: 11.4,
      name: "-3sd",
    },
    {
      month: 54,
      y: 11.5,
      name: "-3sd",
    },
    {
      month: 55,
      y: 11.6,
      name: "-3sd",
    },
    {
      month: 56,
      y: 11.7,
      name: "-3sd",
    },
    {
      month: 57,
      y: 11.8,
      name: "-3sd",
    },
    {
      month: 58,
      y: 11.9,
      name: "-3sd",
    },
    {
      month: 59,
      y: 12,
      name: "-3sd",
    },
    {
      month: 60,
      y: 12.1,
      name: "-3sd",
    },
    {
      month: 61,
      y: 12.352,
      name: "-3sd",
    },
    {
      month: 62,
      y: 12.456,
      name: "-3sd",
    },
    {
      month: 63,
      y: 12.559,
      name: "-3sd",
    },
    {
      month: 64,
      y: 12.662,
      name: "-3sd",
    },
    {
      month: 65,
      y: 12.764,
      name: "-3sd",
    },
    {
      month: 66,
      y: 12.866,
      name: "-3sd",
    },
    {
      month: 67,
      y: 12.968,
      name: "-3sd",
    },
    {
      month: 68,
      y: 13.069,
      name: "-3sd",
    },
    {
      month: 69,
      y: 13.169,
      name: "-3sd",
    },
    {
      month: 70,
      y: 13.27,
      name: "-3sd",
    },
    {
      month: 71,
      y: 13.371,
      name: "-3sd",
    },
    {
      month: 72,
      y: 13.471,
      name: "-3sd",
    },
    {
      month: 73,
      y: 13.572,
      name: "-3sd",
    },
    {
      month: 74,
      y: 13.673,
      name: "-3sd",
    },
    {
      month: 75,
      y: 13.775,
      name: "-3sd",
    },
    {
      month: 76,
      y: 13.878,
      name: "-3sd",
    },
    {
      month: 77,
      y: 13.982,
      name: "-3sd",
    },
    {
      month: 78,
      y: 14.087,
      name: "-3sd",
    },
    {
      month: 79,
      y: 14.193,
      name: "-3sd",
    },
    {
      month: 80,
      y: 14.301,
      name: "-3sd",
    },
    {
      month: 81,
      y: 14.411,
      name: "-3sd",
    },
    {
      month: 82,
      y: 14.522,
      name: "-3sd",
    },
    {
      month: 83,
      y: 14.635,
      name: "-3sd",
    },
    {
      month: 84,
      y: 14.75,
      name: "-3sd",
    },
    {
      month: 85,
      y: 14.867,
      name: "-3sd",
    },
    {
      month: 86,
      y: 14.987,
      name: "-3sd",
    },
    {
      month: 87,
      y: 15.108,
      name: "-3sd",
    },
    {
      month: 88,
      y: 15.231,
      name: "-3sd",
    },
    {
      month: 89,
      y: 15.356,
      name: "-3sd",
    },
    {
      month: 90,
      y: 15.483,
      name: "-3sd",
    },
    {
      month: 91,
      y: 15.612,
      name: "-3sd",
    },
    {
      month: 92,
      y: 15.744,
      name: "-3sd",
    },
    {
      month: 93,
      y: 15.877,
      name: "-3sd",
    },
    {
      month: 94,
      y: 16.013,
      name: "-3sd",
    },
    {
      month: 95,
      y: 16.151,
      name: "-3sd",
    },
    {
      month: 96,
      y: 16.291,
      name: "-3sd",
    },
    {
      month: 97,
      y: 16.434,
      name: "-3sd",
    },
    {
      month: 98,
      y: 16.579,
      name: "-3sd",
    },
    {
      month: 99,
      y: 16.726,
      name: "-3sd",
    },
    {
      month: 100,
      y: 16.875,
      name: "-3sd",
    },
    {
      month: 101,
      y: 17.027,
      name: "-3sd",
    },
    {
      month: 102,
      y: 17.181,
      name: "-3sd",
    },
    {
      month: 103,
      y: 17.337,
      name: "-3sd",
    },
    {
      month: 104,
      y: 17.495,
      name: "-3sd",
    },
    {
      month: 105,
      y: 17.655,
      name: "-3sd",
    },
    {
      month: 106,
      y: 17.817,
      name: "-3sd",
    },
    {
      month: 107,
      y: 17.98,
      name: "-3sd",
    },
    {
      month: 108,
      y: 18.146,
      name: "-3sd",
    },
    {
      month: 109,
      y: 18.313,
      name: "-3sd",
    },
    {
      month: 110,
      y: 18.482,
      name: "-3sd",
    },
    {
      month: 111,
      y: 18.653,
      name: "-3sd",
    },
    {
      month: 112,
      y: 18.825,
      name: "-3sd",
    },
    {
      month: 113,
      y: 19,
      name: "-3sd",
    },
    {
      month: 114,
      y: 19.176,
      name: "-3sd",
    },
    {
      month: 115,
      y: 19.355,
      name: "-3sd",
    },
    {
      month: 116,
      y: 19.536,
      name: "-3sd",
    },
    {
      month: 117,
      y: 19.72,
      name: "-3sd",
    },
    {
      month: 118,
      y: 19.906,
      name: "-3sd",
    },
    {
      month: 119,
      y: 20.095,
      name: "-3sd",
    },
    {
      month: 120,
      y: 20.286,
      name: "-3sd",
    },
    {
      month: 132,
      y: 23,
      name: "-3sd",
    },
    {
      month: 144,
      y: 27,
      name: "-3sd",
    },
    {
      month: 156,
      y: 32,
      name: "-3sd",
    },
    {
      month: 168,
      y: 36,
      name: "-3sd",
    },
    {
      month: 180,
      y: 39,
      name: "-3sd",
    },
    {
      month: 192,
      y: 41,
      name: "-3sd",
    },
    {
      month: 204,
      y: 42,
      name: "-3sd",
    },
    {
      month: 216,
      y: 43,
      name: "-3sd",
    },
    {
      month: 0,
      y: 2.4,
      name: "-2sd",
    },
    {
      month: 1,
      y: 3.2,
      name: "-2sd",
    },
    {
      month: 2,
      y: 3.9,
      name: "-2sd",
    },
    {
      month: 3,
      y: 4.5,
      name: "-2sd",
    },
    {
      month: 4,
      y: 5,
      name: "-2sd",
    },
    {
      month: 5,
      y: 5.4,
      name: "-2sd",
    },
    {
      month: 6,
      y: 5.7,
      name: "-2sd",
    },
    {
      month: 7,
      y: 6,
      name: "-2sd",
    },
    {
      month: 8,
      y: 6.3,
      name: "-2sd",
    },
    {
      month: 9,
      y: 6.5,
      name: "-2sd",
    },
    {
      month: 10,
      y: 6.7,
      name: "-2sd",
    },
    {
      month: 11,
      y: 6.9,
      name: "-2sd",
    },
    {
      month: 12,
      y: 7,
      name: "-2sd",
    },
    {
      month: 13,
      y: 7.2,
      name: "-2sd",
    },
    {
      month: 14,
      y: 7.4,
      name: "-2sd",
    },
    {
      month: 15,
      y: 7.6,
      name: "-2sd",
    },
    {
      month: 16,
      y: 7.7,
      name: "-2sd",
    },
    {
      month: 17,
      y: 7.9,
      name: "-2sd",
    },
    {
      month: 18,
      y: 8.1,
      name: "-2sd",
    },
    {
      month: 19,
      y: 8.2,
      name: "-2sd",
    },
    {
      month: 20,
      y: 8.4,
      name: "-2sd",
    },
    {
      month: 21,
      y: 8.6,
      name: "-2sd",
    },
    {
      month: 22,
      y: 8.7,
      name: "-2sd",
    },
    {
      month: 23,
      y: 8.9,
      name: "-2sd",
    },
    {
      month: 24,
      y: 9,
      name: "-2sd",
    },
    {
      month: 25,
      y: 9.2,
      name: "-2sd",
    },
    {
      month: 26,
      y: 9.4,
      name: "-2sd",
    },
    {
      month: 27,
      y: 9.5,
      name: "-2sd",
    },
    {
      month: 28,
      y: 9.7,
      name: "-2sd",
    },
    {
      month: 29,
      y: 9.8,
      name: "-2sd",
    },
    {
      month: 30,
      y: 10,
      name: "-2sd",
    },
    {
      month: 31,
      y: 10.1,
      name: "-2sd",
    },
    {
      month: 32,
      y: 10.3,
      name: "-2sd",
    },
    {
      month: 33,
      y: 10.4,
      name: "-2sd",
    },
    {
      month: 34,
      y: 10.5,
      name: "-2sd",
    },
    {
      month: 35,
      y: 10.7,
      name: "-2sd",
    },
    {
      month: 36,
      y: 10.8,
      name: "-2sd",
    },
    {
      month: 37,
      y: 10.9,
      name: "-2sd",
    },
    {
      month: 38,
      y: 11.1,
      name: "-2sd",
    },
    {
      month: 39,
      y: 11.2,
      name: "-2sd",
    },
    {
      month: 40,
      y: 11.3,
      name: "-2sd",
    },
    {
      month: 41,
      y: 11.5,
      name: "-2sd",
    },
    {
      month: 42,
      y: 11.6,
      name: "-2sd",
    },
    {
      month: 43,
      y: 11.7,
      name: "-2sd",
    },
    {
      month: 44,
      y: 11.8,
      name: "-2sd",
    },
    {
      month: 45,
      y: 12,
      name: "-2sd",
    },
    {
      month: 46,
      y: 12.1,
      name: "-2sd",
    },
    {
      month: 47,
      y: 12.2,
      name: "-2sd",
    },
    {
      month: 48,
      y: 12.3,
      name: "-2sd",
    },
    {
      month: 49,
      y: 12.4,
      name: "-2sd",
    },
    {
      month: 50,
      y: 12.6,
      name: "-2sd",
    },
    {
      month: 51,
      y: 12.7,
      name: "-2sd",
    },
    {
      month: 52,
      y: 12.8,
      name: "-2sd",
    },
    {
      month: 53,
      y: 12.9,
      name: "-2sd",
    },
    {
      month: 54,
      y: 13,
      name: "-2sd",
    },
    {
      month: 55,
      y: 13.2,
      name: "-2sd",
    },
    {
      month: 56,
      y: 13.3,
      name: "-2sd",
    },
    {
      month: 57,
      y: 13.4,
      name: "-2sd",
    },
    {
      month: 58,
      y: 13.5,
      name: "-2sd",
    },
    {
      month: 59,
      y: 13.6,
      name: "-2sd",
    },
    {
      month: 60,
      y: 13.7,
      name: "-2sd",
    },
    {
      month: 61,
      y: 13.961,
      name: "-2sd",
    },
    {
      month: 62,
      y: 14.083,
      name: "-2sd",
    },
    {
      month: 63,
      y: 14.204,
      name: "-2sd",
    },
    {
      month: 64,
      y: 14.324,
      name: "-2sd",
    },
    {
      month: 65,
      y: 14.444,
      name: "-2sd",
    },
    {
      month: 66,
      y: 14.564,
      name: "-2sd",
    },
    {
      month: 67,
      y: 14.683,
      name: "-2sd",
    },
    {
      month: 68,
      y: 14.801,
      name: "-2sd",
    },
    {
      month: 69,
      y: 14.919,
      name: "-2sd",
    },
    {
      month: 70,
      y: 15.038,
      name: "-2sd",
    },
    {
      month: 71,
      y: 15.156,
      name: "-2sd",
    },
    {
      month: 72,
      y: 15.274,
      name: "-2sd",
    },
    {
      month: 73,
      y: 15.393,
      name: "-2sd",
    },
    {
      month: 74,
      y: 15.512,
      name: "-2sd",
    },
    {
      month: 75,
      y: 15.632,
      name: "-2sd",
    },
    {
      month: 76,
      y: 15.753,
      name: "-2sd",
    },
    {
      month: 77,
      y: 15.875,
      name: "-2sd",
    },
    {
      month: 78,
      y: 15.998,
      name: "-2sd",
    },
    {
      month: 79,
      y: 16.124,
      name: "-2sd",
    },
    {
      month: 80,
      y: 16.25,
      name: "-2sd",
    },
    {
      month: 81,
      y: 16.379,
      name: "-2sd",
    },
    {
      month: 82,
      y: 16.51,
      name: "-2sd",
    },
    {
      month: 83,
      y: 16.643,
      name: "-2sd",
    },
    {
      month: 84,
      y: 16.779,
      name: "-2sd",
    },
    {
      month: 85,
      y: 16.916,
      name: "-2sd",
    },
    {
      month: 86,
      y: 17.056,
      name: "-2sd",
    },
    {
      month: 87,
      y: 17.199,
      name: "-2sd",
    },
    {
      month: 88,
      y: 17.343,
      name: "-2sd",
    },
    {
      month: 89,
      y: 17.49,
      name: "-2sd",
    },
    {
      month: 90,
      y: 17.639,
      name: "-2sd",
    },
    {
      month: 91,
      y: 17.791,
      name: "-2sd",
    },
    {
      month: 92,
      y: 17.946,
      name: "-2sd",
    },
    {
      month: 93,
      y: 18.102,
      name: "-2sd",
    },
    {
      month: 94,
      y: 18.262,
      name: "-2sd",
    },
    {
      month: 95,
      y: 18.424,
      name: "-2sd",
    },
    {
      month: 96,
      y: 18.588,
      name: "-2sd",
    },
    {
      month: 97,
      y: 18.756,
      name: "-2sd",
    },
    {
      month: 98,
      y: 18.926,
      name: "-2sd",
    },
    {
      month: 99,
      y: 19.098,
      name: "-2sd",
    },
    {
      month: 100,
      y: 19.274,
      name: "-2sd",
    },
    {
      month: 101,
      y: 19.452,
      name: "-2sd",
    },
    {
      month: 102,
      y: 19.632,
      name: "-2sd",
    },
    {
      month: 103,
      y: 19.815,
      name: "-2sd",
    },
    {
      month: 104,
      y: 20.001,
      name: "-2sd",
    },
    {
      month: 105,
      y: 20.188,
      name: "-2sd",
    },
    {
      month: 106,
      y: 20.378,
      name: "-2sd",
    },
    {
      month: 107,
      y: 20.57,
      name: "-2sd",
    },
    {
      month: 108,
      y: 20.764,
      name: "-2sd",
    },
    {
      month: 109,
      y: 20.96,
      name: "-2sd",
    },
    {
      month: 110,
      y: 21.158,
      name: "-2sd",
    },
    {
      month: 111,
      y: 21.359,
      name: "-2sd",
    },
    {
      month: 112,
      y: 21.561,
      name: "-2sd",
    },
    {
      month: 113,
      y: 21.766,
      name: "-2sd",
    },
    {
      month: 114,
      y: 21.973,
      name: "-2sd",
    },
    {
      month: 115,
      y: 22.183,
      name: "-2sd",
    },
    {
      month: 116,
      y: 22.395,
      name: "-2sd",
    },
    {
      month: 117,
      y: 22.61,
      name: "-2sd",
    },
    {
      month: 118,
      y: 22.828,
      name: "-2sd",
    },
    {
      month: 119,
      y: 23.049,
      name: "-2sd",
    },
    {
      month: 120,
      y: 23.274,
      name: "-2sd",
    },
    {
      month: 132,
      y: 26,
      name: "-2sd",
    },
    {
      month: 144,
      y: 31,
      name: "-2sd",
    },
    {
      month: 156,
      y: 36,
      name: "-2sd",
    },
    {
      month: 168,
      y: 40,
      name: "-2sd",
    },
    {
      month: 180,
      y: 43,
      name: "-2sd",
    },
    {
      month: 192,
      y: 45,
      name: "-2sd",
    },
    {
      month: 204,
      y: 46.5,
      name: "-2sd",
    },
    {
      month: 216,
      y: 47.5,
      name: "-2sd",
    },
    {
      month: 0,
      y: 2.8,
      name: "-1sd",
    },
    {
      month: 1,
      y: 3.6,
      name: "-1sd",
    },
    {
      month: 2,
      y: 4.5,
      name: "-1sd",
    },
    {
      month: 3,
      y: 5.2,
      name: "-1sd",
    },
    {
      month: 4,
      y: 5.7,
      name: "-1sd",
    },
    {
      month: 5,
      y: 6.1,
      name: "-1sd",
    },
    {
      month: 6,
      y: 6.5,
      name: "-1sd",
    },
    {
      month: 7,
      y: 6.8,
      name: "-1sd",
    },
    {
      month: 8,
      y: 7,
      name: "-1sd",
    },
    {
      month: 9,
      y: 7.3,
      name: "-1sd",
    },
    {
      month: 10,
      y: 7.5,
      name: "-1sd",
    },
    {
      month: 11,
      y: 7.7,
      name: "-1sd",
    },
    {
      month: 12,
      y: 7.9,
      name: "-1sd",
    },
    {
      month: 13,
      y: 8.1,
      name: "-1sd",
    },
    {
      month: 14,
      y: 8.3,
      name: "-1sd",
    },
    {
      month: 15,
      y: 8.5,
      name: "-1sd",
    },
    {
      month: 16,
      y: 8.7,
      name: "-1sd",
    },
    {
      month: 17,
      y: 8.9,
      name: "-1sd",
    },
    {
      month: 18,
      y: 9.1,
      name: "-1sd",
    },
    {
      month: 19,
      y: 9.2,
      name: "-1sd",
    },
    {
      month: 20,
      y: 9.4,
      name: "-1sd",
    },
    {
      month: 21,
      y: 9.6,
      name: "-1sd",
    },
    {
      month: 22,
      y: 9.8,
      name: "-1sd",
    },
    {
      month: 23,
      y: 10,
      name: "-1sd",
    },
    {
      month: 24,
      y: 10.2,
      name: "-1sd",
    },
    {
      month: 25,
      y: 10.3,
      name: "-1sd",
    },
    {
      month: 26,
      y: 10.5,
      name: "-1sd",
    },
    {
      month: 27,
      y: 10.7,
      name: "-1sd",
    },
    {
      month: 28,
      y: 10.9,
      name: "-1sd",
    },
    {
      month: 29,
      y: 11.1,
      name: "-1sd",
    },
    {
      month: 30,
      y: 11.2,
      name: "-1sd",
    },
    {
      month: 31,
      y: 11.4,
      name: "-1sd",
    },
    {
      month: 32,
      y: 11.6,
      name: "-1sd",
    },
    {
      month: 33,
      y: 11.7,
      name: "-1sd",
    },
    {
      month: 34,
      y: 11.9,
      name: "-1sd",
    },
    {
      month: 35,
      y: 12,
      name: "-1sd",
    },
    {
      month: 36,
      y: 12.2,
      name: "-1sd",
    },
    {
      month: 37,
      y: 12.4,
      name: "-1sd",
    },
    {
      month: 38,
      y: 12.5,
      name: "-1sd",
    },
    {
      month: 39,
      y: 12.7,
      name: "-1sd",
    },
    {
      month: 40,
      y: 12.8,
      name: "-1sd",
    },
    {
      month: 41,
      y: 13,
      name: "-1sd",
    },
    {
      month: 42,
      y: 13.1,
      name: "-1sd",
    },
    {
      month: 43,
      y: 13.3,
      name: "-1sd",
    },
    {
      month: 44,
      y: 13.4,
      name: "-1sd",
    },
    {
      month: 45,
      y: 13.6,
      name: "-1sd",
    },
    {
      month: 46,
      y: 13.7,
      name: "-1sd",
    },
    {
      month: 47,
      y: 13.9,
      name: "-1sd",
    },
    {
      month: 48,
      y: 14,
      name: "-1sd",
    },
    {
      month: 49,
      y: 14.2,
      name: "-1sd",
    },
    {
      month: 50,
      y: 14.3,
      name: "-1sd",
    },
    {
      month: 51,
      y: 14.5,
      name: "-1sd",
    },
    {
      month: 52,
      y: 14.6,
      name: "-1sd",
    },
    {
      month: 53,
      y: 14.8,
      name: "-1sd",
    },
    {
      month: 54,
      y: 14.9,
      name: "-1sd",
    },
    {
      month: 55,
      y: 15.1,
      name: "-1sd",
    },
    {
      month: 56,
      y: 15.2,
      name: "-1sd",
    },
    {
      month: 57,
      y: 15.3,
      name: "-1sd",
    },
    {
      month: 58,
      y: 15.5,
      name: "-1sd",
    },
    {
      month: 59,
      y: 15.6,
      name: "-1sd",
    },
    {
      month: 60,
      y: 15.8,
      name: "-1sd",
    },
    {
      month: 61,
      y: 15.899,
      name: "-1sd",
    },
    {
      month: 62,
      y: 16.043,
      name: "-1sd",
    },
    {
      month: 63,
      y: 16.187,
      name: "-1sd",
    },
    {
      month: 64,
      y: 16.33,
      name: "-1sd",
    },
    {
      month: 65,
      y: 16.473,
      name: "-1sd",
    },
    {
      month: 66,
      y: 16.616,
      name: "-1sd",
    },
    {
      month: 67,
      y: 16.758,
      name: "-1sd",
    },
    {
      month: 68,
      y: 16.899,
      name: "-1sd",
    },
    {
      month: 69,
      y: 17.041,
      name: "-1sd",
    },
    {
      month: 70,
      y: 17.182,
      name: "-1sd",
    },
    {
      month: 71,
      y: 17.323,
      name: "-1sd",
    },
    {
      month: 72,
      y: 17.465,
      name: "-1sd",
    },
    {
      month: 73,
      y: 17.607,
      name: "-1sd",
    },
    {
      month: 74,
      y: 17.75,
      name: "-1sd",
    },
    {
      month: 75,
      y: 17.893,
      name: "-1sd",
    },
    {
      month: 76,
      y: 18.038,
      name: "-1sd",
    },
    {
      month: 77,
      y: 18.185,
      name: "-1sd",
    },
    {
      month: 78,
      y: 18.333,
      name: "-1sd",
    },
    {
      month: 79,
      y: 18.483,
      name: "-1sd",
    },
    {
      month: 80,
      y: 18.635,
      name: "-1sd",
    },
    {
      month: 81,
      y: 18.79,
      name: "-1sd",
    },
    {
      month: 82,
      y: 18.947,
      name: "-1sd",
    },
    {
      month: 83,
      y: 19.106,
      name: "-1sd",
    },
    {
      month: 84,
      y: 19.268,
      name: "-1sd",
    },
    {
      month: 85,
      y: 19.433,
      name: "-1sd",
    },
    {
      month: 86,
      y: 19.601,
      name: "-1sd",
    },
    {
      month: 87,
      y: 19.772,
      name: "-1sd",
    },
    {
      month: 88,
      y: 19.945,
      name: "-1sd",
    },
    {
      month: 89,
      y: 20.121,
      name: "-1sd",
    },
    {
      month: 90,
      y: 20.299,
      name: "-1sd",
    },
    {
      month: 91,
      y: 20.481,
      name: "-1sd",
    },
    {
      month: 92,
      y: 20.666,
      name: "-1sd",
    },
    {
      month: 93,
      y: 20.853,
      name: "-1sd",
    },
    {
      month: 94,
      y: 21.044,
      name: "-1sd",
    },
    {
      month: 95,
      y: 21.238,
      name: "-1sd",
    },
    {
      month: 96,
      y: 21.435,
      name: "-1sd",
    },
    {
      month: 97,
      y: 21.635,
      name: "-1sd",
    },
    {
      month: 98,
      y: 21.838,
      name: "-1sd",
    },
    {
      month: 99,
      y: 22.045,
      name: "-1sd",
    },
    {
      month: 100,
      y: 22.254,
      name: "-1sd",
    },
    {
      month: 101,
      y: 22.467,
      name: "-1sd",
    },
    {
      month: 102,
      y: 22.683,
      name: "-1sd",
    },
    {
      month: 103,
      y: 22.901,
      name: "-1sd",
    },
    {
      month: 104,
      y: 23.123,
      name: "-1sd",
    },
    {
      month: 105,
      y: 23.347,
      name: "-1sd",
    },
    {
      month: 106,
      y: 23.574,
      name: "-1sd",
    },
    {
      month: 107,
      y: 23.803,
      name: "-1sd",
    },
    {
      month: 108,
      y: 24.035,
      name: "-1sd",
    },
    {
      month: 109,
      y: 24.27,
      name: "-1sd",
    },
    {
      month: 110,
      y: 24.506,
      name: "-1sd",
    },
    {
      month: 111,
      y: 24.745,
      name: "-1sd",
    },
    {
      month: 112,
      y: 24.987,
      name: "-1sd",
    },
    {
      month: 113,
      y: 25.232,
      name: "-1sd",
    },
    {
      month: 114,
      y: 25.479,
      name: "-1sd",
    },
    {
      month: 115,
      y: 25.729,
      name: "-1sd",
    },
    {
      month: 116,
      y: 25.982,
      name: "-1sd",
    },
    {
      month: 117,
      y: 26.239,
      name: "-1sd",
    },
    {
      month: 118,
      y: 26.499,
      name: "-1sd",
    },
    {
      month: 119,
      y: 26.763,
      name: "-1sd",
    },
    {
      month: 120,
      y: 27.031,
      name: "-1sd",
    },
    {
      month: 132,
      y: 32,
      name: "-1sd",
    },
    {
      month: 144,
      y: 37,
      name: "-1sd",
    },
    {
      month: 156,
      y: 42,
      name: "-1sd",
    },
    {
      month: 168,
      y: 46,
      name: "-1sd",
    },
    {
      month: 180,
      y: 49,
      name: "-1sd",
    },
    {
      month: 192,
      y: 51,
      name: "-1sd",
    },
    {
      month: 204,
      y: 52.5,
      name: "-1sd",
    },
    {
      month: 216,
      y: 53.6,
      name: "-1sd",
    },
    {
      month: 0,
      y: 3.2,
      name: "mediane",
    },
    {
      month: 1,
      y: 4.2,
      name: "mediane",
    },
    {
      month: 2,
      y: 5.1,
      name: "mediane",
    },
    {
      month: 3,
      y: 5.8,
      name: "mediane",
    },
    {
      month: 4,
      y: 6.4,
      name: "mediane",
    },
    {
      month: 5,
      y: 6.9,
      name: "mediane",
    },
    {
      month: 6,
      y: 7.3,
      name: "mediane",
    },
    {
      month: 7,
      y: 7.6,
      name: "mediane",
    },
    {
      month: 8,
      y: 7.9,
      name: "mediane",
    },
    {
      month: 9,
      y: 8.2,
      name: "mediane",
    },
    {
      month: 10,
      y: 8.5,
      name: "mediane",
    },
    {
      month: 11,
      y: 8.7,
      name: "mediane",
    },
    {
      month: 12,
      y: 8.9,
      name: "mediane",
    },
    {
      month: 13,
      y: 9.2,
      name: "mediane",
    },
    {
      month: 14,
      y: 9.4,
      name: "mediane",
    },
    {
      month: 15,
      y: 9.6,
      name: "mediane",
    },
    {
      month: 16,
      y: 9.8,
      name: "mediane",
    },
    {
      month: 17,
      y: 10,
      name: "mediane",
    },
    {
      month: 18,
      y: 10.2,
      name: "mediane",
    },
    {
      month: 19,
      y: 10.4,
      name: "mediane",
    },
    {
      month: 20,
      y: 10.6,
      name: "mediane",
    },
    {
      month: 21,
      y: 10.9,
      name: "mediane",
    },
    {
      month: 22,
      y: 11.1,
      name: "mediane",
    },
    {
      month: 23,
      y: 11.3,
      name: "mediane",
    },
    {
      month: 24,
      y: 11.5,
      name: "mediane",
    },
    {
      month: 25,
      y: 11.7,
      name: "mediane",
    },
    {
      month: 26,
      y: 11.9,
      name: "mediane",
    },
    {
      month: 27,
      y: 12.1,
      name: "mediane",
    },
    {
      month: 28,
      y: 12.3,
      name: "mediane",
    },
    {
      month: 29,
      y: 12.5,
      name: "mediane",
    },
    {
      month: 30,
      y: 12.7,
      name: "mediane",
    },
    {
      month: 31,
      y: 12.9,
      name: "mediane",
    },
    {
      month: 32,
      y: 13.1,
      name: "mediane",
    },
    {
      month: 33,
      y: 13.3,
      name: "mediane",
    },
    {
      month: 34,
      y: 13.5,
      name: "mediane",
    },
    {
      month: 35,
      y: 13.7,
      name: "mediane",
    },
    {
      month: 36,
      y: 13.9,
      name: "mediane",
    },
    {
      month: 37,
      y: 14,
      name: "mediane",
    },
    {
      month: 38,
      y: 14.2,
      name: "mediane",
    },
    {
      month: 39,
      y: 14.4,
      name: "mediane",
    },
    {
      month: 40,
      y: 14.6,
      name: "mediane",
    },
    {
      month: 41,
      y: 14.8,
      name: "mediane",
    },
    {
      month: 42,
      y: 15,
      name: "mediane",
    },
    {
      month: 43,
      y: 15.2,
      name: "mediane",
    },
    {
      month: 44,
      y: 15.3,
      name: "mediane",
    },
    {
      month: 45,
      y: 15.5,
      name: "mediane",
    },
    {
      month: 46,
      y: 15.7,
      name: "mediane",
    },
    {
      month: 47,
      y: 15.9,
      name: "mediane",
    },
    {
      month: 48,
      y: 16.1,
      name: "mediane",
    },
    {
      month: 49,
      y: 16.3,
      name: "mediane",
    },
    {
      month: 50,
      y: 16.4,
      name: "mediane",
    },
    {
      month: 51,
      y: 16.6,
      name: "mediane",
    },
    {
      month: 52,
      y: 16.8,
      name: "mediane",
    },
    {
      month: 53,
      y: 17,
      name: "mediane",
    },
    {
      month: 54,
      y: 17.2,
      name: "mediane",
    },
    {
      month: 55,
      y: 17.3,
      name: "mediane",
    },
    {
      month: 56,
      y: 17.5,
      name: "mediane",
    },
    {
      month: 57,
      y: 17.7,
      name: "mediane",
    },
    {
      month: 58,
      y: 17.9,
      name: "mediane",
    },
    {
      month: 59,
      y: 18,
      name: "mediane",
    },
    {
      month: 60,
      y: 18.2,
      name: "mediane",
    },
    {
      month: 61,
      y: 18.258,
      name: "mediane",
    },
    {
      month: 62,
      y: 18.433,
      name: "mediane",
    },
    {
      month: 63,
      y: 18.607,
      name: "mediane",
    },
    {
      month: 64,
      y: 18.781,
      name: "mediane",
    },
    {
      month: 65,
      y: 18.954,
      name: "mediane",
    },
    {
      month: 66,
      y: 19.128,
      name: "mediane",
    },
    {
      month: 67,
      y: 19.3,
      name: "mediane",
    },
    {
      month: 68,
      y: 19.473,
      name: "mediane",
    },
    {
      month: 69,
      y: 19.646,
      name: "mediane",
    },
    {
      month: 70,
      y: 19.818,
      name: "mediane",
    },
    {
      month: 71,
      y: 19.991,
      name: "mediane",
    },
    {
      month: 72,
      y: 20.164,
      name: "mediane",
    },
    {
      month: 73,
      y: 20.338,
      name: "mediane",
    },
    {
      month: 74,
      y: 20.512,
      name: "mediane",
    },
    {
      month: 75,
      y: 20.688,
      name: "mediane",
    },
    {
      month: 76,
      y: 20.866,
      name: "mediane",
    },
    {
      month: 77,
      y: 21.046,
      name: "mediane",
    },
    {
      month: 78,
      y: 21.227,
      name: "mediane",
    },
    {
      month: 79,
      y: 21.411,
      name: "mediane",
    },
    {
      month: 80,
      y: 21.598,
      name: "mediane",
    },
    {
      month: 81,
      y: 21.787,
      name: "mediane",
    },
    {
      month: 82,
      y: 21.98,
      name: "mediane",
    },
    {
      month: 83,
      y: 22.175,
      name: "mediane",
    },
    {
      month: 84,
      y: 22.374,
      name: "mediane",
    },
    {
      month: 85,
      y: 22.576,
      name: "mediane",
    },
    {
      month: 86,
      y: 22.782,
      name: "mediane",
    },
    {
      month: 87,
      y: 22.99,
      name: "mediane",
    },
    {
      month: 88,
      y: 23.202,
      name: "mediane",
    },
    {
      month: 89,
      y: 23.418,
      name: "mediane",
    },
    {
      month: 90,
      y: 23.637,
      name: "mediane",
    },
    {
      month: 91,
      y: 23.859,
      name: "mediane",
    },
    {
      month: 92,
      y: 24.085,
      name: "mediane",
    },
    {
      month: 93,
      y: 24.315,
      name: "mediane",
    },
    {
      month: 94,
      y: 24.548,
      name: "mediane",
    },
    {
      month: 95,
      y: 24.785,
      name: "mediane",
    },
    {
      month: 96,
      y: 25.026,
      name: "mediane",
    },
    {
      month: 97,
      y: 25.271,
      name: "mediane",
    },
    {
      month: 98,
      y: 25.52,
      name: "mediane",
    },
    {
      month: 99,
      y: 25.772,
      name: "mediane",
    },
    {
      month: 100,
      y: 26.028,
      name: "mediane",
    },
    {
      month: 101,
      y: 26.288,
      name: "mediane",
    },
    {
      month: 102,
      y: 26.552,
      name: "mediane",
    },
    {
      month: 103,
      y: 26.819,
      name: "mediane",
    },
    {
      month: 104,
      y: 27.09,
      name: "mediane",
    },
    {
      month: 105,
      y: 27.364,
      name: "mediane",
    },
    {
      month: 106,
      y: 27.641,
      name: "mediane",
    },
    {
      month: 107,
      y: 27.921,
      name: "mediane",
    },
    {
      month: 108,
      y: 28.204,
      name: "mediane",
    },
    {
      month: 109,
      y: 28.49,
      name: "mediane",
    },
    {
      month: 110,
      y: 28.779,
      name: "mediane",
    },
    {
      month: 111,
      y: 29.071,
      name: "mediane",
    },
    {
      month: 112,
      y: 29.366,
      name: "mediane",
    },
    {
      month: 113,
      y: 29.665,
      name: "mediane",
    },
    {
      month: 114,
      y: 29.966,
      name: "mediane",
    },
    {
      month: 115,
      y: 30.272,
      name: "mediane",
    },
    {
      month: 116,
      y: 30.58,
      name: "mediane",
    },
    {
      month: 117,
      y: 30.893,
      name: "mediane",
    },
    {
      month: 118,
      y: 31.21,
      name: "mediane",
    },
    {
      month: 119,
      y: 31.532,
      name: "mediane",
    },
    {
      month: 120,
      y: 31.858,
      name: "mediane",
    },
    {
      month: 132,
      y: 38,
      name: "mediane",
    },
    {
      month: 144,
      y: 43,
      name: "mediane",
    },
    {
      month: 156,
      y: 48,
      name: "mediane",
    },
    {
      month: 168,
      y: 52.6,
      name: "mediane",
    },
    {
      month: 180,
      y: 55,
      name: "mediane",
    },
    {
      month: 192,
      y: 57,
      name: "mediane",
    },
    {
      month: 204,
      y: 58.5,
      name: "mediane",
    },
    {
      month: 216,
      y: 59.5,
      name: "mediane",
    },
    {
      month: 0,
      y: 3.7,
      name: "+1sd",
    },
    {
      month: 1,
      y: 4.8,
      name: "+1sd",
    },
    {
      month: 2,
      y: 5.8,
      name: "+1sd",
    },
    {
      month: 3,
      y: 6.6,
      name: "+1sd",
    },
    {
      month: 4,
      y: 7.3,
      name: "+1sd",
    },
    {
      month: 5,
      y: 7.8,
      name: "+1sd",
    },
    {
      month: 6,
      y: 8.2,
      name: "+1sd",
    },
    {
      month: 7,
      y: 8.6,
      name: "+1sd",
    },
    {
      month: 8,
      y: 9,
      name: "+1sd",
    },
    {
      month: 9,
      y: 9.3,
      name: "+1sd",
    },
    {
      month: 10,
      y: 9.6,
      name: "+1sd",
    },
    {
      month: 11,
      y: 9.9,
      name: "+1sd",
    },
    {
      month: 12,
      y: 10.1,
      name: "+1sd",
    },
    {
      month: 13,
      y: 10.4,
      name: "+1sd",
    },
    {
      month: 14,
      y: 10.6,
      name: "+1sd",
    },
    {
      month: 15,
      y: 10.9,
      name: "+1sd",
    },
    {
      month: 16,
      y: 11.1,
      name: "+1sd",
    },
    {
      month: 17,
      y: 11.4,
      name: "+1sd",
    },
    {
      month: 18,
      y: 11.6,
      name: "+1sd",
    },
    {
      month: 19,
      y: 11.8,
      name: "+1sd",
    },
    {
      month: 20,
      y: 12.1,
      name: "+1sd",
    },
    {
      month: 21,
      y: 12.3,
      name: "+1sd",
    },
    {
      month: 22,
      y: 12.5,
      name: "+1sd",
    },
    {
      month: 23,
      y: 12.8,
      name: "+1sd",
    },
    {
      month: 24,
      y: 13,
      name: "+1sd",
    },
    {
      month: 25,
      y: 13.3,
      name: "+1sd",
    },
    {
      month: 26,
      y: 13.5,
      name: "+1sd",
    },
    {
      month: 27,
      y: 13.7,
      name: "+1sd",
    },
    {
      month: 28,
      y: 14,
      name: "+1sd",
    },
    {
      month: 29,
      y: 14.2,
      name: "+1sd",
    },
    {
      month: 30,
      y: 14.4,
      name: "+1sd",
    },
    {
      month: 31,
      y: 14.7,
      name: "+1sd",
    },
    {
      month: 32,
      y: 14.9,
      name: "+1sd",
    },
    {
      month: 33,
      y: 15.1,
      name: "+1sd",
    },
    {
      month: 34,
      y: 15.4,
      name: "+1sd",
    },
    {
      month: 35,
      y: 15.6,
      name: "+1sd",
    },
    {
      month: 36,
      y: 15.8,
      name: "+1sd",
    },
    {
      month: 37,
      y: 16,
      name: "+1sd",
    },
    {
      month: 38,
      y: 16.3,
      name: "+1sd",
    },
    {
      month: 39,
      y: 16.5,
      name: "+1sd",
    },
    {
      month: 40,
      y: 16.7,
      name: "+1sd",
    },
    {
      month: 41,
      y: 16.9,
      name: "+1sd",
    },
    {
      month: 42,
      y: 17.2,
      name: "+1sd",
    },
    {
      month: 43,
      y: 17.4,
      name: "+1sd",
    },
    {
      month: 44,
      y: 17.6,
      name: "+1sd",
    },
    {
      month: 45,
      y: 17.8,
      name: "+1sd",
    },
    {
      month: 46,
      y: 18.1,
      name: "+1sd",
    },
    {
      month: 47,
      y: 18.3,
      name: "+1sd",
    },
    {
      month: 48,
      y: 18.5,
      name: "+1sd",
    },
    {
      month: 49,
      y: 18.8,
      name: "+1sd",
    },
    {
      month: 50,
      y: 19,
      name: "+1sd",
    },
    {
      month: 51,
      y: 19.2,
      name: "+1sd",
    },
    {
      month: 52,
      y: 19.4,
      name: "+1sd",
    },
    {
      month: 53,
      y: 19.7,
      name: "+1sd",
    },
    {
      month: 54,
      y: 19.9,
      name: "+1sd",
    },
    {
      month: 55,
      y: 20.1,
      name: "+1sd",
    },
    {
      month: 56,
      y: 20.3,
      name: "+1sd",
    },
    {
      month: 57,
      y: 20.6,
      name: "+1sd",
    },
    {
      month: 58,
      y: 20.8,
      name: "+1sd",
    },
    {
      month: 59,
      y: 21,
      name: "+1sd",
    },
    {
      month: 60,
      y: 21.2,
      name: "+1sd",
    },
    {
      month: 61,
      y: 21.169,
      name: "+1sd",
    },
    {
      month: 62,
      y: 21.386,
      name: "+1sd",
    },
    {
      month: 63,
      y: 21.601,
      name: "+1sd",
    },
    {
      month: 64,
      y: 21.817,
      name: "+1sd",
    },
    {
      month: 65,
      y: 22.032,
      name: "+1sd",
    },
    {
      month: 66,
      y: 22.247,
      name: "+1sd",
    },
    {
      month: 67,
      y: 22.462,
      name: "+1sd",
    },
    {
      month: 68,
      y: 22.677,
      name: "+1sd",
    },
    {
      month: 69,
      y: 22.893,
      name: "+1sd",
    },
    {
      month: 70,
      y: 23.108,
      name: "+1sd",
    },
    {
      month: 71,
      y: 23.324,
      name: "+1sd",
    },
    {
      month: 72,
      y: 23.541,
      name: "+1sd",
    },
    {
      month: 73,
      y: 23.759,
      name: "+1sd",
    },
    {
      month: 74,
      y: 23.978,
      name: "+1sd",
    },
    {
      month: 75,
      y: 24.199,
      name: "+1sd",
    },
    {
      month: 76,
      y: 24.423,
      name: "+1sd",
    },
    {
      month: 77,
      y: 24.648,
      name: "+1sd",
    },
    {
      month: 78,
      y: 24.877,
      name: "+1sd",
    },
    {
      month: 79,
      y: 25.108,
      name: "+1sd",
    },
    {
      month: 80,
      y: 25.343,
      name: "+1sd",
    },
    {
      month: 81,
      y: 25.581,
      name: "+1sd",
    },
    {
      month: 82,
      y: 25.823,
      name: "+1sd",
    },
    {
      month: 83,
      y: 26.069,
      name: "+1sd",
    },
    {
      month: 84,
      y: 26.32,
      name: "+1sd",
    },
    {
      month: 85,
      y: 26.574,
      name: "+1sd",
    },
    {
      month: 86,
      y: 26.832,
      name: "+1sd",
    },
    {
      month: 87,
      y: 27.095,
      name: "+1sd",
    },
    {
      month: 88,
      y: 27.362,
      name: "+1sd",
    },
    {
      month: 89,
      y: 27.633,
      name: "+1sd",
    },
    {
      month: 90,
      y: 27.908,
      name: "+1sd",
    },
    {
      month: 91,
      y: 28.188,
      name: "+1sd",
    },
    {
      month: 92,
      y: 28.472,
      name: "+1sd",
    },
    {
      month: 93,
      y: 28.761,
      name: "+1sd",
    },
    {
      month: 94,
      y: 29.054,
      name: "+1sd",
    },
    {
      month: 95,
      y: 29.352,
      name: "+1sd",
    },
    {
      month: 96,
      y: 29.655,
      name: "+1sd",
    },
    {
      month: 97,
      y: 29.963,
      name: "+1sd",
    },
    {
      month: 98,
      y: 30.275,
      name: "+1sd",
    },
    {
      month: 99,
      y: 30.593,
      name: "+1sd",
    },
    {
      month: 100,
      y: 30.914,
      name: "+1sd",
    },
    {
      month: 101,
      y: 31.241,
      name: "+1sd",
    },
    {
      month: 102,
      y: 31.572,
      name: "+1sd",
    },
    {
      month: 103,
      y: 31.907,
      name: "+1sd",
    },
    {
      month: 104,
      y: 32.247,
      name: "+1sd",
    },
    {
      month: 105,
      y: 32.591,
      name: "+1sd",
    },
    {
      month: 106,
      y: 32.939,
      name: "+1sd",
    },
    {
      month: 107,
      y: 33.29,
      name: "+1sd",
    },
    {
      month: 108,
      y: 33.645,
      name: "+1sd",
    },
    {
      month: 109,
      y: 34.004,
      name: "+1sd",
    },
    {
      month: 110,
      y: 34.367,
      name: "+1sd",
    },
    {
      month: 111,
      y: 34.733,
      name: "+1sd",
    },
    {
      month: 112,
      y: 35.104,
      name: "+1sd",
    },
    {
      month: 113,
      y: 35.478,
      name: "+1sd",
    },
    {
      month: 114,
      y: 35.856,
      name: "+1sd",
    },
    {
      month: 115,
      y: 36.238,
      name: "+1sd",
    },
    {
      month: 116,
      y: 36.625,
      name: "+1sd",
    },
    {
      month: 117,
      y: 37.017,
      name: "+1sd",
    },
    {
      month: 118,
      y: 37.414,
      name: "+1sd",
    },
    {
      month: 119,
      y: 37.815,
      name: "+1sd",
    },
    {
      month: 120,
      y: 38.223,
      name: "+1sd",
    },
    {
      month: 132,
      y: 44,
      name: "+1sd",
    },
    {
      month: 144,
      y: 49,
      name: "+1sd",
    },
    {
      month: 156,
      y: 54,
      name: "+1sd",
    },
    {
      month: 168,
      y: 58,
      name: "+1sd",
    },
    {
      month: 180,
      y: 61,
      name: "+1sd",
    },
    {
      month: 192,
      y: 63,
      name: "+1sd",
    },
    {
      month: 204,
      y: 64.5,
      name: "+1sd",
    },
    {
      month: 216,
      y: 65.6,
      name: "+1sd",
    },
    {
      month: 0,
      y: 4.2,
      name: "+2sd",
    },
    {
      month: 1,
      y: 5.5,
      name: "+2sd",
    },
    {
      month: 2,
      y: 6.6,
      name: "+2sd",
    },
    {
      month: 3,
      y: 7.5,
      name: "+2sd",
    },
    {
      month: 4,
      y: 8.2,
      name: "+2sd",
    },
    {
      month: 5,
      y: 8.8,
      name: "+2sd",
    },
    {
      month: 6,
      y: 9.3,
      name: "+2sd",
    },
    {
      month: 7,
      y: 9.8,
      name: "+2sd",
    },
    {
      month: 8,
      y: 10.2,
      name: "+2sd",
    },
    {
      month: 9,
      y: 10.5,
      name: "+2sd",
    },
    {
      month: 10,
      y: 10.9,
      name: "+2sd",
    },
    {
      month: 11,
      y: 11.2,
      name: "+2sd",
    },
    {
      month: 12,
      y: 11.5,
      name: "+2sd",
    },
    {
      month: 13,
      y: 11.8,
      name: "+2sd",
    },
    {
      month: 14,
      y: 12.1,
      name: "+2sd",
    },
    {
      month: 15,
      y: 12.4,
      name: "+2sd",
    },
    {
      month: 16,
      y: 12.6,
      name: "+2sd",
    },
    {
      month: 17,
      y: 12.9,
      name: "+2sd",
    },
    {
      month: 18,
      y: 13.2,
      name: "+2sd",
    },
    {
      month: 19,
      y: 13.5,
      name: "+2sd",
    },
    {
      month: 20,
      y: 13.7,
      name: "+2sd",
    },
    {
      month: 21,
      y: 14,
      name: "+2sd",
    },
    {
      month: 22,
      y: 14.3,
      name: "+2sd",
    },
    {
      month: 23,
      y: 14.6,
      name: "+2sd",
    },
    {
      month: 24,
      y: 14.8,
      name: "+2sd",
    },
    {
      month: 25,
      y: 15.1,
      name: "+2sd",
    },
    {
      month: 26,
      y: 15.4,
      name: "+2sd",
    },
    {
      month: 27,
      y: 15.7,
      name: "+2sd",
    },
    {
      month: 28,
      y: 16,
      name: "+2sd",
    },
    {
      month: 29,
      y: 16.2,
      name: "+2sd",
    },
    {
      month: 30,
      y: 16.5,
      name: "+2sd",
    },
    {
      month: 31,
      y: 16.8,
      name: "+2sd",
    },
    {
      month: 32,
      y: 17.1,
      name: "+2sd",
    },
    {
      month: 33,
      y: 17.3,
      name: "+2sd",
    },
    {
      month: 34,
      y: 17.6,
      name: "+2sd",
    },
    {
      month: 35,
      y: 17.9,
      name: "+2sd",
    },
    {
      month: 36,
      y: 18.1,
      name: "+2sd",
    },
    {
      month: 37,
      y: 18.4,
      name: "+2sd",
    },
    {
      month: 38,
      y: 18.7,
      name: "+2sd",
    },
    {
      month: 39,
      y: 19,
      name: "+2sd",
    },
    {
      month: 40,
      y: 19.2,
      name: "+2sd",
    },
    {
      month: 41,
      y: 19.5,
      name: "+2sd",
    },
    {
      month: 42,
      y: 19.8,
      name: "+2sd",
    },
    {
      month: 43,
      y: 20.1,
      name: "+2sd",
    },
    {
      month: 44,
      y: 20.4,
      name: "+2sd",
    },
    {
      month: 45,
      y: 20.7,
      name: "+2sd",
    },
    {
      month: 46,
      y: 20.9,
      name: "+2sd",
    },
    {
      month: 47,
      y: 21.2,
      name: "+2sd",
    },
    {
      month: 48,
      y: 21.5,
      name: "+2sd",
    },
    {
      month: 49,
      y: 21.8,
      name: "+2sd",
    },
    {
      month: 50,
      y: 22.1,
      name: "+2sd",
    },
    {
      month: 51,
      y: 22.4,
      name: "+2sd",
    },
    {
      month: 52,
      y: 22.6,
      name: "+2sd",
    },
    {
      month: 53,
      y: 22.9,
      name: "+2sd",
    },
    {
      month: 54,
      y: 23.2,
      name: "+2sd",
    },
    {
      month: 55,
      y: 23.5,
      name: "+2sd",
    },
    {
      month: 56,
      y: 23.8,
      name: "+2sd",
    },
    {
      month: 57,
      y: 24.1,
      name: "+2sd",
    },
    {
      month: 58,
      y: 24.4,
      name: "+2sd",
    },
    {
      month: 59,
      y: 24.6,
      name: "+2sd",
    },
    {
      month: 60,
      y: 24.9,
      name: "+2sd",
    },
    {
      month: 61,
      y: 24.817,
      name: "+2sd",
    },
    {
      month: 62,
      y: 25.09,
      name: "+2sd",
    },
    {
      month: 63,
      y: 25.363,
      name: "+2sd",
    },
    {
      month: 64,
      y: 25.637,
      name: "+2sd",
    },
    {
      month: 65,
      y: 25.911,
      name: "+2sd",
    },
    {
      month: 66,
      y: 26.185,
      name: "+2sd",
    },
    {
      month: 67,
      y: 26.46,
      name: "+2sd",
    },
    {
      month: 68,
      y: 26.735,
      name: "+2sd",
    },
    {
      month: 69,
      y: 27.011,
      name: "+2sd",
    },
    {
      month: 70,
      y: 27.288,
      name: "+2sd",
    },
    {
      month: 71,
      y: 27.566,
      name: "+2sd",
    },
    {
      month: 72,
      y: 27.845,
      name: "+2sd",
    },
    {
      month: 73,
      y: 28.126,
      name: "+2sd",
    },
    {
      month: 74,
      y: 28.409,
      name: "+2sd",
    },
    {
      month: 75,
      y: 28.695,
      name: "+2sd",
    },
    {
      month: 76,
      y: 28.983,
      name: "+2sd",
    },
    {
      month: 77,
      y: 29.276,
      name: "+2sd",
    },
    {
      month: 78,
      y: 29.572,
      name: "+2sd",
    },
    {
      month: 79,
      y: 29.871,
      name: "+2sd",
    },
    {
      month: 80,
      y: 30.176,
      name: "+2sd",
    },
    {
      month: 81,
      y: 30.485,
      name: "+2sd",
    },
    {
      month: 82,
      y: 30.799,
      name: "+2sd",
    },
    {
      month: 83,
      y: 31.118,
      name: "+2sd",
    },
    {
      month: 84,
      y: 31.443,
      name: "+2sd",
    },
    {
      month: 85,
      y: 31.773,
      name: "+2sd",
    },
    {
      month: 86,
      y: 32.109,
      name: "+2sd",
    },
    {
      month: 87,
      y: 32.45,
      name: "+2sd",
    },
    {
      month: 88,
      y: 32.796,
      name: "+2sd",
    },
    {
      month: 89,
      y: 33.149,
      name: "+2sd",
    },
    {
      month: 90,
      y: 33.507,
      name: "+2sd",
    },
    {
      month: 91,
      y: 33.87,
      name: "+2sd",
    },
    {
      month: 92,
      y: 34.239,
      name: "+2sd",
    },
    {
      month: 93,
      y: 34.614,
      name: "+2sd",
    },
    {
      month: 94,
      y: 34.996,
      name: "+2sd",
    },
    {
      month: 95,
      y: 35.383,
      name: "+2sd",
    },
    {
      month: 96,
      y: 35.776,
      name: "+2sd",
    },
    {
      month: 97,
      y: 36.176,
      name: "+2sd",
    },
    {
      month: 98,
      y: 36.582,
      name: "+2sd",
    },
    {
      month: 99,
      y: 36.994,
      name: "+2sd",
    },
    {
      month: 100,
      y: 37.412,
      name: "+2sd",
    },
    {
      month: 101,
      y: 37.836,
      name: "+2sd",
    },
    {
      month: 102,
      y: 38.265,
      name: "+2sd",
    },
    {
      month: 103,
      y: 38.702,
      name: "+2sd",
    },
    {
      month: 104,
      y: 39.142,
      name: "+2sd",
    },
    {
      month: 105,
      y: 39.589,
      name: "+2sd",
    },
    {
      month: 106,
      y: 40.041,
      name: "+2sd",
    },
    {
      month: 107,
      y: 40.497,
      name: "+2sd",
    },
    {
      month: 108,
      y: 40.958,
      name: "+2sd",
    },
    {
      month: 109,
      y: 41.424,
      name: "+2sd",
    },
    {
      month: 110,
      y: 41.895,
      name: "+2sd",
    },
    {
      month: 111,
      y: 42.37,
      name: "+2sd",
    },
    {
      month: 112,
      y: 42.851,
      name: "+2sd",
    },
    {
      month: 113,
      y: 43.335,
      name: "+2sd",
    },
    {
      month: 114,
      y: 43.826,
      name: "+2sd",
    },
    {
      month: 115,
      y: 44.321,
      name: "+2sd",
    },
    {
      month: 116,
      y: 44.823,
      name: "+2sd",
    },
    {
      month: 117,
      y: 45.329,
      name: "+2sd",
    },
    {
      month: 118,
      y: 45.843,
      name: "+2sd",
    },
    {
      month: 119,
      y: 46.363,
      name: "+2sd",
    },
    {
      month: 120,
      y: 46.89,
      name: "+2sd",
    },
    {
      month: 132,
      y: 52,
      name: "+2sd",
    },
    {
      month: 144,
      y: 57.5,
      name: "+2sd",
    },
    {
      month: 156,
      y: 61,
      name: "+2sd",
    },
    {
      month: 168,
      y: 64.6,
      name: "+2sd",
    },
    {
      month: 180,
      y: 67,
      name: "+2sd",
    },
    {
      month: 192,
      y: 69,
      name: "+2sd",
    },
    {
      month: 204,
      y: 70.5,
      name: "+2sd",
    },
    {
      month: 216,
      y: 71.6,
      name: "+2sd",
    },
    {
      month: 0,
      y: 4.8,
      name: "+3sd",
    },
    {
      month: 1,
      y: 6.2,
      name: "+3sd",
    },
    {
      month: 2,
      y: 7.5,
      name: "+3sd",
    },
    {
      month: 3,
      y: 8.5,
      name: "+3sd",
    },
    {
      month: 4,
      y: 9.3,
      name: "+3sd",
    },
    {
      month: 5,
      y: 10,
      name: "+3sd",
    },
    {
      month: 6,
      y: 10.6,
      name: "+3sd",
    },
    {
      month: 7,
      y: 11.1,
      name: "+3sd",
    },
    {
      month: 8,
      y: 11.6,
      name: "+3sd",
    },
    {
      month: 9,
      y: 12,
      name: "+3sd",
    },
    {
      month: 10,
      y: 12.4,
      name: "+3sd",
    },
    {
      month: 11,
      y: 12.8,
      name: "+3sd",
    },
    {
      month: 12,
      y: 13.1,
      name: "+3sd",
    },
    {
      month: 13,
      y: 13.5,
      name: "+3sd",
    },
    {
      month: 14,
      y: 13.8,
      name: "+3sd",
    },
    {
      month: 15,
      y: 14.1,
      name: "+3sd",
    },
    {
      month: 16,
      y: 14.5,
      name: "+3sd",
    },
    {
      month: 17,
      y: 14.8,
      name: "+3sd",
    },
    {
      month: 18,
      y: 15.1,
      name: "+3sd",
    },
    {
      month: 19,
      y: 15.4,
      name: "+3sd",
    },
    {
      month: 20,
      y: 15.7,
      name: "+3sd",
    },
    {
      month: 21,
      y: 16,
      name: "+3sd",
    },
    {
      month: 22,
      y: 16.4,
      name: "+3sd",
    },
    {
      month: 23,
      y: 16.7,
      name: "+3sd",
    },
    {
      month: 24,
      y: 17,
      name: "+3sd",
    },
    {
      month: 25,
      y: 17.3,
      name: "+3sd",
    },
    {
      month: 26,
      y: 17.7,
      name: "+3sd",
    },
    {
      month: 27,
      y: 18,
      name: "+3sd",
    },
    {
      month: 28,
      y: 18.3,
      name: "+3sd",
    },
    {
      month: 29,
      y: 18.7,
      name: "+3sd",
    },
    {
      month: 30,
      y: 19,
      name: "+3sd",
    },
    {
      month: 31,
      y: 19.3,
      name: "+3sd",
    },
    {
      month: 32,
      y: 19.6,
      name: "+3sd",
    },
    {
      month: 33,
      y: 20,
      name: "+3sd",
    },
    {
      month: 34,
      y: 20.3,
      name: "+3sd",
    },
    {
      month: 35,
      y: 20.6,
      name: "+3sd",
    },
    {
      month: 36,
      y: 20.9,
      name: "+3sd",
    },
    {
      month: 37,
      y: 21.3,
      name: "+3sd",
    },
    {
      month: 38,
      y: 21.6,
      name: "+3sd",
    },
    {
      month: 39,
      y: 22,
      name: "+3sd",
    },
    {
      month: 40,
      y: 22.3,
      name: "+3sd",
    },
    {
      month: 41,
      y: 22.7,
      name: "+3sd",
    },
    {
      month: 42,
      y: 23,
      name: "+3sd",
    },
    {
      month: 43,
      y: 23.4,
      name: "+3sd",
    },
    {
      month: 44,
      y: 23.7,
      name: "+3sd",
    },
    {
      month: 45,
      y: 24.1,
      name: "+3sd",
    },
    {
      month: 46,
      y: 24.5,
      name: "+3sd",
    },
    {
      month: 47,
      y: 24.8,
      name: "+3sd",
    },
    {
      month: 48,
      y: 25.2,
      name: "+3sd",
    },
    {
      month: 49,
      y: 25.5,
      name: "+3sd",
    },
    {
      month: 50,
      y: 25.9,
      name: "+3sd",
    },
    {
      month: 51,
      y: 26.3,
      name: "+3sd",
    },
    {
      month: 52,
      y: 26.6,
      name: "+3sd",
    },
    {
      month: 53,
      y: 27,
      name: "+3sd",
    },
    {
      month: 54,
      y: 27.4,
      name: "+3sd",
    },
    {
      month: 55,
      y: 27.7,
      name: "+3sd",
    },
    {
      month: 56,
      y: 28.1,
      name: "+3sd",
    },
    {
      month: 57,
      y: 28.5,
      name: "+3sd",
    },
    {
      month: 58,
      y: 28.8,
      name: "+3sd",
    },
    {
      month: 59,
      y: 29.2,
      name: "+3sd",
    },
    {
      month: 60,
      y: 29.5,
      name: "+3sd",
    },
    {
      month: 61,
      y: 29.468,
      name: "+3sd",
    },
    {
      month: 62,
      y: 29.823,
      name: "+3sd",
    },
    {
      month: 63,
      y: 30.178,
      name: "+3sd",
    },
    {
      month: 64,
      y: 30.535,
      name: "+3sd",
    },
    {
      month: 65,
      y: 30.893,
      name: "+3sd",
    },
    {
      month: 66,
      y: 31.253,
      name: "+3sd",
    },
    {
      month: 67,
      y: 31.614,
      name: "+3sd",
    },
    {
      month: 68,
      y: 31.977,
      name: "+3sd",
    },
    {
      month: 69,
      y: 32.342,
      name: "+3sd",
    },
    {
      month: 70,
      y: 32.708,
      name: "+3sd",
    },
    {
      month: 71,
      y: 33.077,
      name: "+3sd",
    },
    {
      month: 71.8,
      y: 33.448,
      name: "+3sd",
    },
    {
      month: 73,
      y: 33.822,
      name: "+3sd",
    },
    {
      month: 74,
      y: 34.2,
      name: "+3sd",
    },
    {
      month: 75,
      y: 34.581,
      name: "+3sd",
    },
    {
      month: 76,
      y: 34.968,
      name: "+3sd",
    },
    {
      month: 77,
      y: 35.36,
      name: "+3sd",
    },
    {
      month: 78,
      y: 35.757,
      name: "+3sd",
    },
    {
      month: 79,
      y: 36.158,
      name: "+3sd",
    },
    {
      month: 80,
      y: 36.568,
      name: "+3sd",
    },
    {
      month: 81,
      y: 36.983,
      name: "+3sd",
    },
    {
      month: 82,
      y: 37.406,
      name: "+3sd",
    },
    {
      month: 83,
      y: 37.836,
      name: "+3sd",
    },
    {
      month: 84,
      y: 38.274,
      name: "+3sd",
    },
    {
      month: 85,
      y: 38.719,
      name: "+3sd",
    },
    {
      month: 86,
      y: 39.171,
      name: "+3sd",
    },
    {
      month: 87,
      y: 39.632,
      name: "+3sd",
    },
    {
      month: 88,
      y: 40.099,
      name: "+3sd",
    },
    {
      month: 89,
      y: 40.574,
      name: "+3sd",
    },
    {
      month: 90,
      y: 41.058,
      name: "+3sd",
    },
    {
      month: 91,
      y: 41.549,
      name: "+3sd",
    },
    {
      month: 92,
      y: 42.048,
      name: "+3sd",
    },
    {
      month: 93,
      y: 42.555,
      name: "+3sd",
    },
    {
      month: 94,
      y: 43.072,
      name: "+3sd",
    },
    {
      month: 95,
      y: 43.596,
      name: "+3sd",
    },
    {
      month: 96,
      y: 44.128,
      name: "+3sd",
    },
    {
      month: 97,
      y: 44.67,
      name: "+3sd",
    },
    {
      month: 98,
      y: 45.22,
      name: "+3sd",
    },
    {
      month: 99,
      y: 45.778,
      name: "+3sd",
    },
    {
      month: 100,
      y: 46.343,
      name: "+3sd",
    },
    {
      month: 101,
      y: 46.918,
      name: "+3sd",
    },
    {
      month: 102,
      y: 47.499,
      name: "+3sd",
    },
    {
      month: 103,
      y: 48.092,
      name: "+3sd",
    },
    {
      month: 104,
      y: 48.688,
      name: "+3sd",
    },
    {
      month: 105,
      y: 49.293,
      name: "+3sd",
    },
    {
      month: 106,
      y: 49.906,
      name: "+3sd",
    },
    {
      month: 107,
      y: 50.525,
      name: "+3sd",
    },
    {
      month: 108,
      y: 51.149,
      name: "+3sd",
    },
    {
      month: 109,
      y: 51.781,
      name: "+3sd",
    },
    {
      month: 110,
      y: 52.419,
      name: "+3sd",
    },
    {
      month: 111,
      y: 53.063,
      name: "+3sd",
    },
    {
      month: 112,
      y: 53.714,
      name: "+3sd",
    },
    {
      month: 113,
      y: 54.371,
      name: "+3sd",
    },
    {
      month: 114,
      y: 55,
      name: "+3sd",
    },
    {
      month: 115,
      y: 55.5,
      name: "+3sd",
    },
    {
      month: 116,
      y: 56,
      name: "+3sd",
    },
    {
      month: 117,
      y: 56.5,
      name: "+3sd",
    },
    {
      month: 118,
      y: 57,
      name: "+3sd",
    },
    {
      month: 120,
      y: 57.8,
      name: "+3sd",
    },
    {
      month: 132,
      y: 63,
      name: "+3sd",
    },
    {
      month: 180,
      y: 76,
      name: "+3sd",
    },
    {
      month: 204,
      y: 79.6,
      name: "+3sd",
    },
    {
      month: 216,
      y: 80,
      name: "+3sd",
    },
  ],

  boys_weight: [
    {
      month: 0,
      y: 2.1,
      name: "-3sd",
    },
    {
      month: 1,
      y: 2.9,
      name: "-3sd",
    },
    {
      month: 2,
      y: 3.8,
      name: "-3sd",
    },
    {
      month: 3,
      y: 4.4,
      name: "-3sd",
    },
    {
      month: 4,
      y: 4.9,
      name: "-3sd",
    },
    {
      month: 5,
      y: 5.3,
      name: "-3sd",
    },
    {
      month: 6,
      y: 5.7,
      name: "-3sd",
    },
    {
      month: 7,
      y: 5.9,
      name: "-3sd",
    },
    {
      month: 8,
      y: 6.2,
      name: "-3sd",
    },
    {
      month: 9,
      y: 6.4,
      name: "-3sd",
    },
    {
      month: 10,
      y: 6.6,
      name: "-3sd",
    },
    {
      month: 11,
      y: 6.8,
      name: "-3sd",
    },
    {
      month: 12,
      y: 6.9,
      name: "-3sd",
    },
    {
      month: 13,
      y: 7.1,
      name: "-3sd",
    },
    {
      month: 14,
      y: 7.2,
      name: "-3sd",
    },
    {
      month: 15,
      y: 7.4,
      name: "-3sd",
    },
    {
      month: 16,
      y: 7.5,
      name: "-3sd",
    },
    {
      month: 17,
      y: 7.7,
      name: "-3sd",
    },
    {
      month: 18,
      y: 7.8,
      name: "-3sd",
    },
    {
      month: 19,
      y: 8,
      name: "-3sd",
    },
    {
      month: 20,
      y: 8.1,
      name: "-3sd",
    },
    {
      month: 21,
      y: 8.2,
      name: "-3sd",
    },
    {
      month: 22,
      y: 8.4,
      name: "-3sd",
    },
    {
      month: 23,
      y: 8.5,
      name: "-3sd",
    },
    {
      month: 24,
      y: 8.6,
      name: "-3sd",
    },
    {
      month: 25,
      y: 8.8,
      name: "-3sd",
    },
    {
      month: 26,
      y: 8.9,
      name: "-3sd",
    },
    {
      month: 27,
      y: 9,
      name: "-3sd",
    },
    {
      month: 28,
      y: 9.1,
      name: "-3sd",
    },
    {
      month: 29,
      y: 9.2,
      name: "-3sd",
    },
    {
      month: 30,
      y: 9.4,
      name: "-3sd",
    },
    {
      month: 31,
      y: 9.5,
      name: "-3sd",
    },
    {
      month: 32,
      y: 9.6,
      name: "-3sd",
    },
    {
      month: 33,
      y: 9.7,
      name: "-3sd",
    },
    {
      month: 34,
      y: 9.8,
      name: "-3sd",
    },
    {
      month: 35,
      y: 9.9,
      name: "-3sd",
    },
    {
      month: 36,
      y: 10,
      name: "-3sd",
    },
    {
      month: 37,
      y: 10.1,
      name: "-3sd",
    },
    {
      month: 38,
      y: 10.2,
      name: "-3sd",
    },
    {
      month: 39,
      y: 10.3,
      name: "-3sd",
    },
    {
      month: 40,
      y: 10.4,
      name: "-3sd",
    },
    {
      month: 41,
      y: 10.5,
      name: "-3sd",
    },
    {
      month: 42,
      y: 10.6,
      name: "-3sd",
    },
    {
      month: 43,
      y: 10.7,
      name: "-3sd",
    },
    {
      month: 44,
      y: 10.8,
      name: "-3sd",
    },
    {
      month: 45,
      y: 10.9,
      name: "-3sd",
    },
    {
      month: 46,
      y: 11,
      name: "-3sd",
    },
    {
      month: 47,
      y: 11.1,
      name: "-3sd",
    },
    {
      month: 48,
      y: 11.2,
      name: "-3sd",
    },
    {
      month: 49,
      y: 11.3,
      name: "-3sd",
    },
    {
      month: 50,
      y: 11.4,
      name: "-3sd",
    },
    {
      month: 51,
      y: 11.5,
      name: "-3sd",
    },
    {
      month: 52,
      y: 11.6,
      name: "-3sd",
    },
    {
      month: 53,
      y: 11.7,
      name: "-3sd",
    },
    {
      month: 54,
      y: 11.8,
      name: "-3sd",
    },
    {
      month: 55,
      y: 11.9,
      name: "-3sd",
    },
    {
      month: 56,
      y: 12,
      name: "-3sd",
    },
    {
      month: 57,
      y: 12.1,
      name: "-3sd",
    },
    {
      month: 58,
      y: 12.2,
      name: "-3sd",
    },
    {
      month: 59,
      y: 12.3,
      name: "-3sd",
    },
    {
      month: 60,
      y: 12.4,
      name: "-3sd",
    },
    {
      month: 61,
      y: 12.718,
      name: "-3sd",
    },
    {
      month: 62,
      y: 12.833,
      name: "-3sd",
    },
    {
      month: 63,
      y: 12.95,
      name: "-3sd",
    },
    {
      month: 64,
      y: 13.067,
      name: "-3sd",
    },
    {
      month: 65,
      y: 13.186,
      name: "-3sd",
    },
    {
      month: 66,
      y: 13.307,
      name: "-3sd",
    },
    {
      month: 67,
      y: 13.429,
      name: "-3sd",
    },
    {
      month: 68,
      y: 13.553,
      name: "-3sd",
    },
    {
      month: 69,
      y: 13.679,
      name: "-3sd",
    },
    {
      month: 70,
      y: 13.805,
      name: "-3sd",
    },
    {
      month: 71,
      y: 13.934,
      name: "-3sd",
    },
    {
      month: 72,
      y: 14.063,
      name: "-3sd",
    },
    {
      month: 73,
      y: 14.193,
      name: "-3sd",
    },
    {
      month: 74,
      y: 14.324,
      name: "-3sd",
    },
    {
      month: 75,
      y: 14.456,
      name: "-3sd",
    },
    {
      month: 76,
      y: 14.588,
      name: "-3sd",
    },
    {
      month: 77,
      y: 14.721,
      name: "-3sd",
    },
    {
      month: 78,
      y: 14.855,
      name: "-3sd",
    },
    {
      month: 79,
      y: 14.99,
      name: "-3sd",
    },
    {
      month: 80,
      y: 15.125,
      name: "-3sd",
    },
    {
      month: 81,
      y: 15.259,
      name: "-3sd",
    },
    {
      month: 82,
      y: 15.395,
      name: "-3sd",
    },
    {
      month: 83,
      y: 15.531,
      name: "-3sd",
    },
    {
      month: 84,
      y: 15.666,
      name: "-3sd",
    },
    {
      month: 85,
      y: 15.802,
      name: "-3sd",
    },
    {
      month: 86,
      y: 15.937,
      name: "-3sd",
    },
    {
      month: 87,
      y: 16.072,
      name: "-3sd",
    },
    {
      month: 88,
      y: 16.207,
      name: "-3sd",
    },
    {
      month: 89,
      y: 16.341,
      name: "-3sd",
    },
    {
      month: 90,
      y: 16.475,
      name: "-3sd",
    },
    {
      month: 91,
      y: 16.609,
      name: "-3sd",
    },
    {
      month: 92,
      y: 16.742,
      name: "-3sd",
    },
    {
      month: 93,
      y: 16.875,
      name: "-3sd",
    },
    {
      month: 94,
      y: 17.008,
      name: "-3sd",
    },
    {
      month: 95,
      y: 17.14,
      name: "-3sd",
    },
    {
      month: 96,
      y: 17.271,
      name: "-3sd",
    },
    {
      month: 97,
      y: 17.402,
      name: "-3sd",
    },
    {
      month: 98,
      y: 17.532,
      name: "-3sd",
    },
    {
      month: 99,
      y: 17.662,
      name: "-3sd",
    },
    {
      month: 100,
      y: 17.792,
      name: "-3sd",
    },
    {
      month: 101,
      y: 17.921,
      name: "-3sd",
    },
    {
      month: 102,
      y: 18.05,
      name: "-3sd",
    },
    {
      month: 103,
      y: 18.178,
      name: "-3sd",
    },
    {
      month: 104,
      y: 18.306,
      name: "-3sd",
    },
    {
      month: 105,
      y: 18.433,
      name: "-3sd",
    },
    {
      month: 106,
      y: 18.561,
      name: "-3sd",
    },
    {
      month: 107,
      y: 18.689,
      name: "-3sd",
    },
    {
      month: 108,
      y: 18.817,
      name: "-3sd",
    },
    {
      month: 109,
      y: 18.945,
      name: "-3sd",
    },
    {
      month: 110,
      y: 19.075,
      name: "-3sd",
    },
    {
      month: 111,
      y: 19.205,
      name: "-3sd",
    },
    {
      month: 112,
      y: 19.336,
      name: "-3sd",
    },
    {
      month: 113,
      y: 19.468,
      name: "-3sd",
    },
    {
      month: 114,
      y: 19.601,
      name: "-3sd",
    },
    {
      month: 115,
      y: 19.735,
      name: "-3sd",
    },
    {
      month: 116,
      y: 19.87,
      name: "-3sd",
    },
    {
      month: 117,
      y: 20.006,
      name: "-3sd",
    },
    {
      month: 118,
      y: 20.143,
      name: "-3sd",
    },
    {
      month: 119,
      y: 20.281,
      name: "-3sd",
    },
    {
      month: 120,
      y: 20.42,
      name: "-3sd",
    },
    {
      month: 144,
      y: 27.5,
      name: "-3sd",
    },
    {
      month: 156,
      y: 31,
      name: "-3sd",
    },
    {
      month: 168,
      y: 36,
      name: "-3sd",
    },
    {
      month: 180,
      y: 41,
      name: "-3sd",
    },
    {
      month: 192,
      y: 46,
      name: "-3sd",
    },
    {
      month: 204,
      y: 49.5,
      name: "-3sd",
    },
    {
      month: 216,
      y: 52,
      name: "-3sd",
    },
    {
      month: 0,
      y: 2.5,
      name: "-2sd",
    },
    {
      month: 1,
      y: 3.4,
      name: "-2sd",
    },
    {
      month: 2,
      y: 4.3,
      name: "-2sd",
    },
    {
      month: 3,
      y: 5,
      name: "-2sd",
    },
    {
      month: 4,
      y: 5.6,
      name: "-2sd",
    },
    {
      month: 5,
      y: 6,
      name: "-2sd",
    },
    {
      month: 6,
      y: 6.4,
      name: "-2sd",
    },
    {
      month: 7,
      y: 6.7,
      name: "-2sd",
    },
    {
      month: 8,
      y: 6.9,
      name: "-2sd",
    },
    {
      month: 9,
      y: 7.1,
      name: "-2sd",
    },
    {
      month: 10,
      y: 7.4,
      name: "-2sd",
    },
    {
      month: 11,
      y: 7.6,
      name: "-2sd",
    },
    {
      month: 12,
      y: 7.7,
      name: "-2sd",
    },
    {
      month: 13,
      y: 7.9,
      name: "-2sd",
    },
    {
      month: 14,
      y: 8.1,
      name: "-2sd",
    },
    {
      month: 15,
      y: 8.3,
      name: "-2sd",
    },
    {
      month: 16,
      y: 8.4,
      name: "-2sd",
    },
    {
      month: 17,
      y: 8.6,
      name: "-2sd",
    },
    {
      month: 18,
      y: 8.8,
      name: "-2sd",
    },
    {
      month: 19,
      y: 8.9,
      name: "-2sd",
    },
    {
      month: 20,
      y: 9.1,
      name: "-2sd",
    },
    {
      month: 21,
      y: 9.2,
      name: "-2sd",
    },
    {
      month: 22,
      y: 9.4,
      name: "-2sd",
    },
    {
      month: 23,
      y: 9.5,
      name: "-2sd",
    },
    {
      month: 24,
      y: 9.7,
      name: "-2sd",
    },
    {
      month: 25,
      y: 9.8,
      name: "-2sd",
    },
    {
      month: 26,
      y: 10,
      name: "-2sd",
    },
    {
      month: 27,
      y: 10.1,
      name: "-2sd",
    },
    {
      month: 28,
      y: 10.2,
      name: "-2sd",
    },
    {
      month: 29,
      y: 10.4,
      name: "-2sd",
    },
    {
      month: 30,
      y: 10.5,
      name: "-2sd",
    },
    {
      month: 31,
      y: 10.7,
      name: "-2sd",
    },
    {
      month: 32,
      y: 10.8,
      name: "-2sd",
    },
    {
      month: 33,
      y: 10.9,
      name: "-2sd",
    },
    {
      month: 34,
      y: 11,
      name: "-2sd",
    },
    {
      month: 35,
      y: 11.2,
      name: "-2sd",
    },
    {
      month: 36,
      y: 11.3,
      name: "-2sd",
    },
    {
      month: 37,
      y: 11.4,
      name: "-2sd",
    },
    {
      month: 38,
      y: 11.5,
      name: "-2sd",
    },
    {
      month: 39,
      y: 11.6,
      name: "-2sd",
    },
    {
      month: 40,
      y: 11.8,
      name: "-2sd",
    },
    {
      month: 41,
      y: 11.9,
      name: "-2sd",
    },
    {
      month: 42,
      y: 12,
      name: "-2sd",
    },
    {
      month: 43,
      y: 12.1,
      name: "-2sd",
    },
    {
      month: 44,
      y: 12.2,
      name: "-2sd",
    },
    {
      month: 45,
      y: 12.4,
      name: "-2sd",
    },
    {
      month: 46,
      y: 12.5,
      name: "-2sd",
    },
    {
      month: 47,
      y: 12.6,
      name: "-2sd",
    },
    {
      month: 48,
      y: 12.7,
      name: "-2sd",
    },
    {
      month: 49,
      y: 12.8,
      name: "-2sd",
    },
    {
      month: 50,
      y: 12.9,
      name: "-2sd",
    },
    {
      month: 51,
      y: 13.1,
      name: "-2sd",
    },
    {
      month: 52,
      y: 13.2,
      name: "-2sd",
    },
    {
      month: 53,
      y: 13.3,
      name: "-2sd",
    },
    {
      month: 54,
      y: 13.4,
      name: "-2sd",
    },
    {
      month: 55,
      y: 13.5,
      name: "-2sd",
    },
    {
      month: 56,
      y: 13.6,
      name: "-2sd",
    },
    {
      month: 57,
      y: 13.7,
      name: "-2sd",
    },
    {
      month: 58,
      y: 13.8,
      name: "-2sd",
    },
    {
      month: 59,
      y: 14,
      name: "-2sd",
    },
    {
      month: 60,
      y: 14.1,
      name: "-2sd",
    },
    {
      month: 61,
      y: 14.367,
      name: "-2sd",
    },
    {
      month: 62,
      y: 14.496,
      name: "-2sd",
    },
    {
      month: 63,
      y: 14.627,
      name: "-2sd",
    },
    {
      month: 64,
      y: 14.759,
      name: "-2sd",
    },
    {
      month: 65,
      y: 14.892,
      name: "-2sd",
    },
    {
      month: 66,
      y: 15.027,
      name: "-2sd",
    },
    {
      month: 67,
      y: 15.164,
      name: "-2sd",
    },
    {
      month: 68,
      y: 15.302,
      name: "-2sd",
    },
    {
      month: 69,
      y: 15.442,
      name: "-2sd",
    },
    {
      month: 70,
      y: 15.583,
      name: "-2sd",
    },
    {
      month: 71,
      y: 15.726,
      name: "-2sd",
    },
    {
      month: 72,
      y: 15.87,
      name: "-2sd",
    },
    {
      month: 73,
      y: 16.015,
      name: "-2sd",
    },
    {
      month: 74,
      y: 16.16,
      name: "-2sd",
    },
    {
      month: 75,
      y: 16.307,
      name: "-2sd",
    },
    {
      month: 76,
      y: 16.454,
      name: "-2sd",
    },
    {
      month: 77,
      y: 16.602,
      name: "-2sd",
    },
    {
      month: 78,
      y: 16.751,
      name: "-2sd",
    },
    {
      month: 79,
      y: 16.9,
      name: "-2sd",
    },
    {
      month: 80,
      y: 17.05,
      name: "-2sd",
    },
    {
      month: 81,
      y: 17.201,
      name: "-2sd",
    },
    {
      month: 82,
      y: 17.352,
      name: "-2sd",
    },
    {
      month: 83,
      y: 17.503,
      name: "-2sd",
    },
    {
      month: 84,
      y: 17.655,
      name: "-2sd",
    },
    {
      month: 85,
      y: 17.807,
      name: "-2sd",
    },
    {
      month: 86,
      y: 17.958,
      name: "-2sd",
    },
    {
      month: 87,
      y: 18.11,
      name: "-2sd",
    },
    {
      month: 88,
      y: 18.262,
      name: "-2sd",
    },
    {
      month: 89,
      y: 18.414,
      name: "-2sd",
    },
    {
      month: 90,
      y: 18.565,
      name: "-2sd",
    },
    {
      month: 91,
      y: 18.717,
      name: "-2sd",
    },
    {
      month: 92,
      y: 18.868,
      name: "-2sd",
    },
    {
      month: 93,
      y: 19.019,
      name: "-2sd",
    },
    {
      month: 94,
      y: 19.17,
      name: "-2sd",
    },
    {
      month: 95,
      y: 19.321,
      name: "-2sd",
    },
    {
      month: 96,
      y: 19.472,
      name: "-2sd",
    },
    {
      month: 97,
      y: 19.622,
      name: "-2sd",
    },
    {
      month: 98,
      y: 19.772,
      name: "-2sd",
    },
    {
      month: 99,
      y: 19.922,
      name: "-2sd",
    },
    {
      month: 100,
      y: 20.072,
      name: "-2sd",
    },
    {
      month: 101,
      y: 20.222,
      name: "-2sd",
    },
    {
      month: 102,
      y: 20.372,
      name: "-2sd",
    },
    {
      month: 103,
      y: 20.522,
      name: "-2sd",
    },
    {
      month: 104,
      y: 20.672,
      name: "-2sd",
    },
    {
      month: 105,
      y: 20.822,
      name: "-2sd",
    },
    {
      month: 106,
      y: 20.972,
      name: "-2sd",
    },
    {
      month: 107,
      y: 21.123,
      name: "-2sd",
    },
    {
      month: 108,
      y: 21.275,
      name: "-2sd",
    },
    {
      month: 109,
      y: 21.428,
      name: "-2sd",
    },
    {
      month: 110,
      y: 21.582,
      name: "-2sd",
    },
    {
      month: 111,
      y: 21.737,
      name: "-2sd",
    },
    {
      month: 112,
      y: 21.894,
      name: "-2sd",
    },
    {
      month: 113,
      y: 22.052,
      name: "-2sd",
    },
    {
      month: 114,
      y: 22.212,
      name: "-2sd",
    },
    {
      month: 115,
      y: 22.373,
      name: "-2sd",
    },
    {
      month: 116,
      y: 22.537,
      name: "-2sd",
    },
    {
      month: 117,
      y: 22.701,
      name: "-2sd",
    },
    {
      month: 118,
      y: 22.868,
      name: "-2sd",
    },
    {
      month: 119,
      y: 23.036,
      name: "-2sd",
    },
    {
      month: 120,
      y: 23.206,
      name: "-2sd",
    },
    {
      month: 144,
      y: 31.5,
      name: "-2sd",
    },
    {
      month: 156,
      y: 36,
      name: "-2sd",
    },
    {
      month: 168,
      y: 40.6,
      name: "-2sd",
    },
    {
      month: 180,
      y: 46,
      name: "-2sd",
    },
    {
      month: 192,
      y: 51,
      name: "-2sd",
    },
    {
      month: 204,
      y: 55,
      name: "-2sd",
    },
    {
      month: 216,
      y: 58,
      name: "-2sd",
    },
    {
      month: 0,
      y: 2.9,
      name: "-1sd",
    },
    {
      month: 1,
      y: 3.9,
      name: "-1sd",
    },
    {
      month: 2,
      y: 4.9,
      name: "-1sd",
    },
    {
      month: 3,
      y: 5.7,
      name: "-1sd",
    },
    {
      month: 4,
      y: 6.2,
      name: "-1sd",
    },
    {
      month: 5,
      y: 6.7,
      name: "-1sd",
    },
    {
      month: 6,
      y: 7.1,
      name: "-1sd",
    },
    {
      month: 7,
      y: 7.4,
      name: "-1sd",
    },
    {
      month: 8,
      y: 7.7,
      name: "-1sd",
    },
    {
      month: 9,
      y: 8,
      name: "-1sd",
    },
    {
      month: 10,
      y: 8.2,
      name: "-1sd",
    },
    {
      month: 11,
      y: 8.4,
      name: "-1sd",
    },
    {
      month: 12,
      y: 8.6,
      name: "-1sd",
    },
    {
      month: 13,
      y: 8.8,
      name: "-1sd",
    },
    {
      month: 14,
      y: 9,
      name: "-1sd",
    },
    {
      month: 15,
      y: 9.2,
      name: "-1sd",
    },
    {
      month: 16,
      y: 9.4,
      name: "-1sd",
    },
    {
      month: 17,
      y: 9.6,
      name: "-1sd",
    },
    {
      month: 18,
      y: 9.8,
      name: "-1sd",
    },
    {
      month: 19,
      y: 10,
      name: "-1sd",
    },
    {
      month: 20,
      y: 10.1,
      name: "-1sd",
    },
    {
      month: 21,
      y: 10.3,
      name: "-1sd",
    },
    {
      month: 22,
      y: 10.5,
      name: "-1sd",
    },
    {
      month: 23,
      y: 10.7,
      name: "-1sd",
    },
    {
      month: 24,
      y: 10.8,
      name: "-1sd",
    },
    {
      month: 25,
      y: 11,
      name: "-1sd",
    },
    {
      month: 26,
      y: 11.2,
      name: "-1sd",
    },
    {
      month: 27,
      y: 11.3,
      name: "-1sd",
    },
    {
      month: 28,
      y: 11.5,
      name: "-1sd",
    },
    {
      month: 29,
      y: 11.7,
      name: "-1sd",
    },
    {
      month: 30,
      y: 11.8,
      name: "-1sd",
    },
    {
      month: 31,
      y: 12,
      name: "-1sd",
    },
    {
      month: 32,
      y: 12.1,
      name: "-1sd",
    },
    {
      month: 33,
      y: 12.3,
      name: "-1sd",
    },
    {
      month: 34,
      y: 12.4,
      name: "-1sd",
    },
    {
      month: 35,
      y: 12.6,
      name: "-1sd",
    },
    {
      month: 36,
      y: 12.7,
      name: "-1sd",
    },
    {
      month: 37,
      y: 12.9,
      name: "-1sd",
    },
    {
      month: 38,
      y: 13,
      name: "-1sd",
    },
    {
      month: 39,
      y: 13.1,
      name: "-1sd",
    },
    {
      month: 40,
      y: 13.3,
      name: "-1sd",
    },
    {
      month: 41,
      y: 13.4,
      name: "-1sd",
    },
    {
      month: 42,
      y: 13.6,
      name: "-1sd",
    },
    {
      month: 43,
      y: 13.7,
      name: "-1sd",
    },
    {
      month: 44,
      y: 13.8,
      name: "-1sd",
    },
    {
      month: 45,
      y: 14,
      name: "-1sd",
    },
    {
      month: 46,
      y: 14.1,
      name: "-1sd",
    },
    {
      month: 47,
      y: 14.3,
      name: "-1sd",
    },
    {
      month: 48,
      y: 14.4,
      name: "-1sd",
    },
    {
      month: 49,
      y: 14.5,
      name: "-1sd",
    },
    {
      month: 50,
      y: 14.7,
      name: "-1sd",
    },
    {
      month: 51,
      y: 14.8,
      name: "-1sd",
    },
    {
      month: 52,
      y: 15,
      name: "-1sd",
    },
    {
      month: 53,
      y: 15.1,
      name: "-1sd",
    },
    {
      month: 54,
      y: 15.2,
      name: "-1sd",
    },
    {
      month: 55,
      y: 15.4,
      name: "-1sd",
    },
    {
      month: 56,
      y: 15.5,
      name: "-1sd",
    },
    {
      month: 57,
      y: 15.6,
      name: "-1sd",
    },
    {
      month: 58,
      y: 15.8,
      name: "-1sd",
    },
    {
      month: 59,
      y: 15.9,
      name: "-1sd",
    },
    {
      month: 60,
      y: 16,
      name: "-1sd",
    },
    {
      month: 61,
      y: 16.279,
      name: "-1sd",
    },
    {
      month: 62,
      y: 16.428,
      name: "-1sd",
    },
    {
      month: 63,
      y: 16.578,
      name: "-1sd",
    },
    {
      month: 64,
      y: 16.729,
      name: "-1sd",
    },
    {
      month: 65,
      y: 16.882,
      name: "-1sd",
    },
    {
      month: 66,
      y: 17.036,
      name: "-1sd",
    },
    {
      month: 67,
      y: 17.192,
      name: "-1sd",
    },
    {
      month: 68,
      y: 17.35,
      name: "-1sd",
    },
    {
      month: 69,
      y: 17.509,
      name: "-1sd",
    },
    {
      month: 70,
      y: 17.67,
      name: "-1sd",
    },
    {
      month: 71,
      y: 17.832,
      name: "-1sd",
    },
    {
      month: 72,
      y: 17.996,
      name: "-1sd",
    },
    {
      month: 73,
      y: 18.16,
      name: "-1sd",
    },
    {
      month: 74,
      y: 18.326,
      name: "-1sd",
    },
    {
      month: 75,
      y: 18.492,
      name: "-1sd",
    },
    {
      month: 76,
      y: 18.659,
      name: "-1sd",
    },
    {
      month: 77,
      y: 18.828,
      name: "-1sd",
    },
    {
      month: 78,
      y: 18.997,
      name: "-1sd",
    },
    {
      month: 79,
      y: 19.167,
      name: "-1sd",
    },
    {
      month: 80,
      y: 19.338,
      name: "-1sd",
    },
    {
      month: 81,
      y: 19.51,
      name: "-1sd",
    },
    {
      month: 82,
      y: 19.682,
      name: "-1sd",
    },
    {
      month: 83,
      y: 19.855,
      name: "-1sd",
    },
    {
      month: 84,
      y: 20.029,
      name: "-1sd",
    },
    {
      month: 85,
      y: 20.203,
      name: "-1sd",
    },
    {
      month: 86,
      y: 20.377,
      name: "-1sd",
    },
    {
      month: 87,
      y: 20.552,
      name: "-1sd",
    },
    {
      month: 88,
      y: 20.727,
      name: "-1sd",
    },
    {
      month: 89,
      y: 20.903,
      name: "-1sd",
    },
    {
      month: 90,
      y: 21.078,
      name: "-1sd",
    },
    {
      month: 91,
      y: 21.255,
      name: "-1sd",
    },
    {
      month: 92,
      y: 21.431,
      name: "-1sd",
    },
    {
      month: 93,
      y: 21.607,
      name: "-1sd",
    },
    {
      month: 94,
      y: 21.784,
      name: "-1sd",
    },
    {
      month: 95,
      y: 21.961,
      name: "-1sd",
    },
    {
      month: 96,
      y: 22.138,
      name: "-1sd",
    },
    {
      month: 97,
      y: 22.316,
      name: "-1sd",
    },
    {
      month: 98,
      y: 22.494,
      name: "-1sd",
    },
    {
      month: 99,
      y: 22.672,
      name: "-1sd",
    },
    {
      month: 100,
      y: 22.851,
      name: "-1sd",
    },
    {
      month: 101,
      y: 23.031,
      name: "-1sd",
    },
    {
      month: 102,
      y: 23.21,
      name: "-1sd",
    },
    {
      month: 103,
      y: 23.39,
      name: "-1sd",
    },
    {
      month: 104,
      y: 23.571,
      name: "-1sd",
    },
    {
      month: 105,
      y: 23.753,
      name: "-1sd",
    },
    {
      month: 106,
      y: 23.936,
      name: "-1sd",
    },
    {
      month: 107,
      y: 24.119,
      name: "-1sd",
    },
    {
      month: 108,
      y: 24.305,
      name: "-1sd",
    },
    {
      month: 109,
      y: 24.492,
      name: "-1sd",
    },
    {
      month: 110,
      y: 24.681,
      name: "-1sd",
    },
    {
      month: 111,
      y: 24.871,
      name: "-1sd",
    },
    {
      month: 112,
      y: 25.064,
      name: "-1sd",
    },
    {
      month: 113,
      y: 25.259,
      name: "-1sd",
    },
    {
      month: 114,
      y: 25.457,
      name: "-1sd",
    },
    {
      month: 115,
      y: 25.656,
      name: "-1sd",
    },
    {
      month: 116,
      y: 25.859,
      name: "-1sd",
    },
    {
      month: 117,
      y: 26.064,
      name: "-1sd",
    },
    {
      month: 118,
      y: 26.271,
      name: "-1sd",
    },
    {
      month: 119,
      y: 26.481,
      name: "-1sd",
    },
    {
      month: 120,
      y: 26.694,
      name: "-1sd",
    },
    {
      month: 144,
      y: 35.8,
      name: "-1sd",
    },
    {
      month: 156,
      y: 40,
      name: "-1sd",
    },
    {
      month: 168,
      y: 46,
      name: "-1sd",
    },
    {
      month: 180,
      y: 51,
      name: "-1sd",
    },
    {
      month: 192,
      y: 56.3,
      name: "-1sd",
    },
    {
      month: 204,
      y: 60.3,
      name: "-1sd",
    },
    {
      month: 216,
      y: 63,
      name: "-1sd",
    },
    {
      month: 0,
      y: 3.3,
      name: "mediane",
    },
    {
      month: 1,
      y: 4.5,
      name: "mediane",
    },
    {
      month: 2,
      y: 5.6,
      name: "mediane",
    },
    {
      month: 3,
      y: 6.4,
      name: "mediane",
    },
    {
      month: 4,
      y: 7,
      name: "mediane",
    },
    {
      month: 5,
      y: 7.5,
      name: "mediane",
    },
    {
      month: 6,
      y: 7.9,
      name: "mediane",
    },
    {
      month: 7,
      y: 8.3,
      name: "mediane",
    },
    {
      month: 8,
      y: 8.6,
      name: "mediane",
    },
    {
      month: 9,
      y: 8.9,
      name: "mediane",
    },
    {
      month: 10,
      y: 9.2,
      name: "mediane",
    },
    {
      month: 11,
      y: 9.4,
      name: "mediane",
    },
    {
      month: 12,
      y: 9.6,
      name: "mediane",
    },
    {
      month: 13,
      y: 9.9,
      name: "mediane",
    },
    {
      month: 14,
      y: 10.1,
      name: "mediane",
    },
    {
      month: 15,
      y: 10.3,
      name: "mediane",
    },
    {
      month: 16,
      y: 10.5,
      name: "mediane",
    },
    {
      month: 17,
      y: 10.7,
      name: "mediane",
    },
    {
      month: 18,
      y: 10.9,
      name: "mediane",
    },
    {
      month: 19,
      y: 11.1,
      name: "mediane",
    },
    {
      month: 20,
      y: 11.3,
      name: "mediane",
    },
    {
      month: 21,
      y: 11.5,
      name: "mediane",
    },
    {
      month: 22,
      y: 11.8,
      name: "mediane",
    },
    {
      month: 23,
      y: 12,
      name: "mediane",
    },
    {
      month: 24,
      y: 12.2,
      name: "mediane",
    },
    {
      month: 25,
      y: 12.4,
      name: "mediane",
    },
    {
      month: 26,
      y: 12.5,
      name: "mediane",
    },
    {
      month: 27,
      y: 12.7,
      name: "mediane",
    },
    {
      month: 28,
      y: 12.9,
      name: "mediane",
    },
    {
      month: 29,
      y: 13.1,
      name: "mediane",
    },
    {
      month: 30,
      y: 13.3,
      name: "mediane",
    },
    {
      month: 31,
      y: 13.5,
      name: "mediane",
    },
    {
      month: 32,
      y: 13.7,
      name: "mediane",
    },
    {
      month: 33,
      y: 13.8,
      name: "mediane",
    },
    {
      month: 34,
      y: 14,
      name: "mediane",
    },
    {
      month: 35,
      y: 14.2,
      name: "mediane",
    },
    {
      month: 36,
      y: 14.3,
      name: "mediane",
    },
    {
      month: 37,
      y: 14.5,
      name: "mediane",
    },
    {
      month: 38,
      y: 14.7,
      name: "mediane",
    },
    {
      month: 39,
      y: 14.8,
      name: "mediane",
    },
    {
      month: 40,
      y: 15,
      name: "mediane",
    },
    {
      month: 41,
      y: 15.2,
      name: "mediane",
    },
    {
      month: 42,
      y: 15.3,
      name: "mediane",
    },
    {
      month: 43,
      y: 15.5,
      name: "mediane",
    },
    {
      month: 44,
      y: 15.7,
      name: "mediane",
    },
    {
      month: 45,
      y: 15.8,
      name: "mediane",
    },
    {
      month: 46,
      y: 16,
      name: "mediane",
    },
    {
      month: 47,
      y: 16.2,
      name: "mediane",
    },
    {
      month: 48,
      y: 16.3,
      name: "mediane",
    },
    {
      month: 49,
      y: 16.5,
      name: "mediane",
    },
    {
      month: 50,
      y: 16.7,
      name: "mediane",
    },
    {
      month: 51,
      y: 16.8,
      name: "mediane",
    },
    {
      month: 52,
      y: 17,
      name: "mediane",
    },
    {
      month: 53,
      y: 17.2,
      name: "mediane",
    },
    {
      month: 54,
      y: 17.3,
      name: "mediane",
    },
    {
      month: 55,
      y: 17.5,
      name: "mediane",
    },
    {
      month: 56,
      y: 17.7,
      name: "mediane",
    },
    {
      month: 57,
      y: 17.8,
      name: "mediane",
    },
    {
      month: 58,
      y: 18,
      name: "mediane",
    },
    {
      month: 59,
      y: 18.2,
      name: "mediane",
    },
    {
      month: 60,
      y: 18.3,
      name: "mediane",
    },
    {
      month: 61,
      y: 18.506,
      name: "mediane",
    },
    {
      month: 62,
      y: 18.68,
      name: "mediane",
    },
    {
      month: 63,
      y: 18.856,
      name: "mediane",
    },
    {
      month: 64,
      y: 19.034,
      name: "mediane",
    },
    {
      month: 65,
      y: 19.213,
      name: "mediane",
    },
    {
      month: 66,
      y: 19.394,
      name: "mediane",
    },
    {
      month: 67,
      y: 19.576,
      name: "mediane",
    },
    {
      month: 68,
      y: 19.761,
      name: "mediane",
    },
    {
      month: 69,
      y: 19.947,
      name: "mediane",
    },
    {
      month: 70,
      y: 20.134,
      name: "mediane",
    },
    {
      month: 71,
      y: 20.324,
      name: "mediane",
    },
    {
      month: 72,
      y: 20.514,
      name: "mediane",
    },
    {
      month: 73,
      y: 20.705,
      name: "mediane",
    },
    {
      month: 74,
      y: 20.898,
      name: "mediane",
    },
    {
      month: 75,
      y: 21.092,
      name: "mediane",
    },
    {
      month: 76,
      y: 21.287,
      name: "mediane",
    },
    {
      month: 77,
      y: 21.483,
      name: "mediane",
    },
    {
      month: 78,
      y: 21.681,
      name: "mediane",
    },
    {
      month: 79,
      y: 21.88,
      name: "mediane",
    },
    {
      month: 80,
      y: 22.08,
      name: "mediane",
    },
    {
      month: 81,
      y: 22.281,
      name: "mediane",
    },
    {
      month: 82,
      y: 22.484,
      name: "mediane",
    },
    {
      month: 83,
      y: 22.687,
      name: "mediane",
    },
    {
      month: 84,
      y: 22.892,
      name: "mediane",
    },
    {
      month: 85,
      y: 23.097,
      name: "mediane",
    },
    {
      month: 86,
      y: 23.303,
      name: "mediane",
    },
    {
      month: 87,
      y: 23.51,
      name: "mediane",
    },
    {
      month: 88,
      y: 23.718,
      name: "mediane",
    },
    {
      month: 89,
      y: 23.927,
      name: "mediane",
    },
    {
      month: 90,
      y: 24.137,
      name: "mediane",
    },
    {
      month: 91,
      y: 24.348,
      name: "mediane",
    },
    {
      month: 92,
      y: 24.56,
      name: "mediane",
    },
    {
      month: 93,
      y: 24.772,
      name: "mediane",
    },
    {
      month: 94,
      y: 24.986,
      name: "mediane",
    },
    {
      month: 95,
      y: 25.2,
      name: "mediane",
    },
    {
      month: 96,
      y: 25.416,
      name: "mediane",
    },
    {
      month: 97,
      y: 25.633,
      name: "mediane",
    },
    {
      month: 98,
      y: 25.851,
      name: "mediane",
    },
    {
      month: 99,
      y: 26.071,
      name: "mediane",
    },
    {
      month: 100,
      y: 26.291,
      name: "mediane",
    },
    {
      month: 101,
      y: 26.513,
      name: "mediane",
    },
    {
      month: 102,
      y: 26.736,
      name: "mediane",
    },
    {
      month: 103,
      y: 26.96,
      name: "mediane",
    },
    {
      month: 104,
      y: 27.186,
      name: "mediane",
    },
    {
      month: 105,
      y: 27.414,
      name: "mediane",
    },
    {
      month: 106,
      y: 27.643,
      name: "mediane",
    },
    {
      month: 107,
      y: 27.875,
      name: "mediane",
    },
    {
      month: 108,
      y: 28.109,
      name: "mediane",
    },
    {
      month: 109,
      y: 28.346,
      name: "mediane",
    },
    {
      month: 110,
      y: 28.585,
      name: "mediane",
    },
    {
      month: 111,
      y: 28.828,
      name: "mediane",
    },
    {
      month: 112,
      y: 29.073,
      name: "mediane",
    },
    {
      month: 113,
      y: 29.322,
      name: "mediane",
    },
    {
      month: 114,
      y: 29.574,
      name: "mediane",
    },
    {
      month: 115,
      y: 29.829,
      name: "mediane",
    },
    {
      month: 116,
      y: 30.088,
      name: "mediane",
    },
    {
      month: 117,
      y: 30.35,
      name: "mediane",
    },
    {
      month: 118,
      y: 30.616,
      name: "mediane",
    },
    {
      month: 119,
      y: 30.885,
      name: "mediane",
    },
    {
      month: 120,
      y: 31.159,
      name: "mediane",
    },
    {
      month: 156,
      y: 45,
      name: "mediane",
    },
    {
      month: 168,
      y: 50.8,
      name: "mediane",
    },
    {
      month: 180,
      y: 57,
      name: "mediane",
    },
    {
      month: 192,
      y: 62,
      name: "mediane",
    },
    {
      month: 204,
      y: 66,
      name: "mediane",
    },
    {
      month: 216,
      y: 68.8,
      name: "mediane",
    },
    {
      month: 0,
      y: 3.9,
      name: "+1sd",
    },
    {
      month: 1,
      y: 5.1,
      name: "+1sd",
    },
    {
      month: 2,
      y: 6.3,
      name: "+1sd",
    },
    {
      month: 3,
      y: 7.2,
      name: "+1sd",
    },
    {
      month: 4,
      y: 7.8,
      name: "+1sd",
    },
    {
      month: 5,
      y: 8.4,
      name: "+1sd",
    },
    {
      month: 6,
      y: 8.8,
      name: "+1sd",
    },
    {
      month: 7,
      y: 9.2,
      name: "+1sd",
    },
    {
      month: 8,
      y: 9.6,
      name: "+1sd",
    },
    {
      month: 9,
      y: 9.9,
      name: "+1sd",
    },
    {
      month: 10,
      y: 10.2,
      name: "+1sd",
    },
    {
      month: 11,
      y: 10.5,
      name: "+1sd",
    },
    {
      month: 12,
      y: 10.8,
      name: "+1sd",
    },
    {
      month: 13,
      y: 11,
      name: "+1sd",
    },
    {
      month: 14,
      y: 11.3,
      name: "+1sd",
    },
    {
      month: 15,
      y: 11.5,
      name: "+1sd",
    },
    {
      month: 16,
      y: 11.7,
      name: "+1sd",
    },
    {
      month: 17,
      y: 12,
      name: "+1sd",
    },
    {
      month: 18,
      y: 12.2,
      name: "+1sd",
    },
    {
      month: 19,
      y: 12.5,
      name: "+1sd",
    },
    {
      month: 20,
      y: 12.7,
      name: "+1sd",
    },
    {
      month: 21,
      y: 12.9,
      name: "+1sd",
    },
    {
      month: 22,
      y: 13.2,
      name: "+1sd",
    },
    {
      month: 23,
      y: 13.4,
      name: "+1sd",
    },
    {
      month: 24,
      y: 13.6,
      name: "+1sd",
    },
    {
      month: 25,
      y: 13.9,
      name: "+1sd",
    },
    {
      month: 26,
      y: 14.1,
      name: "+1sd",
    },
    {
      month: 27,
      y: 14.3,
      name: "+1sd",
    },
    {
      month: 28,
      y: 14.5,
      name: "+1sd",
    },
    {
      month: 29,
      y: 14.8,
      name: "+1sd",
    },
    {
      month: 30,
      y: 15,
      name: "+1sd",
    },
    {
      month: 31,
      y: 15.2,
      name: "+1sd",
    },
    {
      month: 32,
      y: 15.4,
      name: "+1sd",
    },
    {
      month: 33,
      y: 15.6,
      name: "+1sd",
    },
    {
      month: 34,
      y: 15.8,
      name: "+1sd",
    },
    {
      month: 35,
      y: 16,
      name: "+1sd",
    },
    {
      month: 36,
      y: 16.2,
      name: "+1sd",
    },
    {
      month: 37,
      y: 16.4,
      name: "+1sd",
    },
    {
      month: 38,
      y: 16.6,
      name: "+1sd",
    },
    {
      month: 39,
      y: 16.8,
      name: "+1sd",
    },
    {
      month: 40,
      y: 17,
      name: "+1sd",
    },
    {
      month: 41,
      y: 17.2,
      name: "+1sd",
    },
    {
      month: 42,
      y: 17.4,
      name: "+1sd",
    },
    {
      month: 43,
      y: 17.6,
      name: "+1sd",
    },
    {
      month: 44,
      y: 17.8,
      name: "+1sd",
    },
    {
      month: 45,
      y: 18,
      name: "+1sd",
    },
    {
      month: 46,
      y: 18.2,
      name: "+1sd",
    },
    {
      month: 47,
      y: 18.4,
      name: "+1sd",
    },
    {
      month: 48,
      y: 18.6,
      name: "+1sd",
    },
    {
      month: 49,
      y: 18.8,
      name: "+1sd",
    },
    {
      month: 50,
      y: 19,
      name: "+1sd",
    },
    {
      month: 51,
      y: 19.2,
      name: "+1sd",
    },
    {
      month: 52,
      y: 19.4,
      name: "+1sd",
    },
    {
      month: 53,
      y: 19.6,
      name: "+1sd",
    },
    {
      month: 54,
      y: 19.8,
      name: "+1sd",
    },
    {
      month: 55,
      y: 20,
      name: "+1sd",
    },
    {
      month: 56,
      y: 20.2,
      name: "+1sd",
    },
    {
      month: 57,
      y: 20.4,
      name: "+1sd",
    },
    {
      month: 58,
      y: 20.6,
      name: "+1sd",
    },
    {
      month: 59,
      y: 20.8,
      name: "+1sd",
    },
    {
      month: 60,
      y: 21,
      name: "+1sd",
    },
    {
      month: 61,
      y: 21.109,
      name: "+1sd",
    },
    {
      month: 62,
      y: 21.319,
      name: "+1sd",
    },
    {
      month: 63,
      y: 21.53,
      name: "+1sd",
    },
    {
      month: 64,
      y: 21.744,
      name: "+1sd",
    },
    {
      month: 65,
      y: 21.959,
      name: "+1sd",
    },
    {
      month: 66,
      y: 22.176,
      name: "+1sd",
    },
    {
      month: 67,
      y: 22.395,
      name: "+1sd",
    },
    {
      month: 68,
      y: 22.615,
      name: "+1sd",
    },
    {
      month: 69,
      y: 22.839,
      name: "+1sd",
    },
    {
      month: 70,
      y: 23.063,
      name: "+1sd",
    },
    {
      month: 71,
      y: 23.29,
      name: "+1sd",
    },
    {
      month: 72,
      y: 23.517,
      name: "+1sd",
    },
    {
      month: 73,
      y: 23.747,
      name: "+1sd",
    },
    {
      month: 74,
      y: 23.978,
      name: "+1sd",
    },
    {
      month: 75,
      y: 24.21,
      name: "+1sd",
    },
    {
      month: 76,
      y: 24.445,
      name: "+1sd",
    },
    {
      month: 77,
      y: 24.68,
      name: "+1sd",
    },
    {
      month: 78,
      y: 24.918,
      name: "+1sd",
    },
    {
      month: 79,
      y: 25.158,
      name: "+1sd",
    },
    {
      month: 80,
      y: 25.399,
      name: "+1sd",
    },
    {
      month: 81,
      y: 25.642,
      name: "+1sd",
    },
    {
      month: 82,
      y: 25.887,
      name: "+1sd",
    },
    {
      month: 83,
      y: 26.134,
      name: "+1sd",
    },
    {
      month: 84,
      y: 26.382,
      name: "+1sd",
    },
    {
      month: 85,
      y: 26.632,
      name: "+1sd",
    },
    {
      month: 86,
      y: 26.885,
      name: "+1sd",
    },
    {
      month: 87,
      y: 27.138,
      name: "+1sd",
    },
    {
      month: 88,
      y: 27.394,
      name: "+1sd",
    },
    {
      month: 89,
      y: 27.652,
      name: "+1sd",
    },
    {
      month: 90,
      y: 27.911,
      name: "+1sd",
    },
    {
      month: 91,
      y: 28.172,
      name: "+1sd",
    },
    {
      month: 92,
      y: 28.436,
      name: "+1sd",
    },
    {
      month: 93,
      y: 28.701,
      name: "+1sd",
    },
    {
      month: 94,
      y: 28.969,
      name: "+1sd",
    },
    {
      month: 95,
      y: 29.239,
      name: "+1sd",
    },
    {
      month: 96,
      y: 29.512,
      name: "+1sd",
    },
    {
      month: 97,
      y: 29.787,
      name: "+1sd",
    },
    {
      month: 98,
      y: 30.064,
      name: "+1sd",
    },
    {
      month: 99,
      y: 30.344,
      name: "+1sd",
    },
    {
      month: 100,
      y: 30.627,
      name: "+1sd",
    },
    {
      month: 101,
      y: 30.912,
      name: "+1sd",
    },
    {
      month: 102,
      y: 31.199,
      name: "+1sd",
    },
    {
      month: 103,
      y: 31.49,
      name: "+1sd",
    },
    {
      month: 104,
      y: 31.784,
      name: "+1sd",
    },
    {
      month: 105,
      y: 32.08,
      name: "+1sd",
    },
    {
      month: 106,
      y: 32.381,
      name: "+1sd",
    },
    {
      month: 107,
      y: 32.685,
      name: "+1sd",
    },
    {
      month: 108,
      y: 32.993,
      name: "+1sd",
    },
    {
      month: 109,
      y: 33.305,
      name: "+1sd",
    },
    {
      month: 110,
      y: 33.621,
      name: "+1sd",
    },
    {
      month: 111,
      y: 33.941,
      name: "+1sd",
    },
    {
      month: 112,
      y: 34.266,
      name: "+1sd",
    },
    {
      month: 113,
      y: 34.595,
      name: "+1sd",
    },
    {
      month: 114,
      y: 34.929,
      name: "+1sd",
    },
    {
      month: 115,
      y: 35.268,
      name: "+1sd",
    },
    {
      month: 116,
      y: 35.612,
      name: "+1sd",
    },
    {
      month: 117,
      y: 35.96,
      name: "+1sd",
    },
    {
      month: 118,
      y: 36.313,
      name: "+1sd",
    },
    {
      month: 119,
      y: 36.671,
      name: "+1sd",
    },
    {
      month: 120,
      y: 37.035,
      name: "+1sd",
    },
    {
      month: 156,
      y: 53,
      name: "+1sd",
    },
    {
      month: 168,
      y: 58.5,
      name: "+1sd",
    },
    {
      month: 180,
      y: 65,
      name: "+1sd",
    },
    {
      month: 192,
      y: 70,
      name: "+1sd",
    },
    {
      month: 204,
      y: 74.8,
      name: "+1sd",
    },
    {
      month: 216,
      y: 78,
      name: "+1sd",
    },
    {
      month: 0,
      y: 4.4,
      name: "+2sd",
    },
    {
      month: 1,
      y: 5.8,
      name: "+2sd",
    },
    {
      month: 2,
      y: 7.1,
      name: "+2sd",
    },
    {
      month: 3,
      y: 8,
      name: "+2sd",
    },
    {
      month: 4,
      y: 8.7,
      name: "+2sd",
    },
    {
      month: 5,
      y: 9.3,
      name: "+2sd",
    },
    {
      month: 6,
      y: 9.8,
      name: "+2sd",
    },
    {
      month: 7,
      y: 10.3,
      name: "+2sd",
    },
    {
      month: 8,
      y: 10.7,
      name: "+2sd",
    },
    {
      month: 9,
      y: 11,
      name: "+2sd",
    },
    {
      month: 10,
      y: 11.4,
      name: "+2sd",
    },
    {
      month: 11,
      y: 11.7,
      name: "+2sd",
    },
    {
      month: 12,
      y: 12,
      name: "+2sd",
    },
    {
      month: 13,
      y: 12.3,
      name: "+2sd",
    },
    {
      month: 14,
      y: 12.6,
      name: "+2sd",
    },
    {
      month: 15,
      y: 12.8,
      name: "+2sd",
    },
    {
      month: 16,
      y: 13.1,
      name: "+2sd",
    },
    {
      month: 17,
      y: 13.4,
      name: "+2sd",
    },
    {
      month: 18,
      y: 13.7,
      name: "+2sd",
    },
    {
      month: 19,
      y: 13.9,
      name: "+2sd",
    },
    {
      month: 20,
      y: 14.2,
      name: "+2sd",
    },
    {
      month: 21,
      y: 14.5,
      name: "+2sd",
    },
    {
      month: 22,
      y: 14.7,
      name: "+2sd",
    },
    {
      month: 23,
      y: 15,
      name: "+2sd",
    },
    {
      month: 24,
      y: 15.3,
      name: "+2sd",
    },
    {
      month: 25,
      y: 15.5,
      name: "+2sd",
    },
    {
      month: 26,
      y: 15.8,
      name: "+2sd",
    },
    {
      month: 27,
      y: 16.1,
      name: "+2sd",
    },
    {
      month: 28,
      y: 16.3,
      name: "+2sd",
    },
    {
      month: 29,
      y: 16.6,
      name: "+2sd",
    },
    {
      month: 30,
      y: 16.9,
      name: "+2sd",
    },
    {
      month: 31,
      y: 17.1,
      name: "+2sd",
    },
    {
      month: 32,
      y: 17.4,
      name: "+2sd",
    },
    {
      month: 33,
      y: 17.6,
      name: "+2sd",
    },
    {
      month: 34,
      y: 17.8,
      name: "+2sd",
    },
    {
      month: 35,
      y: 18.1,
      name: "+2sd",
    },
    {
      month: 36,
      y: 18.3,
      name: "+2sd",
    },
    {
      month: 37,
      y: 18.6,
      name: "+2sd",
    },
    {
      month: 38,
      y: 18.8,
      name: "+2sd",
    },
    {
      month: 39,
      y: 19,
      name: "+2sd",
    },
    {
      month: 40,
      y: 19.3,
      name: "+2sd",
    },
    {
      month: 41,
      y: 19.5,
      name: "+2sd",
    },
    {
      month: 42,
      y: 19.7,
      name: "+2sd",
    },
    {
      month: 43,
      y: 20,
      name: "+2sd",
    },
    {
      month: 44,
      y: 20.2,
      name: "+2sd",
    },
    {
      month: 45,
      y: 20.5,
      name: "+2sd",
    },
    {
      month: 46,
      y: 20.7,
      name: "+2sd",
    },
    {
      month: 47,
      y: 20.9,
      name: "+2sd",
    },
    {
      month: 48,
      y: 21.2,
      name: "+2sd",
    },
    {
      month: 49,
      y: 21.4,
      name: "+2sd",
    },
    {
      month: 50,
      y: 21.7,
      name: "+2sd",
    },
    {
      month: 51,
      y: 21.9,
      name: "+2sd",
    },
    {
      month: 52,
      y: 22.2,
      name: "+2sd",
    },
    {
      month: 53,
      y: 22.4,
      name: "+2sd",
    },
    {
      month: 54,
      y: 22.7,
      name: "+2sd",
    },
    {
      month: 55,
      y: 22.9,
      name: "+2sd",
    },
    {
      month: 56,
      y: 23.2,
      name: "+2sd",
    },
    {
      month: 57,
      y: 23.4,
      name: "+2sd",
    },
    {
      month: 58,
      y: 23.7,
      name: "+2sd",
    },
    {
      month: 59,
      y: 23.9,
      name: "+2sd",
    },
    {
      month: 60,
      y: 24.2,
      name: "+2sd",
    },
    {
      month: 61,
      y: 24.165,
      name: "+2sd",
    },
    {
      month: 62,
      y: 24.423,
      name: "+2sd",
    },
    {
      month: 63,
      y: 24.683,
      name: "+2sd",
    },
    {
      month: 64,
      y: 24.946,
      name: "+2sd",
    },
    {
      month: 65,
      y: 25.21,
      name: "+2sd",
    },
    {
      month: 66,
      y: 25.477,
      name: "+2sd",
    },
    {
      month: 67,
      y: 25.747,
      name: "+2sd",
    },
    {
      month: 68,
      y: 26.018,
      name: "+2sd",
    },
    {
      month: 69,
      y: 26.293,
      name: "+2sd",
    },
    {
      month: 70,
      y: 26.569,
      name: "+2sd",
    },
    {
      month: 71,
      y: 26.848,
      name: "+2sd",
    },
    {
      month: 72,
      y: 27.129,
      name: "+2sd",
    },
    {
      month: 73,
      y: 27.412,
      name: "+2sd",
    },
    {
      month: 74,
      y: 27.697,
      name: "+2sd",
    },
    {
      month: 75,
      y: 27.984,
      name: "+2sd",
    },
    {
      month: 76,
      y: 28.275,
      name: "+2sd",
    },
    {
      month: 77,
      y: 28.567,
      name: "+2sd",
    },
    {
      month: 78,
      y: 28.862,
      name: "+2sd",
    },
    {
      month: 79,
      y: 29.161,
      name: "+2sd",
    },
    {
      month: 80,
      y: 29.461,
      name: "+2sd",
    },
    {
      month: 81,
      y: 29.765,
      name: "+2sd",
    },
    {
      month: 82,
      y: 30.072,
      name: "+2sd",
    },
    {
      month: 83,
      y: 30.382,
      name: "+2sd",
    },
    {
      month: 84,
      y: 30.695,
      name: "+2sd",
    },
    {
      month: 85,
      y: 31.011,
      name: "+2sd",
    },
    {
      month: 86,
      y: 31.33,
      name: "+2sd",
    },
    {
      month: 87,
      y: 31.653,
      name: "+2sd",
    },
    {
      month: 88,
      y: 31.979,
      name: "+2sd",
    },
    {
      month: 89,
      y: 32.309,
      name: "+2sd",
    },
    {
      month: 90,
      y: 32.642,
      name: "+2sd",
    },
    {
      month: 91,
      y: 32.979,
      name: "+2sd",
    },
    {
      month: 92,
      y: 33.32,
      name: "+2sd",
    },
    {
      month: 93,
      y: 33.665,
      name: "+2sd",
    },
    {
      month: 94,
      y: 34.015,
      name: "+2sd",
    },
    {
      month: 95,
      y: 34.368,
      name: "+2sd",
    },
    {
      month: 96,
      y: 34.727,
      name: "+2sd",
    },
    {
      month: 97,
      y: 35.091,
      name: "+2sd",
    },
    {
      month: 98,
      y: 35.459,
      name: "+2sd",
    },
    {
      month: 99,
      y: 35.832,
      name: "+2sd",
    },
    {
      month: 100,
      y: 36.21,
      name: "+2sd",
    },
    {
      month: 101,
      y: 36.593,
      name: "+2sd",
    },
    {
      month: 102,
      y: 36.981,
      name: "+2sd",
    },
    {
      month: 103,
      y: 37.376,
      name: "+2sd",
    },
    {
      month: 104,
      y: 37.774,
      name: "+2sd",
    },
    {
      month: 105,
      y: 38.179,
      name: "+2sd",
    },
    {
      month: 106,
      y: 38.591,
      name: "+2sd",
    },
    {
      month: 107,
      y: 39.009,
      name: "+2sd",
    },
    {
      month: 108,
      y: 39.433,
      name: "+2sd",
    },
    {
      month: 109,
      y: 39.864,
      name: "+2sd",
    },
    {
      month: 110,
      y: 40.301,
      name: "+2sd",
    },
    {
      month: 111,
      y: 40.744,
      name: "+2sd",
    },
    {
      month: 112,
      y: 41.195,
      name: "+2sd",
    },
    {
      month: 113,
      y: 41.652,
      name: "+2sd",
    },
    {
      month: 114,
      y: 42.116,
      name: "+2sd",
    },
    {
      month: 115,
      y: 42.587,
      name: "+2sd",
    },
    {
      month: 116,
      y: 43.063,
      name: "+2sd",
    },
    {
      month: 117,
      y: 43.547,
      name: "+2sd",
    },
    {
      month: 118,
      y: 44.038,
      name: "+2sd",
    },
    {
      month: 119,
      y: 44.534,
      name: "+2sd",
    },
    {
      month: 120,
      y: 45.038,
      name: "+2sd",
    },
    {
      month: 156,
      y: 63,
      name: "+2sd",
    },
    {
      month: 192,
      y: 78.5,
      name: "+2sd",
    },
    {
      month: 204,
      y: 83.2,
      name: "+2sd",
    },
    {
      month: 216,
      y: 87,
      name: "+2sd",
    },
    {
      month: 0,
      y: 5,
      name: "+3sd",
    },
    {
      month: 1,
      y: 6.6,
      name: "+3sd",
    },
    {
      month: 2,
      y: 8,
      name: "+3sd",
    },
    {
      month: 3,
      y: 9,
      name: "+3sd",
    },
    {
      month: 4,
      y: 9.7,
      name: "+3sd",
    },
    {
      month: 5,
      y: 10.4,
      name: "+3sd",
    },
    {
      month: 6,
      y: 10.9,
      name: "+3sd",
    },
    {
      month: 7,
      y: 11.4,
      name: "+3sd",
    },
    {
      month: 8,
      y: 11.9,
      name: "+3sd",
    },
    {
      month: 9,
      y: 12.3,
      name: "+3sd",
    },
    {
      month: 10,
      y: 12.7,
      name: "+3sd",
    },
    {
      month: 11,
      y: 13,
      name: "+3sd",
    },
    {
      month: 12,
      y: 13.3,
      name: "+3sd",
    },
    {
      month: 13,
      y: 13.7,
      name: "+3sd",
    },
    {
      month: 14,
      y: 14,
      name: "+3sd",
    },
    {
      month: 15,
      y: 14.3,
      name: "+3sd",
    },
    {
      month: 16,
      y: 14.6,
      name: "+3sd",
    },
    {
      month: 17,
      y: 14.9,
      name: "+3sd",
    },
    {
      month: 18,
      y: 15.3,
      name: "+3sd",
    },
    {
      month: 19,
      y: 15.6,
      name: "+3sd",
    },
    {
      month: 20,
      y: 15.9,
      name: "+3sd",
    },
    {
      month: 21,
      y: 16.2,
      name: "+3sd",
    },
    {
      month: 22,
      y: 16.5,
      name: "+3sd",
    },
    {
      month: 23,
      y: 16.8,
      name: "+3sd",
    },
    {
      month: 24,
      y: 17.1,
      name: "+3sd",
    },
    {
      month: 25,
      y: 17.5,
      name: "+3sd",
    },
    {
      month: 26,
      y: 17.8,
      name: "+3sd",
    },
    {
      month: 27,
      y: 18.1,
      name: "+3sd",
    },
    {
      month: 28,
      y: 18.4,
      name: "+3sd",
    },
    {
      month: 29,
      y: 18.7,
      name: "+3sd",
    },
    {
      month: 30,
      y: 19,
      name: "+3sd",
    },
    {
      month: 31,
      y: 19.3,
      name: "+3sd",
    },
    {
      month: 32,
      y: 19.6,
      name: "+3sd",
    },
    {
      month: 33,
      y: 19.9,
      name: "+3sd",
    },
    {
      month: 34,
      y: 20.2,
      name: "+3sd",
    },
    {
      month: 35,
      y: 20.4,
      name: "+3sd",
    },
    {
      month: 36,
      y: 20.7,
      name: "+3sd",
    },
    {
      month: 37,
      y: 21,
      name: "+3sd",
    },
    {
      month: 38,
      y: 21.3,
      name: "+3sd",
    },
    {
      month: 39,
      y: 21.6,
      name: "+3sd",
    },
    {
      month: 40,
      y: 21.9,
      name: "+3sd",
    },
    {
      month: 41,
      y: 22.1,
      name: "+3sd",
    },
    {
      month: 42,
      y: 22.4,
      name: "+3sd",
    },
    {
      month: 43,
      y: 22.7,
      name: "+3sd",
    },
    {
      month: 44,
      y: 23,
      name: "+3sd",
    },
    {
      month: 45,
      y: 23.3,
      name: "+3sd",
    },
    {
      month: 46,
      y: 23.6,
      name: "+3sd",
    },
    {
      month: 47,
      y: 23.9,
      name: "+3sd",
    },
    {
      month: 48,
      y: 24.2,
      name: "+3sd",
    },
    {
      month: 49,
      y: 24.5,
      name: "+3sd",
    },
    {
      month: 50,
      y: 24.8,
      name: "+3sd",
    },
    {
      month: 51,
      y: 25.1,
      name: "+3sd",
    },
    {
      month: 52,
      y: 25.4,
      name: "+3sd",
    },
    {
      month: 53,
      y: 25.7,
      name: "+3sd",
    },
    {
      month: 54,
      y: 26,
      name: "+3sd",
    },
    {
      month: 55,
      y: 26.3,
      name: "+3sd",
    },
    {
      month: 56,
      y: 26.6,
      name: "+3sd",
    },
    {
      month: 57,
      y: 26.9,
      name: "+3sd",
    },
    {
      month: 58,
      y: 27.2,
      name: "+3sd",
    },
    {
      month: 59,
      y: 27.6,
      name: "+3sd",
    },
    {
      month: 60,
      y: 27.9,
      name: "+3sd",
    },
    {
      month: 61,
      y: 27.77,
      name: "+3sd",
    },
    {
      month: 62,
      y: 28.093,
      name: "+3sd",
    },
    {
      month: 63,
      y: 28.42,
      name: "+3sd",
    },
    {
      month: 64,
      y: 28.75,
      name: "+3sd",
    },
    {
      month: 65,
      y: 29.083,
      name: "+3sd",
    },
    {
      month: 66,
      y: 29.42,
      name: "+3sd",
    },
    {
      month: 67,
      y: 29.76,
      name: "+3sd",
    },
    {
      month: 68,
      y: 30.102,
      name: "+3sd",
    },
    {
      month: 69,
      y: 30.449,
      name: "+3sd",
    },
    {
      month: 70,
      y: 30.799,
      name: "+3sd",
    },
    {
      month: 71,
      y: 31.153,
      name: "+3sd",
    },
    {
      month: 72,
      y: 31.508,
      name: "+3sd",
    },
    {
      month: 73,
      y: 31.868,
      name: "+3sd",
    },
    {
      month: 74,
      y: 32.231,
      name: "+3sd",
    },
    {
      month: 75,
      y: 32.598,
      name: "+3sd",
    },
    {
      month: 76,
      y: 32.969,
      name: "+3sd",
    },
    {
      month: 77,
      y: 33.343,
      name: "+3sd",
    },
    {
      month: 78,
      y: 33.723,
      name: "+3sd",
    },
    {
      month: 79,
      y: 34.107,
      name: "+3sd",
    },
    {
      month: 80,
      y: 34.495,
      name: "+3sd",
    },
    {
      month: 81,
      y: 34.889,
      name: "+3sd",
    },
    {
      month: 82,
      y: 35.287,
      name: "+3sd",
    },
    {
      month: 83,
      y: 35.692,
      name: "+3sd",
    },
    {
      month: 84,
      y: 36.1,
      name: "+3sd",
    },
    {
      month: 85,
      y: 36.515,
      name: "+3sd",
    },
    {
      month: 86,
      y: 36.936,
      name: "+3sd",
    },
    {
      month: 87,
      y: 37.363,
      name: "+3sd",
    },
    {
      month: 88,
      y: 37.795,
      name: "+3sd",
    },
    {
      month: 89,
      y: 38.236,
      name: "+3sd",
    },
    {
      month: 90,
      y: 38.682,
      name: "+3sd",
    },
    {
      month: 91,
      y: 39.135,
      name: "+3sd",
    },
    {
      month: 92,
      y: 39.597,
      name: "+3sd",
    },
    {
      month: 93,
      y: 40.065,
      name: "+3sd",
    },
    {
      month: 94,
      y: 40.542,
      name: "+3sd",
    },
    {
      month: 95,
      y: 41.027,
      name: "+3sd",
    },
    {
      month: 96,
      y: 41.521,
      name: "+3sd",
    },
    {
      month: 97,
      y: 42.025,
      name: "+3sd",
    },
    {
      month: 98,
      y: 42.538,
      name: "+3sd",
    },
    {
      month: 99,
      y: 43.06,
      name: "+3sd",
    },
    {
      month: 100,
      y: 43.591,
      name: "+3sd",
    },
    {
      month: 101,
      y: 44.131,
      name: "+3sd",
    },
    {
      month: 102,
      y: 44.682,
      name: "+3sd",
    },
    {
      month: 103,
      y: 45.244,
      name: "+3sd",
    },
    {
      month: 104,
      y: 45.815,
      name: "+3sd",
    },
    {
      month: 105,
      y: 46.397,
      name: "+3sd",
    },
    {
      month: 106,
      y: 46.992,
      name: "+3sd",
    },
    {
      month: 107,
      y: 47.598,
      name: "+3sd",
    },
    {
      month: 108,
      y: 48.214,
      name: "+3sd",
    },
    {
      month: 109,
      y: 48.843,
      name: "+3sd",
    },
    {
      month: 110,
      y: 49.483,
      name: "+3sd",
    },
    {
      month: 111,
      y: 50.132,
      name: "+3sd",
    },
    {
      month: 112,
      y: 50.792,
      name: "+3sd",
    },
    {
      month: 113,
      y: 51.463,
      name: "+3sd",
    },
    {
      month: 114,
      y: 52.146,
      name: "+3sd",
    },

    {
      month: 156,
      y: 74,
      name: "+3sd",
    },
    {
      month: 192,
      y: 88,
      name: "+3sd",
    },
    {
      month: 204,
      y: 92,
      name: "+3sd",
    },
    {
      month: 216,
      y: 95.5,
      name: "+3sd",
    },
  ],

  girls_size: [
    {
      month: 0,
      y: 43.6,
      name: "-3sd",
    },
    {
      month: 1,
      y: 47.8,
      name: "-3sd",
    },
    {
      month: 2,
      y: 51,
      name: "-3sd",
    },
    {
      month: 3,
      y: 53.5,
      name: "-3sd",
    },
    {
      month: 4,
      y: 55.6,
      name: "-3sd",
    },
    {
      month: 5,
      y: 57.4,
      name: "-3sd",
    },
    {
      month: 6,
      y: 58.9,
      name: "-3sd",
    },
    {
      month: 7,
      y: 60.3,
      name: "-3sd",
    },
    {
      month: 8,
      y: 61.7,
      name: "-3sd",
    },
    {
      month: 9,
      y: 62.9,
      name: "-3sd",
    },
    {
      month: 10,
      y: 64.1,
      name: "-3sd",
    },
    {
      month: 11,
      y: 65.2,
      name: "-3sd",
    },
    {
      month: 12,
      y: 66.3,
      name: "-3sd",
    },
    {
      month: 13,
      y: 67.3,
      name: "-3sd",
    },
    {
      month: 14,
      y: 68.3,
      name: "-3sd",
    },
    {
      month: 15,
      y: 69.3,
      name: "-3sd",
    },
    {
      month: 16,
      y: 70.2,
      name: "-3sd",
    },
    {
      month: 17,
      y: 71.1,
      name: "-3sd",
    },
    {
      month: 18,
      y: 72,
      name: "-3sd",
    },
    {
      month: 19,
      y: 72.8,
      name: "-3sd",
    },
    {
      month: 20,
      y: 73.7,
      name: "-3sd",
    },
    {
      month: 21,
      y: 74.5,
      name: "-3sd",
    },
    {
      month: 22,
      y: 75.2,
      name: "-3sd",
    },
    {
      month: 23,
      y: 76,
      name: "-3sd",
    },
    {
      month: 24,
      y: 76.7,
      name: "-3sd",
    },
    {
      month: 25,
      y: 76.8,
      name: "-3sd",
    },
    {
      month: 26,
      y: 77.5,
      name: "-3sd",
    },
    {
      month: 27,
      y: 78.1,
      name: "-3sd",
    },
    {
      month: 28,
      y: 78.8,
      name: "-3sd",
    },
    {
      month: 29,
      y: 79.5,
      name: "-3sd",
    },
    {
      month: 30,
      y: 80.1,
      name: "-3sd",
    },
    {
      month: 31,
      y: 80.7,
      name: "-3sd",
    },
    {
      month: 32,
      y: 81.3,
      name: "-3sd",
    },
    {
      month: 33,
      y: 81.9,
      name: "-3sd",
    },
    {
      month: 34,
      y: 82.5,
      name: "-3sd",
    },
    {
      month: 35,
      y: 83.1,
      name: "-3sd",
    },
    {
      month: 36,
      y: 83.6,
      name: "-3sd",
    },
    {
      month: 37,
      y: 84.2,
      name: "-3sd",
    },
    {
      month: 38,
      y: 84.7,
      name: "-3sd",
    },
    {
      month: 39,
      y: 85.3,
      name: "-3sd",
    },
    {
      month: 40,
      y: 85.8,
      name: "-3sd",
    },
    {
      month: 41,
      y: 86.3,
      name: "-3sd",
    },
    {
      month: 42,
      y: 86.8,
      name: "-3sd",
    },
    {
      month: 43,
      y: 87.4,
      name: "-3sd",
    },
    {
      month: 44,
      y: 87.9,
      name: "-3sd",
    },
    {
      month: 45,
      y: 88.4,
      name: "-3sd",
    },
    {
      month: 46,
      y: 88.9,
      name: "-3sd",
    },
    {
      month: 47,
      y: 89.3,
      name: "-3sd",
    },
    {
      month: 48,
      y: 89.8,
      name: "-3sd",
    },
    {
      month: 49,
      y: 90.3,
      name: "-3sd",
    },
    {
      month: 50,
      y: 90.7,
      name: "-3sd",
    },
    {
      month: 51,
      y: 91.2,
      name: "-3sd",
    },
    {
      month: 52,
      y: 91.7,
      name: "-3sd",
    },
    {
      month: 53,
      y: 92.1,
      name: "-3sd",
    },
    {
      month: 54,
      y: 92.6,
      name: "-3sd",
    },
    {
      month: 55,
      y: 93,
      name: "-3sd",
    },
    {
      month: 56,
      y: 93.4,
      name: "-3sd",
    },
    {
      month: 57,
      y: 93.9,
      name: "-3sd",
    },
    {
      month: 58,
      y: 94.3,
      name: "-3sd",
    },
    {
      month: 59,
      y: 94.7,
      name: "-3sd",
    },
    {
      month: 60,
      y: 95.2,
      name: "-3sd",
    },
    {
      month: 61,
      y: 95.282,
      name: "-3sd",
    },
    {
      month: 62,
      y: 95.708,
      name: "-3sd",
    },
    {
      month: 63,
      y: 96.13,
      name: "-3sd",
    },
    {
      month: 64,
      y: 96.547,
      name: "-3sd",
    },
    {
      month: 65,
      y: 96.963,
      name: "-3sd",
    },
    {
      month: 66,
      y: 97.372,
      name: "-3sd",
    },
    {
      month: 67,
      y: 97.78,
      name: "-3sd",
    },
    {
      month: 68,
      y: 98.184,
      name: "-3sd",
    },
    {
      month: 69,
      y: 98.585,
      name: "-3sd",
    },
    {
      month: 70,
      y: 98.982,
      name: "-3sd",
    },
    {
      month: 71,
      y: 99.375,
      name: "-3sd",
    },
    {
      month: 72,
      y: 99.766,
      name: "-3sd",
    },
    {
      month: 73,
      y: 100.157,
      name: "-3sd",
    },
    {
      month: 74,
      y: 100.546,
      name: "-3sd",
    },
    {
      month: 75,
      y: 100.93,
      name: "-3sd",
    },
    {
      month: 76,
      y: 101.32,
      name: "-3sd",
    },
    {
      month: 77,
      y: 101.705,
      name: "-3sd",
    },
    {
      month: 78,
      y: 102.089,
      name: "-3sd",
    },
    {
      month: 79,
      y: 102.476,
      name: "-3sd",
    },
    {
      month: 80,
      y: 102.859,
      name: "-3sd",
    },
    {
      month: 81,
      y: 103.246,
      name: "-3sd",
    },
    {
      month: 82,
      y: 103.633,
      name: "-3sd",
    },
    {
      month: 83,
      y: 104.02,
      name: "-3sd",
    },
    {
      month: 84,
      y: 104.41,
      name: "-3sd",
    },
    {
      month: 85,
      y: 104.798,
      name: "-3sd",
    },
    {
      month: 86,
      y: 105.19,
      name: "-3sd",
    },
    {
      month: 87,
      y: 105.578,
      name: "-3sd",
    },
    {
      month: 88,
      y: 105.971,
      name: "-3sd",
    },
    {
      month: 89,
      y: 106.368,
      name: "-3sd",
    },
    {
      month: 90,
      y: 106.762,
      name: "-3sd",
    },
    {
      month: 91,
      y: 107.157,
      name: "-3sd",
    },
    {
      month: 92,
      y: 107.556,
      name: "-3sd",
    },
    {
      month: 93,
      y: 107.956,
      name: "-3sd",
    },
    {
      month: 94,
      y: 108.358,
      name: "-3sd",
    },
    {
      month: 95,
      y: 108.76,
      name: "-3sd",
    },
    {
      month: 96,
      y: 109.163,
      name: "-3sd",
    },
    {
      month: 97,
      y: 109.568,
      name: "-3sd",
    },
    {
      month: 98,
      y: 109.977,
      name: "-3sd",
    },
    {
      month: 99,
      y: 110.388,
      name: "-3sd",
    },
    {
      month: 100,
      y: 110.8,
      name: "-3sd",
    },
    {
      month: 101,
      y: 111.213,
      name: "-3sd",
    },
    {
      month: 102,
      y: 111.627,
      name: "-3sd",
    },
    {
      month: 103,
      y: 112.046,
      name: "-3sd",
    },
    {
      month: 104,
      y: 112.467,
      name: "-3sd",
    },
    {
      month: 105,
      y: 112.885,
      name: "-3sd",
    },
    {
      month: 106,
      y: 113.312,
      name: "-3sd",
    },
    {
      month: 107,
      y: 113.737,
      name: "-3sd",
    },
    {
      month: 108,
      y: 114.162,
      name: "-3sd",
    },
    {
      month: 109,
      y: 114.593,
      name: "-3sd",
    },
    {
      month: 110,
      y: 115.025,
      name: "-3sd",
    },
    {
      month: 111,
      y: 115.458,
      name: "-3sd",
    },
    {
      month: 112,
      y: 115.892,
      name: "-3sd",
    },
    {
      month: 113,
      y: 116.331,
      name: "-3sd",
    },
    {
      month: 114,
      y: 116.767,
      name: "-3sd",
    },
    {
      month: 115,
      y: 117.209,
      name: "-3sd",
    },
    {
      month: 116,
      y: 117.655,
      name: "-3sd",
    },
    {
      month: 117,
      y: 118.099,
      name: "-3sd",
    },
    {
      month: 118,
      y: 118.544,
      name: "-3sd",
    },
    {
      month: 119,
      y: 118.994,
      name: "-3sd",
    },
    {
      month: 120,
      y: 119.446,
      name: "-3sd",
    },
    {
      month: 121,
      y: 119.904,
      name: "-3sd",
    },
    {
      month: 122,
      y: 120.358,
      name: "-3sd",
    },
    {
      month: 123,
      y: 120.819,
      name: "-3sd",
    },
    {
      month: 124,
      y: 121.281,
      name: "-3sd",
    },
    {
      month: 125,
      y: 121.744,
      name: "-3sd",
    },
    {
      month: 126,
      y: 122.21,
      name: "-3sd",
    },
    {
      month: 127,
      y: 122.68,
      name: "-3sd",
    },
    {
      month: 128,
      y: 123.152,
      name: "-3sd",
    },
    {
      month: 129,
      y: 123.626,
      name: "-3sd",
    },
    {
      month: 130,
      y: 124.1,
      name: "-3sd",
    },
    {
      month: 131,
      y: 124.574,
      name: "-3sd",
    },
    {
      month: 132,
      y: 125.053,
      name: "-3sd",
    },
    {
      month: 133,
      y: 125.532,
      name: "-3sd",
    },
    {
      month: 134,
      y: 126.011,
      name: "-3sd",
    },
    {
      month: 135,
      y: 126.493,
      name: "-3sd",
    },
    {
      month: 136,
      y: 126.968,
      name: "-3sd",
    },
    {
      month: 137,
      y: 127.447,
      name: "-3sd",
    },
    {
      month: 138,
      y: 127.923,
      name: "-3sd",
    },
    {
      month: 139,
      y: 128.396,
      name: "-3sd",
    },
    {
      month: 140,
      y: 128.869,
      name: "-3sd",
    },
    {
      month: 141,
      y: 129.334,
      name: "-3sd",
    },
    {
      month: 142,
      y: 129.799,
      name: "-3sd",
    },
    {
      month: 143,
      y: 130.258,
      name: "-3sd",
    },
    {
      month: 144,
      y: 130.712,
      name: "-3sd",
    },
    {
      month: 145,
      y: 131.163,
      name: "-3sd",
    },
    {
      month: 146,
      y: 131.603,
      name: "-3sd",
    },
    {
      month: 147,
      y: 132.04,
      name: "-3sd",
    },
    {
      month: 148,
      y: 132.463,
      name: "-3sd",
    },
    {
      month: 149,
      y: 132.882,
      name: "-3sd",
    },
    {
      month: 150,
      y: 133.292,
      name: "-3sd",
    },
    {
      month: 151,
      y: 133.692,
      name: "-3sd",
    },
    {
      month: 152,
      y: 134.087,
      name: "-3sd",
    },
    {
      month: 153,
      y: 134.467,
      name: "-3sd",
    },
    {
      month: 154,
      y: 134.837,
      name: "-3sd",
    },
    {
      month: 155,
      y: 135.201,
      name: "-3sd",
    },
    {
      month: 156,
      y: 135.55,
      name: "-3sd",
    },
    {
      month: 157,
      y: 135.893,
      name: "-3sd",
    },
    {
      month: 158,
      y: 136.225,
      name: "-3sd",
    },
    {
      month: 159,
      y: 136.547,
      name: "-3sd",
    },
    {
      month: 160,
      y: 136.853,
      name: "-3sd",
    },
    {
      month: 161,
      y: 137.153,
      name: "-3sd",
    },
    {
      month: 162,
      y: 137.442,
      name: "-3sd",
    },
    {
      month: 163,
      y: 137.721,
      name: "-3sd",
    },
    {
      month: 164,
      y: 137.99,
      name: "-3sd",
    },
    {
      month: 165,
      y: 138.243,
      name: "-3sd",
    },
    {
      month: 166,
      y: 138.492,
      name: "-3sd",
    },
    {
      month: 167,
      y: 138.731,
      name: "-3sd",
    },
    {
      month: 168,
      y: 138.961,
      name: "-3sd",
    },
    {
      month: 169,
      y: 139.181,
      name: "-3sd",
    },
    {
      month: 170,
      y: 139.387,
      name: "-3sd",
    },
    {
      month: 171,
      y: 139.59,
      name: "-3sd",
    },
    {
      month: 172,
      y: 139.784,
      name: "-3sd",
    },
    {
      month: 173,
      y: 139.965,
      name: "-3sd",
    },
    {
      month: 174,
      y: 140.142,
      name: "-3sd",
    },
    {
      month: 175,
      y: 140.307,
      name: "-3sd",
    },
    {
      month: 176,
      y: 140.469,
      name: "-3sd",
    },
    {
      month: 177,
      y: 140.619,
      name: "-3sd",
    },
    {
      month: 178,
      y: 140.762,
      name: "-3sd",
    },
    {
      month: 179,
      y: 140.898,
      name: "-3sd",
    },
    {
      month: 180,
      y: 141.032,
      name: "-3sd",
    },
    {
      month: 181,
      y: 141.156,
      name: "-3sd",
    },
    {
      month: 182,
      y: 141.273,
      name: "-3sd",
    },
    {
      month: 183,
      y: 141.38,
      name: "-3sd",
    },
    {
      month: 184,
      y: 141.486,
      name: "-3sd",
    },
    {
      month: 185,
      y: 141.588,
      name: "-3sd",
    },
    {
      month: 186,
      y: 141.684,
      name: "-3sd",
    },
    {
      month: 187,
      y: 141.771,
      name: "-3sd",
    },
    {
      month: 188,
      y: 141.859,
      name: "-3sd",
    },
    {
      month: 189,
      y: 141.937,
      name: "-3sd",
    },
    {
      month: 190,
      y: 142.012,
      name: "-3sd",
    },
    {
      month: 191,
      y: 142.088,
      name: "-3sd",
    },
    {
      month: 192,
      y: 142.156,
      name: "-3sd",
    },
    {
      month: 193,
      y: 142.22,
      name: "-3sd",
    },
    {
      month: 194,
      y: 142.282,
      name: "-3sd",
    },
    {
      month: 195,
      y: 142.341,
      name: "-3sd",
    },
    {
      month: 196,
      y: 142.399,
      name: "-3sd",
    },
    {
      month: 197,
      y: 142.449,
      name: "-3sd",
    },
    {
      month: 198,
      y: 142.502,
      name: "-3sd",
    },
    {
      month: 199,
      y: 142.549,
      name: "-3sd",
    },
    {
      month: 200,
      y: 142.6,
      name: "-3sd",
    },
    {
      month: 201,
      y: 142.645,
      name: "-3sd",
    },
    {
      month: 202,
      y: 142.694,
      name: "-3sd",
    },
    {
      month: 203,
      y: 142.737,
      name: "-3sd",
    },
    {
      month: 204,
      y: 142.779,
      name: "-3sd",
    },
    {
      month: 205,
      y: 142.821,
      name: "-3sd",
    },
    {
      month: 206,
      y: 142.862,
      name: "-3sd",
    },
    {
      month: 207,
      y: 142.903,
      name: "-3sd",
    },
    {
      month: 208,
      y: 142.943,
      name: "-3sd",
    },
    {
      month: 209,
      y: 142.983,
      name: "-3sd",
    },
    {
      month: 210,
      y: 143.018,
      name: "-3sd",
    },
    {
      month: 211,
      y: 143.057,
      name: "-3sd",
    },
    {
      month: 212,
      y: 143.091,
      name: "-3sd",
    },
    {
      month: 213,
      y: 143.13,
      name: "-3sd",
    },
    {
      month: 214,
      y: 143.163,
      name: "-3sd",
    },
    {
      month: 215,
      y: 143.196,
      name: "-3sd",
    },
    {
      month: 216,
      y: 143.233,
      name: "-3sd",
    },
    {
      month: 217,
      y: 143.265,
      name: "-3sd",
    },
    {
      month: 218,
      y: 143.296,
      name: "-3sd",
    },
    {
      month: 219,
      y: 143.326,
      name: "-3sd",
    },
    {
      month: 220,
      y: 143.355,
      name: "-3sd",
    },
    {
      month: 221,
      y: 143.379,
      name: "-3sd",
    },
    {
      month: 222,
      y: 143.406,
      name: "-3sd",
    },
    {
      month: 223,
      y: 143.432,
      name: "-3sd",
    },
    {
      month: 224,
      y: 143.452,
      name: "-3sd",
    },
    {
      month: 225,
      y: 143.476,
      name: "-3sd",
    },
    {
      month: 226,
      y: 143.494,
      name: "-3sd",
    },
    {
      month: 227,
      y: 143.516,
      name: "-3sd",
    },
    {
      month: 228,
      y: 143.532,
      name: "-3sd",
    },
    {
      month: 0,
      y: 45.4,
      name: "-2sd",
    },
    {
      month: 1,
      y: 49.8,
      name: "-2sd",
    },
    {
      month: 2,
      y: 53,
      name: "-2sd",
    },
    {
      month: 3,
      y: 55.6,
      name: "-2sd",
    },
    {
      month: 4,
      y: 57.8,
      name: "-2sd",
    },
    {
      month: 5,
      y: 59.6,
      name: "-2sd",
    },
    {
      month: 6,
      y: 61.2,
      name: "-2sd",
    },
    {
      month: 7,
      y: 62.7,
      name: "-2sd",
    },
    {
      month: 8,
      y: 64,
      name: "-2sd",
    },
    {
      month: 9,
      y: 65.3,
      name: "-2sd",
    },
    {
      month: 10,
      y: 66.5,
      name: "-2sd",
    },
    {
      month: 11,
      y: 67.7,
      name: "-2sd",
    },
    {
      month: 12,
      y: 68.9,
      name: "-2sd",
    },
    {
      month: 13,
      y: 70,
      name: "-2sd",
    },
    {
      month: 14,
      y: 71,
      name: "-2sd",
    },
    {
      month: 15,
      y: 72,
      name: "-2sd",
    },
    {
      month: 16,
      y: 73,
      name: "-2sd",
    },
    {
      month: 17,
      y: 74,
      name: "-2sd",
    },
    {
      month: 18,
      y: 74.9,
      name: "-2sd",
    },
    {
      month: 19,
      y: 75.8,
      name: "-2sd",
    },
    {
      month: 20,
      y: 76.7,
      name: "-2sd",
    },
    {
      month: 21,
      y: 77.5,
      name: "-2sd",
    },
    {
      month: 22,
      y: 78.4,
      name: "-2sd",
    },
    {
      month: 23,
      y: 79.2,
      name: "-2sd",
    },
    {
      month: 24,
      y: 79.3,
      name: "-2sd",
    },
    {
      month: 25,
      y: 80,
      name: "-2sd",
    },
    {
      month: 26,
      y: 80.8,
      name: "-2sd",
    },
    {
      month: 27,
      y: 81.5,
      name: "-2sd",
    },
    {
      month: 28,
      y: 82.2,
      name: "-2sd",
    },
    {
      month: 29,
      y: 82.9,
      name: "-2sd",
    },
    {
      month: 30,
      y: 83.6,
      name: "-2sd",
    },
    {
      month: 31,
      y: 84.3,
      name: "-2sd",
    },
    {
      month: 32,
      y: 84.9,
      name: "-2sd",
    },
    {
      month: 33,
      y: 85.6,
      name: "-2sd",
    },
    {
      month: 34,
      y: 86.2,
      name: "-2sd",
    },
    {
      month: 35,
      y: 86.8,
      name: "-2sd",
    },
    {
      month: 36,
      y: 87.4,
      name: "-2sd",
    },
    {
      month: 37,
      y: 88,
      name: "-2sd",
    },
    {
      month: 38,
      y: 88.6,
      name: "-2sd",
    },
    {
      month: 39,
      y: 89.2,
      name: "-2sd",
    },
    {
      month: 40,
      y: 89.8,
      name: "-2sd",
    },
    {
      month: 41,
      y: 90.4,
      name: "-2sd",
    },
    {
      month: 42,
      y: 90.9,
      name: "-2sd",
    },
    {
      month: 43,
      y: 91.5,
      name: "-2sd",
    },
    {
      month: 44,
      y: 92,
      name: "-2sd",
    },
    {
      month: 45,
      y: 92.5,
      name: "-2sd",
    },
    {
      month: 46,
      y: 93.1,
      name: "-2sd",
    },
    {
      month: 47,
      y: 93.6,
      name: "-2sd",
    },
    {
      month: 48,
      y: 94.1,
      name: "-2sd",
    },
    {
      month: 49,
      y: 94.6,
      name: "-2sd",
    },
    {
      month: 50,
      y: 95.1,
      name: "-2sd",
    },
    {
      month: 51,
      y: 95.6,
      name: "-2sd",
    },
    {
      month: 52,
      y: 96.1,
      name: "-2sd",
    },
    {
      month: 53,
      y: 96.6,
      name: "-2sd",
    },
    {
      month: 54,
      y: 97.1,
      name: "-2sd",
    },
    {
      month: 55,
      y: 97.6,
      name: "-2sd",
    },
    {
      month: 56,
      y: 98.1,
      name: "-2sd",
    },
    {
      month: 57,
      y: 98.5,
      name: "-2sd",
    },
    {
      month: 58,
      y: 99,
      name: "-2sd",
    },
    {
      month: 59,
      y: 99.5,
      name: "-2sd",
    },
    {
      month: 60,
      y: 99.9,
      name: "-2sd",
    },
    {
      month: 61,
      y: 100.055,
      name: "-2sd",
    },
    {
      month: 62,
      y: 100.514,
      name: "-2sd",
    },
    {
      month: 63,
      y: 100.968,
      name: "-2sd",
    },
    {
      month: 64,
      y: 101.418,
      name: "-2sd",
    },
    {
      month: 65,
      y: 101.865,
      name: "-2sd",
    },
    {
      month: 66,
      y: 102.306,
      name: "-2sd",
    },
    {
      month: 67,
      y: 102.745,
      name: "-2sd",
    },
    {
      month: 68,
      y: 103.181,
      name: "-2sd",
    },
    {
      month: 69,
      y: 103.612,
      name: "-2sd",
    },
    {
      month: 70,
      y: 104.04,
      name: "-2sd",
    },
    {
      month: 71,
      y: 104.464,
      name: "-2sd",
    },
    {
      month: 72,
      y: 104.885,
      name: "-2sd",
    },
    {
      month: 73,
      y: 105.306,
      name: "-2sd",
    },
    {
      month: 74,
      y: 105.724,
      name: "-2sd",
    },
    {
      month: 75,
      y: 106.139,
      name: "-2sd",
    },
    {
      month: 76,
      y: 106.557,
      name: "-2sd",
    },
    {
      month: 77,
      y: 106.971,
      name: "-2sd",
    },
    {
      month: 78,
      y: 107.385,
      name: "-2sd",
    },
    {
      month: 79,
      y: 107.8,
      name: "-2sd",
    },
    {
      month: 80,
      y: 108.213,
      name: "-2sd",
    },
    {
      month: 81,
      y: 108.628,
      name: "-2sd",
    },
    {
      month: 82,
      y: 109.043,
      name: "-2sd",
    },
    {
      month: 83,
      y: 109.459,
      name: "-2sd",
    },
    {
      month: 84,
      y: 109.877,
      name: "-2sd",
    },
    {
      month: 85,
      y: 110.294,
      name: "-2sd",
    },
    {
      month: 86,
      y: 110.713,
      name: "-2sd",
    },
    {
      month: 87,
      y: 111.13,
      name: "-2sd",
    },
    {
      month: 88,
      y: 111.551,
      name: "-2sd",
    },
    {
      month: 89,
      y: 111.974,
      name: "-2sd",
    },
    {
      month: 90,
      y: 112.396,
      name: "-2sd",
    },
    {
      month: 91,
      y: 112.819,
      name: "-2sd",
    },
    {
      month: 92,
      y: 113.245,
      name: "-2sd",
    },
    {
      month: 93,
      y: 113.672,
      name: "-2sd",
    },
    {
      month: 94,
      y: 114.101,
      name: "-2sd",
    },
    {
      month: 95,
      y: 114.53,
      name: "-2sd",
    },
    {
      month: 96,
      y: 114.961,
      name: "-2sd",
    },
    {
      month: 97,
      y: 115.393,
      name: "-2sd",
    },
    {
      month: 98,
      y: 115.828,
      name: "-2sd",
    },
    {
      month: 99,
      y: 116.265,
      name: "-2sd",
    },
    {
      month: 100,
      y: 116.703,
      name: "-2sd",
    },
    {
      month: 101,
      y: 117.143,
      name: "-2sd",
    },
    {
      month: 102,
      y: 117.584,
      name: "-2sd",
    },
    {
      month: 103,
      y: 118.029,
      name: "-2sd",
    },
    {
      month: 104,
      y: 118.475,
      name: "-2sd",
    },
    {
      month: 105,
      y: 118.92,
      name: "-2sd",
    },
    {
      month: 106,
      y: 119.371,
      name: "-2sd",
    },
    {
      month: 107,
      y: 119.822,
      name: "-2sd",
    },
    {
      month: 108,
      y: 120.273,
      name: "-2sd",
    },
    {
      month: 109,
      y: 120.728,
      name: "-2sd",
    },
    {
      month: 110,
      y: 121.185,
      name: "-2sd",
    },
    {
      month: 111,
      y: 121.643,
      name: "-2sd",
    },
    {
      month: 112,
      y: 122.101,
      name: "-2sd",
    },
    {
      month: 113,
      y: 122.564,
      name: "-2sd",
    },
    {
      month: 114,
      y: 123.025,
      name: "-2sd",
    },
    {
      month: 115,
      y: 123.49,
      name: "-2sd",
    },
    {
      month: 116,
      y: 123.959,
      name: "-2sd",
    },
    {
      month: 117,
      y: 124.427,
      name: "-2sd",
    },
    {
      month: 118,
      y: 124.896,
      name: "-2sd",
    },
    {
      month: 119,
      y: 125.369,
      name: "-2sd",
    },
    {
      month: 120,
      y: 125.843,
      name: "-2sd",
    },
    {
      month: 121,
      y: 126.322,
      name: "-2sd",
    },
    {
      month: 122,
      y: 126.799,
      name: "-2sd",
    },
    {
      month: 123,
      y: 127.281,
      name: "-2sd",
    },
    {
      month: 124,
      y: 127.764,
      name: "-2sd",
    },
    {
      month: 125,
      y: 128.249,
      name: "-2sd",
    },
    {
      month: 126,
      y: 128.736,
      name: "-2sd",
    },
    {
      month: 127,
      y: 129.227,
      name: "-2sd",
    },
    {
      month: 128,
      y: 129.719,
      name: "-2sd",
    },
    {
      month: 129,
      y: 130.213,
      name: "-2sd",
    },
    {
      month: 130,
      y: 130.707,
      name: "-2sd",
    },
    {
      month: 131,
      y: 131.202,
      name: "-2sd",
    },
    {
      month: 132,
      y: 131.7,
      name: "-2sd",
    },
    {
      month: 133,
      y: 132.198,
      name: "-2sd",
    },
    {
      month: 134,
      y: 132.695,
      name: "-2sd",
    },
    {
      month: 135,
      y: 133.193,
      name: "-2sd",
    },
    {
      month: 136,
      y: 133.688,
      name: "-2sd",
    },
    {
      month: 137,
      y: 134.183,
      name: "-2sd",
    },
    {
      month: 138,
      y: 134.675,
      name: "-2sd",
    },
    {
      month: 139,
      y: 135.164,
      name: "-2sd",
    },
    {
      month: 140,
      y: 135.653,
      name: "-2sd",
    },
    {
      month: 141,
      y: 136.134,
      name: "-2sd",
    },
    {
      month: 142,
      y: 136.612,
      name: "-2sd",
    },
    {
      month: 143,
      y: 137.085,
      name: "-2sd",
    },
    {
      month: 144,
      y: 137.552,
      name: "-2sd",
    },
    {
      month: 145,
      y: 138.015,
      name: "-2sd",
    },
    {
      month: 146,
      y: 138.467,
      name: "-2sd",
    },
    {
      month: 147,
      y: 138.914,
      name: "-2sd",
    },
    {
      month: 148,
      y: 139.349,
      name: "-2sd",
    },
    {
      month: 149,
      y: 139.777,
      name: "-2sd",
    },
    {
      month: 150,
      y: 140.196,
      name: "-2sd",
    },
    {
      month: 151,
      y: 140.605,
      name: "-2sd",
    },
    {
      month: 152,
      y: 141.006,
      name: "-2sd",
    },
    {
      month: 153,
      y: 141.393,
      name: "-2sd",
    },
    {
      month: 154,
      y: 141.769,
      name: "-2sd",
    },
    {
      month: 155,
      y: 142.138,
      name: "-2sd",
    },
    {
      month: 156,
      y: 142.492,
      name: "-2sd",
    },
    {
      month: 157,
      y: 142.838,
      name: "-2sd",
    },
    {
      month: 158,
      y: 143.172,
      name: "-2sd",
    },
    {
      month: 159,
      y: 143.496,
      name: "-2sd",
    },
    {
      month: 160,
      y: 143.805,
      name: "-2sd",
    },
    {
      month: 161,
      y: 144.105,
      name: "-2sd",
    },
    {
      month: 162,
      y: 144.395,
      name: "-2sd",
    },
    {
      month: 163,
      y: 144.673,
      name: "-2sd",
    },
    {
      month: 164,
      y: 144.941,
      name: "-2sd",
    },
    {
      month: 165,
      y: 145.194,
      name: "-2sd",
    },
    {
      month: 166,
      y: 145.441,
      name: "-2sd",
    },
    {
      month: 167,
      y: 145.677,
      name: "-2sd",
    },
    {
      month: 168,
      y: 145.903,
      name: "-2sd",
    },
    {
      month: 169,
      y: 146.12,
      name: "-2sd",
    },
    {
      month: 170,
      y: 146.324,
      name: "-2sd",
    },
    {
      month: 171,
      y: 146.522,
      name: "-2sd",
    },
    {
      month: 172,
      y: 146.711,
      name: "-2sd",
    },
    {
      month: 173,
      y: 146.888,
      name: "-2sd",
    },
    {
      month: 174,
      y: 147.059,
      name: "-2sd",
    },
    {
      month: 175,
      y: 147.219,
      name: "-2sd",
    },
    {
      month: 176,
      y: 147.374,
      name: "-2sd",
    },
    {
      month: 177,
      y: 147.518,
      name: "-2sd",
    },
    {
      month: 178,
      y: 147.655,
      name: "-2sd",
    },
    {
      month: 179,
      y: 147.785,
      name: "-2sd",
    },
    {
      month: 180,
      y: 147.911,
      name: "-2sd",
    },
    {
      month: 181,
      y: 148.028,
      name: "-2sd",
    },
    {
      month: 182,
      y: 148.138,
      name: "-2sd",
    },
    {
      month: 183,
      y: 148.239,
      name: "-2sd",
    },
    {
      month: 184,
      y: 148.337,
      name: "-2sd",
    },
    {
      month: 185,
      y: 148.431,
      name: "-2sd",
    },
    {
      month: 186,
      y: 148.519,
      name: "-2sd",
    },
    {
      month: 187,
      y: 148.599,
      name: "-2sd",
    },
    {
      month: 188,
      y: 148.678,
      name: "-2sd",
    },
    {
      month: 189,
      y: 148.749,
      name: "-2sd",
    },
    {
      month: 190,
      y: 148.816,
      name: "-2sd",
    },
    {
      month: 191,
      y: 148.883,
      name: "-2sd",
    },
    {
      month: 192,
      y: 148.942,
      name: "-2sd",
    },
    {
      month: 193,
      y: 148.999,
      name: "-2sd",
    },
    {
      month: 194,
      y: 149.053,
      name: "-2sd",
    },
    {
      month: 195,
      y: 149.103,
      name: "-2sd",
    },
    {
      month: 196,
      y: 149.152,
      name: "-2sd",
    },
    {
      month: 197,
      y: 149.196,
      name: "-2sd",
    },
    {
      month: 198,
      y: 149.24,
      name: "-2sd",
    },
    {
      month: 199,
      y: 149.28,
      name: "-2sd",
    },
    {
      month: 200,
      y: 149.322,
      name: "-2sd",
    },
    {
      month: 201,
      y: 149.36,
      name: "-2sd",
    },
    {
      month: 202,
      y: 149.4,
      name: "-2sd",
    },
    {
      month: 203,
      y: 149.436,
      name: "-2sd",
    },
    {
      month: 204,
      y: 149.471,
      name: "-2sd",
    },
    {
      month: 205,
      y: 149.506,
      name: "-2sd",
    },
    {
      month: 206,
      y: 149.539,
      name: "-2sd",
    },
    {
      month: 207,
      y: 149.573,
      name: "-2sd",
    },
    {
      month: 208,
      y: 149.606,
      name: "-2sd",
    },
    {
      month: 209,
      y: 149.638,
      name: "-2sd",
    },
    {
      month: 210,
      y: 149.667,
      name: "-2sd",
    },
    {
      month: 211,
      y: 149.699,
      name: "-2sd",
    },
    {
      month: 212,
      y: 149.727,
      name: "-2sd",
    },
    {
      month: 213,
      y: 149.758,
      name: "-2sd",
    },
    {
      month: 214,
      y: 149.785,
      name: "-2sd",
    },
    {
      month: 215,
      y: 149.812,
      name: "-2sd",
    },
    {
      month: 216,
      y: 149.842,
      name: "-2sd",
    },
    {
      month: 217,
      y: 149.868,
      name: "-2sd",
    },
    {
      month: 218,
      y: 149.893,
      name: "-2sd",
    },
    {
      month: 219,
      y: 149.917,
      name: "-2sd",
    },
    {
      month: 220,
      y: 149.94,
      name: "-2sd",
    },
    {
      month: 221,
      y: 149.959,
      name: "-2sd",
    },
    {
      month: 222,
      y: 149.98,
      name: "-2sd",
    },
    {
      month: 223,
      y: 150,
      name: "-2sd",
    },
    {
      month: 224,
      y: 150.015,
      name: "-2sd",
    },
    {
      month: 225,
      y: 150.033,
      name: "-2sd",
    },
    {
      month: 226,
      y: 150.047,
      name: "-2sd",
    },
    {
      month: 227,
      y: 150.062,
      name: "-2sd",
    },
    {
      month: 228,
      y: 150.073,
      name: "-2sd",
    },
    {
      month: 0,
      y: 47.3,
      name: "-1sd",
    },
    {
      month: 1,
      y: 51.7,
      name: "-1sd",
    },
    {
      month: 2,
      y: 55,
      name: "-1sd",
    },
    {
      month: 3,
      y: 57.7,
      name: "-1sd",
    },
    {
      month: 4,
      y: 59.9,
      name: "-1sd",
    },
    {
      month: 5,
      y: 61.8,
      name: "-1sd",
    },
    {
      month: 6,
      y: 63.5,
      name: "-1sd",
    },
    {
      month: 7,
      y: 65,
      name: "-1sd",
    },
    {
      month: 8,
      y: 66.4,
      name: "-1sd",
    },
    {
      month: 9,
      y: 67.7,
      name: "-1sd",
    },
    {
      month: 10,
      y: 69,
      name: "-1sd",
    },
    {
      month: 11,
      y: 70.3,
      name: "-1sd",
    },
    {
      month: 12,
      y: 71.4,
      name: "-1sd",
    },
    {
      month: 13,
      y: 72.6,
      name: "-1sd",
    },
    {
      month: 14,
      y: 73.7,
      name: "-1sd",
    },
    {
      month: 15,
      y: 74.8,
      name: "-1sd",
    },
    {
      month: 16,
      y: 75.8,
      name: "-1sd",
    },
    {
      month: 17,
      y: 76.8,
      name: "-1sd",
    },
    {
      month: 18,
      y: 77.8,
      name: "-1sd",
    },
    {
      month: 19,
      y: 78.8,
      name: "-1sd",
    },
    {
      month: 20,
      y: 79.7,
      name: "-1sd",
    },
    {
      month: 21,
      y: 80.6,
      name: "-1sd",
    },
    {
      month: 22,
      y: 81.5,
      name: "-1sd",
    },
    {
      month: 23,
      y: 82.3,
      name: "-1sd",
    },
    {
      month: 24,
      y: 82.5,
      name: "-1sd",
    },
    {
      month: 25,
      y: 83.3,
      name: "-1sd",
    },
    {
      month: 26,
      y: 84.1,
      name: "-1sd",
    },
    {
      month: 27,
      y: 84.9,
      name: "-1sd",
    },
    {
      month: 28,
      y: 85.7,
      name: "-1sd",
    },
    {
      month: 29,
      y: 86.4,
      name: "-1sd",
    },
    {
      month: 30,
      y: 87.1,
      name: "-1sd",
    },
    {
      month: 31,
      y: 87.9,
      name: "-1sd",
    },
    {
      month: 32,
      y: 88.6,
      name: "-1sd",
    },
    {
      month: 33,
      y: 89.3,
      name: "-1sd",
    },
    {
      month: 34,
      y: 89.9,
      name: "-1sd",
    },
    {
      month: 35,
      y: 90.6,
      name: "-1sd",
    },
    {
      month: 36,
      y: 91.2,
      name: "-1sd",
    },
    {
      month: 37,
      y: 91.9,
      name: "-1sd",
    },
    {
      month: 38,
      y: 92.5,
      name: "-1sd",
    },
    {
      month: 39,
      y: 93.1,
      name: "-1sd",
    },
    {
      month: 40,
      y: 93.8,
      name: "-1sd",
    },
    {
      month: 41,
      y: 94.4,
      name: "-1sd",
    },
    {
      month: 42,
      y: 95,
      name: "-1sd",
    },
    {
      month: 43,
      y: 95.6,
      name: "-1sd",
    },
    {
      month: 44,
      y: 96.2,
      name: "-1sd",
    },
    {
      month: 45,
      y: 96.7,
      name: "-1sd",
    },
    {
      month: 46,
      y: 97.3,
      name: "-1sd",
    },
    {
      month: 47,
      y: 97.9,
      name: "-1sd",
    },
    {
      month: 48,
      y: 98.4,
      name: "-1sd",
    },
    {
      month: 49,
      y: 99,
      name: "-1sd",
    },
    {
      month: 50,
      y: 99.5,
      name: "-1sd",
    },
    {
      month: 51,
      y: 100.1,
      name: "-1sd",
    },
    {
      month: 52,
      y: 100.6,
      name: "-1sd",
    },
    {
      month: 53,
      y: 101.1,
      name: "-1sd",
    },
    {
      month: 54,
      y: 101.6,
      name: "-1sd",
    },
    {
      month: 55,
      y: 102.2,
      name: "-1sd",
    },
    {
      month: 56,
      y: 102.7,
      name: "-1sd",
    },
    {
      month: 57,
      y: 103.2,
      name: "-1sd",
    },
    {
      month: 58,
      y: 103.7,
      name: "-1sd",
    },
    {
      month: 59,
      y: 104.2,
      name: "-1sd",
    },
    {
      month: 60,
      y: 104.7,
      name: "-1sd",
    },
    {
      month: 61,
      y: 104.828,
      name: "-1sd",
    },
    {
      month: 62,
      y: 105.32,
      name: "-1sd",
    },
    {
      month: 63,
      y: 105.807,
      name: "-1sd",
    },
    {
      month: 64,
      y: 106.289,
      name: "-1sd",
    },
    {
      month: 65,
      y: 106.767,
      name: "-1sd",
    },
    {
      month: 66,
      y: 107.241,
      name: "-1sd",
    },
    {
      month: 67,
      y: 107.711,
      name: "-1sd",
    },
    {
      month: 68,
      y: 108.177,
      name: "-1sd",
    },
    {
      month: 69,
      y: 108.64,
      name: "-1sd",
    },
    {
      month: 70,
      y: 109.098,
      name: "-1sd",
    },
    {
      month: 71,
      y: 109.553,
      name: "-1sd",
    },
    {
      month: 72,
      y: 110.005,
      name: "-1sd",
    },
    {
      month: 73,
      y: 110.455,
      name: "-1sd",
    },
    {
      month: 74,
      y: 110.903,
      name: "-1sd",
    },
    {
      month: 75,
      y: 111.348,
      name: "-1sd",
    },
    {
      month: 76,
      y: 111.794,
      name: "-1sd",
    },
    {
      month: 77,
      y: 112.238,
      name: "-1sd",
    },
    {
      month: 78,
      y: 112.681,
      name: "-1sd",
    },
    {
      month: 79,
      y: 113.125,
      name: "-1sd",
    },
    {
      month: 80,
      y: 113.567,
      name: "-1sd",
    },
    {
      month: 81,
      y: 114.01,
      name: "-1sd",
    },
    {
      month: 82,
      y: 114.454,
      name: "-1sd",
    },
    {
      month: 83,
      y: 114.898,
      name: "-1sd",
    },
    {
      month: 84,
      y: 115.344,
      name: "-1sd",
    },
    {
      month: 85,
      y: 115.789,
      name: "-1sd",
    },
    {
      month: 86,
      y: 116.236,
      name: "-1sd",
    },
    {
      month: 87,
      y: 116.682,
      name: "-1sd",
    },
    {
      month: 88,
      y: 117.13,
      name: "-1sd",
    },
    {
      month: 89,
      y: 117.581,
      name: "-1sd",
    },
    {
      month: 90,
      y: 118.03,
      name: "-1sd",
    },
    {
      month: 91,
      y: 118.481,
      name: "-1sd",
    },
    {
      month: 92,
      y: 118.934,
      name: "-1sd",
    },
    {
      month: 93,
      y: 119.388,
      name: "-1sd",
    },
    {
      month: 94,
      y: 119.844,
      name: "-1sd",
    },
    {
      month: 95,
      y: 120.3,
      name: "-1sd",
    },
    {
      month: 96,
      y: 120.758,
      name: "-1sd",
    },
    {
      month: 97,
      y: 121.218,
      name: "-1sd",
    },
    {
      month: 98,
      y: 121.679,
      name: "-1sd",
    },
    {
      month: 99,
      y: 122.143,
      name: "-1sd",
    },
    {
      month: 100,
      y: 122.607,
      name: "-1sd",
    },
    {
      month: 101,
      y: 123.073,
      name: "-1sd",
    },
    {
      month: 102,
      y: 123.541,
      name: "-1sd",
    },
    {
      month: 103,
      y: 124.011,
      name: "-1sd",
    },
    {
      month: 104,
      y: 124.483,
      name: "-1sd",
    },
    {
      month: 105,
      y: 124.954,
      name: "-1sd",
    },
    {
      month: 106,
      y: 125.43,
      name: "-1sd",
    },
    {
      month: 107,
      y: 125.906,
      name: "-1sd",
    },
    {
      month: 108,
      y: 126.384,
      name: "-1sd",
    },
    {
      month: 109,
      y: 126.864,
      name: "-1sd",
    },
    {
      month: 110,
      y: 127.345,
      name: "-1sd",
    },
    {
      month: 111,
      y: 127.827,
      name: "-1sd",
    },
    {
      month: 112,
      y: 128.311,
      name: "-1sd",
    },
    {
      month: 113,
      y: 128.797,
      name: "-1sd",
    },
    {
      month: 114,
      y: 129.283,
      name: "-1sd",
    },
    {
      month: 115,
      y: 129.772,
      name: "-1sd",
    },
    {
      month: 116,
      y: 130.263,
      name: "-1sd",
    },
    {
      month: 117,
      y: 130.754,
      name: "-1sd",
    },
    {
      month: 118,
      y: 131.247,
      name: "-1sd",
    },
    {
      month: 119,
      y: 131.743,
      name: "-1sd",
    },
    {
      month: 120,
      y: 132.24,
      name: "-1sd",
    },
    {
      month: 121,
      y: 132.74,
      name: "-1sd",
    },
    {
      month: 122,
      y: 133.24,
      name: "-1sd",
    },
    {
      month: 123,
      y: 133.743,
      name: "-1sd",
    },
    {
      month: 124,
      y: 134.248,
      name: "-1sd",
    },
    {
      month: 125,
      y: 134.754,
      name: "-1sd",
    },
    {
      month: 126,
      y: 135.263,
      name: "-1sd",
    },
    {
      month: 127,
      y: 135.774,
      name: "-1sd",
    },
    {
      month: 128,
      y: 136.286,
      name: "-1sd",
    },
    {
      month: 129,
      y: 136.8,
      name: "-1sd",
    },
    {
      month: 130,
      y: 137.315,
      name: "-1sd",
    },
    {
      month: 131,
      y: 137.83,
      name: "-1sd",
    },
    {
      month: 132,
      y: 138.346,
      name: "-1sd",
    },
    {
      month: 133,
      y: 138.863,
      name: "-1sd",
    },
    {
      month: 134,
      y: 139.378,
      name: "-1sd",
    },
    {
      month: 135,
      y: 139.894,
      name: "-1sd",
    },
    {
      month: 136,
      y: 140.407,
      name: "-1sd",
    },
    {
      month: 137,
      y: 140.919,
      name: "-1sd",
    },
    {
      month: 138,
      y: 141.428,
      name: "-1sd",
    },
    {
      month: 139,
      y: 141.933,
      name: "-1sd",
    },
    {
      month: 140,
      y: 142.436,
      name: "-1sd",
    },
    {
      month: 141,
      y: 142.933,
      name: "-1sd",
    },
    {
      month: 142,
      y: 143.426,
      name: "-1sd",
    },
    {
      month: 143,
      y: 143.912,
      name: "-1sd",
    },
    {
      month: 144,
      y: 144.392,
      name: "-1sd",
    },
    {
      month: 145,
      y: 144.867,
      name: "-1sd",
    },
    {
      month: 146,
      y: 145.331,
      name: "-1sd",
    },
    {
      month: 147,
      y: 145.788,
      name: "-1sd",
    },
    {
      month: 148,
      y: 146.235,
      name: "-1sd",
    },
    {
      month: 149,
      y: 146.673,
      name: "-1sd",
    },
    {
      month: 150,
      y: 147.1,
      name: "-1sd",
    },
    {
      month: 151,
      y: 147.517,
      name: "-1sd",
    },
    {
      month: 152,
      y: 147.924,
      name: "-1sd",
    },
    {
      month: 153,
      y: 148.318,
      name: "-1sd",
    },
    {
      month: 154,
      y: 148.701,
      name: "-1sd",
    },
    {
      month: 155,
      y: 149.074,
      name: "-1sd",
    },
    {
      month: 156,
      y: 149.433,
      name: "-1sd",
    },
    {
      month: 157,
      y: 149.782,
      name: "-1sd",
    },
    {
      month: 158,
      y: 150.12,
      name: "-1sd",
    },
    {
      month: 159,
      y: 150.445,
      name: "-1sd",
    },
    {
      month: 160,
      y: 150.756,
      name: "-1sd",
    },
    {
      month: 161,
      y: 151.058,
      name: "-1sd",
    },
    {
      month: 162,
      y: 151.347,
      name: "-1sd",
    },
    {
      month: 163,
      y: 151.625,
      name: "-1sd",
    },
    {
      month: 164,
      y: 151.892,
      name: "-1sd",
    },
    {
      month: 165,
      y: 152.145,
      name: "-1sd",
    },
    {
      month: 166,
      y: 152.389,
      name: "-1sd",
    },
    {
      month: 167,
      y: 152.623,
      name: "-1sd",
    },
    {
      month: 168,
      y: 152.846,
      name: "-1sd",
    },
    {
      month: 169,
      y: 153.059,
      name: "-1sd",
    },
    {
      month: 170,
      y: 153.261,
      name: "-1sd",
    },
    {
      month: 171,
      y: 153.454,
      name: "-1sd",
    },
    {
      month: 172,
      y: 153.638,
      name: "-1sd",
    },
    {
      month: 173,
      y: 153.81,
      name: "-1sd",
    },
    {
      month: 174,
      y: 153.976,
      name: "-1sd",
    },
    {
      month: 175,
      y: 154.131,
      name: "-1sd",
    },
    {
      month: 176,
      y: 154.279,
      name: "-1sd",
    },
    {
      month: 177,
      y: 154.418,
      name: "-1sd",
    },
    {
      month: 178,
      y: 154.549,
      name: "-1sd",
    },
    {
      month: 179,
      y: 154.672,
      name: "-1sd",
    },
    {
      month: 180,
      y: 154.79,
      name: "-1sd",
    },
    {
      month: 181,
      y: 154.9,
      name: "-1sd",
    },
    {
      month: 182,
      y: 155.003,
      name: "-1sd",
    },
    {
      month: 183,
      y: 155.098,
      name: "-1sd",
    },
    {
      month: 184,
      y: 155.188,
      name: "-1sd",
    },
    {
      month: 185,
      y: 155.273,
      name: "-1sd",
    },
    {
      month: 186,
      y: 155.353,
      name: "-1sd",
    },
    {
      month: 187,
      y: 155.427,
      name: "-1sd",
    },
    {
      month: 188,
      y: 155.497,
      name: "-1sd",
    },
    {
      month: 189,
      y: 155.56,
      name: "-1sd",
    },
    {
      month: 190,
      y: 155.62,
      name: "-1sd",
    },
    {
      month: 191,
      y: 155.677,
      name: "-1sd",
    },
    {
      month: 192,
      y: 155.729,
      name: "-1sd",
    },
    {
      month: 193,
      y: 155.777,
      name: "-1sd",
    },
    {
      month: 194,
      y: 155.823,
      name: "-1sd",
    },
    {
      month: 195,
      y: 155.866,
      name: "-1sd",
    },
    {
      month: 196,
      y: 155.906,
      name: "-1sd",
    },
    {
      month: 197,
      y: 155.942,
      name: "-1sd",
    },
    {
      month: 198,
      y: 155.978,
      name: "-1sd",
    },
    {
      month: 199,
      y: 156.011,
      name: "-1sd",
    },
    {
      month: 200,
      y: 156.045,
      name: "-1sd",
    },
    {
      month: 201,
      y: 156.075,
      name: "-1sd",
    },
    {
      month: 202,
      y: 156.106,
      name: "-1sd",
    },
    {
      month: 203,
      y: 156.135,
      name: "-1sd",
    },
    {
      month: 204,
      y: 156.163,
      name: "-1sd",
    },
    {
      month: 205,
      y: 156.19,
      name: "-1sd",
    },
    {
      month: 206,
      y: 156.216,
      name: "-1sd",
    },
    {
      month: 207,
      y: 156.242,
      name: "-1sd",
    },
    {
      month: 208,
      y: 156.268,
      name: "-1sd",
    },
    {
      month: 209,
      y: 156.293,
      name: "-1sd",
    },
    {
      month: 210,
      y: 156.316,
      name: "-1sd",
    },
    {
      month: 211,
      y: 156.34,
      name: "-1sd",
    },
    {
      month: 212,
      y: 156.363,
      name: "-1sd",
    },
    {
      month: 213,
      y: 156.386,
      name: "-1sd",
    },
    {
      month: 214,
      y: 156.408,
      name: "-1sd",
    },
    {
      month: 215,
      y: 156.429,
      name: "-1sd",
    },
    {
      month: 216,
      y: 156.451,
      name: "-1sd",
    },
    {
      month: 217,
      y: 156.47,
      name: "-1sd",
    },
    {
      month: 218,
      y: 156.489,
      name: "-1sd",
    },
    {
      month: 219,
      y: 156.507,
      name: "-1sd",
    },
    {
      month: 220,
      y: 156.524,
      name: "-1sd",
    },
    {
      month: 221,
      y: 156.539,
      name: "-1sd",
    },
    {
      month: 222,
      y: 156.554,
      name: "-1sd",
    },
    {
      month: 223,
      y: 156.568,
      name: "-1sd",
    },
    {
      month: 224,
      y: 156.579,
      name: "-1sd",
    },
    {
      month: 225,
      y: 156.59,
      name: "-1sd",
    },
    {
      month: 226,
      y: 156.599,
      name: "-1sd",
    },
    {
      month: 227,
      y: 156.608,
      name: "-1sd",
    },
    {
      month: 228,
      y: 156.614,
      name: "-1sd",
    },
    {
      month: 0,
      y: 49.1,
      name: "mediane",
    },
    {
      month: 1,
      y: 53.7,
      name: "mediane",
    },
    {
      month: 2,
      y: 57.1,
      name: "mediane",
    },
    {
      month: 3,
      y: 59.8,
      name: "mediane",
    },
    {
      month: 4,
      y: 62.1,
      name: "mediane",
    },
    {
      month: 5,
      y: 64,
      name: "mediane",
    },
    {
      month: 6,
      y: 65.7,
      name: "mediane",
    },
    {
      month: 7,
      y: 67.3,
      name: "mediane",
    },
    {
      month: 8,
      y: 68.7,
      name: "mediane",
    },
    {
      month: 9,
      y: 70.1,
      name: "mediane",
    },
    {
      month: 10,
      y: 71.5,
      name: "mediane",
    },
    {
      month: 11,
      y: 72.8,
      name: "mediane",
    },
    {
      month: 12,
      y: 74,
      name: "mediane",
    },
    {
      month: 13,
      y: 75.2,
      name: "mediane",
    },
    {
      month: 14,
      y: 76.4,
      name: "mediane",
    },
    {
      month: 15,
      y: 77.5,
      name: "mediane",
    },
    {
      month: 16,
      y: 78.6,
      name: "mediane",
    },
    {
      month: 17,
      y: 79.7,
      name: "mediane",
    },
    {
      month: 18,
      y: 80.7,
      name: "mediane",
    },
    {
      month: 19,
      y: 81.7,
      name: "mediane",
    },
    {
      month: 20,
      y: 82.7,
      name: "mediane",
    },
    {
      month: 21,
      y: 83.7,
      name: "mediane",
    },
    {
      month: 22,
      y: 84.6,
      name: "mediane",
    },
    {
      month: 23,
      y: 85.5,
      name: "mediane",
    },
    {
      month: 24,
      y: 85.7,
      name: "mediane",
    },
    {
      month: 25,
      y: 86.6,
      name: "mediane",
    },
    {
      month: 26,
      y: 87.4,
      name: "mediane",
    },
    {
      month: 27,
      y: 88.3,
      name: "mediane",
    },
    {
      month: 28,
      y: 89.1,
      name: "mediane",
    },
    {
      month: 29,
      y: 89.9,
      name: "mediane",
    },
    {
      month: 30,
      y: 90.7,
      name: "mediane",
    },
    {
      month: 31,
      y: 91.4,
      name: "mediane",
    },
    {
      month: 32,
      y: 92.2,
      name: "mediane",
    },
    {
      month: 33,
      y: 92.9,
      name: "mediane",
    },
    {
      month: 34,
      y: 93.6,
      name: "mediane",
    },
    {
      month: 35,
      y: 94.4,
      name: "mediane",
    },
    {
      month: 36,
      y: 95.1,
      name: "mediane",
    },
    {
      month: 37,
      y: 95.7,
      name: "mediane",
    },
    {
      month: 38,
      y: 96.4,
      name: "mediane",
    },
    {
      month: 39,
      y: 97.1,
      name: "mediane",
    },
    {
      month: 40,
      y: 97.7,
      name: "mediane",
    },
    {
      month: 41,
      y: 98.4,
      name: "mediane",
    },
    {
      month: 42,
      y: 99,
      name: "mediane",
    },
    {
      month: 43,
      y: 99.7,
      name: "mediane",
    },
    {
      month: 44,
      y: 100.3,
      name: "mediane",
    },
    {
      month: 45,
      y: 100.9,
      name: "mediane",
    },
    {
      month: 46,
      y: 101.5,
      name: "mediane",
    },
    {
      month: 47,
      y: 102.1,
      name: "mediane",
    },
    {
      month: 48,
      y: 102.7,
      name: "mediane",
    },
    {
      month: 49,
      y: 103.3,
      name: "mediane",
    },
    {
      month: 50,
      y: 103.9,
      name: "mediane",
    },
    {
      month: 51,
      y: 104.5,
      name: "mediane",
    },
    {
      month: 52,
      y: 105,
      name: "mediane",
    },
    {
      month: 53,
      y: 105.6,
      name: "mediane",
    },
    {
      month: 54,
      y: 106.2,
      name: "mediane",
    },
    {
      month: 55,
      y: 106.7,
      name: "mediane",
    },
    {
      month: 56,
      y: 107.3,
      name: "mediane",
    },
    {
      month: 57,
      y: 107.8,
      name: "mediane",
    },
    {
      month: 58,
      y: 108.4,
      name: "mediane",
    },
    {
      month: 59,
      y: 108.9,
      name: "mediane",
    },
    {
      month: 60,
      y: 109.4,
      name: "mediane",
    },
    {
      month: 61,
      y: 109.602,
      name: "mediane",
    },
    {
      month: 62,
      y: 110.126,
      name: "mediane",
    },
    {
      month: 63,
      y: 110.645,
      name: "mediane",
    },
    {
      month: 64,
      y: 111.16,
      name: "mediane",
    },
    {
      month: 65,
      y: 111.67,
      name: "mediane",
    },
    {
      month: 66,
      y: 112.175,
      name: "mediane",
    },
    {
      month: 67,
      y: 112.677,
      name: "mediane",
    },
    {
      month: 68,
      y: 113.174,
      name: "mediane",
    },
    {
      month: 69,
      y: 113.667,
      name: "mediane",
    },
    {
      month: 70,
      y: 114.156,
      name: "mediane",
    },
    {
      month: 71,
      y: 114.642,
      name: "mediane",
    },
    {
      month: 72,
      y: 115.124,
      name: "mediane",
    },
    {
      month: 73,
      y: 115.604,
      name: "mediane",
    },
    {
      month: 74,
      y: 116.081,
      name: "mediane",
    },
    {
      month: 75,
      y: 116.557,
      name: "mediane",
    },
    {
      month: 76,
      y: 117.031,
      name: "mediane",
    },
    {
      month: 77,
      y: 117.504,
      name: "mediane",
    },
    {
      month: 78,
      y: 117.977,
      name: "mediane",
    },
    {
      month: 79,
      y: 118.449,
      name: "mediane",
    },
    {
      month: 80,
      y: 118.921,
      name: "mediane",
    },
    {
      month: 81,
      y: 119.393,
      name: "mediane",
    },
    {
      month: 82,
      y: 119.865,
      name: "mediane",
    },
    {
      month: 83,
      y: 120.337,
      name: "mediane",
    },
    {
      month: 84,
      y: 120.81,
      name: "mediane",
    },
    {
      month: 85,
      y: 121.284,
      name: "mediane",
    },
    {
      month: 86,
      y: 121.759,
      name: "mediane",
    },
    {
      month: 87,
      y: 122.234,
      name: "mediane",
    },
    {
      month: 88,
      y: 122.71,
      name: "mediane",
    },
    {
      month: 89,
      y: 123.187,
      name: "mediane",
    },
    {
      month: 90,
      y: 123.665,
      name: "mediane",
    },
    {
      month: 91,
      y: 124.144,
      name: "mediane",
    },
    {
      month: 92,
      y: 124.623,
      name: "mediane",
    },
    {
      month: 93,
      y: 125.104,
      name: "mediane",
    },
    {
      month: 94,
      y: 125.587,
      name: "mediane",
    },
    {
      month: 95,
      y: 126.071,
      name: "mediane",
    },
    {
      month: 96,
      y: 126.556,
      name: "mediane",
    },
    {
      month: 97,
      y: 127.042,
      name: "mediane",
    },
    {
      month: 98,
      y: 127.53,
      name: "mediane",
    },
    {
      month: 99,
      y: 128.02,
      name: "mediane",
    },
    {
      month: 100,
      y: 128.511,
      name: "mediane",
    },
    {
      month: 101,
      y: 129.004,
      name: "mediane",
    },
    {
      month: 102,
      y: 129.498,
      name: "mediane",
    },
    {
      month: 103,
      y: 129.993,
      name: "mediane",
    },
    {
      month: 104,
      y: 130.49,
      name: "mediane",
    },
    {
      month: 105,
      y: 130.989,
      name: "mediane",
    },
    {
      month: 106,
      y: 131.49,
      name: "mediane",
    },
    {
      month: 107,
      y: 131.991,
      name: "mediane",
    },
    {
      month: 108,
      y: 132.494,
      name: "mediane",
    },
    {
      month: 109,
      y: 132.999,
      name: "mediane",
    },
    {
      month: 110,
      y: 133.505,
      name: "mediane",
    },
    {
      month: 111,
      y: 134.012,
      name: "mediane",
    },
    {
      month: 112,
      y: 134.52,
      name: "mediane",
    },
    {
      month: 113,
      y: 135.03,
      name: "mediane",
    },
    {
      month: 114,
      y: 135.541,
      name: "mediane",
    },
    {
      month: 115,
      y: 136.053,
      name: "mediane",
    },
    {
      month: 116,
      y: 136.567,
      name: "mediane",
    },
    {
      month: 117,
      y: 137.082,
      name: "mediane",
    },
    {
      month: 118,
      y: 137.599,
      name: "mediane",
    },
    {
      month: 119,
      y: 138.117,
      name: "mediane",
    },
    {
      month: 120,
      y: 138.636,
      name: "mediane",
    },
    {
      month: 121,
      y: 139.158,
      name: "mediane",
    },
    {
      month: 122,
      y: 139.68,
      name: "mediane",
    },
    {
      month: 123,
      y: 140.205,
      name: "mediane",
    },
    {
      month: 124,
      y: 140.731,
      name: "mediane",
    },
    {
      month: 125,
      y: 141.259,
      name: "mediane",
    },
    {
      month: 126,
      y: 141.789,
      name: "mediane",
    },
    {
      month: 127,
      y: 142.321,
      name: "mediane",
    },
    {
      month: 128,
      y: 142.853,
      name: "mediane",
    },
    {
      month: 129,
      y: 143.387,
      name: "mediane",
    },
    {
      month: 130,
      y: 143.922,
      name: "mediane",
    },
    {
      month: 131,
      y: 144.458,
      name: "mediane",
    },
    {
      month: 132,
      y: 144.993,
      name: "mediane",
    },
    {
      month: 133,
      y: 145.528,
      name: "mediane",
    },
    {
      month: 134,
      y: 146.062,
      name: "mediane",
    },
    {
      month: 135,
      y: 146.595,
      name: "mediane",
    },
    {
      month: 136,
      y: 147.126,
      name: "mediane",
    },
    {
      month: 137,
      y: 147.655,
      name: "mediane",
    },
    {
      month: 138,
      y: 148.18,
      name: "mediane",
    },
    {
      month: 139,
      y: 148.702,
      name: "mediane",
    },
    {
      month: 140,
      y: 149.22,
      name: "mediane",
    },
    {
      month: 141,
      y: 149.732,
      name: "mediane",
    },
    {
      month: 142,
      y: 150.239,
      name: "mediane",
    },
    {
      month: 143,
      y: 150.739,
      name: "mediane",
    },
    {
      month: 144,
      y: 151.233,
      name: "mediane",
    },
    {
      month: 145,
      y: 151.718,
      name: "mediane",
    },
    {
      month: 146,
      y: 152.195,
      name: "mediane",
    },
    {
      month: 147,
      y: 152.663,
      name: "mediane",
    },
    {
      month: 148,
      y: 153.121,
      name: "mediane",
    },
    {
      month: 149,
      y: 153.568,
      name: "mediane",
    },
    {
      month: 150,
      y: 154.004,
      name: "mediane",
    },
    {
      month: 151,
      y: 154.429,
      name: "mediane",
    },
    {
      month: 152,
      y: 154.842,
      name: "mediane",
    },
    {
      month: 153,
      y: 155.244,
      name: "mediane",
    },
    {
      month: 154,
      y: 155.633,
      name: "mediane",
    },
    {
      month: 155,
      y: 156.01,
      name: "mediane",
    },
    {
      month: 156,
      y: 156.375,
      name: "mediane",
    },
    {
      month: 157,
      y: 156.727,
      name: "mediane",
    },
    {
      month: 158,
      y: 157.067,
      name: "mediane",
    },
    {
      month: 159,
      y: 157.394,
      name: "mediane",
    },
    {
      month: 160,
      y: 157.708,
      name: "mediane",
    },
    {
      month: 161,
      y: 158.01,
      name: "mediane",
    },
    {
      month: 162,
      y: 158.3,
      name: "mediane",
    },
    {
      month: 163,
      y: 158.577,
      name: "mediane",
    },
    {
      month: 164,
      y: 158.842,
      name: "mediane",
    },
    {
      month: 165,
      y: 159.096,
      name: "mediane",
    },
    {
      month: 166,
      y: 159.338,
      name: "mediane",
    },
    {
      month: 167,
      y: 159.569,
      name: "mediane",
    },
    {
      month: 168,
      y: 159.789,
      name: "mediane",
    },
    {
      month: 169,
      y: 159.998,
      name: "mediane",
    },
    {
      month: 170,
      y: 160.197,
      name: "mediane",
    },
    {
      month: 171,
      y: 160.386,
      name: "mediane",
    },
    {
      month: 172,
      y: 160.564,
      name: "mediane",
    },
    {
      month: 173,
      y: 160.733,
      name: "mediane",
    },
    {
      month: 174,
      y: 160.893,
      name: "mediane",
    },
    {
      month: 175,
      y: 161.043,
      name: "mediane",
    },
    {
      month: 176,
      y: 161.184,
      name: "mediane",
    },
    {
      month: 177,
      y: 161.318,
      name: "mediane",
    },
    {
      month: 178,
      y: 161.442,
      name: "mediane",
    },
    {
      month: 179,
      y: 161.56,
      name: "mediane",
    },
    {
      month: 180,
      y: 161.669,
      name: "mediane",
    },
    {
      month: 181,
      y: 161.772,
      name: "mediane",
    },
    {
      month: 182,
      y: 161.867,
      name: "mediane",
    },
    {
      month: 183,
      y: 161.956,
      name: "mediane",
    },
    {
      month: 184,
      y: 162.039,
      name: "mediane",
    },
    {
      month: 185,
      y: 162.116,
      name: "mediane",
    },
    {
      month: 186,
      y: 162.188,
      name: "mediane",
    },
    {
      month: 187,
      y: 162.254,
      name: "mediane",
    },
    {
      month: 188,
      y: 162.315,
      name: "mediane",
    },
    {
      month: 189,
      y: 162.372,
      name: "mediane",
    },
    {
      month: 190,
      y: 162.424,
      name: "mediane",
    },
    {
      month: 191,
      y: 162.472,
      name: "mediane",
    },
    {
      month: 192,
      y: 162.516,
      name: "mediane",
    },
    {
      month: 193,
      y: 162.556,
      name: "mediane",
    },
    {
      month: 194,
      y: 162.593,
      name: "mediane",
    },
    {
      month: 195,
      y: 162.628,
      name: "mediane",
    },
    {
      month: 196,
      y: 162.659,
      name: "mediane",
    },
    {
      month: 197,
      y: 162.689,
      name: "mediane",
    },
    {
      month: 198,
      y: 162.716,
      name: "mediane",
    },
    {
      month: 199,
      y: 162.742,
      name: "mediane",
    },
    {
      month: 200,
      y: 162.767,
      name: "mediane",
    },
    {
      month: 201,
      y: 162.79,
      name: "mediane",
    },
    {
      month: 202,
      y: 162.813,
      name: "mediane",
    },
    {
      month: 203,
      y: 162.834,
      name: "mediane",
    },
    {
      month: 204,
      y: 162.854,
      name: "mediane",
    },
    {
      month: 205,
      y: 162.874,
      name: "mediane",
    },
    {
      month: 206,
      y: 162.894,
      name: "mediane",
    },
    {
      month: 207,
      y: 162.912,
      name: "mediane",
    },
    {
      month: 208,
      y: 162.93,
      name: "mediane",
    },
    {
      month: 209,
      y: 162.948,
      name: "mediane",
    },
    {
      month: 210,
      y: 162.965,
      name: "mediane",
    },
    {
      month: 211,
      y: 162.982,
      name: "mediane",
    },
    {
      month: 212,
      y: 162.998,
      name: "mediane",
    },
    {
      month: 213,
      y: 163.014,
      name: "mediane",
    },
    {
      month: 214,
      y: 163.03,
      name: "mediane",
    },
    {
      month: 215,
      y: 163.045,
      name: "mediane",
    },
    {
      month: 216,
      y: 163.06,
      name: "mediane",
    },
    {
      month: 217,
      y: 163.073,
      name: "mediane",
    },
    {
      month: 218,
      y: 163.086,
      name: "mediane",
    },
    {
      month: 219,
      y: 163.098,
      name: "mediane",
    },
    {
      month: 220,
      y: 163.109,
      name: "mediane",
    },
    {
      month: 221,
      y: 163.119,
      name: "mediane",
    },
    {
      month: 222,
      y: 163.128,
      name: "mediane",
    },
    {
      month: 223,
      y: 163.136,
      name: "mediane",
    },
    {
      month: 224,
      y: 163.142,
      name: "mediane",
    },
    {
      month: 225,
      y: 163.147,
      name: "mediane",
    },
    {
      month: 226,
      y: 163.151,
      name: "mediane",
    },
    {
      month: 227,
      y: 163.153,
      name: "mediane",
    },
    {
      month: 228,
      y: 163.155,
      name: "mediane",
    },
    {
      month: 0,
      y: 51,
      name: "+1sd",
    },
    {
      month: 1,
      y: 55.6,
      name: "+1sd",
    },
    {
      month: 2,
      y: 59.1,
      name: "+1sd",
    },
    {
      month: 3,
      y: 61.9,
      name: "+1sd",
    },
    {
      month: 4,
      y: 64.3,
      name: "+1sd",
    },
    {
      month: 5,
      y: 66.2,
      name: "+1sd",
    },
    {
      month: 6,
      y: 68,
      name: "+1sd",
    },
    {
      month: 7,
      y: 69.6,
      name: "+1sd",
    },
    {
      month: 8,
      y: 71.1,
      name: "+1sd",
    },
    {
      month: 9,
      y: 72.6,
      name: "+1sd",
    },
    {
      month: 10,
      y: 73.9,
      name: "+1sd",
    },
    {
      month: 11,
      y: 75.3,
      name: "+1sd",
    },
    {
      month: 12,
      y: 76.6,
      name: "+1sd",
    },
    {
      month: 13,
      y: 77.8,
      name: "+1sd",
    },
    {
      month: 14,
      y: 79.1,
      name: "+1sd",
    },
    {
      month: 15,
      y: 80.2,
      name: "+1sd",
    },
    {
      month: 16,
      y: 81.4,
      name: "+1sd",
    },
    {
      month: 17,
      y: 82.5,
      name: "+1sd",
    },
    {
      month: 18,
      y: 83.6,
      name: "+1sd",
    },
    {
      month: 19,
      y: 84.7,
      name: "+1sd",
    },
    {
      month: 20,
      y: 85.7,
      name: "+1sd",
    },
    {
      month: 21,
      y: 86.7,
      name: "+1sd",
    },
    {
      month: 22,
      y: 87.7,
      name: "+1sd",
    },
    {
      month: 23,
      y: 88.7,
      name: "+1sd",
    },
    {
      month: 24,
      y: 88.9,
      name: "+1sd",
    },
    {
      month: 25,
      y: 89.9,
      name: "+1sd",
    },
    {
      month: 26,
      y: 90.8,
      name: "+1sd",
    },
    {
      month: 27,
      y: 91.7,
      name: "+1sd",
    },
    {
      month: 28,
      y: 92.5,
      name: "+1sd",
    },
    {
      month: 29,
      y: 93.4,
      name: "+1sd",
    },
    {
      month: 30,
      y: 94.2,
      name: "+1sd",
    },
    {
      month: 31,
      y: 95,
      name: "+1sd",
    },
    {
      month: 32,
      y: 95.8,
      name: "+1sd",
    },
    {
      month: 33,
      y: 96.6,
      name: "+1sd",
    },
    {
      month: 34,
      y: 97.4,
      name: "+1sd",
    },
    {
      month: 35,
      y: 98.1,
      name: "+1sd",
    },
    {
      month: 36,
      y: 98.9,
      name: "+1sd",
    },
    {
      month: 37,
      y: 99.6,
      name: "+1sd",
    },
    {
      month: 38,
      y: 100.3,
      name: "+1sd",
    },
    {
      month: 39,
      y: 101,
      name: "+1sd",
    },
    {
      month: 40,
      y: 101.7,
      name: "+1sd",
    },
    {
      month: 41,
      y: 102.4,
      name: "+1sd",
    },
    {
      month: 42,
      y: 103.1,
      name: "+1sd",
    },
    {
      month: 43,
      y: 103.8,
      name: "+1sd",
    },
    {
      month: 44,
      y: 104.5,
      name: "+1sd",
    },
    {
      month: 45,
      y: 105.1,
      name: "+1sd",
    },
    {
      month: 46,
      y: 105.8,
      name: "+1sd",
    },
    {
      month: 47,
      y: 106.4,
      name: "+1sd",
    },
    {
      month: 48,
      y: 107,
      name: "+1sd",
    },
    {
      month: 49,
      y: 107.7,
      name: "+1sd",
    },
    {
      month: 50,
      y: 108.3,
      name: "+1sd",
    },
    {
      month: 51,
      y: 108.9,
      name: "+1sd",
    },
    {
      month: 52,
      y: 109.5,
      name: "+1sd",
    },
    {
      month: 53,
      y: 110.1,
      name: "+1sd",
    },
    {
      month: 54,
      y: 110.7,
      name: "+1sd",
    },
    {
      month: 55,
      y: 111.3,
      name: "+1sd",
    },
    {
      month: 56,
      y: 111.9,
      name: "+1sd",
    },
    {
      month: 57,
      y: 112.5,
      name: "+1sd",
    },
    {
      month: 58,
      y: 113,
      name: "+1sd",
    },
    {
      month: 59,
      y: 113.6,
      name: "+1sd",
    },
    {
      month: 60,
      y: 114.2,
      name: "+1sd",
    },
    {
      month: 61,
      y: 114.375,
      name: "+1sd",
    },
    {
      month: 62,
      y: 114.932,
      name: "+1sd",
    },
    {
      month: 63,
      y: 115.484,
      name: "+1sd",
    },
    {
      month: 64,
      y: 116.031,
      name: "+1sd",
    },
    {
      month: 65,
      y: 116.572,
      name: "+1sd",
    },
    {
      month: 66,
      y: 117.11,
      name: "+1sd",
    },
    {
      month: 67,
      y: 117.642,
      name: "+1sd",
    },
    {
      month: 68,
      y: 118.171,
      name: "+1sd",
    },
    {
      month: 69,
      y: 118.695,
      name: "+1sd",
    },
    {
      month: 70,
      y: 119.215,
      name: "+1sd",
    },
    {
      month: 71,
      y: 119.731,
      name: "+1sd",
    },
    {
      month: 72,
      y: 120.244,
      name: "+1sd",
    },
    {
      month: 73,
      y: 120.753,
      name: "+1sd",
    },
    {
      month: 74,
      y: 121.26,
      name: "+1sd",
    },
    {
      month: 75,
      y: 121.766,
      name: "+1sd",
    },
    {
      month: 76,
      y: 122.268,
      name: "+1sd",
    },
    {
      month: 77,
      y: 122.771,
      name: "+1sd",
    },
    {
      month: 78,
      y: 123.273,
      name: "+1sd",
    },
    {
      month: 79,
      y: 123.773,
      name: "+1sd",
    },
    {
      month: 80,
      y: 124.275,
      name: "+1sd",
    },
    {
      month: 81,
      y: 124.775,
      name: "+1sd",
    },
    {
      month: 82,
      y: 125.275,
      name: "+1sd",
    },
    {
      month: 83,
      y: 125.777,
      name: "+1sd",
    },
    {
      month: 84,
      y: 126.277,
      name: "+1sd",
    },
    {
      month: 85,
      y: 126.78,
      name: "+1sd",
    },
    {
      month: 86,
      y: 127.282,
      name: "+1sd",
    },
    {
      month: 87,
      y: 127.786,
      name: "+1sd",
    },
    {
      month: 88,
      y: 128.289,
      name: "+1sd",
    },
    {
      month: 89,
      y: 128.793,
      name: "+1sd",
    },
    {
      month: 90,
      y: 129.299,
      name: "+1sd",
    },
    {
      month: 91,
      y: 129.806,
      name: "+1sd",
    },
    {
      month: 92,
      y: 130.312,
      name: "+1sd",
    },
    {
      month: 93,
      y: 130.821,
      name: "+1sd",
    },
    {
      month: 94,
      y: 131.33,
      name: "+1sd",
    },
    {
      month: 95,
      y: 131.841,
      name: "+1sd",
    },
    {
      month: 96,
      y: 132.353,
      name: "+1sd",
    },
    {
      month: 97,
      y: 132.867,
      name: "+1sd",
    },
    {
      month: 98,
      y: 133.381,
      name: "+1sd",
    },
    {
      month: 99,
      y: 133.897,
      name: "+1sd",
    },
    {
      month: 100,
      y: 134.415,
      name: "+1sd",
    },
    {
      month: 101,
      y: 134.934,
      name: "+1sd",
    },
    {
      month: 102,
      y: 135.454,
      name: "+1sd",
    },
    {
      month: 103,
      y: 135.975,
      name: "+1sd",
    },
    {
      month: 104,
      y: 136.498,
      name: "+1sd",
    },
    {
      month: 105,
      y: 137.024,
      name: "+1sd",
    },
    {
      month: 106,
      y: 137.549,
      name: "+1sd",
    },
    {
      month: 107,
      y: 138.076,
      name: "+1sd",
    },
    {
      month: 108,
      y: 138.605,
      name: "+1sd",
    },
    {
      month: 109,
      y: 139.134,
      name: "+1sd",
    },
    {
      month: 110,
      y: 139.665,
      name: "+1sd",
    },
    {
      month: 111,
      y: 140.196,
      name: "+1sd",
    },
    {
      month: 112,
      y: 140.73,
      name: "+1sd",
    },
    {
      month: 113,
      y: 141.263,
      name: "+1sd",
    },
    {
      month: 114,
      y: 141.799,
      name: "+1sd",
    },
    {
      month: 115,
      y: 142.335,
      name: "+1sd",
    },
    {
      month: 116,
      y: 142.871,
      name: "+1sd",
    },
    {
      month: 117,
      y: 143.41,
      name: "+1sd",
    },
    {
      month: 118,
      y: 143.95,
      name: "+1sd",
    },
    {
      month: 119,
      y: 144.491,
      name: "+1sd",
    },
    {
      month: 120,
      y: 145.033,
      name: "+1sd",
    },
    {
      month: 121,
      y: 145.575,
      name: "+1sd",
    },
    {
      month: 122,
      y: 146.121,
      name: "+1sd",
    },
    {
      month: 123,
      y: 146.667,
      name: "+1sd",
    },
    {
      month: 124,
      y: 147.215,
      name: "+1sd",
    },
    {
      month: 125,
      y: 147.764,
      name: "+1sd",
    },
    {
      month: 126,
      y: 148.316,
      name: "+1sd",
    },
    {
      month: 127,
      y: 148.867,
      name: "+1sd",
    },
    {
      month: 128,
      y: 149.42,
      name: "+1sd",
    },
    {
      month: 129,
      y: 149.975,
      name: "+1sd",
    },
    {
      month: 130,
      y: 150.53,
      name: "+1sd",
    },
    {
      month: 131,
      y: 151.085,
      name: "+1sd",
    },
    {
      month: 132,
      y: 151.639,
      name: "+1sd",
    },
    {
      month: 133,
      y: 152.193,
      name: "+1sd",
    },
    {
      month: 134,
      y: 152.746,
      name: "+1sd",
    },
    {
      month: 135,
      y: 153.296,
      name: "+1sd",
    },
    {
      month: 136,
      y: 153.845,
      name: "+1sd",
    },
    {
      month: 137,
      y: 154.391,
      name: "+1sd",
    },
    {
      month: 138,
      y: 154.933,
      name: "+1sd",
    },
    {
      month: 139,
      y: 155.471,
      name: "+1sd",
    },
    {
      month: 140,
      y: 156.003,
      name: "+1sd",
    },
    {
      month: 141,
      y: 156.532,
      name: "+1sd",
    },
    {
      month: 142,
      y: 157.052,
      name: "+1sd",
    },
    {
      month: 143,
      y: 157.566,
      name: "+1sd",
    },
    {
      month: 144,
      y: 158.073,
      name: "+1sd",
    },
    {
      month: 145,
      y: 158.57,
      name: "+1sd",
    },
    {
      month: 146,
      y: 159.059,
      name: "+1sd",
    },
    {
      month: 147,
      y: 159.537,
      name: "+1sd",
    },
    {
      month: 148,
      y: 160.006,
      name: "+1sd",
    },
    {
      month: 149,
      y: 160.463,
      name: "+1sd",
    },
    {
      month: 150,
      y: 160.908,
      name: "+1sd",
    },
    {
      month: 151,
      y: 161.341,
      name: "+1sd",
    },
    {
      month: 152,
      y: 161.761,
      name: "+1sd",
    },
    {
      month: 153,
      y: 162.169,
      name: "+1sd",
    },
    {
      month: 154,
      y: 162.565,
      name: "+1sd",
    },
    {
      month: 155,
      y: 162.946,
      name: "+1sd",
    },
    {
      month: 156,
      y: 163.316,
      name: "+1sd",
    },
    {
      month: 157,
      y: 163.671,
      name: "+1sd",
    },
    {
      month: 158,
      y: 164.014,
      name: "+1sd",
    },
    {
      month: 159,
      y: 164.343,
      name: "+1sd",
    },
    {
      month: 160,
      y: 164.66,
      name: "+1sd",
    },
    {
      month: 161,
      y: 164.963,
      name: "+1sd",
    },
    {
      month: 162,
      y: 165.252,
      name: "+1sd",
    },
    {
      month: 163,
      y: 165.529,
      name: "+1sd",
    },
    {
      month: 164,
      y: 165.793,
      name: "+1sd",
    },
    {
      month: 165,
      y: 166.047,
      name: "+1sd",
    },
    {
      month: 166,
      y: 166.287,
      name: "+1sd",
    },
    {
      month: 167,
      y: 166.515,
      name: "+1sd",
    },
    {
      month: 168,
      y: 166.732,
      name: "+1sd",
    },
    {
      month: 169,
      y: 166.937,
      name: "+1sd",
    },
    {
      month: 170,
      y: 167.134,
      name: "+1sd",
    },
    {
      month: 171,
      y: 167.318,
      name: "+1sd",
    },
    {
      month: 172,
      y: 167.491,
      name: "+1sd",
    },
    {
      month: 173,
      y: 167.656,
      name: "+1sd",
    },
    {
      month: 174,
      y: 167.809,
      name: "+1sd",
    },
    {
      month: 175,
      y: 167.955,
      name: "+1sd",
    },
    {
      month: 176,
      y: 168.09,
      name: "+1sd",
    },
    {
      month: 177,
      y: 168.217,
      name: "+1sd",
    },
    {
      month: 178,
      y: 168.336,
      name: "+1sd",
    },
    {
      month: 179,
      y: 168.447,
      name: "+1sd",
    },
    {
      month: 180,
      y: 168.548,
      name: "+1sd",
    },
    {
      month: 181,
      y: 168.644,
      name: "+1sd",
    },
    {
      month: 182,
      y: 168.732,
      name: "+1sd",
    },
    {
      month: 183,
      y: 168.815,
      name: "+1sd",
    },
    {
      month: 184,
      y: 168.89,
      name: "+1sd",
    },
    {
      month: 185,
      y: 168.959,
      name: "+1sd",
    },
    {
      month: 186,
      y: 169.023,
      name: "+1sd",
    },
    {
      month: 187,
      y: 169.082,
      name: "+1sd",
    },
    {
      month: 188,
      y: 169.134,
      name: "+1sd",
    },
    {
      month: 189,
      y: 169.183,
      name: "+1sd",
    },
    {
      month: 190,
      y: 169.228,
      name: "+1sd",
    },
    {
      month: 191,
      y: 169.266,
      name: "+1sd",
    },
    {
      month: 192,
      y: 169.302,
      name: "+1sd",
    },
    {
      month: 193,
      y: 169.335,
      name: "+1sd",
    },
    {
      month: 194,
      y: 169.364,
      name: "+1sd",
    },
    {
      month: 195,
      y: 169.39,
      name: "+1sd",
    },
    {
      month: 196,
      y: 169.413,
      name: "+1sd",
    },
    {
      month: 197,
      y: 169.436,
      name: "+1sd",
    },
    {
      month: 198,
      y: 169.455,
      name: "+1sd",
    },
    {
      month: 199,
      y: 169.474,
      name: "+1sd",
    },
    {
      month: 200,
      y: 169.489,
      name: "+1sd",
    },
    {
      month: 201,
      y: 169.506,
      name: "+1sd",
    },
    {
      month: 202,
      y: 169.519,
      name: "+1sd",
    },
    {
      month: 203,
      y: 169.533,
      name: "+1sd",
    },
    {
      month: 204,
      y: 169.546,
      name: "+1sd",
    },
    {
      month: 205,
      y: 169.559,
      name: "+1sd",
    },
    {
      month: 206,
      y: 169.571,
      name: "+1sd",
    },
    {
      month: 207,
      y: 169.582,
      name: "+1sd",
    },
    {
      month: 208,
      y: 169.592,
      name: "+1sd",
    },
    {
      month: 209,
      y: 169.602,
      name: "+1sd",
    },
    {
      month: 210,
      y: 169.614,
      name: "+1sd",
    },
    {
      month: 211,
      y: 169.623,
      name: "+1sd",
    },
    {
      month: 212,
      y: 169.634,
      name: "+1sd",
    },
    {
      month: 213,
      y: 169.643,
      name: "+1sd",
    },
    {
      month: 214,
      y: 169.652,
      name: "+1sd",
    },
    {
      month: 215,
      y: 169.661,
      name: "+1sd",
    },
    {
      month: 216,
      y: 169.668,
      name: "+1sd",
    },
    {
      month: 217,
      y: 169.676,
      name: "+1sd",
    },
    {
      month: 218,
      y: 169.683,
      name: "+1sd",
    },
    {
      month: 219,
      y: 169.689,
      name: "+1sd",
    },
    {
      month: 220,
      y: 169.694,
      name: "+1sd",
    },
    {
      month: 221,
      y: 169.699,
      name: "+1sd",
    },
    {
      month: 222,
      y: 169.702,
      name: "+1sd",
    },
    {
      month: 223,
      y: 169.703,
      name: "+1sd",
    },
    {
      month: 224,
      y: 169.705,
      name: "+1sd",
    },
    {
      month: 225,
      y: 169.704,
      name: "+1sd",
    },
    {
      month: 226,
      y: 169.703,
      name: "+1sd",
    },
    {
      month: 227,
      y: 169.699,
      name: "+1sd",
    },
    {
      month: 228,
      y: 169.696,
      name: "+1sd",
    },
    {
      month: 0,
      y: 52.9,
      name: "+2sd",
    },
    {
      month: 1,
      y: 57.6,
      name: "+2sd",
    },
    {
      month: 2,
      y: 61.1,
      name: "+2sd",
    },
    {
      month: 3,
      y: 64,
      name: "+2sd",
    },
    {
      month: 4,
      y: 66.4,
      name: "+2sd",
    },
    {
      month: 5,
      y: 68.5,
      name: "+2sd",
    },
    {
      month: 6,
      y: 70.3,
      name: "+2sd",
    },
    {
      month: 7,
      y: 71.9,
      name: "+2sd",
    },
    {
      month: 8,
      y: 73.5,
      name: "+2sd",
    },
    {
      month: 9,
      y: 75,
      name: "+2sd",
    },
    {
      month: 10,
      y: 76.4,
      name: "+2sd",
    },
    {
      month: 11,
      y: 77.8,
      name: "+2sd",
    },
    {
      month: 12,
      y: 79.2,
      name: "+2sd",
    },
    {
      month: 13,
      y: 80.5,
      name: "+2sd",
    },
    {
      month: 14,
      y: 81.7,
      name: "+2sd",
    },
    {
      month: 15,
      y: 83,
      name: "+2sd",
    },
    {
      month: 16,
      y: 84.2,
      name: "+2sd",
    },
    {
      month: 17,
      y: 85.4,
      name: "+2sd",
    },
    {
      month: 18,
      y: 86.5,
      name: "+2sd",
    },
    {
      month: 19,
      y: 87.6,
      name: "+2sd",
    },
    {
      month: 20,
      y: 88.7,
      name: "+2sd",
    },
    {
      month: 21,
      y: 89.8,
      name: "+2sd",
    },
    {
      month: 22,
      y: 90.8,
      name: "+2sd",
    },
    {
      month: 23,
      y: 91.9,
      name: "+2sd",
    },
    {
      month: 24,
      y: 92.2,
      name: "+2sd",
    },
    {
      month: 25,
      y: 93.1,
      name: "+2sd",
    },
    {
      month: 26,
      y: 94.1,
      name: "+2sd",
    },
    {
      month: 27,
      y: 95,
      name: "+2sd",
    },
    {
      month: 28,
      y: 96,
      name: "+2sd",
    },
    {
      month: 29,
      y: 96.9,
      name: "+2sd",
    },
    {
      month: 30,
      y: 97.7,
      name: "+2sd",
    },
    {
      month: 31,
      y: 98.6,
      name: "+2sd",
    },
    {
      month: 32,
      y: 99.4,
      name: "+2sd",
    },
    {
      month: 33,
      y: 100.3,
      name: "+2sd",
    },
    {
      month: 34,
      y: 101.1,
      name: "+2sd",
    },
    {
      month: 35,
      y: 101.9,
      name: "+2sd",
    },
    {
      month: 36,
      y: 102.7,
      name: "+2sd",
    },
    {
      month: 37,
      y: 103.4,
      name: "+2sd",
    },
    {
      month: 38,
      y: 104.2,
      name: "+2sd",
    },
    {
      month: 39,
      y: 105,
      name: "+2sd",
    },
    {
      month: 40,
      y: 105.7,
      name: "+2sd",
    },
    {
      month: 41,
      y: 106.4,
      name: "+2sd",
    },
    {
      month: 42,
      y: 107.2,
      name: "+2sd",
    },
    {
      month: 43,
      y: 107.9,
      name: "+2sd",
    },
    {
      month: 44,
      y: 108.6,
      name: "+2sd",
    },
    {
      month: 45,
      y: 109.3,
      name: "+2sd",
    },
    {
      month: 46,
      y: 110,
      name: "+2sd",
    },
    {
      month: 47,
      y: 110.7,
      name: "+2sd",
    },
    {
      month: 48,
      y: 111.3,
      name: "+2sd",
    },
    {
      month: 49,
      y: 112,
      name: "+2sd",
    },
    {
      month: 50,
      y: 112.7,
      name: "+2sd",
    },
    {
      month: 51,
      y: 113.3,
      name: "+2sd",
    },
    {
      month: 52,
      y: 114,
      name: "+2sd",
    },
    {
      month: 53,
      y: 114.6,
      name: "+2sd",
    },
    {
      month: 54,
      y: 115.2,
      name: "+2sd",
    },
    {
      month: 55,
      y: 115.9,
      name: "+2sd",
    },
    {
      month: 56,
      y: 116.5,
      name: "+2sd",
    },
    {
      month: 57,
      y: 117.1,
      name: "+2sd",
    },
    {
      month: 58,
      y: 117.7,
      name: "+2sd",
    },
    {
      month: 59,
      y: 118.3,
      name: "+2sd",
    },
    {
      month: 60,
      y: 118.9,
      name: "+2sd",
    },
    {
      month: 61,
      y: 119.148,
      name: "+2sd",
    },
    {
      month: 62,
      y: 119.738,
      name: "+2sd",
    },
    {
      month: 63,
      y: 120.322,
      name: "+2sd",
    },
    {
      month: 64,
      y: 120.902,
      name: "+2sd",
    },
    {
      month: 65,
      y: 121.474,
      name: "+2sd",
    },
    {
      month: 66,
      y: 122.044,
      name: "+2sd",
    },
    {
      month: 67,
      y: 122.608,
      name: "+2sd",
    },
    {
      month: 68,
      y: 123.167,
      name: "+2sd",
    },
    {
      month: 69,
      y: 123.722,
      name: "+2sd",
    },
    {
      month: 70,
      y: 124.273,
      name: "+2sd",
    },
    {
      month: 71,
      y: 124.82,
      name: "+2sd",
    },
    {
      month: 72,
      y: 125.364,
      name: "+2sd",
    },
    {
      month: 73,
      y: 125.902,
      name: "+2sd",
    },
    {
      month: 74,
      y: 126.438,
      name: "+2sd",
    },
    {
      month: 75,
      y: 126.975,
      name: "+2sd",
    },
    {
      month: 76,
      y: 127.505,
      name: "+2sd",
    },
    {
      month: 77,
      y: 128.037,
      name: "+2sd",
    },
    {
      month: 78,
      y: 128.569,
      name: "+2sd",
    },
    {
      month: 79,
      y: 129.097,
      name: "+2sd",
    },
    {
      month: 80,
      y: 129.628,
      name: "+2sd",
    },
    {
      month: 81,
      y: 130.157,
      name: "+2sd",
    },
    {
      month: 82,
      y: 130.686,
      name: "+2sd",
    },
    {
      month: 83,
      y: 131.216,
      name: "+2sd",
    },
    {
      month: 84,
      y: 131.744,
      name: "+2sd",
    },
    {
      month: 85,
      y: 132.275,
      name: "+2sd",
    },
    {
      month: 86,
      y: 132.805,
      name: "+2sd",
    },
    {
      month: 87,
      y: 133.338,
      name: "+2sd",
    },
    {
      month: 88,
      y: 133.869,
      name: "+2sd",
    },
    {
      month: 89,
      y: 134.399,
      name: "+2sd",
    },
    {
      month: 90,
      y: 134.933,
      name: "+2sd",
    },
    {
      month: 91,
      y: 135.468,
      name: "+2sd",
    },
    {
      month: 92,
      y: 136.002,
      name: "+2sd",
    },
    {
      month: 93,
      y: 136.537,
      name: "+2sd",
    },
    {
      month: 94,
      y: 137.073,
      name: "+2sd",
    },
    {
      month: 95,
      y: 137.611,
      name: "+2sd",
    },
    {
      month: 96,
      y: 138.151,
      name: "+2sd",
    },
    {
      month: 97,
      y: 138.692,
      name: "+2sd",
    },
    {
      month: 98,
      y: 139.233,
      name: "+2sd",
    },
    {
      month: 99,
      y: 139.775,
      name: "+2sd",
    },
    {
      month: 100,
      y: 140.318,
      name: "+2sd",
    },
    {
      month: 101,
      y: 140.864,
      name: "+2sd",
    },
    {
      month: 102,
      y: 141.411,
      name: "+2sd",
    },
    {
      month: 103,
      y: 141.958,
      name: "+2sd",
    },
    {
      month: 104,
      y: 142.506,
      name: "+2sd",
    },
    {
      month: 105,
      y: 143.058,
      name: "+2sd",
    },
    {
      month: 106,
      y: 143.608,
      name: "+2sd",
    },
    {
      month: 107,
      y: 144.161,
      name: "+2sd",
    },
    {
      month: 108,
      y: 144.716,
      name: "+2sd",
    },
    {
      month: 109,
      y: 145.269,
      name: "+2sd",
    },
    {
      month: 110,
      y: 145.824,
      name: "+2sd",
    },
    {
      month: 111,
      y: 146.381,
      name: "+2sd",
    },
    {
      month: 112,
      y: 146.939,
      name: "+2sd",
    },
    {
      month: 113,
      y: 147.496,
      name: "+2sd",
    },
    {
      month: 114,
      y: 148.057,
      name: "+2sd",
    },
    {
      month: 115,
      y: 148.616,
      name: "+2sd",
    },
    {
      month: 116,
      y: 149.175,
      name: "+2sd",
    },
    {
      month: 117,
      y: 149.738,
      name: "+2sd",
    },
    {
      month: 118,
      y: 150.302,
      name: "+2sd",
    },
    {
      month: 119,
      y: 150.865,
      name: "+2sd",
    },
    {
      month: 120,
      y: 151.43,
      name: "+2sd",
    },
    {
      month: 121,
      y: 151.993,
      name: "+2sd",
    },
    {
      month: 122,
      y: 152.562,
      name: "+2sd",
    },
    {
      month: 123,
      y: 153.129,
      name: "+2sd",
    },
    {
      month: 124,
      y: 153.698,
      name: "+2sd",
    },
    {
      month: 125,
      y: 154.269,
      name: "+2sd",
    },
    {
      month: 126,
      y: 154.842,
      name: "+2sd",
    },
    {
      month: 127,
      y: 155.414,
      name: "+2sd",
    },
    {
      month: 128,
      y: 155.987,
      name: "+2sd",
    },
    {
      month: 129,
      y: 156.562,
      name: "+2sd",
    },
    {
      month: 130,
      y: 157.137,
      name: "+2sd",
    },
    {
      month: 131,
      y: 157.713,
      name: "+2sd",
    },
    {
      month: 132,
      y: 158.286,
      name: "+2sd",
    },
    {
      month: 133,
      y: 158.858,
      name: "+2sd",
    },
    {
      month: 134,
      y: 159.43,
      name: "+2sd",
    },
    {
      month: 135,
      y: 159.997,
      name: "+2sd",
    },
    {
      month: 136,
      y: 160.565,
      name: "+2sd",
    },
    {
      month: 137,
      y: 161.127,
      name: "+2sd",
    },
    {
      month: 138,
      y: 161.686,
      name: "+2sd",
    },
    {
      month: 139,
      y: 162.24,
      name: "+2sd",
    },
    {
      month: 140,
      y: 162.787,
      name: "+2sd",
    },
    {
      month: 141,
      y: 163.331,
      name: "+2sd",
    },
    {
      month: 142,
      y: 163.866,
      name: "+2sd",
    },
    {
      month: 143,
      y: 164.393,
      name: "+2sd",
    },
    {
      month: 144,
      y: 164.913,
      name: "+2sd",
    },
    {
      month: 145,
      y: 165.421,
      name: "+2sd",
    },
    {
      month: 146,
      y: 165.923,
      name: "+2sd",
    },
    {
      month: 147,
      y: 166.412,
      name: "+2sd",
    },
    {
      month: 148,
      y: 166.892,
      name: "+2sd",
    },
    {
      month: 149,
      y: 167.358,
      name: "+2sd",
    },
    {
      month: 150,
      y: 167.812,
      name: "+2sd",
    },
    {
      month: 151,
      y: 168.253,
      name: "+2sd",
    },
    {
      month: 152,
      y: 168.679,
      name: "+2sd",
    },
    {
      month: 153,
      y: 169.095,
      name: "+2sd",
    },
    {
      month: 154,
      y: 169.497,
      name: "+2sd",
    },
    {
      month: 155,
      y: 169.883,
      name: "+2sd",
    },
    {
      month: 156,
      y: 170.258,
      name: "+2sd",
    },
    {
      month: 157,
      y: 170.616,
      name: "+2sd",
    },
    {
      month: 158,
      y: 170.961,
      name: "+2sd",
    },
    {
      month: 159,
      y: 171.291,
      name: "+2sd",
    },
    {
      month: 160,
      y: 171.612,
      name: "+2sd",
    },
    {
      month: 161,
      y: 171.915,
      name: "+2sd",
    },
    {
      month: 162,
      y: 172.205,
      name: "+2sd",
    },
    {
      month: 163,
      y: 172.481,
      name: "+2sd",
    },
    {
      month: 164,
      y: 172.744,
      name: "+2sd",
    },
    {
      month: 165,
      y: 172.998,
      name: "+2sd",
    },
    {
      month: 166,
      y: 173.236,
      name: "+2sd",
    },
    {
      month: 167,
      y: 173.461,
      name: "+2sd",
    },
    {
      month: 168,
      y: 173.675,
      name: "+2sd",
    },
    {
      month: 169,
      y: 173.877,
      name: "+2sd",
    },
    {
      month: 170,
      y: 174.07,
      name: "+2sd",
    },
    {
      month: 171,
      y: 174.249,
      name: "+2sd",
    },
    {
      month: 172,
      y: 174.418,
      name: "+2sd",
    },
    {
      month: 173,
      y: 174.579,
      name: "+2sd",
    },
    {
      month: 174,
      y: 174.726,
      name: "+2sd",
    },
    {
      month: 175,
      y: 174.867,
      name: "+2sd",
    },
    {
      month: 176,
      y: 174.995,
      name: "+2sd",
    },
    {
      month: 177,
      y: 175.117,
      name: "+2sd",
    },
    {
      month: 178,
      y: 175.23,
      name: "+2sd",
    },
    {
      month: 179,
      y: 175.334,
      name: "+2sd",
    },
    {
      month: 180,
      y: 175.427,
      name: "+2sd",
    },
    {
      month: 181,
      y: 175.516,
      name: "+2sd",
    },
    {
      month: 182,
      y: 175.597,
      name: "+2sd",
    },
    {
      month: 183,
      y: 175.674,
      name: "+2sd",
    },
    {
      month: 184,
      y: 175.741,
      name: "+2sd",
    },
    {
      month: 185,
      y: 175.802,
      name: "+2sd",
    },
    {
      month: 186,
      y: 175.857,
      name: "+2sd",
    },
    {
      month: 187,
      y: 175.91,
      name: "+2sd",
    },
    {
      month: 188,
      y: 175.953,
      name: "+2sd",
    },
    {
      month: 189,
      y: 175.995,
      name: "+2sd",
    },
    {
      month: 190,
      y: 176.032,
      name: "+2sd",
    },
    {
      month: 191,
      y: 176.061,
      name: "+2sd",
    },
    {
      month: 192,
      y: 176.089,
      name: "+2sd",
    },
    {
      month: 193,
      y: 176.113,
      name: "+2sd",
    },
    {
      month: 194,
      y: 176.134,
      name: "+2sd",
    },
    {
      month: 195,
      y: 176.152,
      name: "+2sd",
    },
    {
      month: 196,
      y: 176.167,
      name: "+2sd",
    },
    {
      month: 197,
      y: 176.182,
      name: "+2sd",
    },
    {
      month: 198,
      y: 176.193,
      name: "+2sd",
    },
    {
      month: 199,
      y: 176.205,
      name: "+2sd",
    },
    {
      month: 200,
      y: 176.212,
      name: "+2sd",
    },
    {
      month: 201,
      y: 176.221,
      name: "+2sd",
    },
    {
      month: 202,
      y: 176.225,
      name: "+2sd",
    },
    {
      month: 203,
      y: 176.232,
      name: "+2sd",
    },
    {
      month: 204,
      y: 176.238,
      name: "+2sd",
    },
    {
      month: 205,
      y: 176.243,
      name: "+2sd",
    },
    {
      month: 206,
      y: 176.248,
      name: "+2sd",
    },
    {
      month: 207,
      y: 176.251,
      name: "+2sd",
    },
    {
      month: 208,
      y: 176.254,
      name: "+2sd",
    },
    {
      month: 209,
      y: 176.257,
      name: "+2sd",
    },
    {
      month: 210,
      y: 176.263,
      name: "+2sd",
    },
    {
      month: 211,
      y: 176.265,
      name: "+2sd",
    },
    {
      month: 212,
      y: 176.27,
      name: "+2sd",
    },
    {
      month: 213,
      y: 176.271,
      name: "+2sd",
    },
    {
      month: 214,
      y: 176.275,
      name: "+2sd",
    },
    {
      month: 215,
      y: 176.278,
      name: "+2sd",
    },
    {
      month: 216,
      y: 176.277,
      name: "+2sd",
    },
    {
      month: 217,
      y: 176.279,
      name: "+2sd",
    },
    {
      month: 218,
      y: 176.28,
      name: "+2sd",
    },
    {
      month: 219,
      y: 176.28,
      name: "+2sd",
    },
    {
      month: 220,
      y: 176.279,
      name: "+2sd",
    },
    {
      month: 221,
      y: 176.28,
      name: "+2sd",
    },
    {
      month: 222,
      y: 176.276,
      name: "+2sd",
    },
    {
      month: 223,
      y: 176.271,
      name: "+2sd",
    },
    {
      month: 224,
      y: 176.268,
      name: "+2sd",
    },
    {
      month: 225,
      y: 176.261,
      name: "+2sd",
    },
    {
      month: 226,
      y: 176.255,
      name: "+2sd",
    },
    {
      month: 227,
      y: 176.245,
      name: "+2sd",
    },
    {
      month: 228,
      y: 176.237,
      name: "+2sd",
    },
    {
      month: 0,
      y: 54.7,
      name: "+3sd",
    },
    {
      month: 1,
      y: 59.5,
      name: "+3sd",
    },
    {
      month: 2,
      y: 63.2,
      name: "+3sd",
    },
    {
      month: 3,
      y: 66.1,
      name: "+3sd",
    },
    {
      month: 4,
      y: 68.6,
      name: "+3sd",
    },
    {
      month: 5,
      y: 70.7,
      name: "+3sd",
    },
    {
      month: 6,
      y: 72.5,
      name: "+3sd",
    },
    {
      month: 7,
      y: 74.2,
      name: "+3sd",
    },
    {
      month: 8,
      y: 75.8,
      name: "+3sd",
    },
    {
      month: 9,
      y: 77.4,
      name: "+3sd",
    },
    {
      month: 10,
      y: 78.9,
      name: "+3sd",
    },
    {
      month: 11,
      y: 80.3,
      name: "+3sd",
    },
    {
      month: 12,
      y: 81.7,
      name: "+3sd",
    },
    {
      month: 13,
      y: 83.1,
      name: "+3sd",
    },
    {
      month: 14,
      y: 84.4,
      name: "+3sd",
    },
    {
      month: 15,
      y: 85.7,
      name: "+3sd",
    },
    {
      month: 16,
      y: 87,
      name: "+3sd",
    },
    {
      month: 17,
      y: 88.2,
      name: "+3sd",
    },
    {
      month: 18,
      y: 89.4,
      name: "+3sd",
    },
    {
      month: 19,
      y: 90.6,
      name: "+3sd",
    },
    {
      month: 20,
      y: 91.7,
      name: "+3sd",
    },
    {
      month: 21,
      y: 92.9,
      name: "+3sd",
    },
    {
      month: 22,
      y: 94,
      name: "+3sd",
    },
    {
      month: 23,
      y: 95,
      name: "+3sd",
    },
    {
      month: 24,
      y: 95.4,
      name: "+3sd",
    },
    {
      month: 25,
      y: 96.4,
      name: "+3sd",
    },
    {
      month: 26,
      y: 97.4,
      name: "+3sd",
    },
    {
      month: 27,
      y: 98.4,
      name: "+3sd",
    },
    {
      month: 28,
      y: 99.4,
      name: "+3sd",
    },
    {
      month: 29,
      y: 100.3,
      name: "+3sd",
    },
    {
      month: 30,
      y: 101.3,
      name: "+3sd",
    },
    {
      month: 31,
      y: 102.2,
      name: "+3sd",
    },
    {
      month: 32,
      y: 103.1,
      name: "+3sd",
    },
    {
      month: 33,
      y: 103.9,
      name: "+3sd",
    },
    {
      month: 34,
      y: 104.8,
      name: "+3sd",
    },
    {
      month: 35,
      y: 105.6,
      name: "+3sd",
    },
    {
      month: 36,
      y: 106.5,
      name: "+3sd",
    },
    {
      month: 37,
      y: 107.3,
      name: "+3sd",
    },
    {
      month: 38,
      y: 108.1,
      name: "+3sd",
    },
    {
      month: 39,
      y: 108.9,
      name: "+3sd",
    },
    {
      month: 40,
      y: 109.7,
      name: "+3sd",
    },
    {
      month: 41,
      y: 110.5,
      name: "+3sd",
    },
    {
      month: 42,
      y: 111.2,
      name: "+3sd",
    },
    {
      month: 43,
      y: 112,
      name: "+3sd",
    },
    {
      month: 44,
      y: 112.7,
      name: "+3sd",
    },
    {
      month: 45,
      y: 113.5,
      name: "+3sd",
    },
    {
      month: 46,
      y: 114.2,
      name: "+3sd",
    },
    {
      month: 47,
      y: 114.9,
      name: "+3sd",
    },
    {
      month: 48,
      y: 115.7,
      name: "+3sd",
    },
    {
      month: 49,
      y: 116.4,
      name: "+3sd",
    },
    {
      month: 50,
      y: 117.1,
      name: "+3sd",
    },
    {
      month: 51,
      y: 117.7,
      name: "+3sd",
    },
    {
      month: 52,
      y: 118.4,
      name: "+3sd",
    },
    {
      month: 53,
      y: 119.1,
      name: "+3sd",
    },
    {
      month: 54,
      y: 119.8,
      name: "+3sd",
    },
    {
      month: 55,
      y: 120.4,
      name: "+3sd",
    },
    {
      month: 56,
      y: 121.1,
      name: "+3sd",
    },
    {
      month: 57,
      y: 121.8,
      name: "+3sd",
    },
    {
      month: 58,
      y: 122.4,
      name: "+3sd",
    },
    {
      month: 59,
      y: 123.1,
      name: "+3sd",
    },
    {
      month: 60,
      y: 123.7,
      name: "+3sd",
    },
    {
      month: 61,
      y: 123.921,
      name: "+3sd",
    },
    {
      month: 62,
      y: 124.543,
      name: "+3sd",
    },
    {
      month: 63,
      y: 125.161,
      name: "+3sd",
    },
    {
      month: 64,
      y: 125.773,
      name: "+3sd",
    },
    {
      month: 65,
      y: 126.376,
      name: "+3sd",
    },
    {
      month: 66,
      y: 126.979,
      name: "+3sd",
    },
    {
      month: 67,
      y: 127.574,
      name: "+3sd",
    },
    {
      month: 68,
      y: 128.164,
      name: "+3sd",
    },
    {
      month: 69,
      y: 128.75,
      name: "+3sd",
    },
    {
      month: 70,
      y: 129.331,
      name: "+3sd",
    },
    {
      month: 71,
      y: 129.909,
      name: "+3sd",
    },
    {
      month: 72,
      y: 130.483,
      name: "+3sd",
    },
    {
      month: 73,
      y: 131.051,
      name: "+3sd",
    },
    {
      month: 74,
      y: 131.616,
      name: "+3sd",
    },
    {
      month: 75,
      y: 132.184,
      name: "+3sd",
    },
    {
      month: 76,
      y: 132.743,
      name: "+3sd",
    },
    {
      month: 77,
      y: 133.304,
      name: "+3sd",
    },
    {
      month: 78,
      y: 133.865,
      name: "+3sd",
    },
    {
      month: 79,
      y: 134.422,
      name: "+3sd",
    },
    {
      month: 80,
      y: 134.982,
      name: "+3sd",
    },
    {
      month: 81,
      y: 135.539,
      name: "+3sd",
    },
    {
      month: 82,
      y: 136.097,
      name: "+3sd",
    },
    {
      month: 83,
      y: 136.655,
      name: "+3sd",
    },
    {
      month: 84,
      y: 137.211,
      name: "+3sd",
    },
    {
      month: 85,
      y: 137.77,
      name: "+3sd",
    },
    {
      month: 86,
      y: 138.328,
      name: "+3sd",
    },
    {
      month: 87,
      y: 138.889,
      name: "+3sd",
    },
    {
      month: 88,
      y: 139.449,
      name: "+3sd",
    },
    {
      month: 89,
      y: 140.005,
      name: "+3sd",
    },
    {
      month: 90,
      y: 140.567,
      name: "+3sd",
    },
    {
      month: 91,
      y: 141.13,
      name: "+3sd",
    },
    {
      month: 92,
      y: 141.691,
      name: "+3sd",
    },
    {
      month: 93,
      y: 142.253,
      name: "+3sd",
    },
    {
      month: 94,
      y: 142.816,
      name: "+3sd",
    },
    {
      month: 95,
      y: 143.381,
      name: "+3sd",
    },
    {
      month: 96,
      y: 143.948,
      name: "+3sd",
    },
    {
      month: 97,
      y: 144.517,
      name: "+3sd",
    },
    {
      month: 98,
      y: 145.084,
      name: "+3sd",
    },
    {
      month: 99,
      y: 145.652,
      name: "+3sd",
    },
    {
      month: 100,
      y: 146.222,
      name: "+3sd",
    },
    {
      month: 101,
      y: 146.794,
      name: "+3sd",
    },
    {
      month: 102,
      y: 147.368,
      name: "+3sd",
    },
    {
      month: 103,
      y: 147.94,
      name: "+3sd",
    },
    {
      month: 104,
      y: 148.514,
      name: "+3sd",
    },
    {
      month: 105,
      y: 149.093,
      name: "+3sd",
    },
    {
      month: 106,
      y: 149.667,
      name: "+3sd",
    },
    {
      month: 107,
      y: 150.246,
      name: "+3sd",
    },
    {
      month: 108,
      y: 150.826,
      name: "+3sd",
    },
    {
      month: 109,
      y: 151.405,
      name: "+3sd",
    },
    {
      month: 110,
      y: 151.984,
      name: "+3sd",
    },
    {
      month: 111,
      y: 152.566,
      name: "+3sd",
    },
    {
      month: 112,
      y: 153.149,
      name: "+3sd",
    },
    {
      month: 113,
      y: 153.729,
      name: "+3sd",
    },
    {
      month: 114,
      y: 154.315,
      name: "+3sd",
    },
    {
      month: 115,
      y: 154.898,
      name: "+3sd",
    },
    {
      month: 116,
      y: 155.479,
      name: "+3sd",
    },
    {
      month: 117,
      y: 156.065,
      name: "+3sd",
    },
    {
      month: 118,
      y: 156.653,
      name: "+3sd",
    },
    {
      month: 119,
      y: 157.239,
      name: "+3sd",
    },
    {
      month: 120,
      y: 157.826,
      name: "+3sd",
    },
    {
      month: 121,
      y: 158.411,
      name: "+3sd",
    },
    {
      month: 122,
      y: 159.002,
      name: "+3sd",
    },
    {
      month: 123,
      y: 159.591,
      name: "+3sd",
    },
    {
      month: 124,
      y: 160.182,
      name: "+3sd",
    },
    {
      month: 125,
      y: 160.774,
      name: "+3sd",
    },
    {
      month: 126,
      y: 161.369,
      name: "+3sd",
    },
    {
      month: 127,
      y: 161.961,
      name: "+3sd",
    },
    {
      month: 128,
      y: 162.554,
      name: "+3sd",
    },
    {
      month: 129,
      y: 163.149,
      name: "+3sd",
    },
    {
      month: 130,
      y: 163.745,
      name: "+3sd",
    },
    {
      month: 131,
      y: 164.341,
      name: "+3sd",
    },
    {
      month: 132,
      y: 164.932,
      name: "+3sd",
    },
    {
      month: 133,
      y: 165.524,
      name: "+3sd",
    },
    {
      month: 134,
      y: 166.114,
      name: "+3sd",
    },
    {
      month: 135,
      y: 166.698,
      name: "+3sd",
    },
    {
      month: 136,
      y: 167.284,
      name: "+3sd",
    },
    {
      month: 137,
      y: 167.863,
      name: "+3sd",
    },
    {
      month: 138,
      y: 168.438,
      name: "+3sd",
    },
    {
      month: 139,
      y: 169.009,
      name: "+3sd",
    },
    {
      month: 140,
      y: 169.57,
      name: "+3sd",
    },
    {
      month: 141,
      y: 170.13,
      name: "+3sd",
    },
    {
      month: 142,
      y: 170.679,
      name: "+3sd",
    },
    {
      month: 143,
      y: 171.22,
      name: "+3sd",
    },
    {
      month: 144,
      y: 171.753,
      name: "+3sd",
    },
    {
      month: 145,
      y: 172.273,
      name: "+3sd",
    },
    {
      month: 146,
      y: 172.787,
      name: "+3sd",
    },
    {
      month: 147,
      y: 173.286,
      name: "+3sd",
    },
    {
      month: 148,
      y: 173.778,
      name: "+3sd",
    },
    {
      month: 149,
      y: 174.253,
      name: "+3sd",
    },
    {
      month: 150,
      y: 174.716,
      name: "+3sd",
    },
    {
      month: 151,
      y: 175.166,
      name: "+3sd",
    },
    {
      month: 152,
      y: 175.597,
      name: "+3sd",
    },
    {
      month: 153,
      y: 176.02,
      name: "+3sd",
    },
    {
      month: 154,
      y: 176.429,
      name: "+3sd",
    },
    {
      month: 155,
      y: 176.819,
      name: "+3sd",
    },
    {
      month: 156,
      y: 177.199,
      name: "+3sd",
    },
    {
      month: 157,
      y: 177.561,
      name: "+3sd",
    },
    {
      month: 158,
      y: 177.908,
      name: "+3sd",
    },
    {
      month: 159,
      y: 178.24,
      name: "+3sd",
    },
    {
      month: 160,
      y: 178.564,
      name: "+3sd",
    },
    {
      month: 161,
      y: 178.868,
      name: "+3sd",
    },
    {
      month: 162,
      y: 179.157,
      name: "+3sd",
    },
    {
      month: 163,
      y: 179.433,
      name: "+3sd",
    },
    {
      month: 164,
      y: 179.695,
      name: "+3sd",
    },
    {
      month: 165,
      y: 179.949,
      name: "+3sd",
    },
    {
      month: 166,
      y: 180.184,
      name: "+3sd",
    },
    {
      month: 167,
      y: 180.407,
      name: "+3sd",
    },
    {
      month: 168,
      y: 180.617,
      name: "+3sd",
    },
    {
      month: 169,
      y: 180.816,
      name: "+3sd",
    },
    {
      month: 170,
      y: 181.007,
      name: "+3sd",
    },
    {
      month: 171,
      y: 181.181,
      name: "+3sd",
    },
    {
      month: 172,
      y: 181.345,
      name: "+3sd",
    },
    {
      month: 173,
      y: 181.502,
      name: "+3sd",
    },
    {
      month: 174,
      y: 181.643,
      name: "+3sd",
    },
    {
      month: 175,
      y: 181.779,
      name: "+3sd",
    },
    {
      month: 176,
      y: 181.9,
      name: "+3sd",
    },
    {
      month: 177,
      y: 182.016,
      name: "+3sd",
    },
    {
      month: 178,
      y: 182.123,
      name: "+3sd",
    },
    {
      month: 179,
      y: 182.221,
      name: "+3sd",
    },
    {
      month: 180,
      y: 182.306,
      name: "+3sd",
    },
    {
      month: 181,
      y: 182.388,
      name: "+3sd",
    },
    {
      month: 182,
      y: 182.462,
      name: "+3sd",
    },
    {
      month: 183,
      y: 182.533,
      name: "+3sd",
    },
    {
      month: 184,
      y: 182.592,
      name: "+3sd",
    },
    {
      month: 185,
      y: 182.645,
      name: "+3sd",
    },
    {
      month: 186,
      y: 182.692,
      name: "+3sd",
    },
    {
      month: 187,
      y: 182.737,
      name: "+3sd",
    },
    {
      month: 188,
      y: 182.772,
      name: "+3sd",
    },
    {
      month: 189,
      y: 182.806,
      name: "+3sd",
    },
    {
      month: 190,
      y: 182.836,
      name: "+3sd",
    },
    {
      month: 191,
      y: 182.855,
      name: "+3sd",
    },
    {
      month: 192,
      y: 182.876,
      name: "+3sd",
    },
    {
      month: 193,
      y: 182.892,
      name: "+3sd",
    },
    {
      month: 194,
      y: 182.904,
      name: "+3sd",
    },
    {
      month: 195,
      y: 182.914,
      name: "+3sd",
    },
    {
      month: 196,
      y: 182.92,
      name: "+3sd",
    },
    {
      month: 197,
      y: 182.929,
      name: "+3sd",
    },
    {
      month: 198,
      y: 182.931,
      name: "+3sd",
    },
    {
      month: 199,
      y: 182.936,
      name: "+3sd",
    },
    {
      month: 200,
      y: 182.934,
      name: "+3sd",
    },
    {
      month: 201,
      y: 182.936,
      name: "+3sd",
    },
    {
      month: 202,
      y: 182.931,
      name: "+3sd",
    },
    {
      month: 203,
      y: 182.931,
      name: "+3sd",
    },
    {
      month: 204,
      y: 182.93,
      name: "+3sd",
    },
    {
      month: 205,
      y: 182.927,
      name: "+3sd",
    },
    {
      month: 206,
      y: 182.925,
      name: "+3sd",
    },
    {
      month: 207,
      y: 182.921,
      name: "+3sd",
    },
    {
      month: 208,
      y: 182.917,
      name: "+3sd",
    },
    {
      month: 209,
      y: 182.912,
      name: "+3sd",
    },
    {
      month: 210,
      y: 182.912,
      name: "+3sd",
    },
    {
      month: 211,
      y: 182.906,
      name: "+3sd",
    },
    {
      month: 212,
      y: 182.905,
      name: "+3sd",
    },
    {
      month: 213,
      y: 182.899,
      name: "+3sd",
    },
    {
      month: 214,
      y: 182.897,
      name: "+3sd",
    },
    {
      month: 215,
      y: 182.894,
      name: "+3sd",
    },
    {
      month: 216,
      y: 182.886,
      name: "+3sd",
    },
    {
      month: 217,
      y: 182.882,
      name: "+3sd",
    },
    {
      month: 218,
      y: 182.877,
      name: "+3sd",
    },
    {
      month: 219,
      y: 182.871,
      name: "+3sd",
    },
    {
      month: 220,
      y: 182.863,
      name: "+3sd",
    },
    {
      month: 221,
      y: 182.86,
      name: "+3sd",
    },
    {
      month: 222,
      y: 182.85,
      name: "+3sd",
    },
    {
      month: 223,
      y: 182.839,
      name: "+3sd",
    },
    {
      month: 224,
      y: 182.831,
      name: "+3sd",
    },
    {
      month: 225,
      y: 182.818,
      name: "+3sd",
    },
    {
      month: 226,
      y: 182.807,
      name: "+3sd",
    },
    {
      month: 227,
      y: 182.791,
      name: "+3sd",
    },
    {
      month: 228,
      y: 182.777,
      name: "+3sd",
    },
  ] as any[],

  boys_size: [
    {
      month: 0,
      y: 44.2,
      name: "-3sd",
    },
    {
      month: 1,
      y: 48.9,
      name: "-3sd",
    },
    {
      month: 2,
      y: 52.4,
      name: "-3sd",
    },
    {
      month: 3,
      y: 55.3,
      name: "-3sd",
    },
    {
      month: 4,
      y: 57.6,
      name: "-3sd",
    },
    {
      month: 5,
      y: 59.6,
      name: "-3sd",
    },
    {
      month: 6,
      y: 61.2,
      name: "-3sd",
    },
    {
      month: 7,
      y: 62.7,
      name: "-3sd",
    },
    {
      month: 8,
      y: 64,
      name: "-3sd",
    },
    {
      month: 9,
      y: 65.2,
      name: "-3sd",
    },
    {
      month: 10,
      y: 66.4,
      name: "-3sd",
    },
    {
      month: 11,
      y: 67.6,
      name: "-3sd",
    },
    {
      month: 12,
      y: 68.6,
      name: "-3sd",
    },
    {
      month: 13,
      y: 69.6,
      name: "-3sd",
    },
    {
      month: 14,
      y: 70.6,
      name: "-3sd",
    },
    {
      month: 15,
      y: 71.6,
      name: "-3sd",
    },
    {
      month: 16,
      y: 72.5,
      name: "-3sd",
    },
    {
      month: 17,
      y: 73.3,
      name: "-3sd",
    },
    {
      month: 18,
      y: 74.2,
      name: "-3sd",
    },
    {
      month: 19,
      y: 75,
      name: "-3sd",
    },
    {
      month: 20,
      y: 75.8,
      name: "-3sd",
    },
    {
      month: 21,
      y: 76.5,
      name: "-3sd",
    },
    {
      month: 22,
      y: 77.2,
      name: "-3sd",
    },
    {
      month: 23,
      y: 78,
      name: "-3sd",
    },
    {
      month: 24,
      y: 78,
      name: "-3sd",
    },
    {
      month: 25,
      y: 78.6,
      name: "-3sd",
    },
    {
      month: 26,
      y: 79.3,
      name: "-3sd",
    },
    {
      month: 27,
      y: 79.9,
      name: "-3sd",
    },
    {
      month: 28,
      y: 80.5,
      name: "-3sd",
    },
    {
      month: 29,
      y: 81.1,
      name: "-3sd",
    },
    {
      month: 30,
      y: 81.7,
      name: "-3sd",
    },
    {
      month: 31,
      y: 82.3,
      name: "-3sd",
    },
    {
      month: 32,
      y: 82.8,
      name: "-3sd",
    },
    {
      month: 33,
      y: 83.4,
      name: "-3sd",
    },
    {
      month: 34,
      y: 83.9,
      name: "-3sd",
    },
    {
      month: 35,
      y: 84.4,
      name: "-3sd",
    },
    {
      month: 36,
      y: 85,
      name: "-3sd",
    },
    {
      month: 37,
      y: 85.5,
      name: "-3sd",
    },
    {
      month: 38,
      y: 86,
      name: "-3sd",
    },
    {
      month: 39,
      y: 86.5,
      name: "-3sd",
    },
    {
      month: 40,
      y: 87,
      name: "-3sd",
    },
    {
      month: 41,
      y: 87.5,
      name: "-3sd",
    },
    {
      month: 42,
      y: 88,
      name: "-3sd",
    },
    {
      month: 43,
      y: 88.4,
      name: "-3sd",
    },
    {
      month: 44,
      y: 88.9,
      name: "-3sd",
    },
    {
      month: 45,
      y: 89.4,
      name: "-3sd",
    },
    {
      month: 46,
      y: 89.8,
      name: "-3sd",
    },
    {
      month: 47,
      y: 90.3,
      name: "-3sd",
    },
    {
      month: 48,
      y: 90.7,
      name: "-3sd",
    },
    {
      month: 49,
      y: 91.2,
      name: "-3sd",
    },
    {
      month: 50,
      y: 91.6,
      name: "-3sd",
    },
    {
      month: 51,
      y: 92.1,
      name: "-3sd",
    },
    {
      month: 52,
      y: 92.5,
      name: "-3sd",
    },
    {
      month: 53,
      y: 93,
      name: "-3sd",
    },
    {
      month: 54,
      y: 93.4,
      name: "-3sd",
    },
    {
      month: 55,
      y: 93.9,
      name: "-3sd",
    },
    {
      month: 56,
      y: 94.3,
      name: "-3sd",
    },
    {
      month: 57,
      y: 94.7,
      name: "-3sd",
    },
    {
      month: 58,
      y: 95.2,
      name: "-3sd",
    },
    {
      month: 59,
      y: 95.6,
      name: "-3sd",
    },
    {
      month: 60,
      y: 96.1,
      name: "-3sd",
    },
    {
      month: 61,
      y: 96.49,
      name: "-3sd",
    },
    {
      month: 62,
      y: 96.933,
      name: "-3sd",
    },
    {
      month: 63,
      y: 97.373,
      name: "-3sd",
    },
    {
      month: 64,
      y: 97.812,
      name: "-3sd",
    },
    {
      month: 65,
      y: 98.245,
      name: "-3sd",
    },
    {
      month: 66,
      y: 98.674,
      name: "-3sd",
    },
    {
      month: 67,
      y: 99.099,
      name: "-3sd",
    },
    {
      month: 68,
      y: 99.523,
      name: "-3sd",
    },
    {
      month: 69,
      y: 99.94,
      name: "-3sd",
    },
    {
      month: 70,
      y: 100.353,
      name: "-3sd",
    },
    {
      month: 71,
      y: 100.766,
      name: "-3sd",
    },
    {
      month: 72,
      y: 101.171,
      name: "-3sd",
    },
    {
      month: 73,
      y: 101.572,
      name: "-3sd",
    },
    {
      month: 74,
      y: 101.974,
      name: "-3sd",
    },
    {
      month: 75,
      y: 102.371,
      name: "-3sd",
    },
    {
      month: 76,
      y: 102.766,
      name: "-3sd",
    },
    {
      month: 77,
      y: 103.162,
      name: "-3sd",
    },
    {
      month: 78,
      y: 103.554,
      name: "-3sd",
    },
    {
      month: 79,
      y: 103.944,
      name: "-3sd",
    },
    {
      month: 80,
      y: 104.333,
      name: "-3sd",
    },
    {
      month: 81,
      y: 104.724,
      name: "-3sd",
    },
    {
      month: 82,
      y: 105.11,
      name: "-3sd",
    },
    {
      month: 83,
      y: 105.494,
      name: "-3sd",
    },
    {
      month: 84,
      y: 105.877,
      name: "-3sd",
    },
    {
      month: 85,
      y: 106.258,
      name: "-3sd",
    },
    {
      month: 86,
      y: 106.636,
      name: "-3sd",
    },
    {
      month: 87,
      y: 107.014,
      name: "-3sd",
    },
    {
      month: 88,
      y: 107.389,
      name: "-3sd",
    },
    {
      month: 89,
      y: 107.763,
      name: "-3sd",
    },
    {
      month: 90,
      y: 108.135,
      name: "-3sd",
    },
    {
      month: 91,
      y: 108.504,
      name: "-3sd",
    },
    {
      month: 92,
      y: 108.872,
      name: "-3sd",
    },
    {
      month: 93,
      y: 109.237,
      name: "-3sd",
    },
    {
      month: 94,
      y: 109.601,
      name: "-3sd",
    },
    {
      month: 95,
      y: 109.962,
      name: "-3sd",
    },
    {
      month: 96,
      y: 110.321,
      name: "-3sd",
    },
    {
      month: 97,
      y: 110.679,
      name: "-3sd",
    },
    {
      month: 98,
      y: 111.034,
      name: "-3sd",
    },
    {
      month: 99,
      y: 111.389,
      name: "-3sd",
    },
    {
      month: 100,
      y: 111.741,
      name: "-3sd",
    },
    {
      month: 101,
      y: 112.093,
      name: "-3sd",
    },
    {
      month: 102,
      y: 112.44,
      name: "-3sd",
    },
    {
      month: 103,
      y: 112.79,
      name: "-3sd",
    },
    {
      month: 104,
      y: 113.139,
      name: "-3sd",
    },
    {
      month: 105,
      y: 113.488,
      name: "-3sd",
    },
    {
      month: 106,
      y: 113.835,
      name: "-3sd",
    },
    {
      month: 107,
      y: 114.183,
      name: "-3sd",
    },
    {
      month: 108,
      y: 114.53,
      name: "-3sd",
    },
    {
      month: 109,
      y: 114.876,
      name: "-3sd",
    },
    {
      month: 110,
      y: 115.222,
      name: "-3sd",
    },
    {
      month: 111,
      y: 115.567,
      name: "-3sd",
    },
    {
      month: 112,
      y: 115.915,
      name: "-3sd",
    },
    {
      month: 113,
      y: 116.258,
      name: "-3sd",
    },
    {
      month: 114,
      y: 116.601,
      name: "-3sd",
    },
    {
      month: 115,
      y: 116.946,
      name: "-3sd",
    },
    {
      month: 116,
      y: 117.287,
      name: "-3sd",
    },
    {
      month: 117,
      y: 117.632,
      name: "-3sd",
    },
    {
      month: 118,
      y: 117.972,
      name: "-3sd",
    },
    {
      month: 119,
      y: 118.315,
      name: "-3sd",
    },
    {
      month: 120,
      y: 118.658,
      name: "-3sd",
    },
    {
      month: 121,
      y: 119.002,
      name: "-3sd",
    },
    {
      month: 122,
      y: 119.346,
      name: "-3sd",
    },
    {
      month: 123,
      y: 119.691,
      name: "-3sd",
    },
    {
      month: 124,
      y: 120.037,
      name: "-3sd",
    },
    {
      month: 125,
      y: 120.384,
      name: "-3sd",
    },
    {
      month: 126,
      y: 120.738,
      name: "-3sd",
    },
    {
      month: 127,
      y: 121.09,
      name: "-3sd",
    },
    {
      month: 128,
      y: 121.449,
      name: "-3sd",
    },
    {
      month: 129,
      y: 121.811,
      name: "-3sd",
    },
    {
      month: 130,
      y: 122.177,
      name: "-3sd",
    },
    {
      month: 131,
      y: 122.545,
      name: "-3sd",
    },
    {
      month: 132,
      y: 122.921,
      name: "-3sd",
    },
    {
      month: 133,
      y: 123.296,
      name: "-3sd",
    },
    {
      month: 134,
      y: 123.679,
      name: "-3sd",
    },
    {
      month: 135,
      y: 124.067,
      name: "-3sd",
    },
    {
      month: 136,
      y: 124.463,
      name: "-3sd",
    },
    {
      month: 137,
      y: 124.859,
      name: "-3sd",
    },
    {
      month: 138,
      y: 125.264,
      name: "-3sd",
    },
    {
      month: 139,
      y: 125.675,
      name: "-3sd",
    },
    {
      month: 140,
      y: 126.09,
      name: "-3sd",
    },
    {
      month: 141,
      y: 126.511,
      name: "-3sd",
    },
    {
      month: 142,
      y: 126.943,
      name: "-3sd",
    },
    {
      month: 143,
      y: 127.38,
      name: "-3sd",
    },
    {
      month: 144,
      y: 127.823,
      name: "-3sd",
    },
    {
      month: 145,
      y: 128.278,
      name: "-3sd",
    },
    {
      month: 146,
      y: 128.734,
      name: "-3sd",
    },
    {
      month: 147,
      y: 129.207,
      name: "-3sd",
    },
    {
      month: 148,
      y: 129.681,
      name: "-3sd",
    },
    {
      month: 149,
      y: 130.167,
      name: "-3sd",
    },
    {
      month: 150,
      y: 130.66,
      name: "-3sd",
    },
    {
      month: 151,
      y: 131.163,
      name: "-3sd",
    },
    {
      month: 152,
      y: 131.668,
      name: "-3sd",
    },
    {
      month: 153,
      y: 132.185,
      name: "-3sd",
    },
    {
      month: 154,
      y: 132.703,
      name: "-3sd",
    },
    {
      month: 155,
      y: 133.228,
      name: "-3sd",
    },
    {
      month: 156,
      y: 133.76,
      name: "-3sd",
    },
    {
      month: 157,
      y: 134.293,
      name: "-3sd",
    },
    {
      month: 158,
      y: 134.827,
      name: "-3sd",
    },
    {
      month: 159,
      y: 135.361,
      name: "-3sd",
    },
    {
      month: 160,
      y: 135.898,
      name: "-3sd",
    },
    {
      month: 161,
      y: 136.437,
      name: "-3sd",
    },
    {
      month: 162,
      y: 136.968,
      name: "-3sd",
    },
    {
      month: 163,
      y: 137.5,
      name: "-3sd",
    },
    {
      month: 164,
      y: 138.032,
      name: "-3sd",
    },
    {
      month: 165,
      y: 138.559,
      name: "-3sd",
    },
    {
      month: 166,
      y: 139.08,
      name: "-3sd",
    },
    {
      month: 167,
      y: 139.594,
      name: "-3sd",
    },
    {
      month: 168,
      y: 140.104,
      name: "-3sd",
    },
    {
      month: 169,
      y: 140.611,
      name: "-3sd",
    },
    {
      month: 170,
      y: 141.104,
      name: "-3sd",
    },
    {
      month: 171,
      y: 141.592,
      name: "-3sd",
    },
    {
      month: 172,
      y: 142.07,
      name: "-3sd",
    },
    {
      month: 173,
      y: 142.541,
      name: "-3sd",
    },
    {
      month: 174,
      y: 143.001,
      name: "-3sd",
    },
    {
      month: 175,
      y: 143.449,
      name: "-3sd",
    },
    {
      month: 176,
      y: 143.886,
      name: "-3sd",
    },
    {
      month: 177,
      y: 144.317,
      name: "-3sd",
    },
    {
      month: 178,
      y: 144.738,
      name: "-3sd",
    },
    {
      month: 179,
      y: 145.147,
      name: "-3sd",
    },
    {
      month: 180,
      y: 145.545,
      name: "-3sd",
    },
    {
      month: 181,
      y: 145.938,
      name: "-3sd",
    },
    {
      month: 182,
      y: 146.32,
      name: "-3sd",
    },
    {
      month: 183,
      y: 146.691,
      name: "-3sd",
    },
    {
      month: 184,
      y: 147.051,
      name: "-3sd",
    },
    {
      month: 185,
      y: 147.4,
      name: "-3sd",
    },
    {
      month: 186,
      y: 147.739,
      name: "-3sd",
    },
    {
      month: 187,
      y: 148.073,
      name: "-3sd",
    },
    {
      month: 188,
      y: 148.392,
      name: "-3sd",
    },
    {
      month: 189,
      y: 148.705,
      name: "-3sd",
    },
    {
      month: 190,
      y: 149.009,
      name: "-3sd",
    },
    {
      month: 191,
      y: 149.298,
      name: "-3sd",
    },
    {
      month: 192,
      y: 149.582,
      name: "-3sd",
    },
    {
      month: 193,
      y: 149.855,
      name: "-3sd",
    },
    {
      month: 194,
      y: 150.119,
      name: "-3sd",
    },
    {
      month: 195,
      y: 150.373,
      name: "-3sd",
    },
    {
      month: 196,
      y: 150.617,
      name: "-3sd",
    },
    {
      month: 197,
      y: 150.851,
      name: "-3sd",
    },
    {
      month: 198,
      y: 151.076,
      name: "-3sd",
    },
    {
      month: 199,
      y: 151.291,
      name: "-3sd",
    },
    {
      month: 200,
      y: 151.497,
      name: "-3sd",
    },
    {
      month: 201,
      y: 151.695,
      name: "-3sd",
    },
    {
      month: 202,
      y: 151.883,
      name: "-3sd",
    },
    {
      month: 203,
      y: 152.057,
      name: "-3sd",
    },
    {
      month: 204,
      y: 152.229,
      name: "-3sd",
    },
    {
      month: 205,
      y: 152.392,
      name: "-3sd",
    },
    {
      month: 206,
      y: 152.543,
      name: "-3sd",
    },
    {
      month: 207,
      y: 152.692,
      name: "-3sd",
    },
    {
      month: 208,
      y: 152.828,
      name: "-3sd",
    },
    {
      month: 209,
      y: 152.964,
      name: "-3sd",
    },
    {
      month: 210,
      y: 153.088,
      name: "-3sd",
    },
    {
      month: 211,
      y: 153.207,
      name: "-3sd",
    },
    {
      month: 212,
      y: 153.321,
      name: "-3sd",
    },
    {
      month: 213,
      y: 153.43,
      name: "-3sd",
    },
    {
      month: 214,
      y: 153.535,
      name: "-3sd",
    },
    {
      month: 215,
      y: 153.636,
      name: "-3sd",
    },
    {
      month: 216,
      y: 153.734,
      name: "-3sd",
    },
    {
      month: 217,
      y: 153.823,
      name: "-3sd",
    },
    {
      month: 218,
      y: 153.915,
      name: "-3sd",
    },
    {
      month: 219,
      y: 153.998,
      name: "-3sd",
    },
    {
      month: 220,
      y: 154.079,
      name: "-3sd",
    },
    {
      month: 221,
      y: 154.158,
      name: "-3sd",
    },
    {
      month: 222,
      y: 154.24,
      name: "-3sd",
    },
    {
      month: 223,
      y: 154.309,
      name: "-3sd",
    },
    {
      month: 224,
      y: 154.383,
      name: "-3sd",
    },
    {
      month: 225,
      y: 154.454,
      name: "-3sd",
    },
    {
      month: 226,
      y: 154.524,
      name: "-3sd",
    },
    {
      month: 227,
      y: 154.587,
      name: "-3sd",
    },
    {
      month: 228,
      y: 154.648,
      name: "-3sd",
    },
    {
      month: 0,
      y: 46.1,
      name: "-2sd",
    },
    {
      month: 1,
      y: 50.8,
      name: "-2sd",
    },
    {
      month: 2,
      y: 54.4,
      name: "-2sd",
    },
    {
      month: 3,
      y: 57.3,
      name: "-2sd",
    },
    {
      month: 4,
      y: 59.7,
      name: "-2sd",
    },
    {
      month: 5,
      y: 61.7,
      name: "-2sd",
    },
    {
      month: 6,
      y: 63.3,
      name: "-2sd",
    },
    {
      month: 7,
      y: 64.8,
      name: "-2sd",
    },
    {
      month: 8,
      y: 66.2,
      name: "-2sd",
    },
    {
      month: 9,
      y: 67.5,
      name: "-2sd",
    },
    {
      month: 10,
      y: 68.7,
      name: "-2sd",
    },
    {
      month: 11,
      y: 69.9,
      name: "-2sd",
    },
    {
      month: 12,
      y: 71,
      name: "-2sd",
    },
    {
      month: 13,
      y: 72.1,
      name: "-2sd",
    },
    {
      month: 14,
      y: 73.1,
      name: "-2sd",
    },
    {
      month: 15,
      y: 74.1,
      name: "-2sd",
    },
    {
      month: 16,
      y: 75,
      name: "-2sd",
    },
    {
      month: 17,
      y: 76,
      name: "-2sd",
    },
    {
      month: 18,
      y: 76.9,
      name: "-2sd",
    },
    {
      month: 19,
      y: 77.7,
      name: "-2sd",
    },
    {
      month: 20,
      y: 78.6,
      name: "-2sd",
    },
    {
      month: 21,
      y: 79.4,
      name: "-2sd",
    },
    {
      month: 22,
      y: 80.2,
      name: "-2sd",
    },
    {
      month: 23,
      y: 81,
      name: "-2sd",
    },
    {
      month: 24,
      y: 81,
      name: "-2sd",
    },
    {
      month: 25,
      y: 81.7,
      name: "-2sd",
    },
    {
      month: 26,
      y: 82.5,
      name: "-2sd",
    },
    {
      month: 27,
      y: 83.1,
      name: "-2sd",
    },
    {
      month: 28,
      y: 83.8,
      name: "-2sd",
    },
    {
      month: 29,
      y: 84.5,
      name: "-2sd",
    },
    {
      month: 30,
      y: 85.1,
      name: "-2sd",
    },
    {
      month: 31,
      y: 85.7,
      name: "-2sd",
    },
    {
      month: 32,
      y: 86.4,
      name: "-2sd",
    },
    {
      month: 33,
      y: 86.9,
      name: "-2sd",
    },
    {
      month: 34,
      y: 87.5,
      name: "-2sd",
    },
    {
      month: 35,
      y: 88.1,
      name: "-2sd",
    },
    {
      month: 36,
      y: 88.7,
      name: "-2sd",
    },
    {
      month: 37,
      y: 89.2,
      name: "-2sd",
    },
    {
      month: 38,
      y: 89.8,
      name: "-2sd",
    },
    {
      month: 39,
      y: 90.3,
      name: "-2sd",
    },
    {
      month: 40,
      y: 90.9,
      name: "-2sd",
    },
    {
      month: 41,
      y: 91.4,
      name: "-2sd",
    },
    {
      month: 42,
      y: 91.9,
      name: "-2sd",
    },
    {
      month: 43,
      y: 92.4,
      name: "-2sd",
    },
    {
      month: 44,
      y: 93,
      name: "-2sd",
    },
    {
      month: 45,
      y: 93.5,
      name: "-2sd",
    },
    {
      month: 46,
      y: 94,
      name: "-2sd",
    },
    {
      month: 47,
      y: 94.4,
      name: "-2sd",
    },
    {
      month: 48,
      y: 94.9,
      name: "-2sd",
    },
    {
      month: 49,
      y: 95.4,
      name: "-2sd",
    },
    {
      month: 50,
      y: 95.9,
      name: "-2sd",
    },
    {
      month: 51,
      y: 96.4,
      name: "-2sd",
    },
    {
      month: 52,
      y: 96.9,
      name: "-2sd",
    },
    {
      month: 53,
      y: 97.4,
      name: "-2sd",
    },
    {
      month: 54,
      y: 97.8,
      name: "-2sd",
    },
    {
      month: 55,
      y: 98.3,
      name: "-2sd",
    },
    {
      month: 56,
      y: 98.8,
      name: "-2sd",
    },
    {
      month: 57,
      y: 99.3,
      name: "-2sd",
    },
    {
      month: 58,
      y: 99.7,
      name: "-2sd",
    },
    {
      month: 59,
      y: 100.2,
      name: "-2sd",
    },
    {
      month: 60,
      y: 100.7,
      name: "-2sd",
    },
    {
      month: 61,
      y: 101.082,
      name: "-2sd",
    },
    {
      month: 62,
      y: 101.555,
      name: "-2sd",
    },
    {
      month: 63,
      y: 102.026,
      name: "-2sd",
    },
    {
      month: 64,
      y: 102.496,
      name: "-2sd",
    },
    {
      month: 65,
      y: 102.96,
      name: "-2sd",
    },
    {
      month: 66,
      y: 103.42,
      name: "-2sd",
    },
    {
      month: 67,
      y: 103.875,
      name: "-2sd",
    },
    {
      month: 68,
      y: 104.329,
      name: "-2sd",
    },
    {
      month: 69,
      y: 104.777,
      name: "-2sd",
    },
    {
      month: 70,
      y: 105.22,
      name: "-2sd",
    },
    {
      month: 71,
      y: 105.662,
      name: "-2sd",
    },
    {
      month: 72,
      y: 106.097,
      name: "-2sd",
    },
    {
      month: 73,
      y: 106.529,
      name: "-2sd",
    },
    {
      month: 74,
      y: 106.96,
      name: "-2sd",
    },
    {
      month: 75,
      y: 107.387,
      name: "-2sd",
    },
    {
      month: 76,
      y: 107.812,
      name: "-2sd",
    },
    {
      month: 77,
      y: 108.237,
      name: "-2sd",
    },
    {
      month: 78,
      y: 108.659,
      name: "-2sd",
    },
    {
      month: 79,
      y: 109.079,
      name: "-2sd",
    },
    {
      month: 80,
      y: 109.499,
      name: "-2sd",
    },
    {
      month: 81,
      y: 109.919,
      name: "-2sd",
    },
    {
      month: 82,
      y: 110.335,
      name: "-2sd",
    },
    {
      month: 83,
      y: 110.75,
      name: "-2sd",
    },
    {
      month: 84,
      y: 111.162,
      name: "-2sd",
    },
    {
      month: 85,
      y: 111.573,
      name: "-2sd",
    },
    {
      month: 86,
      y: 111.983,
      name: "-2sd",
    },
    {
      month: 87,
      y: 112.39,
      name: "-2sd",
    },
    {
      month: 88,
      y: 112.796,
      name: "-2sd",
    },
    {
      month: 89,
      y: 113.2,
      name: "-2sd",
    },
    {
      month: 90,
      y: 113.602,
      name: "-2sd",
    },
    {
      month: 91,
      y: 114.002,
      name: "-2sd",
    },
    {
      month: 92,
      y: 114.399,
      name: "-2sd",
    },
    {
      month: 93,
      y: 114.795,
      name: "-2sd",
    },
    {
      month: 94,
      y: 115.188,
      name: "-2sd",
    },
    {
      month: 95,
      y: 115.58,
      name: "-2sd",
    },
    {
      month: 96,
      y: 115.969,
      name: "-2sd",
    },
    {
      month: 97,
      y: 116.357,
      name: "-2sd",
    },
    {
      month: 98,
      y: 116.743,
      name: "-2sd",
    },
    {
      month: 99,
      y: 117.127,
      name: "-2sd",
    },
    {
      month: 100,
      y: 117.51,
      name: "-2sd",
    },
    {
      month: 101,
      y: 117.892,
      name: "-2sd",
    },
    {
      month: 102,
      y: 118.27,
      name: "-2sd",
    },
    {
      month: 103,
      y: 118.65,
      name: "-2sd",
    },
    {
      month: 104,
      y: 119.03,
      name: "-2sd",
    },
    {
      month: 105,
      y: 119.408,
      name: "-2sd",
    },
    {
      month: 106,
      y: 119.786,
      name: "-2sd",
    },
    {
      month: 107,
      y: 120.164,
      name: "-2sd",
    },
    {
      month: 108,
      y: 120.542,
      name: "-2sd",
    },
    {
      month: 109,
      y: 120.918,
      name: "-2sd",
    },
    {
      month: 110,
      y: 121.295,
      name: "-2sd",
    },
    {
      month: 111,
      y: 121.67,
      name: "-2sd",
    },
    {
      month: 112,
      y: 122.048,
      name: "-2sd",
    },
    {
      month: 113,
      y: 122.422,
      name: "-2sd",
    },
    {
      month: 114,
      y: 122.795,
      name: "-2sd",
    },
    {
      month: 115,
      y: 123.17,
      name: "-2sd",
    },
    {
      month: 116,
      y: 123.542,
      name: "-2sd",
    },
    {
      month: 117,
      y: 123.916,
      name: "-2sd",
    },
    {
      month: 118,
      y: 124.286,
      name: "-2sd",
    },
    {
      month: 119,
      y: 124.659,
      name: "-2sd",
    },
    {
      month: 120,
      y: 125.032,
      name: "-2sd",
    },
    {
      month: 121,
      y: 125.405,
      name: "-2sd",
    },
    {
      month: 122,
      y: 125.779,
      name: "-2sd",
    },
    {
      month: 123,
      y: 126.154,
      name: "-2sd",
    },
    {
      month: 124,
      y: 126.53,
      name: "-2sd",
    },
    {
      month: 125,
      y: 126.907,
      name: "-2sd",
    },
    {
      month: 126,
      y: 127.29,
      name: "-2sd",
    },
    {
      month: 127,
      y: 127.673,
      name: "-2sd",
    },
    {
      month: 128,
      y: 128.062,
      name: "-2sd",
    },
    {
      month: 129,
      y: 128.453,
      name: "-2sd",
    },
    {
      month: 130,
      y: 128.848,
      name: "-2sd",
    },
    {
      month: 131,
      y: 129.247,
      name: "-2sd",
    },
    {
      month: 132,
      y: 129.651,
      name: "-2sd",
    },
    {
      month: 133,
      y: 130.057,
      name: "-2sd",
    },
    {
      month: 134,
      y: 130.47,
      name: "-2sd",
    },
    {
      month: 135,
      y: 130.887,
      name: "-2sd",
    },
    {
      month: 136,
      y: 131.312,
      name: "-2sd",
    },
    {
      month: 137,
      y: 131.738,
      name: "-2sd",
    },
    {
      month: 138,
      y: 132.173,
      name: "-2sd",
    },
    {
      month: 139,
      y: 132.612,
      name: "-2sd",
    },
    {
      month: 140,
      y: 133.058,
      name: "-2sd",
    },
    {
      month: 141,
      y: 133.509,
      name: "-2sd",
    },
    {
      month: 142,
      y: 133.969,
      name: "-2sd",
    },
    {
      month: 143,
      y: 134.436,
      name: "-2sd",
    },
    {
      month: 144,
      y: 134.909,
      name: "-2sd",
    },
    {
      month: 145,
      y: 135.392,
      name: "-2sd",
    },
    {
      month: 146,
      y: 135.879,
      name: "-2sd",
    },
    {
      month: 147,
      y: 136.38,
      name: "-2sd",
    },
    {
      month: 148,
      y: 136.884,
      name: "-2sd",
    },
    {
      month: 149,
      y: 137.399,
      name: "-2sd",
    },
    {
      month: 150,
      y: 137.921,
      name: "-2sd",
    },
    {
      month: 151,
      y: 138.452,
      name: "-2sd",
    },
    {
      month: 152,
      y: 138.986,
      name: "-2sd",
    },
    {
      month: 153,
      y: 139.531,
      name: "-2sd",
    },
    {
      month: 154,
      y: 140.077,
      name: "-2sd",
    },
    {
      month: 155,
      y: 140.629,
      name: "-2sd",
    },
    {
      month: 156,
      y: 141.187,
      name: "-2sd",
    },
    {
      month: 157,
      y: 141.747,
      name: "-2sd",
    },
    {
      month: 158,
      y: 142.307,
      name: "-2sd",
    },
    {
      month: 159,
      y: 142.867,
      name: "-2sd",
    },
    {
      month: 160,
      y: 143.428,
      name: "-2sd",
    },
    {
      month: 161,
      y: 143.989,
      name: "-2sd",
    },
    {
      month: 162,
      y: 144.544,
      name: "-2sd",
    },
    {
      month: 163,
      y: 145.098,
      name: "-2sd",
    },
    {
      month: 164,
      y: 145.65,
      name: "-2sd",
    },
    {
      month: 165,
      y: 146.197,
      name: "-2sd",
    },
    {
      month: 166,
      y: 146.737,
      name: "-2sd",
    },
    {
      month: 167,
      y: 147.269,
      name: "-2sd",
    },
    {
      month: 168,
      y: 147.797,
      name: "-2sd",
    },
    {
      month: 169,
      y: 148.318,
      name: "-2sd",
    },
    {
      month: 170,
      y: 148.827,
      name: "-2sd",
    },
    {
      month: 171,
      y: 149.328,
      name: "-2sd",
    },
    {
      month: 172,
      y: 149.818,
      name: "-2sd",
    },
    {
      month: 173,
      y: 150.299,
      name: "-2sd",
    },
    {
      month: 174,
      y: 150.769,
      name: "-2sd",
    },
    {
      month: 175,
      y: 151.226,
      name: "-2sd",
    },
    {
      month: 176,
      y: 151.671,
      name: "-2sd",
    },
    {
      month: 177,
      y: 152.108,
      name: "-2sd",
    },
    {
      month: 178,
      y: 152.534,
      name: "-2sd",
    },
    {
      month: 179,
      y: 152.947,
      name: "-2sd",
    },
    {
      month: 180,
      y: 153.35,
      name: "-2sd",
    },
    {
      month: 181,
      y: 153.744,
      name: "-2sd",
    },
    {
      month: 182,
      y: 154.126,
      name: "-2sd",
    },
    {
      month: 183,
      y: 154.497,
      name: "-2sd",
    },
    {
      month: 184,
      y: 154.857,
      name: "-2sd",
    },
    {
      month: 185,
      y: 155.205,
      name: "-2sd",
    },
    {
      month: 186,
      y: 155.542,
      name: "-2sd",
    },
    {
      month: 187,
      y: 155.871,
      name: "-2sd",
    },
    {
      month: 188,
      y: 156.187,
      name: "-2sd",
    },
    {
      month: 189,
      y: 156.495,
      name: "-2sd",
    },
    {
      month: 190,
      y: 156.793,
      name: "-2sd",
    },
    {
      month: 191,
      y: 157.077,
      name: "-2sd",
    },
    {
      month: 192,
      y: 157.353,
      name: "-2sd",
    },
    {
      month: 193,
      y: 157.619,
      name: "-2sd",
    },
    {
      month: 194,
      y: 157.875,
      name: "-2sd",
    },
    {
      month: 195,
      y: 158.119,
      name: "-2sd",
    },
    {
      month: 196,
      y: 158.354,
      name: "-2sd",
    },
    {
      month: 197,
      y: 158.578,
      name: "-2sd",
    },
    {
      month: 198,
      y: 158.792,
      name: "-2sd",
    },
    {
      month: 199,
      y: 158.996,
      name: "-2sd",
    },
    {
      month: 200,
      y: 159.191,
      name: "-2sd",
    },
    {
      month: 201,
      y: 159.376,
      name: "-2sd",
    },
    {
      month: 202,
      y: 159.552,
      name: "-2sd",
    },
    {
      month: 203,
      y: 159.715,
      name: "-2sd",
    },
    {
      month: 204,
      y: 159.873,
      name: "-2sd",
    },
    {
      month: 205,
      y: 160.022,
      name: "-2sd",
    },
    {
      month: 206,
      y: 160.16,
      name: "-2sd",
    },
    {
      month: 207,
      y: 160.294,
      name: "-2sd",
    },
    {
      month: 208,
      y: 160.417,
      name: "-2sd",
    },
    {
      month: 209,
      y: 160.537,
      name: "-2sd",
    },
    {
      month: 210,
      y: 160.648,
      name: "-2sd",
    },
    {
      month: 211,
      y: 160.752,
      name: "-2sd",
    },
    {
      month: 212,
      y: 160.852,
      name: "-2sd",
    },
    {
      month: 213,
      y: 160.946,
      name: "-2sd",
    },
    {
      month: 214,
      y: 161.036,
      name: "-2sd",
    },
    {
      month: 215,
      y: 161.122,
      name: "-2sd",
    },
    {
      month: 216,
      y: 161.204,
      name: "-2sd",
    },
    {
      month: 217,
      y: 161.28,
      name: "-2sd",
    },
    {
      month: 218,
      y: 161.355,
      name: "-2sd",
    },
    {
      month: 219,
      y: 161.425,
      name: "-2sd",
    },
    {
      month: 220,
      y: 161.492,
      name: "-2sd",
    },
    {
      month: 221,
      y: 161.556,
      name: "-2sd",
    },
    {
      month: 222,
      y: 161.622,
      name: "-2sd",
    },
    {
      month: 223,
      y: 161.678,
      name: "-2sd",
    },
    {
      month: 224,
      y: 161.737,
      name: "-2sd",
    },
    {
      month: 225,
      y: 161.793,
      name: "-2sd",
    },
    {
      month: 226,
      y: 161.848,
      name: "-2sd",
    },
    {
      month: 227,
      y: 161.898,
      name: "-2sd",
    },
    {
      month: 228,
      y: 161.947,
      name: "-2sd",
    },
    {
      month: 0,
      y: 48,
      name: "-1sd",
    },
    {
      month: 1,
      y: 52.8,
      name: "-1sd",
    },
    {
      month: 2,
      y: 56.4,
      name: "-1sd",
    },
    {
      month: 3,
      y: 59.4,
      name: "-1sd",
    },
    {
      month: 4,
      y: 61.8,
      name: "-1sd",
    },
    {
      month: 5,
      y: 63.8,
      name: "-1sd",
    },
    {
      month: 6,
      y: 65.5,
      name: "-1sd",
    },
    {
      month: 7,
      y: 67,
      name: "-1sd",
    },
    {
      month: 8,
      y: 68.4,
      name: "-1sd",
    },
    {
      month: 9,
      y: 69.7,
      name: "-1sd",
    },
    {
      month: 10,
      y: 71,
      name: "-1sd",
    },
    {
      month: 11,
      y: 72.2,
      name: "-1sd",
    },
    {
      month: 12,
      y: 73.4,
      name: "-1sd",
    },
    {
      month: 13,
      y: 74.5,
      name: "-1sd",
    },
    {
      month: 14,
      y: 75.6,
      name: "-1sd",
    },
    {
      month: 15,
      y: 76.6,
      name: "-1sd",
    },
    {
      month: 16,
      y: 77.6,
      name: "-1sd",
    },
    {
      month: 17,
      y: 78.6,
      name: "-1sd",
    },
    {
      month: 18,
      y: 79.6,
      name: "-1sd",
    },
    {
      month: 19,
      y: 80.5,
      name: "-1sd",
    },
    {
      month: 20,
      y: 81.4,
      name: "-1sd",
    },
    {
      month: 21,
      y: 82.3,
      name: "-1sd",
    },
    {
      month: 22,
      y: 83.1,
      name: "-1sd",
    },
    {
      month: 23,
      y: 83.9,
      name: "-1sd",
    },
    {
      month: 24,
      y: 84.1,
      name: "-1sd",
    },
    {
      month: 25,
      y: 84.9,
      name: "-1sd",
    },
    {
      month: 26,
      y: 85.6,
      name: "-1sd",
    },
    {
      month: 27,
      y: 86.4,
      name: "-1sd",
    },
    {
      month: 28,
      y: 87.1,
      name: "-1sd",
    },
    {
      month: 29,
      y: 87.8,
      name: "-1sd",
    },
    {
      month: 30,
      y: 88.5,
      name: "-1sd",
    },
    {
      month: 31,
      y: 89.2,
      name: "-1sd",
    },
    {
      month: 32,
      y: 89.9,
      name: "-1sd",
    },
    {
      month: 33,
      y: 90.5,
      name: "-1sd",
    },
    {
      month: 34,
      y: 91.1,
      name: "-1sd",
    },
    {
      month: 35,
      y: 91.8,
      name: "-1sd",
    },
    {
      month: 36,
      y: 92.4,
      name: "-1sd",
    },
    {
      month: 37,
      y: 93,
      name: "-1sd",
    },
    {
      month: 38,
      y: 93.6,
      name: "-1sd",
    },
    {
      month: 39,
      y: 94.2,
      name: "-1sd",
    },
    {
      month: 40,
      y: 94.7,
      name: "-1sd",
    },
    {
      month: 41,
      y: 95.3,
      name: "-1sd",
    },
    {
      month: 42,
      y: 95.9,
      name: "-1sd",
    },
    {
      month: 43,
      y: 96.4,
      name: "-1sd",
    },
    {
      month: 44,
      y: 97,
      name: "-1sd",
    },
    {
      month: 45,
      y: 97.5,
      name: "-1sd",
    },
    {
      month: 46,
      y: 98.1,
      name: "-1sd",
    },
    {
      month: 47,
      y: 98.6,
      name: "-1sd",
    },
    {
      month: 48,
      y: 99.1,
      name: "-1sd",
    },
    {
      month: 49,
      y: 99.7,
      name: "-1sd",
    },
    {
      month: 50,
      y: 100.2,
      name: "-1sd",
    },
    {
      month: 51,
      y: 100.7,
      name: "-1sd",
    },
    {
      month: 52,
      y: 101.2,
      name: "-1sd",
    },
    {
      month: 53,
      y: 101.7,
      name: "-1sd",
    },
    {
      month: 54,
      y: 102.3,
      name: "-1sd",
    },
    {
      month: 55,
      y: 102.8,
      name: "-1sd",
    },
    {
      month: 56,
      y: 103.3,
      name: "-1sd",
    },
    {
      month: 57,
      y: 103.8,
      name: "-1sd",
    },
    {
      month: 58,
      y: 104.3,
      name: "-1sd",
    },
    {
      month: 59,
      y: 104.8,
      name: "-1sd",
    },
    {
      month: 60,
      y: 105.3,
      name: "-1sd",
    },
    {
      month: 61,
      y: 105.673,
      name: "-1sd",
    },
    {
      month: 62,
      y: 106.178,
      name: "-1sd",
    },
    {
      month: 63,
      y: 106.68,
      name: "-1sd",
    },
    {
      month: 64,
      y: 107.18,
      name: "-1sd",
    },
    {
      month: 65,
      y: 107.675,
      name: "-1sd",
    },
    {
      month: 66,
      y: 108.165,
      name: "-1sd",
    },
    {
      month: 67,
      y: 108.652,
      name: "-1sd",
    },
    {
      month: 68,
      y: 109.135,
      name: "-1sd",
    },
    {
      month: 69,
      y: 109.613,
      name: "-1sd",
    },
    {
      month: 70,
      y: 110.088,
      name: "-1sd",
    },
    {
      month: 71,
      y: 110.558,
      name: "-1sd",
    },
    {
      month: 72,
      y: 111.024,
      name: "-1sd",
    },
    {
      month: 73,
      y: 111.486,
      name: "-1sd",
    },
    {
      month: 74,
      y: 111.946,
      name: "-1sd",
    },
    {
      month: 75,
      y: 112.403,
      name: "-1sd",
    },
    {
      month: 76,
      y: 112.858,
      name: "-1sd",
    },
    {
      month: 77,
      y: 113.313,
      name: "-1sd",
    },
    {
      month: 78,
      y: 113.765,
      name: "-1sd",
    },
    {
      month: 79,
      y: 114.215,
      name: "-1sd",
    },
    {
      month: 80,
      y: 114.664,
      name: "-1sd",
    },
    {
      month: 81,
      y: 115.114,
      name: "-1sd",
    },
    {
      month: 82,
      y: 115.56,
      name: "-1sd",
    },
    {
      month: 83,
      y: 116.005,
      name: "-1sd",
    },
    {
      month: 84,
      y: 116.448,
      name: "-1sd",
    },
    {
      month: 85,
      y: 116.889,
      name: "-1sd",
    },
    {
      month: 86,
      y: 117.329,
      name: "-1sd",
    },
    {
      month: 87,
      y: 117.766,
      name: "-1sd",
    },
    {
      month: 88,
      y: 118.203,
      name: "-1sd",
    },
    {
      month: 89,
      y: 118.637,
      name: "-1sd",
    },
    {
      month: 90,
      y: 119.069,
      name: "-1sd",
    },
    {
      month: 91,
      y: 119.499,
      name: "-1sd",
    },
    {
      month: 92,
      y: 119.927,
      name: "-1sd",
    },
    {
      month: 93,
      y: 120.353,
      name: "-1sd",
    },
    {
      month: 94,
      y: 120.776,
      name: "-1sd",
    },
    {
      month: 95,
      y: 121.198,
      name: "-1sd",
    },
    {
      month: 96,
      y: 121.617,
      name: "-1sd",
    },
    {
      month: 97,
      y: 122.035,
      name: "-1sd",
    },
    {
      month: 98,
      y: 122.451,
      name: "-1sd",
    },
    {
      month: 99,
      y: 122.865,
      name: "-1sd",
    },
    {
      month: 100,
      y: 123.278,
      name: "-1sd",
    },
    {
      month: 101,
      y: 123.69,
      name: "-1sd",
    },
    {
      month: 102,
      y: 124.1,
      name: "-1sd",
    },
    {
      month: 103,
      y: 124.51,
      name: "-1sd",
    },
    {
      month: 104,
      y: 124.92,
      name: "-1sd",
    },
    {
      month: 105,
      y: 125.329,
      name: "-1sd",
    },
    {
      month: 106,
      y: 125.737,
      name: "-1sd",
    },
    {
      month: 107,
      y: 126.146,
      name: "-1sd",
    },
    {
      month: 108,
      y: 126.553,
      name: "-1sd",
    },
    {
      month: 109,
      y: 126.961,
      name: "-1sd",
    },
    {
      month: 110,
      y: 127.368,
      name: "-1sd",
    },
    {
      month: 111,
      y: 127.774,
      name: "-1sd",
    },
    {
      month: 112,
      y: 128.18,
      name: "-1sd",
    },
    {
      month: 113,
      y: 128.585,
      name: "-1sd",
    },
    {
      month: 114,
      y: 128.989,
      name: "-1sd",
    },
    {
      month: 115,
      y: 129.393,
      name: "-1sd",
    },
    {
      month: 116,
      y: 129.796,
      name: "-1sd",
    },
    {
      month: 117,
      y: 130.199,
      name: "-1sd",
    },
    {
      month: 118,
      y: 130.601,
      name: "-1sd",
    },
    {
      month: 119,
      y: 131.003,
      name: "-1sd",
    },
    {
      month: 120,
      y: 131.406,
      name: "-1sd",
    },
    {
      month: 121,
      y: 131.809,
      name: "-1sd",
    },
    {
      month: 122,
      y: 132.212,
      name: "-1sd",
    },
    {
      month: 123,
      y: 132.617,
      name: "-1sd",
    },
    {
      month: 124,
      y: 133.023,
      name: "-1sd",
    },
    {
      month: 125,
      y: 133.431,
      name: "-1sd",
    },
    {
      month: 126,
      y: 133.843,
      name: "-1sd",
    },
    {
      month: 127,
      y: 134.256,
      name: "-1sd",
    },
    {
      month: 128,
      y: 134.674,
      name: "-1sd",
    },
    {
      month: 129,
      y: 135.095,
      name: "-1sd",
    },
    {
      month: 130,
      y: 135.52,
      name: "-1sd",
    },
    {
      month: 131,
      y: 135.948,
      name: "-1sd",
    },
    {
      month: 132,
      y: 136.382,
      name: "-1sd",
    },
    {
      month: 133,
      y: 136.818,
      name: "-1sd",
    },
    {
      month: 134,
      y: 137.261,
      name: "-1sd",
    },
    {
      month: 135,
      y: 137.707,
      name: "-1sd",
    },
    {
      month: 136,
      y: 138.161,
      name: "-1sd",
    },
    {
      month: 137,
      y: 138.617,
      name: "-1sd",
    },
    {
      month: 138,
      y: 139.081,
      name: "-1sd",
    },
    {
      month: 139,
      y: 139.55,
      name: "-1sd",
    },
    {
      month: 140,
      y: 140.025,
      name: "-1sd",
    },
    {
      month: 141,
      y: 140.507,
      name: "-1sd",
    },
    {
      month: 142,
      y: 140.996,
      name: "-1sd",
    },
    {
      month: 143,
      y: 141.492,
      name: "-1sd",
    },
    {
      month: 144,
      y: 141.995,
      name: "-1sd",
    },
    {
      month: 145,
      y: 142.507,
      name: "-1sd",
    },
    {
      month: 146,
      y: 143.024,
      name: "-1sd",
    },
    {
      month: 147,
      y: 143.553,
      name: "-1sd",
    },
    {
      month: 148,
      y: 144.087,
      name: "-1sd",
    },
    {
      month: 149,
      y: 144.631,
      name: "-1sd",
    },
    {
      month: 150,
      y: 145.182,
      name: "-1sd",
    },
    {
      month: 151,
      y: 145.741,
      name: "-1sd",
    },
    {
      month: 152,
      y: 146.305,
      name: "-1sd",
    },
    {
      month: 153,
      y: 146.877,
      name: "-1sd",
    },
    {
      month: 154,
      y: 147.451,
      name: "-1sd",
    },
    {
      month: 155,
      y: 148.031,
      name: "-1sd",
    },
    {
      month: 156,
      y: 148.615,
      name: "-1sd",
    },
    {
      month: 157,
      y: 149.2,
      name: "-1sd",
    },
    {
      month: 158,
      y: 149.786,
      name: "-1sd",
    },
    {
      month: 159,
      y: 150.372,
      name: "-1sd",
    },
    {
      month: 160,
      y: 150.957,
      name: "-1sd",
    },
    {
      month: 161,
      y: 151.542,
      name: "-1sd",
    },
    {
      month: 162,
      y: 152.12,
      name: "-1sd",
    },
    {
      month: 163,
      y: 152.696,
      name: "-1sd",
    },
    {
      month: 164,
      y: 153.268,
      name: "-1sd",
    },
    {
      month: 165,
      y: 153.834,
      name: "-1sd",
    },
    {
      month: 166,
      y: 154.394,
      name: "-1sd",
    },
    {
      month: 167,
      y: 154.945,
      name: "-1sd",
    },
    {
      month: 168,
      y: 155.489,
      name: "-1sd",
    },
    {
      month: 169,
      y: 156.025,
      name: "-1sd",
    },
    {
      month: 170,
      y: 156.549,
      name: "-1sd",
    },
    {
      month: 171,
      y: 157.064,
      name: "-1sd",
    },
    {
      month: 172,
      y: 157.566,
      name: "-1sd",
    },
    {
      month: 173,
      y: 158.058,
      name: "-1sd",
    },
    {
      month: 174,
      y: 158.537,
      name: "-1sd",
    },
    {
      month: 175,
      y: 159.003,
      name: "-1sd",
    },
    {
      month: 176,
      y: 159.456,
      name: "-1sd",
    },
    {
      month: 177,
      y: 159.899,
      name: "-1sd",
    },
    {
      month: 178,
      y: 160.33,
      name: "-1sd",
    },
    {
      month: 179,
      y: 160.748,
      name: "-1sd",
    },
    {
      month: 180,
      y: 161.154,
      name: "-1sd",
    },
    {
      month: 181,
      y: 161.549,
      name: "-1sd",
    },
    {
      month: 182,
      y: 161.933,
      name: "-1sd",
    },
    {
      month: 183,
      y: 162.304,
      name: "-1sd",
    },
    {
      month: 184,
      y: 162.662,
      name: "-1sd",
    },
    {
      month: 185,
      y: 163.009,
      name: "-1sd",
    },
    {
      month: 186,
      y: 163.344,
      name: "-1sd",
    },
    {
      month: 187,
      y: 163.67,
      name: "-1sd",
    },
    {
      month: 188,
      y: 163.982,
      name: "-1sd",
    },
    {
      month: 189,
      y: 164.285,
      name: "-1sd",
    },
    {
      month: 190,
      y: 164.577,
      name: "-1sd",
    },
    {
      month: 191,
      y: 164.856,
      name: "-1sd",
    },
    {
      month: 192,
      y: 165.125,
      name: "-1sd",
    },
    {
      month: 193,
      y: 165.383,
      name: "-1sd",
    },
    {
      month: 194,
      y: 165.63,
      name: "-1sd",
    },
    {
      month: 195,
      y: 165.866,
      name: "-1sd",
    },
    {
      month: 196,
      y: 166.091,
      name: "-1sd",
    },
    {
      month: 197,
      y: 166.305,
      name: "-1sd",
    },
    {
      month: 198,
      y: 166.509,
      name: "-1sd",
    },
    {
      month: 199,
      y: 166.702,
      name: "-1sd",
    },
    {
      month: 200,
      y: 166.885,
      name: "-1sd",
    },
    {
      month: 201,
      y: 167.058,
      name: "-1sd",
    },
    {
      month: 202,
      y: 167.221,
      name: "-1sd",
    },
    {
      month: 203,
      y: 167.373,
      name: "-1sd",
    },
    {
      month: 204,
      y: 167.517,
      name: "-1sd",
    },
    {
      month: 205,
      y: 167.652,
      name: "-1sd",
    },
    {
      month: 206,
      y: 167.778,
      name: "-1sd",
    },
    {
      month: 207,
      y: 167.897,
      name: "-1sd",
    },
    {
      month: 208,
      y: 168.007,
      name: "-1sd",
    },
    {
      month: 209,
      y: 168.111,
      name: "-1sd",
    },
    {
      month: 210,
      y: 168.207,
      name: "-1sd",
    },
    {
      month: 211,
      y: 168.298,
      name: "-1sd",
    },
    {
      month: 212,
      y: 168.382,
      name: "-1sd",
    },
    {
      month: 213,
      y: 168.462,
      name: "-1sd",
    },
    {
      month: 214,
      y: 168.537,
      name: "-1sd",
    },
    {
      month: 215,
      y: 168.608,
      name: "-1sd",
    },
    {
      month: 216,
      y: 168.675,
      name: "-1sd",
    },
    {
      month: 217,
      y: 168.736,
      name: "-1sd",
    },
    {
      month: 218,
      y: 168.796,
      name: "-1sd",
    },
    {
      month: 219,
      y: 168.851,
      name: "-1sd",
    },
    {
      month: 220,
      y: 168.904,
      name: "-1sd",
    },
    {
      month: 221,
      y: 168.954,
      name: "-1sd",
    },
    {
      month: 222,
      y: 169.003,
      name: "-1sd",
    },
    {
      month: 223,
      y: 169.047,
      name: "-1sd",
    },
    {
      month: 224,
      y: 169.091,
      name: "-1sd",
    },
    {
      month: 225,
      y: 169.133,
      name: "-1sd",
    },
    {
      month: 226,
      y: 169.173,
      name: "-1sd",
    },
    {
      month: 227,
      y: 169.21,
      name: "-1sd",
    },
    {
      month: 228,
      y: 169.245,
      name: "-1sd",
    },
    {
      month: 0,
      y: 49.9,
      name: "mediane",
    },
    {
      month: 1,
      y: 54.7,
      name: "mediane",
    },
    {
      month: 2,
      y: 58.4,
      name: "mediane",
    },
    {
      month: 3,
      y: 61.4,
      name: "mediane",
    },
    {
      month: 4,
      y: 63.9,
      name: "mediane",
    },
    {
      month: 5,
      y: 65.9,
      name: "mediane",
    },
    {
      month: 6,
      y: 67.6,
      name: "mediane",
    },
    {
      month: 7,
      y: 69.2,
      name: "mediane",
    },
    {
      month: 8,
      y: 70.6,
      name: "mediane",
    },
    {
      month: 9,
      y: 72,
      name: "mediane",
    },
    {
      month: 10,
      y: 73.3,
      name: "mediane",
    },
    {
      month: 11,
      y: 74.5,
      name: "mediane",
    },
    {
      month: 12,
      y: 75.7,
      name: "mediane",
    },
    {
      month: 13,
      y: 76.9,
      name: "mediane",
    },
    {
      month: 14,
      y: 78,
      name: "mediane",
    },
    {
      month: 15,
      y: 79.1,
      name: "mediane",
    },
    {
      month: 16,
      y: 80.2,
      name: "mediane",
    },
    {
      month: 17,
      y: 81.2,
      name: "mediane",
    },
    {
      month: 18,
      y: 82.3,
      name: "mediane",
    },
    {
      month: 19,
      y: 83.2,
      name: "mediane",
    },
    {
      month: 20,
      y: 84.2,
      name: "mediane",
    },
    {
      month: 21,
      y: 85.1,
      name: "mediane",
    },
    {
      month: 22,
      y: 86,
      name: "mediane",
    },
    {
      month: 23,
      y: 86.9,
      name: "mediane",
    },
    {
      month: 24,
      y: 87.1,
      name: "mediane",
    },
    {
      month: 25,
      y: 88,
      name: "mediane",
    },
    {
      month: 26,
      y: 88.8,
      name: "mediane",
    },
    {
      month: 27,
      y: 89.6,
      name: "mediane",
    },
    {
      month: 28,
      y: 90.4,
      name: "mediane",
    },
    {
      month: 29,
      y: 91.2,
      name: "mediane",
    },
    {
      month: 30,
      y: 91.9,
      name: "mediane",
    },
    {
      month: 31,
      y: 92.7,
      name: "mediane",
    },
    {
      month: 32,
      y: 93.4,
      name: "mediane",
    },
    {
      month: 33,
      y: 94.1,
      name: "mediane",
    },
    {
      month: 34,
      y: 94.8,
      name: "mediane",
    },
    {
      month: 35,
      y: 95.4,
      name: "mediane",
    },
    {
      month: 36,
      y: 96.1,
      name: "mediane",
    },
    {
      month: 37,
      y: 96.7,
      name: "mediane",
    },
    {
      month: 38,
      y: 97.4,
      name: "mediane",
    },
    {
      month: 39,
      y: 98,
      name: "mediane",
    },
    {
      month: 40,
      y: 98.6,
      name: "mediane",
    },
    {
      month: 41,
      y: 99.2,
      name: "mediane",
    },
    {
      month: 42,
      y: 99.9,
      name: "mediane",
    },
    {
      month: 43,
      y: 100.4,
      name: "mediane",
    },
    {
      month: 44,
      y: 101,
      name: "mediane",
    },
    {
      month: 45,
      y: 101.6,
      name: "mediane",
    },
    {
      month: 46,
      y: 102.2,
      name: "mediane",
    },
    {
      month: 47,
      y: 102.8,
      name: "mediane",
    },
    {
      month: 48,
      y: 103.3,
      name: "mediane",
    },
    {
      month: 49,
      y: 103.9,
      name: "mediane",
    },
    {
      month: 50,
      y: 104.4,
      name: "mediane",
    },
    {
      month: 51,
      y: 105,
      name: "mediane",
    },
    {
      month: 52,
      y: 105.6,
      name: "mediane",
    },
    {
      month: 53,
      y: 106.1,
      name: "mediane",
    },
    {
      month: 54,
      y: 106.7,
      name: "mediane",
    },
    {
      month: 55,
      y: 107.2,
      name: "mediane",
    },
    {
      month: 56,
      y: 107.8,
      name: "mediane",
    },
    {
      month: 57,
      y: 108.3,
      name: "mediane",
    },
    {
      month: 58,
      y: 108.9,
      name: "mediane",
    },
    {
      month: 59,
      y: 109.4,
      name: "mediane",
    },
    {
      month: 60,
      y: 110,
      name: "mediane",
    },
    {
      month: 61,
      y: 110.265,
      name: "mediane",
    },
    {
      month: 62,
      y: 110.801,
      name: "mediane",
    },
    {
      month: 63,
      y: 111.334,
      name: "mediane",
    },
    {
      month: 64,
      y: 111.864,
      name: "mediane",
    },
    {
      month: 65,
      y: 112.39,
      name: "mediane",
    },
    {
      month: 66,
      y: 112.911,
      name: "mediane",
    },
    {
      month: 67,
      y: 113.428,
      name: "mediane",
    },
    {
      month: 68,
      y: 113.941,
      name: "mediane",
    },
    {
      month: 69,
      y: 114.45,
      name: "mediane",
    },
    {
      month: 70,
      y: 114.955,
      name: "mediane",
    },
    {
      month: 71,
      y: 115.455,
      name: "mediane",
    },
    {
      month: 72,
      y: 115.951,
      name: "mediane",
    },
    {
      month: 73,
      y: 116.443,
      name: "mediane",
    },
    {
      month: 74,
      y: 116.932,
      name: "mediane",
    },
    {
      month: 75,
      y: 117.42,
      name: "mediane",
    },
    {
      month: 76,
      y: 117.905,
      name: "mediane",
    },
    {
      month: 77,
      y: 118.388,
      name: "mediane",
    },
    {
      month: 78,
      y: 118.87,
      name: "mediane",
    },
    {
      month: 79,
      y: 119.351,
      name: "mediane",
    },
    {
      month: 80,
      y: 119.83,
      name: "mediane",
    },
    {
      month: 81,
      y: 120.308,
      name: "mediane",
    },
    {
      month: 82,
      y: 120.785,
      name: "mediane",
    },
    {
      month: 83,
      y: 121.26,
      name: "mediane",
    },
    {
      month: 84,
      y: 121.734,
      name: "mediane",
    },
    {
      month: 85,
      y: 122.205,
      name: "mediane",
    },
    {
      month: 86,
      y: 122.675,
      name: "mediane",
    },
    {
      month: 87,
      y: 123.143,
      name: "mediane",
    },
    {
      month: 88,
      y: 123.609,
      name: "mediane",
    },
    {
      month: 89,
      y: 124.074,
      name: "mediane",
    },
    {
      month: 90,
      y: 124.536,
      name: "mediane",
    },
    {
      month: 91,
      y: 124.996,
      name: "mediane",
    },
    {
      month: 92,
      y: 125.454,
      name: "mediane",
    },
    {
      month: 93,
      y: 125.91,
      name: "mediane",
    },
    {
      month: 94,
      y: 126.364,
      name: "mediane",
    },
    {
      month: 95,
      y: 126.816,
      name: "mediane",
    },
    {
      month: 96,
      y: 127.265,
      name: "mediane",
    },
    {
      month: 97,
      y: 127.713,
      name: "mediane",
    },
    {
      month: 98,
      y: 128.159,
      name: "mediane",
    },
    {
      month: 99,
      y: 128.603,
      name: "mediane",
    },
    {
      month: 100,
      y: 129.047,
      name: "mediane",
    },
    {
      month: 101,
      y: 129.489,
      name: "mediane",
    },
    {
      month: 102,
      y: 129.93,
      name: "mediane",
    },
    {
      month: 103,
      y: 130.37,
      name: "mediane",
    },
    {
      month: 104,
      y: 130.81,
      name: "mediane",
    },
    {
      month: 105,
      y: 131.25,
      name: "mediane",
    },
    {
      month: 106,
      y: 131.688,
      name: "mediane",
    },
    {
      month: 107,
      y: 132.127,
      name: "mediane",
    },
    {
      month: 108,
      y: 132.565,
      name: "mediane",
    },
    {
      month: 109,
      y: 133.003,
      name: "mediane",
    },
    {
      month: 110,
      y: 133.44,
      name: "mediane",
    },
    {
      month: 111,
      y: 133.877,
      name: "mediane",
    },
    {
      month: 112,
      y: 134.313,
      name: "mediane",
    },
    {
      month: 113,
      y: 134.748,
      name: "mediane",
    },
    {
      month: 114,
      y: 135.183,
      name: "mediane",
    },
    {
      month: 115,
      y: 135.617,
      name: "mediane",
    },
    {
      month: 116,
      y: 136.05,
      name: "mediane",
    },
    {
      month: 117,
      y: 136.483,
      name: "mediane",
    },
    {
      month: 118,
      y: 136.915,
      name: "mediane",
    },
    {
      month: 119,
      y: 137.347,
      name: "mediane",
    },
    {
      month: 120,
      y: 137.78,
      name: "mediane",
    },
    {
      month: 121,
      y: 138.212,
      name: "mediane",
    },
    {
      month: 122,
      y: 138.645,
      name: "mediane",
    },
    {
      month: 123,
      y: 139.08,
      name: "mediane",
    },
    {
      month: 124,
      y: 139.516,
      name: "mediane",
    },
    {
      month: 125,
      y: 139.954,
      name: "mediane",
    },
    {
      month: 126,
      y: 140.395,
      name: "mediane",
    },
    {
      month: 127,
      y: 140.839,
      name: "mediane",
    },
    {
      month: 128,
      y: 141.286,
      name: "mediane",
    },
    {
      month: 129,
      y: 141.737,
      name: "mediane",
    },
    {
      month: 130,
      y: 142.192,
      name: "mediane",
    },
    {
      month: 131,
      y: 142.65,
      name: "mediane",
    },
    {
      month: 132,
      y: 143.113,
      name: "mediane",
    },
    {
      month: 133,
      y: 143.58,
      name: "mediane",
    },
    {
      month: 134,
      y: 144.051,
      name: "mediane",
    },
    {
      month: 135,
      y: 144.528,
      name: "mediane",
    },
    {
      month: 136,
      y: 145.009,
      name: "mediane",
    },
    {
      month: 137,
      y: 145.496,
      name: "mediane",
    },
    {
      month: 138,
      y: 145.989,
      name: "mediane",
    },
    {
      month: 139,
      y: 146.488,
      name: "mediane",
    },
    {
      month: 140,
      y: 146.993,
      name: "mediane",
    },
    {
      month: 141,
      y: 147.504,
      name: "mediane",
    },
    {
      month: 142,
      y: 148.022,
      name: "mediane",
    },
    {
      month: 143,
      y: 148.548,
      name: "mediane",
    },
    {
      month: 144,
      y: 149.081,
      name: "mediane",
    },
    {
      month: 145,
      y: 149.621,
      name: "mediane",
    },
    {
      month: 146,
      y: 150.169,
      name: "mediane",
    },
    {
      month: 147,
      y: 150.726,
      name: "mediane",
    },
    {
      month: 148,
      y: 151.29,
      name: "mediane",
    },
    {
      month: 149,
      y: 151.862,
      name: "mediane",
    },
    {
      month: 150,
      y: 152.442,
      name: "mediane",
    },
    {
      month: 151,
      y: 153.03,
      name: "mediane",
    },
    {
      month: 152,
      y: 153.623,
      name: "mediane",
    },
    {
      month: 153,
      y: 154.222,
      name: "mediane",
    },
    {
      month: 154,
      y: 154.826,
      name: "mediane",
    },
    {
      month: 155,
      y: 155.433,
      name: "mediane",
    },
    {
      month: 156,
      y: 156.043,
      name: "mediane",
    },
    {
      month: 157,
      y: 156.654,
      name: "mediane",
    },
    {
      month: 158,
      y: 157.266,
      name: "mediane",
    },
    {
      month: 159,
      y: 157.878,
      name: "mediane",
    },
    {
      month: 160,
      y: 158.487,
      name: "mediane",
    },
    {
      month: 161,
      y: 159.094,
      name: "mediane",
    },
    {
      month: 162,
      y: 159.696,
      name: "mediane",
    },
    {
      month: 163,
      y: 160.294,
      name: "mediane",
    },
    {
      month: 164,
      y: 160.886,
      name: "mediane",
    },
    {
      month: 165,
      y: 161.472,
      name: "mediane",
    },
    {
      month: 166,
      y: 162.05,
      name: "mediane",
    },
    {
      month: 167,
      y: 162.621,
      name: "mediane",
    },
    {
      month: 168,
      y: 163.182,
      name: "mediane",
    },
    {
      month: 169,
      y: 163.732,
      name: "mediane",
    },
    {
      month: 170,
      y: 164.272,
      name: "mediane",
    },
    {
      month: 171,
      y: 164.799,
      name: "mediane",
    },
    {
      month: 172,
      y: 165.314,
      name: "mediane",
    },
    {
      month: 173,
      y: 165.816,
      name: "mediane",
    },
    {
      month: 174,
      y: 166.305,
      name: "mediane",
    },
    {
      month: 175,
      y: 166.78,
      name: "mediane",
    },
    {
      month: 176,
      y: 167.242,
      name: "mediane",
    },
    {
      month: 177,
      y: 167.69,
      name: "mediane",
    },
    {
      month: 178,
      y: 168.126,
      name: "mediane",
    },
    {
      month: 179,
      y: 168.548,
      name: "mediane",
    },
    {
      month: 180,
      y: 168.958,
      name: "mediane",
    },
    {
      month: 181,
      y: 169.355,
      name: "mediane",
    },
    {
      month: 182,
      y: 169.739,
      name: "mediane",
    },
    {
      month: 183,
      y: 170.11,
      name: "mediane",
    },
    {
      month: 184,
      y: 170.468,
      name: "mediane",
    },
    {
      month: 185,
      y: 170.814,
      name: "mediane",
    },
    {
      month: 186,
      y: 171.147,
      name: "mediane",
    },
    {
      month: 187,
      y: 171.468,
      name: "mediane",
    },
    {
      month: 188,
      y: 171.777,
      name: "mediane",
    },
    {
      month: 189,
      y: 172.075,
      name: "mediane",
    },
    {
      month: 190,
      y: 172.361,
      name: "mediane",
    },
    {
      month: 191,
      y: 172.634,
      name: "mediane",
    },
    {
      month: 192,
      y: 172.897,
      name: "mediane",
    },
    {
      month: 193,
      y: 173.147,
      name: "mediane",
    },
    {
      month: 194,
      y: 173.386,
      name: "mediane",
    },
    {
      month: 195,
      y: 173.613,
      name: "mediane",
    },
    {
      month: 196,
      y: 173.828,
      name: "mediane",
    },
    {
      month: 197,
      y: 174.032,
      name: "mediane",
    },
    {
      month: 198,
      y: 174.225,
      name: "mediane",
    },
    {
      month: 199,
      y: 174.407,
      name: "mediane",
    },
    {
      month: 200,
      y: 174.578,
      name: "mediane",
    },
    {
      month: 201,
      y: 174.739,
      name: "mediane",
    },
    {
      month: 202,
      y: 174.89,
      name: "mediane",
    },
    {
      month: 203,
      y: 175.03,
      name: "mediane",
    },
    {
      month: 204,
      y: 175.161,
      name: "mediane",
    },
    {
      month: 205,
      y: 175.282,
      name: "mediane",
    },
    {
      month: 206,
      y: 175.395,
      name: "mediane",
    },
    {
      month: 207,
      y: 175.5,
      name: "mediane",
    },
    {
      month: 208,
      y: 175.596,
      name: "mediane",
    },
    {
      month: 209,
      y: 175.685,
      name: "mediane",
    },
    {
      month: 210,
      y: 175.767,
      name: "mediane",
    },
    {
      month: 211,
      y: 175.843,
      name: "mediane",
    },
    {
      month: 212,
      y: 175.913,
      name: "mediane",
    },
    {
      month: 213,
      y: 175.978,
      name: "mediane",
    },
    {
      month: 214,
      y: 176.038,
      name: "mediane",
    },
    {
      month: 215,
      y: 176.094,
      name: "mediane",
    },
    {
      month: 216,
      y: 176.145,
      name: "mediane",
    },
    {
      month: 217,
      y: 176.192,
      name: "mediane",
    },
    {
      month: 218,
      y: 176.237,
      name: "mediane",
    },
    {
      month: 219,
      y: 176.278,
      name: "mediane",
    },
    {
      month: 220,
      y: 176.316,
      name: "mediane",
    },
    {
      month: 221,
      y: 176.352,
      name: "mediane",
    },
    {
      month: 222,
      y: 176.385,
      name: "mediane",
    },
    {
      month: 223,
      y: 176.416,
      name: "mediane",
    },
    {
      month: 224,
      y: 176.445,
      name: "mediane",
    },
    {
      month: 225,
      y: 176.472,
      name: "mediane",
    },
    {
      month: 226,
      y: 176.498,
      name: "mediane",
    },
    {
      month: 227,
      y: 176.521,
      name: "mediane",
    },
    {
      month: 228,
      y: 176.543,
      name: "mediane",
    },
    {
      month: 0,
      y: 51.8,
      name: "+1sd",
    },
    {
      month: 1,
      y: 56.7,
      name: "+1sd",
    },
    {
      month: 2,
      y: 60.4,
      name: "+1sd",
    },
    {
      month: 3,
      y: 63.5,
      name: "+1sd",
    },
    {
      month: 4,
      y: 66,
      name: "+1sd",
    },
    {
      month: 5,
      y: 68,
      name: "+1sd",
    },
    {
      month: 6,
      y: 69.8,
      name: "+1sd",
    },
    {
      month: 7,
      y: 71.3,
      name: "+1sd",
    },
    {
      month: 8,
      y: 72.8,
      name: "+1sd",
    },
    {
      month: 9,
      y: 74.2,
      name: "+1sd",
    },
    {
      month: 10,
      y: 75.6,
      name: "+1sd",
    },
    {
      month: 11,
      y: 76.9,
      name: "+1sd",
    },
    {
      month: 12,
      y: 78.1,
      name: "+1sd",
    },
    {
      month: 13,
      y: 79.3,
      name: "+1sd",
    },
    {
      month: 14,
      y: 80.5,
      name: "+1sd",
    },
    {
      month: 15,
      y: 81.7,
      name: "+1sd",
    },
    {
      month: 16,
      y: 82.8,
      name: "+1sd",
    },
    {
      month: 17,
      y: 83.9,
      name: "+1sd",
    },
    {
      month: 18,
      y: 85,
      name: "+1sd",
    },
    {
      month: 19,
      y: 86,
      name: "+1sd",
    },
    {
      month: 20,
      y: 87,
      name: "+1sd",
    },
    {
      month: 21,
      y: 88,
      name: "+1sd",
    },
    {
      month: 22,
      y: 89,
      name: "+1sd",
    },
    {
      month: 23,
      y: 89.9,
      name: "+1sd",
    },
    {
      month: 24,
      y: 90.2,
      name: "+1sd",
    },
    {
      month: 25,
      y: 91.1,
      name: "+1sd",
    },
    {
      month: 26,
      y: 92,
      name: "+1sd",
    },
    {
      month: 27,
      y: 92.9,
      name: "+1sd",
    },
    {
      month: 28,
      y: 93.7,
      name: "+1sd",
    },
    {
      month: 29,
      y: 94.5,
      name: "+1sd",
    },
    {
      month: 30,
      y: 95.3,
      name: "+1sd",
    },
    {
      month: 31,
      y: 96.1,
      name: "+1sd",
    },
    {
      month: 32,
      y: 96.9,
      name: "+1sd",
    },
    {
      month: 33,
      y: 97.6,
      name: "+1sd",
    },
    {
      month: 34,
      y: 98.4,
      name: "+1sd",
    },
    {
      month: 35,
      y: 99.1,
      name: "+1sd",
    },
    {
      month: 36,
      y: 99.8,
      name: "+1sd",
    },
    {
      month: 37,
      y: 100.5,
      name: "+1sd",
    },
    {
      month: 38,
      y: 101.2,
      name: "+1sd",
    },
    {
      month: 39,
      y: 101.8,
      name: "+1sd",
    },
    {
      month: 40,
      y: 102.5,
      name: "+1sd",
    },
    {
      month: 41,
      y: 103.2,
      name: "+1sd",
    },
    {
      month: 42,
      y: 103.8,
      name: "+1sd",
    },
    {
      month: 43,
      y: 104.5,
      name: "+1sd",
    },
    {
      month: 44,
      y: 105.1,
      name: "+1sd",
    },
    {
      month: 45,
      y: 105.7,
      name: "+1sd",
    },
    {
      month: 46,
      y: 106.3,
      name: "+1sd",
    },
    {
      month: 47,
      y: 106.9,
      name: "+1sd",
    },
    {
      month: 48,
      y: 107.5,
      name: "+1sd",
    },
    {
      month: 49,
      y: 108.1,
      name: "+1sd",
    },
    {
      month: 50,
      y: 108.7,
      name: "+1sd",
    },
    {
      month: 51,
      y: 109.3,
      name: "+1sd",
    },
    {
      month: 52,
      y: 109.9,
      name: "+1sd",
    },
    {
      month: 53,
      y: 110.5,
      name: "+1sd",
    },
    {
      month: 54,
      y: 111.1,
      name: "+1sd",
    },
    {
      month: 55,
      y: 111.7,
      name: "+1sd",
    },
    {
      month: 56,
      y: 112.3,
      name: "+1sd",
    },
    {
      month: 57,
      y: 112.8,
      name: "+1sd",
    },
    {
      month: 58,
      y: 113.4,
      name: "+1sd",
    },
    {
      month: 59,
      y: 114,
      name: "+1sd",
    },
    {
      month: 60,
      y: 114.6,
      name: "+1sd",
    },
    {
      month: 61,
      y: 114.856,
      name: "+1sd",
    },
    {
      month: 62,
      y: 115.423,
      name: "+1sd",
    },
    {
      month: 63,
      y: 115.988,
      name: "+1sd",
    },
    {
      month: 64,
      y: 116.547,
      name: "+1sd",
    },
    {
      month: 65,
      y: 117.104,
      name: "+1sd",
    },
    {
      month: 66,
      y: 117.657,
      name: "+1sd",
    },
    {
      month: 67,
      y: 118.204,
      name: "+1sd",
    },
    {
      month: 68,
      y: 118.747,
      name: "+1sd",
    },
    {
      month: 69,
      y: 119.287,
      name: "+1sd",
    },
    {
      month: 70,
      y: 119.822,
      name: "+1sd",
    },
    {
      month: 71,
      y: 120.351,
      name: "+1sd",
    },
    {
      month: 72,
      y: 120.878,
      name: "+1sd",
    },
    {
      month: 73,
      y: 121.4,
      name: "+1sd",
    },
    {
      month: 74,
      y: 121.919,
      name: "+1sd",
    },
    {
      month: 75,
      y: 122.436,
      name: "+1sd",
    },
    {
      month: 76,
      y: 122.951,
      name: "+1sd",
    },
    {
      month: 77,
      y: 123.463,
      name: "+1sd",
    },
    {
      month: 78,
      y: 123.975,
      name: "+1sd",
    },
    {
      month: 79,
      y: 124.486,
      name: "+1sd",
    },
    {
      month: 80,
      y: 124.996,
      name: "+1sd",
    },
    {
      month: 81,
      y: 125.503,
      name: "+1sd",
    },
    {
      month: 82,
      y: 126.01,
      name: "+1sd",
    },
    {
      month: 83,
      y: 126.516,
      name: "+1sd",
    },
    {
      month: 84,
      y: 127.019,
      name: "+1sd",
    },
    {
      month: 85,
      y: 127.521,
      name: "+1sd",
    },
    {
      month: 86,
      y: 128.021,
      name: "+1sd",
    },
    {
      month: 87,
      y: 128.519,
      name: "+1sd",
    },
    {
      month: 88,
      y: 129.016,
      name: "+1sd",
    },
    {
      month: 89,
      y: 129.511,
      name: "+1sd",
    },
    {
      month: 90,
      y: 130.003,
      name: "+1sd",
    },
    {
      month: 91,
      y: 130.494,
      name: "+1sd",
    },
    {
      month: 92,
      y: 130.982,
      name: "+1sd",
    },
    {
      month: 93,
      y: 131.468,
      name: "+1sd",
    },
    {
      month: 94,
      y: 131.952,
      name: "+1sd",
    },
    {
      month: 95,
      y: 132.434,
      name: "+1sd",
    },
    {
      month: 96,
      y: 132.913,
      name: "+1sd",
    },
    {
      month: 97,
      y: 133.391,
      name: "+1sd",
    },
    {
      month: 98,
      y: 133.867,
      name: "+1sd",
    },
    {
      month: 99,
      y: 134.342,
      name: "+1sd",
    },
    {
      month: 100,
      y: 134.815,
      name: "+1sd",
    },
    {
      month: 101,
      y: 135.287,
      name: "+1sd",
    },
    {
      month: 102,
      y: 135.76,
      name: "+1sd",
    },
    {
      month: 103,
      y: 136.231,
      name: "+1sd",
    },
    {
      month: 104,
      y: 136.701,
      name: "+1sd",
    },
    {
      month: 105,
      y: 137.17,
      name: "+1sd",
    },
    {
      month: 106,
      y: 137.639,
      name: "+1sd",
    },
    {
      month: 107,
      y: 138.108,
      name: "+1sd",
    },
    {
      month: 108,
      y: 138.577,
      name: "+1sd",
    },
    {
      month: 109,
      y: 139.045,
      name: "+1sd",
    },
    {
      month: 110,
      y: 139.513,
      name: "+1sd",
    },
    {
      month: 111,
      y: 139.98,
      name: "+1sd",
    },
    {
      month: 112,
      y: 140.446,
      name: "+1sd",
    },
    {
      month: 113,
      y: 140.912,
      name: "+1sd",
    },
    {
      month: 114,
      y: 141.377,
      name: "+1sd",
    },
    {
      month: 115,
      y: 141.84,
      name: "+1sd",
    },
    {
      month: 116,
      y: 142.304,
      name: "+1sd",
    },
    {
      month: 117,
      y: 142.767,
      name: "+1sd",
    },
    {
      month: 118,
      y: 143.23,
      name: "+1sd",
    },
    {
      month: 119,
      y: 143.691,
      name: "+1sd",
    },
    {
      month: 120,
      y: 144.153,
      name: "+1sd",
    },
    {
      month: 121,
      y: 144.615,
      name: "+1sd",
    },
    {
      month: 122,
      y: 145.078,
      name: "+1sd",
    },
    {
      month: 123,
      y: 145.543,
      name: "+1sd",
    },
    {
      month: 124,
      y: 146.009,
      name: "+1sd",
    },
    {
      month: 125,
      y: 146.477,
      name: "+1sd",
    },
    {
      month: 126,
      y: 146.947,
      name: "+1sd",
    },
    {
      month: 127,
      y: 147.422,
      name: "+1sd",
    },
    {
      month: 128,
      y: 147.898,
      name: "+1sd",
    },
    {
      month: 129,
      y: 148.379,
      name: "+1sd",
    },
    {
      month: 130,
      y: 148.863,
      name: "+1sd",
    },
    {
      month: 131,
      y: 149.352,
      name: "+1sd",
    },
    {
      month: 132,
      y: 149.843,
      name: "+1sd",
    },
    {
      month: 133,
      y: 150.341,
      name: "+1sd",
    },
    {
      month: 134,
      y: 150.842,
      name: "+1sd",
    },
    {
      month: 135,
      y: 151.348,
      name: "+1sd",
    },
    {
      month: 136,
      y: 151.858,
      name: "+1sd",
    },
    {
      month: 137,
      y: 152.375,
      name: "+1sd",
    },
    {
      month: 138,
      y: 152.897,
      name: "+1sd",
    },
    {
      month: 139,
      y: 153.425,
      name: "+1sd",
    },
    {
      month: 140,
      y: 153.96,
      name: "+1sd",
    },
    {
      month: 141,
      y: 154.502,
      name: "+1sd",
    },
    {
      month: 142,
      y: 155.049,
      name: "+1sd",
    },
    {
      month: 143,
      y: 155.604,
      name: "+1sd",
    },
    {
      month: 144,
      y: 156.167,
      name: "+1sd",
    },
    {
      month: 145,
      y: 156.736,
      name: "+1sd",
    },
    {
      month: 146,
      y: 157.314,
      name: "+1sd",
    },
    {
      month: 147,
      y: 157.899,
      name: "+1sd",
    },
    {
      month: 148,
      y: 158.493,
      name: "+1sd",
    },
    {
      month: 149,
      y: 159.094,
      name: "+1sd",
    },
    {
      month: 150,
      y: 159.703,
      name: "+1sd",
    },
    {
      month: 151,
      y: 160.319,
      name: "+1sd",
    },
    {
      month: 152,
      y: 160.942,
      name: "+1sd",
    },
    {
      month: 153,
      y: 161.568,
      name: "+1sd",
    },
    {
      month: 154,
      y: 162.2,
      name: "+1sd",
    },
    {
      month: 155,
      y: 162.835,
      name: "+1sd",
    },
    {
      month: 156,
      y: 163.47,
      name: "+1sd",
    },
    {
      month: 157,
      y: 164.107,
      name: "+1sd",
    },
    {
      month: 158,
      y: 164.746,
      name: "+1sd",
    },
    {
      month: 159,
      y: 165.383,
      name: "+1sd",
    },
    {
      month: 160,
      y: 166.017,
      name: "+1sd",
    },
    {
      month: 161,
      y: 166.646,
      name: "+1sd",
    },
    {
      month: 162,
      y: 167.272,
      name: "+1sd",
    },
    {
      month: 163,
      y: 167.892,
      name: "+1sd",
    },
    {
      month: 164,
      y: 168.504,
      name: "+1sd",
    },
    {
      month: 165,
      y: 169.11,
      name: "+1sd",
    },
    {
      month: 166,
      y: 169.707,
      name: "+1sd",
    },
    {
      month: 167,
      y: 170.296,
      name: "+1sd",
    },
    {
      month: 168,
      y: 170.874,
      name: "+1sd",
    },
    {
      month: 169,
      y: 171.439,
      name: "+1sd",
    },
    {
      month: 170,
      y: 171.994,
      name: "+1sd",
    },
    {
      month: 171,
      y: 172.535,
      name: "+1sd",
    },
    {
      month: 172,
      y: 173.063,
      name: "+1sd",
    },
    {
      month: 173,
      y: 173.575,
      name: "+1sd",
    },
    {
      month: 174,
      y: 174.073,
      name: "+1sd",
    },
    {
      month: 175,
      y: 174.557,
      name: "+1sd",
    },
    {
      month: 176,
      y: 175.027,
      name: "+1sd",
    },
    {
      month: 177,
      y: 175.481,
      name: "+1sd",
    },
    {
      month: 178,
      y: 175.921,
      name: "+1sd",
    },
    {
      month: 179,
      y: 176.349,
      name: "+1sd",
    },
    {
      month: 180,
      y: 176.762,
      name: "+1sd",
    },
    {
      month: 181,
      y: 177.16,
      name: "+1sd",
    },
    {
      month: 182,
      y: 177.545,
      name: "+1sd",
    },
    {
      month: 183,
      y: 177.916,
      name: "+1sd",
    },
    {
      month: 184,
      y: 178.274,
      name: "+1sd",
    },
    {
      month: 185,
      y: 178.618,
      name: "+1sd",
    },
    {
      month: 186,
      y: 178.949,
      name: "+1sd",
    },
    {
      month: 187,
      y: 179.266,
      name: "+1sd",
    },
    {
      month: 188,
      y: 179.573,
      name: "+1sd",
    },
    {
      month: 189,
      y: 179.865,
      name: "+1sd",
    },
    {
      month: 190,
      y: 180.144,
      name: "+1sd",
    },
    {
      month: 191,
      y: 180.413,
      name: "+1sd",
    },
    {
      month: 192,
      y: 180.668,
      name: "+1sd",
    },
    {
      month: 193,
      y: 180.911,
      name: "+1sd",
    },
    {
      month: 194,
      y: 181.141,
      name: "+1sd",
    },
    {
      month: 195,
      y: 181.359,
      name: "+1sd",
    },
    {
      month: 196,
      y: 181.565,
      name: "+1sd",
    },
    {
      month: 197,
      y: 181.759,
      name: "+1sd",
    },
    {
      month: 198,
      y: 181.942,
      name: "+1sd",
    },
    {
      month: 199,
      y: 182.112,
      name: "+1sd",
    },
    {
      month: 200,
      y: 182.272,
      name: "+1sd",
    },
    {
      month: 201,
      y: 182.421,
      name: "+1sd",
    },
    {
      month: 202,
      y: 182.559,
      name: "+1sd",
    },
    {
      month: 203,
      y: 182.688,
      name: "+1sd",
    },
    {
      month: 204,
      y: 182.805,
      name: "+1sd",
    },
    {
      month: 205,
      y: 182.912,
      name: "+1sd",
    },
    {
      month: 206,
      y: 183.013,
      name: "+1sd",
    },
    {
      month: 207,
      y: 183.102,
      name: "+1sd",
    },
    {
      month: 208,
      y: 183.185,
      name: "+1sd",
    },
    {
      month: 209,
      y: 183.259,
      name: "+1sd",
    },
    {
      month: 210,
      y: 183.327,
      name: "+1sd",
    },
    {
      month: 211,
      y: 183.389,
      name: "+1sd",
    },
    {
      month: 212,
      y: 183.444,
      name: "+1sd",
    },
    {
      month: 213,
      y: 183.494,
      name: "+1sd",
    },
    {
      month: 214,
      y: 183.539,
      name: "+1sd",
    },
    {
      month: 215,
      y: 183.579,
      name: "+1sd",
    },
    {
      month: 216,
      y: 183.615,
      name: "+1sd",
    },
    {
      month: 217,
      y: 183.649,
      name: "+1sd",
    },
    {
      month: 218,
      y: 183.678,
      name: "+1sd",
    },
    {
      month: 219,
      y: 183.704,
      name: "+1sd",
    },
    {
      month: 220,
      y: 183.729,
      name: "+1sd",
    },
    {
      month: 221,
      y: 183.75,
      name: "+1sd",
    },
    {
      month: 222,
      y: 183.767,
      name: "+1sd",
    },
    {
      month: 223,
      y: 183.785,
      name: "+1sd",
    },
    {
      month: 224,
      y: 183.8,
      name: "+1sd",
    },
    {
      month: 225,
      y: 183.812,
      name: "+1sd",
    },
    {
      month: 226,
      y: 183.822,
      name: "+1sd",
    },
    {
      month: 227,
      y: 183.833,
      name: "+1sd",
    },
    {
      month: 228,
      y: 183.841,
      name: "+1sd",
    },
    {
      month: 0,
      y: 53.7,
      name: "+2sd",
    },
    {
      month: 1,
      y: 58.6,
      name: "+2sd",
    },
    {
      month: 2,
      y: 62.4,
      name: "+2sd",
    },
    {
      month: 3,
      y: 65.5,
      name: "+2sd",
    },
    {
      month: 4,
      y: 68,
      name: "+2sd",
    },
    {
      month: 5,
      y: 70.1,
      name: "+2sd",
    },
    {
      month: 6,
      y: 71.9,
      name: "+2sd",
    },
    {
      month: 7,
      y: 73.5,
      name: "+2sd",
    },
    {
      month: 8,
      y: 75,
      name: "+2sd",
    },
    {
      month: 9,
      y: 76.5,
      name: "+2sd",
    },
    {
      month: 10,
      y: 77.9,
      name: "+2sd",
    },
    {
      month: 11,
      y: 79.2,
      name: "+2sd",
    },
    {
      month: 12,
      y: 80.5,
      name: "+2sd",
    },
    {
      month: 13,
      y: 81.8,
      name: "+2sd",
    },
    {
      month: 14,
      y: 83,
      name: "+2sd",
    },
    {
      month: 15,
      y: 84.2,
      name: "+2sd",
    },
    {
      month: 16,
      y: 85.4,
      name: "+2sd",
    },
    {
      month: 17,
      y: 86.5,
      name: "+2sd",
    },
    {
      month: 18,
      y: 87.7,
      name: "+2sd",
    },
    {
      month: 19,
      y: 88.8,
      name: "+2sd",
    },
    {
      month: 20,
      y: 89.8,
      name: "+2sd",
    },
    {
      month: 21,
      y: 90.9,
      name: "+2sd",
    },
    {
      month: 22,
      y: 91.9,
      name: "+2sd",
    },
    {
      month: 23,
      y: 92.9,
      name: "+2sd",
    },
    {
      month: 24,
      y: 93.2,
      name: "+2sd",
    },
    {
      month: 25,
      y: 94.2,
      name: "+2sd",
    },
    {
      month: 26,
      y: 95.2,
      name: "+2sd",
    },
    {
      month: 27,
      y: 96.1,
      name: "+2sd",
    },
    {
      month: 28,
      y: 97,
      name: "+2sd",
    },
    {
      month: 29,
      y: 97.9,
      name: "+2sd",
    },
    {
      month: 30,
      y: 98.7,
      name: "+2sd",
    },
    {
      month: 31,
      y: 99.6,
      name: "+2sd",
    },
    {
      month: 32,
      y: 100.4,
      name: "+2sd",
    },
    {
      month: 33,
      y: 101.2,
      name: "+2sd",
    },
    {
      month: 34,
      y: 102,
      name: "+2sd",
    },
    {
      month: 35,
      y: 102.7,
      name: "+2sd",
    },
    {
      month: 36,
      y: 103.5,
      name: "+2sd",
    },
    {
      month: 37,
      y: 104.2,
      name: "+2sd",
    },
    {
      month: 38,
      y: 105,
      name: "+2sd",
    },
    {
      month: 39,
      y: 105.7,
      name: "+2sd",
    },
    {
      month: 40,
      y: 106.4,
      name: "+2sd",
    },
    {
      month: 41,
      y: 107.1,
      name: "+2sd",
    },
    {
      month: 42,
      y: 107.8,
      name: "+2sd",
    },
    {
      month: 43,
      y: 108.5,
      name: "+2sd",
    },
    {
      month: 44,
      y: 109.1,
      name: "+2sd",
    },
    {
      month: 45,
      y: 109.8,
      name: "+2sd",
    },
    {
      month: 46,
      y: 110.4,
      name: "+2sd",
    },
    {
      month: 47,
      y: 111.1,
      name: "+2sd",
    },
    {
      month: 48,
      y: 111.7,
      name: "+2sd",
    },
    {
      month: 49,
      y: 112.4,
      name: "+2sd",
    },
    {
      month: 50,
      y: 113,
      name: "+2sd",
    },
    {
      month: 51,
      y: 113.6,
      name: "+2sd",
    },
    {
      month: 52,
      y: 114.2,
      name: "+2sd",
    },
    {
      month: 53,
      y: 114.9,
      name: "+2sd",
    },
    {
      month: 54,
      y: 115.5,
      name: "+2sd",
    },
    {
      month: 55,
      y: 116.1,
      name: "+2sd",
    },
    {
      month: 56,
      y: 116.7,
      name: "+2sd",
    },
    {
      month: 57,
      y: 117.4,
      name: "+2sd",
    },
    {
      month: 58,
      y: 118,
      name: "+2sd",
    },
    {
      month: 59,
      y: 118.6,
      name: "+2sd",
    },
    {
      month: 60,
      y: 119.2,
      name: "+2sd",
    },
    {
      month: 61,
      y: 119.448,
      name: "+2sd",
    },
    {
      month: 62,
      y: 120.046,
      name: "+2sd",
    },
    {
      month: 63,
      y: 120.641,
      name: "+2sd",
    },
    {
      month: 64,
      y: 121.231,
      name: "+2sd",
    },
    {
      month: 65,
      y: 121.819,
      name: "+2sd",
    },
    {
      month: 66,
      y: 122.402,
      name: "+2sd",
    },
    {
      month: 67,
      y: 122.981,
      name: "+2sd",
    },
    {
      month: 68,
      y: 123.553,
      name: "+2sd",
    },
    {
      month: 69,
      y: 124.123,
      name: "+2sd",
    },
    {
      month: 70,
      y: 124.689,
      name: "+2sd",
    },
    {
      month: 71,
      y: 125.248,
      name: "+2sd",
    },
    {
      month: 72,
      y: 125.804,
      name: "+2sd",
    },
    {
      month: 73,
      y: 126.357,
      name: "+2sd",
    },
    {
      month: 74,
      y: 126.905,
      name: "+2sd",
    },
    {
      month: 75,
      y: 127.452,
      name: "+2sd",
    },
    {
      month: 76,
      y: 127.997,
      name: "+2sd",
    },
    {
      month: 77,
      y: 128.539,
      name: "+2sd",
    },
    {
      month: 78,
      y: 129.081,
      name: "+2sd",
    },
    {
      month: 79,
      y: 129.622,
      name: "+2sd",
    },
    {
      month: 80,
      y: 130.162,
      name: "+2sd",
    },
    {
      month: 81,
      y: 130.698,
      name: "+2sd",
    },
    {
      month: 82,
      y: 131.236,
      name: "+2sd",
    },
    {
      month: 83,
      y: 131.771,
      name: "+2sd",
    },
    {
      month: 84,
      y: 132.305,
      name: "+2sd",
    },
    {
      month: 85,
      y: 132.837,
      name: "+2sd",
    },
    {
      month: 86,
      y: 133.367,
      name: "+2sd",
    },
    {
      month: 87,
      y: 133.896,
      name: "+2sd",
    },
    {
      month: 88,
      y: 134.423,
      name: "+2sd",
    },
    {
      month: 89,
      y: 134.947,
      name: "+2sd",
    },
    {
      month: 90,
      y: 135.47,
      name: "+2sd",
    },
    {
      month: 91,
      y: 135.991,
      name: "+2sd",
    },
    {
      month: 92,
      y: 136.51,
      name: "+2sd",
    },
    {
      month: 93,
      y: 137.026,
      name: "+2sd",
    },
    {
      month: 94,
      y: 137.54,
      name: "+2sd",
    },
    {
      month: 95,
      y: 138.051,
      name: "+2sd",
    },
    {
      month: 96,
      y: 138.561,
      name: "+2sd",
    },
    {
      month: 97,
      y: 139.069,
      name: "+2sd",
    },
    {
      month: 98,
      y: 139.575,
      name: "+2sd",
    },
    {
      month: 99,
      y: 140.08,
      name: "+2sd",
    },
    {
      month: 100,
      y: 140.583,
      name: "+2sd",
    },
    {
      month: 101,
      y: 141.086,
      name: "+2sd",
    },
    {
      month: 102,
      y: 141.59,
      name: "+2sd",
    },
    {
      month: 103,
      y: 142.091,
      name: "+2sd",
    },
    {
      month: 104,
      y: 142.591,
      name: "+2sd",
    },
    {
      month: 105,
      y: 143.091,
      name: "+2sd",
    },
    {
      month: 106,
      y: 143.59,
      name: "+2sd",
    },
    {
      month: 107,
      y: 144.09,
      name: "+2sd",
    },
    {
      month: 108,
      y: 144.589,
      name: "+2sd",
    },
    {
      month: 109,
      y: 145.088,
      name: "+2sd",
    },
    {
      month: 110,
      y: 145.586,
      name: "+2sd",
    },
    {
      month: 111,
      y: 146.084,
      name: "+2sd",
    },
    {
      month: 112,
      y: 146.578,
      name: "+2sd",
    },
    {
      month: 113,
      y: 147.075,
      name: "+2sd",
    },
    {
      month: 114,
      y: 147.571,
      name: "+2sd",
    },
    {
      month: 115,
      y: 148.064,
      name: "+2sd",
    },
    {
      month: 116,
      y: 148.559,
      name: "+2sd",
    },
    {
      month: 117,
      y: 149.05,
      name: "+2sd",
    },
    {
      month: 118,
      y: 149.544,
      name: "+2sd",
    },
    {
      month: 119,
      y: 150.036,
      name: "+2sd",
    },
    {
      month: 120,
      y: 150.527,
      name: "+2sd",
    },
    {
      month: 121,
      y: 151.019,
      name: "+2sd",
    },
    {
      month: 122,
      y: 151.511,
      name: "+2sd",
    },
    {
      month: 123,
      y: 152.006,
      name: "+2sd",
    },
    {
      month: 124,
      y: 152.502,
      name: "+2sd",
    },
    {
      month: 125,
      y: 153.001,
      name: "+2sd",
    },
    {
      month: 126,
      y: 153.499,
      name: "+2sd",
    },
    {
      month: 127,
      y: 154.004,
      name: "+2sd",
    },
    {
      month: 128,
      y: 154.51,
      name: "+2sd",
    },
    {
      month: 129,
      y: 155.02,
      name: "+2sd",
    },
    {
      month: 130,
      y: 155.535,
      name: "+2sd",
    },
    {
      month: 131,
      y: 156.054,
      name: "+2sd",
    },
    {
      month: 132,
      y: 156.574,
      name: "+2sd",
    },
    {
      month: 133,
      y: 157.102,
      name: "+2sd",
    },
    {
      month: 134,
      y: 157.632,
      name: "+2sd",
    },
    {
      month: 135,
      y: 158.168,
      name: "+2sd",
    },
    {
      month: 136,
      y: 158.707,
      name: "+2sd",
    },
    {
      month: 137,
      y: 159.255,
      name: "+2sd",
    },
    {
      month: 138,
      y: 159.806,
      name: "+2sd",
    },
    {
      month: 139,
      y: 160.363,
      name: "+2sd",
    },
    {
      month: 140,
      y: 160.928,
      name: "+2sd",
    },
    {
      month: 141,
      y: 161.499,
      name: "+2sd",
    },
    {
      month: 142,
      y: 162.076,
      name: "+2sd",
    },
    {
      month: 143,
      y: 162.66,
      name: "+2sd",
    },
    {
      month: 144,
      y: 163.252,
      name: "+2sd",
    },
    {
      month: 145,
      y: 163.85,
      name: "+2sd",
    },
    {
      month: 146,
      y: 164.46,
      name: "+2sd",
    },
    {
      month: 147,
      y: 165.072,
      name: "+2sd",
    },
    {
      month: 148,
      y: 165.696,
      name: "+2sd",
    },
    {
      month: 149,
      y: 166.326,
      name: "+2sd",
    },
    {
      month: 150,
      y: 166.964,
      name: "+2sd",
    },
    {
      month: 151,
      y: 167.607,
      name: "+2sd",
    },
    {
      month: 152,
      y: 168.261,
      name: "+2sd",
    },
    {
      month: 153,
      y: 168.914,
      name: "+2sd",
    },
    {
      month: 154,
      y: 169.575,
      name: "+2sd",
    },
    {
      month: 155,
      y: 170.236,
      name: "+2sd",
    },
    {
      month: 156,
      y: 170.898,
      name: "+2sd",
    },
    {
      month: 157,
      y: 171.561,
      name: "+2sd",
    },
    {
      month: 158,
      y: 172.225,
      name: "+2sd",
    },
    {
      month: 159,
      y: 172.888,
      name: "+2sd",
    },
    {
      month: 160,
      y: 173.547,
      name: "+2sd",
    },
    {
      month: 161,
      y: 174.198,
      name: "+2sd",
    },
    {
      month: 162,
      y: 174.848,
      name: "+2sd",
    },
    {
      month: 163,
      y: 175.49,
      name: "+2sd",
    },
    {
      month: 164,
      y: 176.122,
      name: "+2sd",
    },
    {
      month: 165,
      y: 176.747,
      name: "+2sd",
    },
    {
      month: 166,
      y: 177.364,
      name: "+2sd",
    },
    {
      month: 167,
      y: 177.972,
      name: "+2sd",
    },
    {
      month: 168,
      y: 178.566,
      name: "+2sd",
    },
    {
      month: 169,
      y: 179.146,
      name: "+2sd",
    },
    {
      month: 170,
      y: 179.717,
      name: "+2sd",
    },
    {
      month: 171,
      y: 180.271,
      name: "+2sd",
    },
    {
      month: 172,
      y: 180.811,
      name: "+2sd",
    },
    {
      month: 173,
      y: 181.334,
      name: "+2sd",
    },
    {
      month: 174,
      y: 181.841,
      name: "+2sd",
    },
    {
      month: 175,
      y: 182.334,
      name: "+2sd",
    },
    {
      month: 176,
      y: 182.812,
      name: "+2sd",
    },
    {
      month: 177,
      y: 183.272,
      name: "+2sd",
    },
    {
      month: 178,
      y: 183.717,
      name: "+2sd",
    },
    {
      month: 179,
      y: 184.149,
      name: "+2sd",
    },
    {
      month: 180,
      y: 184.566,
      name: "+2sd",
    },
    {
      month: 181,
      y: 184.966,
      name: "+2sd",
    },
    {
      month: 182,
      y: 185.351,
      name: "+2sd",
    },
    {
      month: 183,
      y: 185.723,
      name: "+2sd",
    },
    {
      month: 184,
      y: 186.079,
      name: "+2sd",
    },
    {
      month: 185,
      y: 186.423,
      name: "+2sd",
    },
    {
      month: 186,
      y: 186.752,
      name: "+2sd",
    },
    {
      month: 187,
      y: 187.065,
      name: "+2sd",
    },
    {
      month: 188,
      y: 187.368,
      name: "+2sd",
    },
    {
      month: 189,
      y: 187.654,
      name: "+2sd",
    },
    {
      month: 190,
      y: 187.928,
      name: "+2sd",
    },
    {
      month: 191,
      y: 188.192,
      name: "+2sd",
    },
    {
      month: 192,
      y: 188.44,
      name: "+2sd",
    },
    {
      month: 193,
      y: 188.675,
      name: "+2sd",
    },
    {
      month: 194,
      y: 188.897,
      name: "+2sd",
    },
    {
      month: 195,
      y: 189.106,
      name: "+2sd",
    },
    {
      month: 196,
      y: 189.302,
      name: "+2sd",
    },
    {
      month: 197,
      y: 189.486,
      name: "+2sd",
    },
    {
      month: 198,
      y: 189.658,
      name: "+2sd",
    },
    {
      month: 199,
      y: 189.818,
      name: "+2sd",
    },
    {
      month: 200,
      y: 189.966,
      name: "+2sd",
    },
    {
      month: 201,
      y: 190.102,
      name: "+2sd",
    },
    {
      month: 202,
      y: 190.227,
      name: "+2sd",
    },
    {
      month: 203,
      y: 190.345,
      name: "+2sd",
    },
    {
      month: 204,
      y: 190.449,
      name: "+2sd",
    },
    {
      month: 205,
      y: 190.542,
      name: "+2sd",
    },
    {
      month: 206,
      y: 190.63,
      name: "+2sd",
    },
    {
      month: 207,
      y: 190.705,
      name: "+2sd",
    },
    {
      month: 208,
      y: 190.774,
      name: "+2sd",
    },
    {
      month: 209,
      y: 190.833,
      name: "+2sd",
    },
    {
      month: 210,
      y: 190.887,
      name: "+2sd",
    },
    {
      month: 211,
      y: 190.934,
      name: "+2sd",
    },
    {
      month: 212,
      y: 190.975,
      name: "+2sd",
    },
    {
      month: 213,
      y: 191.01,
      name: "+2sd",
    },
    {
      month: 214,
      y: 191.04,
      name: "+2sd",
    },
    {
      month: 215,
      y: 191.065,
      name: "+2sd",
    },
    {
      month: 216,
      y: 191.086,
      name: "+2sd",
    },
    {
      month: 217,
      y: 191.105,
      name: "+2sd",
    },
    {
      month: 218,
      y: 191.118,
      name: "+2sd",
    },
    {
      month: 219,
      y: 191.131,
      name: "+2sd",
    },
    {
      month: 220,
      y: 191.141,
      name: "+2sd",
    },
    {
      month: 221,
      y: 191.148,
      name: "+2sd",
    },
    {
      month: 222,
      y: 191.149,
      name: "+2sd",
    },
    {
      month: 223,
      y: 191.154,
      name: "+2sd",
    },
    {
      month: 224,
      y: 191.154,
      name: "+2sd",
    },
    {
      month: 225,
      y: 191.151,
      name: "+2sd",
    },
    {
      month: 226,
      y: 191.147,
      name: "+2sd",
    },
    {
      month: 227,
      y: 191.144,
      name: "+2sd",
    },
    {
      month: 228,
      y: 191.14,
      name: "+2sd",
    },
    {
      month: 0,
      y: 55.6,
      name: "+3sd",
    },
    {
      month: 1,
      y: 60.6,
      name: "+3sd",
    },
    {
      month: 2,
      y: 64.4,
      name: "+3sd",
    },
    {
      month: 3,
      y: 67.6,
      name: "+3sd",
    },
    {
      month: 4,
      y: 70.1,
      name: "+3sd",
    },
    {
      month: 5,
      y: 72.2,
      name: "+3sd",
    },
    {
      month: 6,
      y: 74,
      name: "+3sd",
    },
    {
      month: 7,
      y: 75.7,
      name: "+3sd",
    },
    {
      month: 8,
      y: 77.2,
      name: "+3sd",
    },
    {
      month: 9,
      y: 78.7,
      name: "+3sd",
    },
    {
      month: 10,
      y: 80.1,
      name: "+3sd",
    },
    {
      month: 11,
      y: 81.5,
      name: "+3sd",
    },
    {
      month: 12,
      y: 82.9,
      name: "+3sd",
    },
    {
      month: 13,
      y: 84.2,
      name: "+3sd",
    },
    {
      month: 14,
      y: 85.5,
      name: "+3sd",
    },
    {
      month: 15,
      y: 86.7,
      name: "+3sd",
    },
    {
      month: 16,
      y: 88,
      name: "+3sd",
    },
    {
      month: 17,
      y: 89.2,
      name: "+3sd",
    },
    {
      month: 18,
      y: 90.4,
      name: "+3sd",
    },
    {
      month: 19,
      y: 91.5,
      name: "+3sd",
    },
    {
      month: 20,
      y: 92.6,
      name: "+3sd",
    },
    {
      month: 21,
      y: 93.8,
      name: "+3sd",
    },
    {
      month: 22,
      y: 94.9,
      name: "+3sd",
    },
    {
      month: 23,
      y: 95.9,
      name: "+3sd",
    },
    {
      month: 24,
      y: 96.3,
      name: "+3sd",
    },
    {
      month: 25,
      y: 97.3,
      name: "+3sd",
    },
    {
      month: 26,
      y: 98.3,
      name: "+3sd",
    },
    {
      month: 27,
      y: 99.3,
      name: "+3sd",
    },
    {
      month: 28,
      y: 100.3,
      name: "+3sd",
    },
    {
      month: 29,
      y: 101.2,
      name: "+3sd",
    },
    {
      month: 30,
      y: 102.1,
      name: "+3sd",
    },
    {
      month: 31,
      y: 103,
      name: "+3sd",
    },
    {
      month: 32,
      y: 103.9,
      name: "+3sd",
    },
    {
      month: 33,
      y: 104.8,
      name: "+3sd",
    },
    {
      month: 34,
      y: 105.6,
      name: "+3sd",
    },
    {
      month: 35,
      y: 106.4,
      name: "+3sd",
    },
    {
      month: 36,
      y: 107.2,
      name: "+3sd",
    },
    {
      month: 37,
      y: 108,
      name: "+3sd",
    },
    {
      month: 38,
      y: 108.8,
      name: "+3sd",
    },
    {
      month: 39,
      y: 109.5,
      name: "+3sd",
    },
    {
      month: 40,
      y: 110.3,
      name: "+3sd",
    },
    {
      month: 41,
      y: 111,
      name: "+3sd",
    },
    {
      month: 42,
      y: 111.7,
      name: "+3sd",
    },
    {
      month: 43,
      y: 112.5,
      name: "+3sd",
    },
    {
      month: 44,
      y: 113.2,
      name: "+3sd",
    },
    {
      month: 45,
      y: 113.9,
      name: "+3sd",
    },
    {
      month: 46,
      y: 114.6,
      name: "+3sd",
    },
    {
      month: 47,
      y: 115.2,
      name: "+3sd",
    },
    {
      month: 48,
      y: 115.9,
      name: "+3sd",
    },
    {
      month: 49,
      y: 116.6,
      name: "+3sd",
    },
    {
      month: 50,
      y: 117.3,
      name: "+3sd",
    },
    {
      month: 51,
      y: 117.9,
      name: "+3sd",
    },
    {
      month: 52,
      y: 118.6,
      name: "+3sd",
    },
    {
      month: 53,
      y: 119.2,
      name: "+3sd",
    },
    {
      month: 54,
      y: 119.9,
      name: "+3sd",
    },
    {
      month: 55,
      y: 120.6,
      name: "+3sd",
    },
    {
      month: 56,
      y: 121.2,
      name: "+3sd",
    },
    {
      month: 57,
      y: 121.9,
      name: "+3sd",
    },
    {
      month: 58,
      y: 122.6,
      name: "+3sd",
    },
    {
      month: 59,
      y: 123.2,
      name: "+3sd",
    },
    {
      month: 60,
      y: 123.9,
      name: "+3sd",
    },
    {
      month: 61,
      y: 124.039,
      name: "+3sd",
    },
    {
      month: 62,
      y: 124.668,
      name: "+3sd",
    },
    {
      month: 63,
      y: 125.295,
      name: "+3sd",
    },
    {
      month: 64,
      y: 125.915,
      name: "+3sd",
    },
    {
      month: 65,
      y: 126.534,
      name: "+3sd",
    },
    {
      month: 66,
      y: 127.148,
      name: "+3sd",
    },
    {
      month: 67,
      y: 127.757,
      name: "+3sd",
    },
    {
      month: 68,
      y: 128.359,
      name: "+3sd",
    },
    {
      month: 69,
      y: 128.96,
      name: "+3sd",
    },
    {
      month: 70,
      y: 129.556,
      name: "+3sd",
    },
    {
      month: 71,
      y: 130.144,
      name: "+3sd",
    },
    {
      month: 72,
      y: 130.731,
      name: "+3sd",
    },
    {
      month: 73,
      y: 131.314,
      name: "+3sd",
    },
    {
      month: 74,
      y: 131.891,
      name: "+3sd",
    },
    {
      month: 75,
      y: 132.468,
      name: "+3sd",
    },
    {
      month: 76,
      y: 133.044,
      name: "+3sd",
    },
    {
      month: 77,
      y: 133.614,
      name: "+3sd",
    },
    {
      month: 78,
      y: 134.186,
      name: "+3sd",
    },
    {
      month: 79,
      y: 134.758,
      name: "+3sd",
    },
    {
      month: 80,
      y: 135.328,
      name: "+3sd",
    },
    {
      month: 81,
      y: 135.893,
      name: "+3sd",
    },
    {
      month: 82,
      y: 136.461,
      name: "+3sd",
    },
    {
      month: 83,
      y: 137.027,
      name: "+3sd",
    },
    {
      month: 84,
      y: 137.591,
      name: "+3sd",
    },
    {
      month: 85,
      y: 138.153,
      name: "+3sd",
    },
    {
      month: 86,
      y: 138.714,
      name: "+3sd",
    },
    {
      month: 87,
      y: 139.272,
      name: "+3sd",
    },
    {
      month: 88,
      y: 139.829,
      name: "+3sd",
    },
    {
      month: 89,
      y: 140.384,
      name: "+3sd",
    },
    {
      month: 90,
      y: 140.938,
      name: "+3sd",
    },
    {
      month: 91,
      y: 141.488,
      name: "+3sd",
    },
    {
      month: 92,
      y: 142.037,
      name: "+3sd",
    },
    {
      month: 93,
      y: 142.583,
      name: "+3sd",
    },
    {
      month: 94,
      y: 143.127,
      name: "+3sd",
    },
    {
      month: 95,
      y: 143.669,
      name: "+3sd",
    },
    {
      month: 96,
      y: 144.209,
      name: "+3sd",
    },
    {
      month: 97,
      y: 144.747,
      name: "+3sd",
    },
    {
      month: 98,
      y: 145.284,
      name: "+3sd",
    },
    {
      month: 99,
      y: 145.818,
      name: "+3sd",
    },
    {
      month: 100,
      y: 146.352,
      name: "+3sd",
    },
    {
      month: 101,
      y: 146.884,
      name: "+3sd",
    },
    {
      month: 102,
      y: 147.42,
      name: "+3sd",
    },
    {
      month: 103,
      y: 147.951,
      name: "+3sd",
    },
    {
      month: 104,
      y: 148.481,
      name: "+3sd",
    },
    {
      month: 105,
      y: 149.011,
      name: "+3sd",
    },
    {
      month: 106,
      y: 149.541,
      name: "+3sd",
    },
    {
      month: 107,
      y: 150.071,
      name: "+3sd",
    },
    {
      month: 108,
      y: 150.601,
      name: "+3sd",
    },
    {
      month: 109,
      y: 151.13,
      name: "+3sd",
    },
    {
      month: 110,
      y: 151.659,
      name: "+3sd",
    },
    {
      month: 111,
      y: 152.187,
      name: "+3sd",
    },
    {
      month: 112,
      y: 152.711,
      name: "+3sd",
    },
    {
      month: 113,
      y: 153.238,
      name: "+3sd",
    },
    {
      month: 114,
      y: 153.765,
      name: "+3sd",
    },
    {
      month: 115,
      y: 154.287,
      name: "+3sd",
    },
    {
      month: 116,
      y: 154.813,
      name: "+3sd",
    },
    {
      month: 117,
      y: 155.334,
      name: "+3sd",
    },
    {
      month: 118,
      y: 155.859,
      name: "+3sd",
    },
    {
      month: 119,
      y: 156.38,
      name: "+3sd",
    },
    {
      month: 120,
      y: 156.901,
      name: "+3sd",
    },
    {
      month: 121,
      y: 157.422,
      name: "+3sd",
    },
    {
      month: 122,
      y: 157.945,
      name: "+3sd",
    },
    {
      month: 123,
      y: 158.469,
      name: "+3sd",
    },
    {
      month: 124,
      y: 158.995,
      name: "+3sd",
    },
    {
      month: 125,
      y: 159.524,
      name: "+3sd",
    },
    {
      month: 126,
      y: 160.051,
      name: "+3sd",
    },
    {
      month: 127,
      y: 160.587,
      name: "+3sd",
    },
    {
      month: 128,
      y: 161.122,
      name: "+3sd",
    },
    {
      month: 129,
      y: 161.662,
      name: "+3sd",
    },
    {
      month: 130,
      y: 162.206,
      name: "+3sd",
    },
    {
      month: 131,
      y: 162.755,
      name: "+3sd",
    },
    {
      month: 132,
      y: 163.304,
      name: "+3sd",
    },
    {
      month: 133,
      y: 163.863,
      name: "+3sd",
    },
    {
      month: 134,
      y: 164.423,
      name: "+3sd",
    },
    {
      month: 135,
      y: 164.988,
      name: "+3sd",
    },
    {
      month: 136,
      y: 165.556,
      name: "+3sd",
    },
    {
      month: 137,
      y: 166.134,
      name: "+3sd",
    },
    {
      month: 138,
      y: 166.714,
      name: "+3sd",
    },
    {
      month: 139,
      y: 167.301,
      name: "+3sd",
    },
    {
      month: 140,
      y: 167.895,
      name: "+3sd",
    },
    {
      month: 141,
      y: 168.497,
      name: "+3sd",
    },
    {
      month: 142,
      y: 169.102,
      name: "+3sd",
    },
    {
      month: 143,
      y: 169.716,
      name: "+3sd",
    },
    {
      month: 144,
      y: 170.338,
      name: "+3sd",
    },
    {
      month: 145,
      y: 170.965,
      name: "+3sd",
    },
    {
      month: 146,
      y: 171.605,
      name: "+3sd",
    },
    {
      month: 147,
      y: 172.245,
      name: "+3sd",
    },
    {
      month: 148,
      y: 172.899,
      name: "+3sd",
    },
    {
      month: 149,
      y: 173.557,
      name: "+3sd",
    },
    {
      month: 150,
      y: 174.225,
      name: "+3sd",
    },
    {
      month: 151,
      y: 174.896,
      name: "+3sd",
    },
    {
      month: 152,
      y: 175.579,
      name: "+3sd",
    },
    {
      month: 153,
      y: 176.259,
      name: "+3sd",
    },
    {
      month: 154,
      y: 176.949,
      name: "+3sd",
    },
    {
      month: 155,
      y: 177.638,
      name: "+3sd",
    },
    {
      month: 156,
      y: 178.325,
      name: "+3sd",
    },
    {
      month: 157,
      y: 179.015,
      name: "+3sd",
    },
    {
      month: 158,
      y: 179.705,
      name: "+3sd",
    },
    {
      month: 159,
      y: 180.394,
      name: "+3sd",
    },
    {
      month: 160,
      y: 181.076,
      name: "+3sd",
    },
    {
      month: 161,
      y: 181.75,
      name: "+3sd",
    },
    {
      month: 162,
      y: 182.424,
      name: "+3sd",
    },
    {
      month: 163,
      y: 183.088,
      name: "+3sd",
    },
    {
      month: 164,
      y: 183.74,
      name: "+3sd",
    },
    {
      month: 165,
      y: 184.385,
      name: "+3sd",
    },
    {
      month: 166,
      y: 185.021,
      name: "+3sd",
    },
    {
      month: 167,
      y: 185.648,
      name: "+3sd",
    },
    {
      month: 168,
      y: 186.259,
      name: "+3sd",
    },
    {
      month: 169,
      y: 186.853,
      name: "+3sd",
    },
    {
      month: 170,
      y: 187.439,
      name: "+3sd",
    },
    {
      month: 171,
      y: 188.006,
      name: "+3sd",
    },
    {
      month: 172,
      y: 188.559,
      name: "+3sd",
    },
    {
      month: 173,
      y: 189.092,
      name: "+3sd",
    },
    {
      month: 174,
      y: 189.609,
      name: "+3sd",
    },
    {
      month: 175,
      y: 190.111,
      name: "+3sd",
    },
    {
      month: 176,
      y: 190.597,
      name: "+3sd",
    },
    {
      month: 177,
      y: 191.063,
      name: "+3sd",
    },
    {
      month: 178,
      y: 191.513,
      name: "+3sd",
    },
    {
      month: 179,
      y: 191.949,
      name: "+3sd",
    },
    {
      month: 180,
      y: 192.371,
      name: "+3sd",
    },
    {
      month: 181,
      y: 192.772,
      name: "+3sd",
    },
    {
      month: 182,
      y: 193.158,
      name: "+3sd",
    },
    {
      month: 183,
      y: 193.529,
      name: "+3sd",
    },
    {
      month: 184,
      y: 193.885,
      name: "+3sd",
    },
    {
      month: 185,
      y: 194.227,
      name: "+3sd",
    },
    {
      month: 186,
      y: 194.555,
      name: "+3sd",
    },
    {
      month: 187,
      y: 194.863,
      name: "+3sd",
    },
    {
      month: 188,
      y: 195.163,
      name: "+3sd",
    },
    {
      month: 189,
      y: 195.444,
      name: "+3sd",
    },
    {
      month: 190,
      y: 195.712,
      name: "+3sd",
    },
    {
      month: 191,
      y: 195.971,
      name: "+3sd",
    },
    {
      month: 192,
      y: 196.212,
      name: "+3sd",
    },
    {
      month: 193,
      y: 196.439,
      name: "+3sd",
    },
    {
      month: 194,
      y: 196.652,
      name: "+3sd",
    },
    {
      month: 195,
      y: 196.852,
      name: "+3sd",
    },
    {
      month: 196,
      y: 197.039,
      name: "+3sd",
    },
    {
      month: 197,
      y: 197.213,
      name: "+3sd",
    },
    {
      month: 198,
      y: 197.374,
      name: "+3sd",
    },
    {
      month: 199,
      y: 197.523,
      name: "+3sd",
    },
    {
      month: 200,
      y: 197.659,
      name: "+3sd",
    },
    {
      month: 201,
      y: 197.784,
      name: "+3sd",
    },
    {
      month: 202,
      y: 197.896,
      name: "+3sd",
    },
    {
      month: 203,
      y: 198.003,
      name: "+3sd",
    },
    {
      month: 204,
      y: 198.093,
      name: "+3sd",
    },
    {
      month: 205,
      y: 198.173,
      name: "+3sd",
    },
    {
      month: 206,
      y: 198.247,
      name: "+3sd",
    },
    {
      month: 207,
      y: 198.307,
      name: "+3sd",
    },
    {
      month: 208,
      y: 198.364,
      name: "+3sd",
    },
    {
      month: 209,
      y: 198.406,
      name: "+3sd",
    },
    {
      month: 210,
      y: 198.446,
      name: "+3sd",
    },
    {
      month: 211,
      y: 198.479,
      name: "+3sd",
    },
    {
      month: 212,
      y: 198.506,
      name: "+3sd",
    },
    {
      month: 213,
      y: 198.526,
      name: "+3sd",
    },
    {
      month: 214,
      y: 198.541,
      name: "+3sd",
    },
    {
      month: 215,
      y: 198.551,
      name: "+3sd",
    },
    {
      month: 216,
      y: 198.556,
      name: "+3sd",
    },
    {
      month: 217,
      y: 198.562,
      name: "+3sd",
    },
    {
      month: 218,
      y: 198.559,
      name: "+3sd",
    },
    {
      month: 219,
      y: 198.558,
      name: "+3sd",
    },
    {
      month: 220,
      y: 198.553,
      name: "+3sd",
    },
    {
      month: 221,
      y: 198.546,
      name: "+3sd",
    },
    {
      month: 222,
      y: 198.53,
      name: "+3sd",
    },
    {
      month: 223,
      y: 198.523,
      name: "+3sd",
    },
    {
      month: 224,
      y: 198.508,
      name: "+3sd",
    },
    {
      month: 225,
      y: 198.491,
      name: "+3sd",
    },
    {
      month: 226,
      y: 198.472,
      name: "+3sd",
    },
    {
      month: 227,
      y: 198.456,
      name: "+3sd",
    },
    {
      month: 228,
      y: 198.438,
      name: "+3sd",
    },
  ] as any[],

  girls_head_circumference: [
    {
      month: 0,
      y: 30.3,
      name: "-3sd",
    },
    {
      month: 1,
      y: 33,
      name: "-3sd",
    },
    {
      month: 2,
      y: 34.6,
      name: "-3sd",
    },
    {
      month: 3,
      y: 35.8,
      name: "-3sd",
    },
    {
      month: 4,
      y: 36.8,
      name: "-3sd",
    },
    {
      month: 5,
      y: 37.6,
      name: "-3sd",
    },
    {
      month: 6,
      y: 38.3,
      name: "-3sd",
    },
    {
      month: 7,
      y: 38.9,
      name: "-3sd",
    },
    {
      month: 8,
      y: 39.4,
      name: "-3sd",
    },
    {
      month: 9,
      y: 39.8,
      name: "-3sd",
    },
    {
      month: 10,
      y: 40.2,
      name: "-3sd",
    },
    {
      month: 11,
      y: 40.5,
      name: "-3sd",
    },
    {
      month: 12,
      y: 40.8,
      name: "-3sd",
    },
    {
      month: 13,
      y: 41.1,
      name: "-3sd",
    },
    {
      month: 14,
      y: 41.3,
      name: "-3sd",
    },
    {
      month: 15,
      y: 41.5,
      name: "-3sd",
    },
    {
      month: 16,
      y: 41.7,
      name: "-3sd",
    },
    {
      month: 17,
      y: 41.9,
      name: "-3sd",
    },
    {
      month: 18,
      y: 42.1,
      name: "-3sd",
    },
    {
      month: 19,
      y: 42.3,
      name: "-3sd",
    },
    {
      month: 20,
      y: 42.4,
      name: "-3sd",
    },
    {
      month: 21,
      y: 42.6,
      name: "-3sd",
    },
    {
      month: 22,
      y: 42.7,
      name: "-3sd",
    },
    {
      month: 23,
      y: 42.9,
      name: "-3sd",
    },
    {
      month: 24,
      y: 43,
      name: "-3sd",
    },
    {
      month: 25,
      y: 43.1,
      name: "-3sd",
    },
    {
      month: 26,
      y: 43.3,
      name: "-3sd",
    },
    {
      month: 27,
      y: 43.4,
      name: "-3sd",
    },
    {
      month: 28,
      y: 43.5,
      name: "-3sd",
    },
    {
      month: 29,
      y: 43.6,
      name: "-3sd",
    },
    {
      month: 30,
      y: 43.7,
      name: "-3sd",
    },
    {
      month: 31,
      y: 43.8,
      name: "-3sd",
    },
    {
      month: 32,
      y: 43.9,
      name: "-3sd",
    },
    {
      month: 33,
      y: 44,
      name: "-3sd",
    },
    {
      month: 34,
      y: 44.1,
      name: "-3sd",
    },
    {
      month: 35,
      y: 44.2,
      name: "-3sd",
    },
    {
      month: 36,
      y: 44.3,
      name: "-3sd",
    },
    {
      month: 37,
      y: 44.4,
      name: "-3sd",
    },
    {
      month: 38,
      y: 44.4,
      name: "-3sd",
    },
    {
      month: 39,
      y: 44.5,
      name: "-3sd",
    },
    {
      month: 40,
      y: 44.6,
      name: "-3sd",
    },
    {
      month: 41,
      y: 44.6,
      name: "-3sd",
    },
    {
      month: 42,
      y: 44.7,
      name: "-3sd",
    },
    {
      month: 43,
      y: 44.8,
      name: "-3sd",
    },
    {
      month: 44,
      y: 44.8,
      name: "-3sd",
    },
    {
      month: 45,
      y: 44.9,
      name: "-3sd",
    },
    {
      month: 46,
      y: 45,
      name: "-3sd",
    },
    {
      month: 47,
      y: 45,
      name: "-3sd",
    },
    {
      month: 48,
      y: 45.1,
      name: "-3sd",
    },
    {
      month: 49,
      y: 45.1,
      name: "-3sd",
    },
    {
      month: 50,
      y: 45.2,
      name: "-3sd",
    },
    {
      month: 51,
      y: 45.2,
      name: "-3sd",
    },
    {
      month: 52,
      y: 45.3,
      name: "-3sd",
    },
    {
      month: 53,
      y: 45.3,
      name: "-3sd",
    },
    {
      month: 54,
      y: 45.4,
      name: "-3sd",
    },
    {
      month: 55,
      y: 45.4,
      name: "-3sd",
    },
    {
      month: 56,
      y: 45.5,
      name: "-3sd",
    },
    {
      month: 57,
      y: 45.5,
      name: "-3sd",
    },
    {
      month: 58,
      y: 45.6,
      name: "-3sd",
    },
    {
      month: 59,
      y: 45.6,
      name: "-3sd",
    },
    {
      month: 60,
      y: 45.7,
      name: "-3sd",
    },
    {
      month: 0,
      y: 31.5,
      name: "-2sd",
    },
    {
      month: 1,
      y: 34.2,
      name: "-2sd",
    },
    {
      month: 2,
      y: 35.8,
      name: "-2sd",
    },
    {
      month: 3,
      y: 37.1,
      name: "-2sd",
    },
    {
      month: 4,
      y: 38.1,
      name: "-2sd",
    },
    {
      month: 5,
      y: 38.9,
      name: "-2sd",
    },
    {
      month: 6,
      y: 39.6,
      name: "-2sd",
    },
    {
      month: 7,
      y: 40.2,
      name: "-2sd",
    },
    {
      month: 8,
      y: 40.7,
      name: "-2sd",
    },
    {
      month: 9,
      y: 41.2,
      name: "-2sd",
    },
    {
      month: 10,
      y: 41.5,
      name: "-2sd",
    },
    {
      month: 11,
      y: 41.9,
      name: "-2sd",
    },
    {
      month: 12,
      y: 42.2,
      name: "-2sd",
    },
    {
      month: 13,
      y: 42.4,
      name: "-2sd",
    },
    {
      month: 14,
      y: 42.7,
      name: "-2sd",
    },
    {
      month: 15,
      y: 42.9,
      name: "-2sd",
    },
    {
      month: 16,
      y: 43.1,
      name: "-2sd",
    },
    {
      month: 17,
      y: 43.3,
      name: "-2sd",
    },
    {
      month: 18,
      y: 43.5,
      name: "-2sd",
    },
    {
      month: 19,
      y: 43.6,
      name: "-2sd",
    },
    {
      month: 20,
      y: 43.8,
      name: "-2sd",
    },
    {
      month: 21,
      y: 44,
      name: "-2sd",
    },
    {
      month: 22,
      y: 44.1,
      name: "-2sd",
    },
    {
      month: 23,
      y: 44.3,
      name: "-2sd",
    },
    {
      month: 24,
      y: 44.4,
      name: "-2sd",
    },
    {
      month: 25,
      y: 44.5,
      name: "-2sd",
    },
    {
      month: 26,
      y: 44.7,
      name: "-2sd",
    },
    {
      month: 27,
      y: 44.8,
      name: "-2sd",
    },
    {
      month: 28,
      y: 44.9,
      name: "-2sd",
    },
    {
      month: 29,
      y: 45,
      name: "-2sd",
    },
    {
      month: 30,
      y: 45.1,
      name: "-2sd",
    },
    {
      month: 31,
      y: 45.2,
      name: "-2sd",
    },
    {
      month: 32,
      y: 45.3,
      name: "-2sd",
    },
    {
      month: 33,
      y: 45.4,
      name: "-2sd",
    },
    {
      month: 34,
      y: 45.5,
      name: "-2sd",
    },
    {
      month: 35,
      y: 45.6,
      name: "-2sd",
    },
    {
      month: 36,
      y: 45.7,
      name: "-2sd",
    },
    {
      month: 37,
      y: 45.8,
      name: "-2sd",
    },
    {
      month: 38,
      y: 45.8,
      name: "-2sd",
    },
    {
      month: 39,
      y: 45.9,
      name: "-2sd",
    },
    {
      month: 40,
      y: 46,
      name: "-2sd",
    },
    {
      month: 41,
      y: 46.1,
      name: "-2sd",
    },
    {
      month: 42,
      y: 46.1,
      name: "-2sd",
    },
    {
      month: 43,
      y: 46.2,
      name: "-2sd",
    },
    {
      month: 44,
      y: 46.3,
      name: "-2sd",
    },
    {
      month: 45,
      y: 46.3,
      name: "-2sd",
    },
    {
      month: 46,
      y: 46.4,
      name: "-2sd",
    },
    {
      month: 47,
      y: 46.4,
      name: "-2sd",
    },
    {
      month: 48,
      y: 46.5,
      name: "-2sd",
    },
    {
      month: 49,
      y: 46.5,
      name: "-2sd",
    },
    {
      month: 50,
      y: 46.6,
      name: "-2sd",
    },
    {
      month: 51,
      y: 46.7,
      name: "-2sd",
    },
    {
      month: 52,
      y: 46.7,
      name: "-2sd",
    },
    {
      month: 53,
      y: 46.8,
      name: "-2sd",
    },
    {
      month: 54,
      y: 46.8,
      name: "-2sd",
    },
    {
      month: 55,
      y: 46.9,
      name: "-2sd",
    },
    {
      month: 56,
      y: 46.9,
      name: "-2sd",
    },
    {
      month: 57,
      y: 46.9,
      name: "-2sd",
    },
    {
      month: 58,
      y: 47,
      name: "-2sd",
    },
    {
      month: 59,
      y: 47,
      name: "-2sd",
    },
    {
      month: 60,
      y: 47.1,
      name: "-2sd",
    },
    {
      month: 0,
      y: 32.7,
      name: "-1sd",
    },
    {
      month: 1,
      y: 35.4,
      name: "-1sd",
    },
    {
      month: 2,
      y: 37,
      name: "-1sd",
    },
    {
      month: 3,
      y: 38.3,
      name: "-1sd",
    },
    {
      month: 4,
      y: 39.3,
      name: "-1sd",
    },
    {
      month: 5,
      y: 40.2,
      name: "-1sd",
    },
    {
      month: 6,
      y: 40.9,
      name: "-1sd",
    },
    {
      month: 7,
      y: 41.5,
      name: "-1sd",
    },
    {
      month: 8,
      y: 42,
      name: "-1sd",
    },
    {
      month: 9,
      y: 42.5,
      name: "-1sd",
    },
    {
      month: 10,
      y: 42.9,
      name: "-1sd",
    },
    {
      month: 11,
      y: 43.2,
      name: "-1sd",
    },
    {
      month: 12,
      y: 43.5,
      name: "-1sd",
    },
    {
      month: 13,
      y: 43.8,
      name: "-1sd",
    },
    {
      month: 14,
      y: 44.1,
      name: "-1sd",
    },
    {
      month: 15,
      y: 44.3,
      name: "-1sd",
    },
    {
      month: 16,
      y: 44.5,
      name: "-1sd",
    },
    {
      month: 17,
      y: 44.7,
      name: "-1sd",
    },
    {
      month: 18,
      y: 44.9,
      name: "-1sd",
    },
    {
      month: 19,
      y: 45,
      name: "-1sd",
    },
    {
      month: 20,
      y: 45.2,
      name: "-1sd",
    },
    {
      month: 21,
      y: 45.3,
      name: "-1sd",
    },
    {
      month: 22,
      y: 45.5,
      name: "-1sd",
    },
    {
      month: 23,
      y: 45.6,
      name: "-1sd",
    },
    {
      month: 24,
      y: 45.8,
      name: "-1sd",
    },
    {
      month: 25,
      y: 45.9,
      name: "-1sd",
    },
    {
      month: 26,
      y: 46.1,
      name: "-1sd",
    },
    {
      month: 27,
      y: 46.2,
      name: "-1sd",
    },
    {
      month: 28,
      y: 46.3,
      name: "-1sd",
    },
    {
      month: 29,
      y: 46.4,
      name: "-1sd",
    },
    {
      month: 30,
      y: 46.5,
      name: "-1sd",
    },
    {
      month: 31,
      y: 46.6,
      name: "-1sd",
    },
    {
      month: 32,
      y: 46.7,
      name: "-1sd",
    },
    {
      month: 33,
      y: 46.8,
      name: "-1sd",
    },
    {
      month: 34,
      y: 46.9,
      name: "-1sd",
    },
    {
      month: 35,
      y: 47,
      name: "-1sd",
    },
    {
      month: 36,
      y: 47.1,
      name: "-1sd",
    },
    {
      month: 37,
      y: 47.2,
      name: "-1sd",
    },
    {
      month: 38,
      y: 47.3,
      name: "-1sd",
    },
    {
      month: 39,
      y: 47.3,
      name: "-1sd",
    },
    {
      month: 40,
      y: 47.4,
      name: "-1sd",
    },
    {
      month: 41,
      y: 47.5,
      name: "-1sd",
    },
    {
      month: 42,
      y: 47.5,
      name: "-1sd",
    },
    {
      month: 43,
      y: 47.6,
      name: "-1sd",
    },
    {
      month: 44,
      y: 47.7,
      name: "-1sd",
    },
    {
      month: 45,
      y: 47.7,
      name: "-1sd",
    },
    {
      month: 46,
      y: 47.8,
      name: "-1sd",
    },
    {
      month: 47,
      y: 47.9,
      name: "-1sd",
    },
    {
      month: 48,
      y: 47.9,
      name: "-1sd",
    },
    {
      month: 49,
      y: 48,
      name: "-1sd",
    },
    {
      month: 50,
      y: 48,
      name: "-1sd",
    },
    {
      month: 51,
      y: 48.1,
      name: "-1sd",
    },
    {
      month: 52,
      y: 48.1,
      name: "-1sd",
    },
    {
      month: 53,
      y: 48.2,
      name: "-1sd",
    },
    {
      month: 54,
      y: 48.2,
      name: "-1sd",
    },
    {
      month: 55,
      y: 48.3,
      name: "-1sd",
    },
    {
      month: 56,
      y: 48.3,
      name: "-1sd",
    },
    {
      month: 57,
      y: 48.4,
      name: "-1sd",
    },
    {
      month: 58,
      y: 48.4,
      name: "-1sd",
    },
    {
      month: 59,
      y: 48.5,
      name: "-1sd",
    },
    {
      month: 60,
      y: 48.5,
      name: "-1sd",
    },
    {
      month: 0,
      y: 33.9,
      name: "mediane",
    },
    {
      month: 1,
      y: 36.5,
      name: "mediane",
    },
    {
      month: 2,
      y: 38.3,
      name: "mediane",
    },
    {
      month: 3,
      y: 39.5,
      name: "mediane",
    },
    {
      month: 4,
      y: 40.6,
      name: "mediane",
    },
    {
      month: 5,
      y: 41.5,
      name: "mediane",
    },
    {
      month: 6,
      y: 42.2,
      name: "mediane",
    },
    {
      month: 7,
      y: 42.8,
      name: "mediane",
    },
    {
      month: 8,
      y: 43.4,
      name: "mediane",
    },
    {
      month: 9,
      y: 43.8,
      name: "mediane",
    },
    {
      month: 10,
      y: 44.2,
      name: "mediane",
    },
    {
      month: 11,
      y: 44.6,
      name: "mediane",
    },
    {
      month: 12,
      y: 44.9,
      name: "mediane",
    },
    {
      month: 13,
      y: 45.2,
      name: "mediane",
    },
    {
      month: 14,
      y: 45.4,
      name: "mediane",
    },
    {
      month: 15,
      y: 45.7,
      name: "mediane",
    },
    {
      month: 16,
      y: 45.9,
      name: "mediane",
    },
    {
      month: 17,
      y: 46.1,
      name: "mediane",
    },
    {
      month: 18,
      y: 46.2,
      name: "mediane",
    },
    {
      month: 19,
      y: 46.4,
      name: "mediane",
    },
    {
      month: 20,
      y: 46.6,
      name: "mediane",
    },
    {
      month: 21,
      y: 46.7,
      name: "mediane",
    },
    {
      month: 22,
      y: 46.9,
      name: "mediane",
    },
    {
      month: 23,
      y: 47,
      name: "mediane",
    },
    {
      month: 24,
      y: 47.2,
      name: "mediane",
    },
    {
      month: 25,
      y: 47.3,
      name: "mediane",
    },
    {
      month: 26,
      y: 47.5,
      name: "mediane",
    },
    {
      month: 27,
      y: 47.6,
      name: "mediane",
    },
    {
      month: 28,
      y: 47.7,
      name: "mediane",
    },
    {
      month: 29,
      y: 47.8,
      name: "mediane",
    },
    {
      month: 30,
      y: 47.9,
      name: "mediane",
    },
    {
      month: 31,
      y: 48,
      name: "mediane",
    },
    {
      month: 32,
      y: 48.1,
      name: "mediane",
    },
    {
      month: 33,
      y: 48.2,
      name: "mediane",
    },
    {
      month: 34,
      y: 48.3,
      name: "mediane",
    },
    {
      month: 35,
      y: 48.4,
      name: "mediane",
    },
    {
      month: 36,
      y: 48.5,
      name: "mediane",
    },
    {
      month: 37,
      y: 48.6,
      name: "mediane",
    },
    {
      month: 38,
      y: 48.7,
      name: "mediane",
    },
    {
      month: 39,
      y: 48.7,
      name: "mediane",
    },
    {
      month: 40,
      y: 48.8,
      name: "mediane",
    },
    {
      month: 41,
      y: 48.9,
      name: "mediane",
    },
    {
      month: 42,
      y: 49,
      name: "mediane",
    },
    {
      month: 43,
      y: 49,
      name: "mediane",
    },
    {
      month: 44,
      y: 49.1,
      name: "mediane",
    },
    {
      month: 45,
      y: 49.2,
      name: "mediane",
    },
    {
      month: 46,
      y: 49.2,
      name: "mediane",
    },
    {
      month: 47,
      y: 49.3,
      name: "mediane",
    },
    {
      month: 48,
      y: 49.3,
      name: "mediane",
    },
    {
      month: 49,
      y: 49.4,
      name: "mediane",
    },
    {
      month: 50,
      y: 49.4,
      name: "mediane",
    },
    {
      month: 51,
      y: 49.5,
      name: "mediane",
    },
    {
      month: 52,
      y: 49.5,
      name: "mediane",
    },
    {
      month: 53,
      y: 49.6,
      name: "mediane",
    },
    {
      month: 54,
      y: 49.6,
      name: "mediane",
    },
    {
      month: 55,
      y: 49.7,
      name: "mediane",
    },
    {
      month: 56,
      y: 49.7,
      name: "mediane",
    },
    {
      month: 57,
      y: 49.8,
      name: "mediane",
    },
    {
      month: 58,
      y: 49.8,
      name: "mediane",
    },
    {
      month: 59,
      y: 49.9,
      name: "mediane",
    },
    {
      month: 60,
      y: 49.9,
      name: "mediane",
    },
    {
      month: 0,
      y: 35.1,
      name: "+1sd",
    },
    {
      month: 1,
      y: 37.7,
      name: "+1sd",
    },
    {
      month: 2,
      y: 39.5,
      name: "+1sd",
    },
    {
      month: 3,
      y: 40.8,
      name: "+1sd",
    },
    {
      month: 4,
      y: 41.8,
      name: "+1sd",
    },
    {
      month: 5,
      y: 42.7,
      name: "+1sd",
    },
    {
      month: 6,
      y: 43.5,
      name: "+1sd",
    },
    {
      month: 7,
      y: 44.1,
      name: "+1sd",
    },
    {
      month: 8,
      y: 44.7,
      name: "+1sd",
    },
    {
      month: 9,
      y: 45.2,
      name: "+1sd",
    },
    {
      month: 10,
      y: 45.6,
      name: "+1sd",
    },
    {
      month: 11,
      y: 45.9,
      name: "+1sd",
    },
    {
      month: 12,
      y: 46.3,
      name: "+1sd",
    },
    {
      month: 13,
      y: 46.5,
      name: "+1sd",
    },
    {
      month: 14,
      y: 46.8,
      name: "+1sd",
    },
    {
      month: 15,
      y: 47,
      name: "+1sd",
    },
    {
      month: 16,
      y: 47.2,
      name: "+1sd",
    },
    {
      month: 17,
      y: 47.4,
      name: "+1sd",
    },
    {
      month: 18,
      y: 47.6,
      name: "+1sd",
    },
    {
      month: 19,
      y: 47.8,
      name: "+1sd",
    },
    {
      month: 20,
      y: 48,
      name: "+1sd",
    },
    {
      month: 21,
      y: 48.1,
      name: "+1sd",
    },
    {
      month: 22,
      y: 48.3,
      name: "+1sd",
    },
    {
      month: 23,
      y: 48.4,
      name: "+1sd",
    },
    {
      month: 24,
      y: 48.6,
      name: "+1sd",
    },
    {
      month: 25,
      y: 48.7,
      name: "+1sd",
    },
    {
      month: 26,
      y: 48.9,
      name: "+1sd",
    },
    {
      month: 27,
      y: 49,
      name: "+1sd",
    },
    {
      month: 28,
      y: 49.1,
      name: "+1sd",
    },
    {
      month: 29,
      y: 49.2,
      name: "+1sd",
    },
    {
      month: 30,
      y: 49.3,
      name: "+1sd",
    },
    {
      month: 31,
      y: 49.4,
      name: "+1sd",
    },
    {
      month: 32,
      y: 49.6,
      name: "+1sd",
    },
    {
      month: 33,
      y: 49.7,
      name: "+1sd",
    },
    {
      month: 34,
      y: 49.7,
      name: "+1sd",
    },
    {
      month: 35,
      y: 49.8,
      name: "+1sd",
    },
    {
      month: 36,
      y: 49.9,
      name: "+1sd",
    },
    {
      month: 37,
      y: 50,
      name: "+1sd",
    },
    {
      month: 38,
      y: 50.1,
      name: "+1sd",
    },
    {
      month: 39,
      y: 50.2,
      name: "+1sd",
    },
    {
      month: 40,
      y: 50.2,
      name: "+1sd",
    },
    {
      month: 41,
      y: 50.3,
      name: "+1sd",
    },
    {
      month: 42,
      y: 50.4,
      name: "+1sd",
    },
    {
      month: 43,
      y: 50.4,
      name: "+1sd",
    },
    {
      month: 44,
      y: 50.5,
      name: "+1sd",
    },
    {
      month: 45,
      y: 50.6,
      name: "+1sd",
    },
    {
      month: 46,
      y: 50.6,
      name: "+1sd",
    },
    {
      month: 47,
      y: 50.7,
      name: "+1sd",
    },
    {
      month: 48,
      y: 50.8,
      name: "+1sd",
    },
    {
      month: 49,
      y: 50.8,
      name: "+1sd",
    },
    {
      month: 50,
      y: 50.9,
      name: "+1sd",
    },
    {
      month: 51,
      y: 50.9,
      name: "+1sd",
    },
    {
      month: 52,
      y: 51,
      name: "+1sd",
    },
    {
      month: 53,
      y: 51,
      name: "+1sd",
    },
    {
      month: 54,
      y: 51.1,
      name: "+1sd",
    },
    {
      month: 55,
      y: 51.1,
      name: "+1sd",
    },
    {
      month: 56,
      y: 51.2,
      name: "+1sd",
    },
    {
      month: 57,
      y: 51.2,
      name: "+1sd",
    },
    {
      month: 58,
      y: 51.3,
      name: "+1sd",
    },
    {
      month: 59,
      y: 51.3,
      name: "+1sd",
    },
    {
      month: 60,
      y: 51.3,
      name: "+1sd",
    },
    {
      month: 0,
      y: 36.2,
      name: "+2sd",
    },
    {
      month: 1,
      y: 38.9,
      name: "+2sd",
    },
    {
      month: 2,
      y: 40.7,
      name: "+2sd",
    },
    {
      month: 3,
      y: 42,
      name: "+2sd",
    },
    {
      month: 4,
      y: 43.1,
      name: "+2sd",
    },
    {
      month: 5,
      y: 44,
      name: "+2sd",
    },
    {
      month: 6,
      y: 44.8,
      name: "+2sd",
    },
    {
      month: 7,
      y: 45.5,
      name: "+2sd",
    },
    {
      month: 8,
      y: 46,
      name: "+2sd",
    },
    {
      month: 9,
      y: 46.5,
      name: "+2sd",
    },
    {
      month: 10,
      y: 46.9,
      name: "+2sd",
    },
    {
      month: 11,
      y: 47.3,
      name: "+2sd",
    },
    {
      month: 12,
      y: 47.6,
      name: "+2sd",
    },
    {
      month: 13,
      y: 47.9,
      name: "+2sd",
    },
    {
      month: 14,
      y: 48.2,
      name: "+2sd",
    },
    {
      month: 15,
      y: 48.4,
      name: "+2sd",
    },
    {
      month: 16,
      y: 48.6,
      name: "+2sd",
    },
    {
      month: 17,
      y: 48.8,
      name: "+2sd",
    },
    {
      month: 18,
      y: 49,
      name: "+2sd",
    },
    {
      month: 19,
      y: 49.2,
      name: "+2sd",
    },
    {
      month: 20,
      y: 49.4,
      name: "+2sd",
    },
    {
      month: 21,
      y: 49.5,
      name: "+2sd",
    },
    {
      month: 22,
      y: 49.7,
      name: "+2sd",
    },
    {
      month: 23,
      y: 49.8,
      name: "+2sd",
    },
    {
      month: 24,
      y: 50,
      name: "+2sd",
    },
    {
      month: 25,
      y: 50.1,
      name: "+2sd",
    },
    {
      month: 26,
      y: 50.3,
      name: "+2sd",
    },
    {
      month: 27,
      y: 50.4,
      name: "+2sd",
    },
    {
      month: 28,
      y: 50.5,
      name: "+2sd",
    },
    {
      month: 29,
      y: 50.6,
      name: "+2sd",
    },
    {
      month: 30,
      y: 50.7,
      name: "+2sd",
    },
    {
      month: 31,
      y: 50.9,
      name: "+2sd",
    },
    {
      month: 32,
      y: 51,
      name: "+2sd",
    },
    {
      month: 33,
      y: 51.1,
      name: "+2sd",
    },
    {
      month: 34,
      y: 51.2,
      name: "+2sd",
    },
    {
      month: 35,
      y: 51.2,
      name: "+2sd",
    },
    {
      month: 36,
      y: 51.3,
      name: "+2sd",
    },
    {
      month: 37,
      y: 51.4,
      name: "+2sd",
    },
    {
      month: 38,
      y: 51.5,
      name: "+2sd",
    },
    {
      month: 39,
      y: 51.6,
      name: "+2sd",
    },
    {
      month: 40,
      y: 51.7,
      name: "+2sd",
    },
    {
      month: 41,
      y: 51.7,
      name: "+2sd",
    },
    {
      month: 42,
      y: 51.8,
      name: "+2sd",
    },
    {
      month: 43,
      y: 51.9,
      name: "+2sd",
    },
    {
      month: 44,
      y: 51.9,
      name: "+2sd",
    },
    {
      month: 45,
      y: 52,
      name: "+2sd",
    },
    {
      month: 46,
      y: 52.1,
      name: "+2sd",
    },
    {
      month: 47,
      y: 52.1,
      name: "+2sd",
    },
    {
      month: 48,
      y: 52.2,
      name: "+2sd",
    },
    {
      month: 49,
      y: 52.2,
      name: "+2sd",
    },
    {
      month: 50,
      y: 52.3,
      name: "+2sd",
    },
    {
      month: 51,
      y: 52.3,
      name: "+2sd",
    },
    {
      month: 52,
      y: 52.4,
      name: "+2sd",
    },
    {
      month: 53,
      y: 52.4,
      name: "+2sd",
    },
    {
      month: 54,
      y: 52.5,
      name: "+2sd",
    },
    {
      month: 55,
      y: 52.5,
      name: "+2sd",
    },
    {
      month: 56,
      y: 52.6,
      name: "+2sd",
    },
    {
      month: 57,
      y: 52.6,
      name: "+2sd",
    },
    {
      month: 58,
      y: 52.7,
      name: "+2sd",
    },
    {
      month: 59,
      y: 52.7,
      name: "+2sd",
    },
    {
      month: 60,
      y: 52.8,
      name: "+2sd",
    },
    {
      month: 0,
      y: 37.4,
      name: "+3sd",
    },
    {
      month: 1,
      y: 40.1,
      name: "+3sd",
    },
    {
      month: 2,
      y: 41.9,
      name: "+3sd",
    },
    {
      month: 3,
      y: 43.3,
      name: "+3sd",
    },
    {
      month: 4,
      y: 44.4,
      name: "+3sd",
    },
    {
      month: 5,
      y: 45.3,
      name: "+3sd",
    },
    {
      month: 6,
      y: 46.1,
      name: "+3sd",
    },
    {
      month: 7,
      y: 46.8,
      name: "+3sd",
    },
    {
      month: 8,
      y: 47.4,
      name: "+3sd",
    },
    {
      month: 9,
      y: 47.8,
      name: "+3sd",
    },
    {
      month: 10,
      y: 48.3,
      name: "+3sd",
    },
    {
      month: 11,
      y: 48.6,
      name: "+3sd",
    },
    {
      month: 12,
      y: 49,
      name: "+3sd",
    },
    {
      month: 13,
      y: 49.3,
      name: "+3sd",
    },
    {
      month: 14,
      y: 49.5,
      name: "+3sd",
    },
    {
      month: 15,
      y: 49.8,
      name: "+3sd",
    },
    {
      month: 16,
      y: 50,
      name: "+3sd",
    },
    {
      month: 17,
      y: 50.2,
      name: "+3sd",
    },
    {
      month: 18,
      y: 50.4,
      name: "+3sd",
    },
    {
      month: 19,
      y: 50.6,
      name: "+3sd",
    },
    {
      month: 20,
      y: 50.7,
      name: "+3sd",
    },
    {
      month: 21,
      y: 50.9,
      name: "+3sd",
    },
    {
      month: 22,
      y: 51.1,
      name: "+3sd",
    },
    {
      month: 23,
      y: 51.2,
      name: "+3sd",
    },
    {
      month: 24,
      y: 51.4,
      name: "+3sd",
    },
    {
      month: 25,
      y: 51.5,
      name: "+3sd",
    },
    {
      month: 26,
      y: 51.7,
      name: "+3sd",
    },
    {
      month: 27,
      y: 51.8,
      name: "+3sd",
    },
    {
      month: 28,
      y: 51.9,
      name: "+3sd",
    },
    {
      month: 29,
      y: 52,
      name: "+3sd",
    },
    {
      month: 30,
      y: 52.2,
      name: "+3sd",
    },
    {
      month: 31,
      y: 52.3,
      name: "+3sd",
    },
    {
      month: 32,
      y: 52.4,
      name: "+3sd",
    },
    {
      month: 33,
      y: 52.5,
      name: "+3sd",
    },
    {
      month: 34,
      y: 52.6,
      name: "+3sd",
    },
    {
      month: 35,
      y: 52.7,
      name: "+3sd",
    },
    {
      month: 36,
      y: 52.7,
      name: "+3sd",
    },
    {
      month: 37,
      y: 52.8,
      name: "+3sd",
    },
    {
      month: 38,
      y: 52.9,
      name: "+3sd",
    },
    {
      month: 39,
      y: 53,
      name: "+3sd",
    },
    {
      month: 40,
      y: 53.1,
      name: "+3sd",
    },
    {
      month: 41,
      y: 53.1,
      name: "+3sd",
    },
    {
      month: 42,
      y: 53.2,
      name: "+3sd",
    },
    {
      month: 43,
      y: 53.3,
      name: "+3sd",
    },
    {
      month: 44,
      y: 53.3,
      name: "+3sd",
    },
    {
      month: 45,
      y: 53.4,
      name: "+3sd",
    },
    {
      month: 46,
      y: 53.5,
      name: "+3sd",
    },
    {
      month: 47,
      y: 53.5,
      name: "+3sd",
    },
    {
      month: 48,
      y: 53.6,
      name: "+3sd",
    },
    {
      month: 49,
      y: 53.6,
      name: "+3sd",
    },
    {
      month: 50,
      y: 53.7,
      name: "+3sd",
    },
    {
      month: 51,
      y: 53.8,
      name: "+3sd",
    },
    {
      month: 52,
      y: 53.8,
      name: "+3sd",
    },
    {
      month: 53,
      y: 53.9,
      name: "+3sd",
    },
    {
      month: 54,
      y: 53.9,
      name: "+3sd",
    },
    {
      month: 55,
      y: 54,
      name: "+3sd",
    },
    {
      month: 56,
      y: 54,
      name: "+3sd",
    },
    {
      month: 57,
      y: 54.1,
      name: "+3sd",
    },
    {
      month: 58,
      y: 54.1,
      name: "+3sd",
    },
    {
      month: 59,
      y: 54.1,
      name: "+3sd",
    },
    {
      month: 60,
      y: 54.2,
      name: "+3sd",
    },
  ],

  boys_head_circumference: [
    {
      month: 0,
      y: 30.7,
      name: "-3sd",
    },
    {
      month: 1,
      y: 33.8,
      name: "-3sd",
    },
    {
      month: 2,
      y: 35.6,
      name: "-3sd",
    },
    {
      month: 3,
      y: 37,
      name: "-3sd",
    },
    {
      month: 4,
      y: 38,
      name: "-3sd",
    },
    {
      month: 5,
      y: 38.9,
      name: "-3sd",
    },
    {
      month: 6,
      y: 39.7,
      name: "-3sd",
    },
    {
      month: 7,
      y: 40.3,
      name: "-3sd",
    },
    {
      month: 8,
      y: 40.8,
      name: "-3sd",
    },
    {
      month: 9,
      y: 41.2,
      name: "-3sd",
    },
    {
      month: 10,
      y: 41.6,
      name: "-3sd",
    },
    {
      month: 11,
      y: 41.9,
      name: "-3sd",
    },
    {
      month: 12,
      y: 42.2,
      name: "-3sd",
    },
    {
      month: 13,
      y: 42.5,
      name: "-3sd",
    },
    {
      month: 14,
      y: 42.7,
      name: "-3sd",
    },
    {
      month: 15,
      y: 42.9,
      name: "-3sd",
    },
    {
      month: 16,
      y: 43.1,
      name: "-3sd",
    },
    {
      month: 17,
      y: 43.2,
      name: "-3sd",
    },
    {
      month: 18,
      y: 43.4,
      name: "-3sd",
    },
    {
      month: 19,
      y: 43.5,
      name: "-3sd",
    },
    {
      month: 20,
      y: 43.7,
      name: "-3sd",
    },
    {
      month: 21,
      y: 43.8,
      name: "-3sd",
    },
    {
      month: 22,
      y: 43.9,
      name: "-3sd",
    },
    {
      month: 23,
      y: 44.1,
      name: "-3sd",
    },
    {
      month: 24,
      y: 44.2,
      name: "-3sd",
    },
    {
      month: 25,
      y: 44.3,
      name: "-3sd",
    },
    {
      month: 26,
      y: 44.4,
      name: "-3sd",
    },
    {
      month: 27,
      y: 44.5,
      name: "-3sd",
    },
    {
      month: 28,
      y: 44.6,
      name: "-3sd",
    },
    {
      month: 29,
      y: 44.7,
      name: "-3sd",
    },
    {
      month: 30,
      y: 44.8,
      name: "-3sd",
    },
    {
      month: 31,
      y: 44.8,
      name: "-3sd",
    },
    {
      month: 32,
      y: 44.9,
      name: "-3sd",
    },
    {
      month: 33,
      y: 45,
      name: "-3sd",
    },
    {
      month: 34,
      y: 45.1,
      name: "-3sd",
    },
    {
      month: 35,
      y: 45.1,
      name: "-3sd",
    },
    {
      month: 36,
      y: 45.2,
      name: "-3sd",
    },
    {
      month: 37,
      y: 45.3,
      name: "-3sd",
    },
    {
      month: 38,
      y: 45.3,
      name: "-3sd",
    },
    {
      month: 39,
      y: 45.4,
      name: "-3sd",
    },
    {
      month: 40,
      y: 45.4,
      name: "-3sd",
    },
    {
      month: 41,
      y: 45.5,
      name: "-3sd",
    },
    {
      month: 42,
      y: 45.5,
      name: "-3sd",
    },
    {
      month: 43,
      y: 45.6,
      name: "-3sd",
    },
    {
      month: 44,
      y: 45.6,
      name: "-3sd",
    },
    {
      month: 45,
      y: 45.7,
      name: "-3sd",
    },
    {
      month: 46,
      y: 45.7,
      name: "-3sd",
    },
    {
      month: 47,
      y: 45.8,
      name: "-3sd",
    },
    {
      month: 48,
      y: 45.8,
      name: "-3sd",
    },
    {
      month: 49,
      y: 45.9,
      name: "-3sd",
    },
    {
      month: 50,
      y: 45.9,
      name: "-3sd",
    },
    {
      month: 51,
      y: 45.9,
      name: "-3sd",
    },
    {
      month: 52,
      y: 46,
      name: "-3sd",
    },
    {
      month: 53,
      y: 46,
      name: "-3sd",
    },
    {
      month: 54,
      y: 46.1,
      name: "-3sd",
    },
    {
      month: 55,
      y: 46.1,
      name: "-3sd",
    },
    {
      month: 56,
      y: 46.1,
      name: "-3sd",
    },
    {
      month: 57,
      y: 46.2,
      name: "-3sd",
    },
    {
      month: 58,
      y: 46.2,
      name: "-3sd",
    },
    {
      month: 59,
      y: 46.2,
      name: "-3sd",
    },
    {
      month: 60,
      y: 46.3,
      name: "-3sd",
    },
    {
      month: 0,
      y: 31.9,
      name: "-2sd",
    },
    {
      month: 1,
      y: 34.9,
      name: "-2sd",
    },
    {
      month: 2,
      y: 36.8,
      name: "-2sd",
    },
    {
      month: 3,
      y: 38.1,
      name: "-2sd",
    },
    {
      month: 4,
      y: 39.2,
      name: "-2sd",
    },
    {
      month: 5,
      y: 40.1,
      name: "-2sd",
    },
    {
      month: 6,
      y: 40.9,
      name: "-2sd",
    },
    {
      month: 7,
      y: 41.5,
      name: "-2sd",
    },
    {
      month: 8,
      y: 42,
      name: "-2sd",
    },
    {
      month: 9,
      y: 42.5,
      name: "-2sd",
    },
    {
      month: 10,
      y: 42.9,
      name: "-2sd",
    },
    {
      month: 11,
      y: 43.2,
      name: "-2sd",
    },
    {
      month: 12,
      y: 43.5,
      name: "-2sd",
    },
    {
      month: 13,
      y: 43.8,
      name: "-2sd",
    },
    {
      month: 14,
      y: 44,
      name: "-2sd",
    },
    {
      month: 15,
      y: 44.2,
      name: "-2sd",
    },
    {
      month: 16,
      y: 44.4,
      name: "-2sd",
    },
    {
      month: 17,
      y: 44.6,
      name: "-2sd",
    },
    {
      month: 18,
      y: 44.7,
      name: "-2sd",
    },
    {
      month: 19,
      y: 44.9,
      name: "-2sd",
    },
    {
      month: 20,
      y: 45,
      name: "-2sd",
    },
    {
      month: 21,
      y: 45.2,
      name: "-2sd",
    },
    {
      month: 22,
      y: 45.3,
      name: "-2sd",
    },
    {
      month: 23,
      y: 45.4,
      name: "-2sd",
    },
    {
      month: 24,
      y: 45.5,
      name: "-2sd",
    },
    {
      month: 25,
      y: 45.6,
      name: "-2sd",
    },
    {
      month: 26,
      y: 45.8,
      name: "-2sd",
    },
    {
      month: 27,
      y: 45.9,
      name: "-2sd",
    },
    {
      month: 28,
      y: 46,
      name: "-2sd",
    },
    {
      month: 29,
      y: 46.1,
      name: "-2sd",
    },
    {
      month: 30,
      y: 46.1,
      name: "-2sd",
    },
    {
      month: 31,
      y: 46.2,
      name: "-2sd",
    },
    {
      month: 32,
      y: 46.3,
      name: "-2sd",
    },
    {
      month: 33,
      y: 46.4,
      name: "-2sd",
    },
    {
      month: 34,
      y: 46.5,
      name: "-2sd",
    },
    {
      month: 35,
      y: 46.6,
      name: "-2sd",
    },
    {
      month: 36,
      y: 46.6,
      name: "-2sd",
    },
    {
      month: 37,
      y: 46.7,
      name: "-2sd",
    },
    {
      month: 38,
      y: 46.8,
      name: "-2sd",
    },
    {
      month: 39,
      y: 46.8,
      name: "-2sd",
    },
    {
      month: 40,
      y: 46.9,
      name: "-2sd",
    },
    {
      month: 41,
      y: 46.9,
      name: "-2sd",
    },
    {
      month: 42,
      y: 47,
      name: "-2sd",
    },
    {
      month: 43,
      y: 47,
      name: "-2sd",
    },
    {
      month: 44,
      y: 47.1,
      name: "-2sd",
    },
    {
      month: 45,
      y: 47.1,
      name: "-2sd",
    },
    {
      month: 46,
      y: 47.2,
      name: "-2sd",
    },
    {
      month: 47,
      y: 47.2,
      name: "-2sd",
    },
    {
      month: 48,
      y: 47.3,
      name: "-2sd",
    },
    {
      month: 49,
      y: 47.3,
      name: "-2sd",
    },
    {
      month: 50,
      y: 47.4,
      name: "-2sd",
    },
    {
      month: 51,
      y: 47.4,
      name: "-2sd",
    },
    {
      month: 52,
      y: 47.5,
      name: "-2sd",
    },
    {
      month: 53,
      y: 47.5,
      name: "-2sd",
    },
    {
      month: 54,
      y: 47.5,
      name: "-2sd",
    },
    {
      month: 55,
      y: 47.6,
      name: "-2sd",
    },
    {
      month: 56,
      y: 47.6,
      name: "-2sd",
    },
    {
      month: 57,
      y: 47.6,
      name: "-2sd",
    },
    {
      month: 58,
      y: 47.7,
      name: "-2sd",
    },
    {
      month: 59,
      y: 47.7,
      name: "-2sd",
    },
    {
      month: 60,
      y: 47.7,
      name: "-2sd",
    },
    {
      month: 0,
      y: 33.2,
      name: "-1sd",
    },
    {
      month: 1,
      y: 36.1,
      name: "-1sd",
    },
    {
      month: 2,
      y: 38,
      name: "-1sd",
    },
    {
      month: 3,
      y: 39.3,
      name: "-1sd",
    },
    {
      month: 4,
      y: 40.4,
      name: "-1sd",
    },
    {
      month: 5,
      y: 41.4,
      name: "-1sd",
    },
    {
      month: 6,
      y: 42.1,
      name: "-1sd",
    },
    {
      month: 7,
      y: 42.7,
      name: "-1sd",
    },
    {
      month: 8,
      y: 43.3,
      name: "-1sd",
    },
    {
      month: 9,
      y: 43.7,
      name: "-1sd",
    },
    {
      month: 10,
      y: 44.1,
      name: "-1sd",
    },
    {
      month: 11,
      y: 44.5,
      name: "-1sd",
    },
    {
      month: 12,
      y: 44.8,
      name: "-1sd",
    },
    {
      month: 13,
      y: 45,
      name: "-1sd",
    },
    {
      month: 14,
      y: 45.3,
      name: "-1sd",
    },
    {
      month: 15,
      y: 45.5,
      name: "-1sd",
    },
    {
      month: 16,
      y: 45.7,
      name: "-1sd",
    },
    {
      month: 17,
      y: 45.9,
      name: "-1sd",
    },
    {
      month: 18,
      y: 46,
      name: "-1sd",
    },
    {
      month: 19,
      y: 46.2,
      name: "-1sd",
    },
    {
      month: 20,
      y: 46.4,
      name: "-1sd",
    },
    {
      month: 21,
      y: 46.5,
      name: "-1sd",
    },
    {
      month: 22,
      y: 46.6,
      name: "-1sd",
    },
    {
      month: 23,
      y: 46.8,
      name: "-1sd",
    },
    {
      month: 24,
      y: 46.9,
      name: "-1sd",
    },
    {
      month: 25,
      y: 47,
      name: "-1sd",
    },
    {
      month: 26,
      y: 47.1,
      name: "-1sd",
    },
    {
      month: 27,
      y: 47.2,
      name: "-1sd",
    },
    {
      month: 28,
      y: 47.3,
      name: "-1sd",
    },
    {
      month: 29,
      y: 47.4,
      name: "-1sd",
    },
    {
      month: 30,
      y: 47.5,
      name: "-1sd",
    },
    {
      month: 31,
      y: 47.6,
      name: "-1sd",
    },
    {
      month: 32,
      y: 47.7,
      name: "-1sd",
    },
    {
      month: 33,
      y: 47.8,
      name: "-1sd",
    },
    {
      month: 34,
      y: 47.9,
      name: "-1sd",
    },
    {
      month: 35,
      y: 48,
      name: "-1sd",
    },
    {
      month: 36,
      y: 48,
      name: "-1sd",
    },
    {
      month: 37,
      y: 48.1,
      name: "-1sd",
    },
    {
      month: 38,
      y: 48.2,
      name: "-1sd",
    },
    {
      month: 39,
      y: 48.2,
      name: "-1sd",
    },
    {
      month: 40,
      y: 48.3,
      name: "-1sd",
    },
    {
      month: 41,
      y: 48.4,
      name: "-1sd",
    },
    {
      month: 42,
      y: 48.4,
      name: "-1sd",
    },
    {
      month: 43,
      y: 48.5,
      name: "-1sd",
    },
    {
      month: 44,
      y: 48.5,
      name: "-1sd",
    },
    {
      month: 45,
      y: 48.6,
      name: "-1sd",
    },
    {
      month: 46,
      y: 48.7,
      name: "-1sd",
    },
    {
      month: 47,
      y: 48.7,
      name: "-1sd",
    },
    {
      month: 48,
      y: 48.7,
      name: "-1sd",
    },
    {
      month: 49,
      y: 48.8,
      name: "-1sd",
    },
    {
      month: 50,
      y: 48.8,
      name: "-1sd",
    },
    {
      month: 51,
      y: 48.9,
      name: "-1sd",
    },
    {
      month: 52,
      y: 48.9,
      name: "-1sd",
    },
    {
      month: 53,
      y: 49,
      name: "-1sd",
    },
    {
      month: 54,
      y: 49,
      name: "-1sd",
    },
    {
      month: 55,
      y: 49.1,
      name: "-1sd",
    },
    {
      month: 56,
      y: 49.1,
      name: "-1sd",
    },
    {
      month: 57,
      y: 49.1,
      name: "-1sd",
    },
    {
      month: 58,
      y: 49.2,
      name: "-1sd",
    },
    {
      month: 59,
      y: 49.2,
      name: "-1sd",
    },
    {
      month: 60,
      y: 49.2,
      name: "-1sd",
    },
    {
      month: 0,
      y: 34.5,
      name: "mediane",
    },
    {
      month: 1,
      y: 37.3,
      name: "mediane",
    },
    {
      month: 2,
      y: 39.1,
      name: "mediane",
    },
    {
      month: 3,
      y: 40.5,
      name: "mediane",
    },
    {
      month: 4,
      y: 41.6,
      name: "mediane",
    },
    {
      month: 5,
      y: 42.6,
      name: "mediane",
    },
    {
      month: 6,
      y: 43.3,
      name: "mediane",
    },
    {
      month: 7,
      y: 44,
      name: "mediane",
    },
    {
      month: 8,
      y: 44.5,
      name: "mediane",
    },
    {
      month: 9,
      y: 45,
      name: "mediane",
    },
    {
      month: 10,
      y: 45.4,
      name: "mediane",
    },
    {
      month: 11,
      y: 45.8,
      name: "mediane",
    },
    {
      month: 12,
      y: 46.1,
      name: "mediane",
    },
    {
      month: 13,
      y: 46.3,
      name: "mediane",
    },
    {
      month: 14,
      y: 46.6,
      name: "mediane",
    },
    {
      month: 15,
      y: 46.8,
      name: "mediane",
    },
    {
      month: 16,
      y: 47,
      name: "mediane",
    },
    {
      month: 17,
      y: 47.2,
      name: "mediane",
    },
    {
      month: 18,
      y: 47.4,
      name: "mediane",
    },
    {
      month: 19,
      y: 47.5,
      name: "mediane",
    },
    {
      month: 20,
      y: 47.7,
      name: "mediane",
    },
    {
      month: 21,
      y: 47.8,
      name: "mediane",
    },
    {
      month: 22,
      y: 48,
      name: "mediane",
    },
    {
      month: 23,
      y: 48.1,
      name: "mediane",
    },
    {
      month: 24,
      y: 48.3,
      name: "mediane",
    },
    {
      month: 25,
      y: 48.4,
      name: "mediane",
    },
    {
      month: 26,
      y: 48.5,
      name: "mediane",
    },
    {
      month: 27,
      y: 48.6,
      name: "mediane",
    },
    {
      month: 28,
      y: 48.7,
      name: "mediane",
    },
    {
      month: 29,
      y: 48.8,
      name: "mediane",
    },
    {
      month: 30,
      y: 48.9,
      name: "mediane",
    },
    {
      month: 31,
      y: 49,
      name: "mediane",
    },
    {
      month: 32,
      y: 49.1,
      name: "mediane",
    },
    {
      month: 33,
      y: 49.2,
      name: "mediane",
    },
    {
      month: 34,
      y: 49.3,
      name: "mediane",
    },
    {
      month: 35,
      y: 49.4,
      name: "mediane",
    },
    {
      month: 36,
      y: 49.5,
      name: "mediane",
    },
    {
      month: 37,
      y: 49.5,
      name: "mediane",
    },
    {
      month: 38,
      y: 49.6,
      name: "mediane",
    },
    {
      month: 39,
      y: 49.7,
      name: "mediane",
    },
    {
      month: 40,
      y: 49.7,
      name: "mediane",
    },
    {
      month: 41,
      y: 49.8,
      name: "mediane",
    },
    {
      month: 42,
      y: 49.9,
      name: "mediane",
    },
    {
      month: 43,
      y: 49.9,
      name: "mediane",
    },
    {
      month: 44,
      y: 50,
      name: "mediane",
    },
    {
      month: 45,
      y: 50.1,
      name: "mediane",
    },
    {
      month: 46,
      y: 50.1,
      name: "mediane",
    },
    {
      month: 47,
      y: 50.2,
      name: "mediane",
    },
    {
      month: 48,
      y: 50.2,
      name: "mediane",
    },
    {
      month: 49,
      y: 50.3,
      name: "mediane",
    },
    {
      month: 50,
      y: 50.3,
      name: "mediane",
    },
    {
      month: 51,
      y: 50.4,
      name: "mediane",
    },
    {
      month: 52,
      y: 50.4,
      name: "mediane",
    },
    {
      month: 53,
      y: 50.4,
      name: "mediane",
    },
    {
      month: 54,
      y: 50.5,
      name: "mediane",
    },
    {
      month: 55,
      y: 50.5,
      name: "mediane",
    },
    {
      month: 56,
      y: 50.6,
      name: "mediane",
    },
    {
      month: 57,
      y: 50.6,
      name: "mediane",
    },
    {
      month: 58,
      y: 50.7,
      name: "mediane",
    },
    {
      month: 59,
      y: 50.7,
      name: "mediane",
    },
    {
      month: 60,
      y: 50.7,
      name: "mediane",
    },
    {
      month: 0,
      y: 35.7,
      name: "+1sd",
    },
    {
      month: 1,
      y: 38.4,
      name: "+1sd",
    },
    {
      month: 2,
      y: 40.3,
      name: "+1sd",
    },
    {
      month: 3,
      y: 41.7,
      name: "+1sd",
    },
    {
      month: 4,
      y: 42.8,
      name: "+1sd",
    },
    {
      month: 5,
      y: 43.8,
      name: "+1sd",
    },
    {
      month: 6,
      y: 44.6,
      name: "+1sd",
    },
    {
      month: 7,
      y: 45.2,
      name: "+1sd",
    },
    {
      month: 8,
      y: 45.8,
      name: "+1sd",
    },
    {
      month: 9,
      y: 46.3,
      name: "+1sd",
    },
    {
      month: 10,
      y: 46.7,
      name: "+1sd",
    },
    {
      month: 11,
      y: 47,
      name: "+1sd",
    },
    {
      month: 12,
      y: 47.4,
      name: "+1sd",
    },
    {
      month: 13,
      y: 47.6,
      name: "+1sd",
    },
    {
      month: 14,
      y: 47.9,
      name: "+1sd",
    },
    {
      month: 15,
      y: 48.1,
      name: "+1sd",
    },
    {
      month: 16,
      y: 48.3,
      name: "+1sd",
    },
    {
      month: 17,
      y: 48.5,
      name: "+1sd",
    },
    {
      month: 18,
      y: 48.7,
      name: "+1sd",
    },
    {
      month: 19,
      y: 48.9,
      name: "+1sd",
    },
    {
      month: 20,
      y: 49,
      name: "+1sd",
    },
    {
      month: 21,
      y: 49.2,
      name: "+1sd",
    },
    {
      month: 22,
      y: 49.3,
      name: "+1sd",
    },
    {
      month: 23,
      y: 49.5,
      name: "+1sd",
    },
    {
      month: 24,
      y: 49.6,
      name: "+1sd",
    },
    {
      month: 25,
      y: 49.7,
      name: "+1sd",
    },
    {
      month: 26,
      y: 49.9,
      name: "+1sd",
    },
    {
      month: 27,
      y: 50,
      name: "+1sd",
    },
    {
      month: 28,
      y: 50.1,
      name: "+1sd",
    },
    {
      month: 29,
      y: 50.2,
      name: "+1sd",
    },
    {
      month: 30,
      y: 50.3,
      name: "+1sd",
    },
    {
      month: 31,
      y: 50.4,
      name: "+1sd",
    },
    {
      month: 32,
      y: 50.5,
      name: "+1sd",
    },
    {
      month: 33,
      y: 50.6,
      name: "+1sd",
    },
    {
      month: 34,
      y: 50.7,
      name: "+1sd",
    },
    {
      month: 35,
      y: 50.8,
      name: "+1sd",
    },
    {
      month: 36,
      y: 50.9,
      name: "+1sd",
    },
    {
      month: 37,
      y: 51,
      name: "+1sd",
    },
    {
      month: 38,
      y: 51,
      name: "+1sd",
    },
    {
      month: 39,
      y: 51.1,
      name: "+1sd",
    },
    {
      month: 40,
      y: 51.2,
      name: "+1sd",
    },
    {
      month: 41,
      y: 51.3,
      name: "+1sd",
    },
    {
      month: 42,
      y: 51.3,
      name: "+1sd",
    },
    {
      month: 43,
      y: 51.4,
      name: "+1sd",
    },
    {
      month: 44,
      y: 51.4,
      name: "+1sd",
    },
    {
      month: 45,
      y: 51.5,
      name: "+1sd",
    },
    {
      month: 46,
      y: 51.6,
      name: "+1sd",
    },
    {
      month: 47,
      y: 51.6,
      name: "+1sd",
    },
    {
      month: 48,
      y: 51.7,
      name: "+1sd",
    },
    {
      month: 49,
      y: 51.7,
      name: "+1sd",
    },
    {
      month: 50,
      y: 51.8,
      name: "+1sd",
    },
    {
      month: 51,
      y: 51.8,
      name: "+1sd",
    },
    {
      month: 52,
      y: 51.9,
      name: "+1sd",
    },
    {
      month: 53,
      y: 51.9,
      name: "+1sd",
    },
    {
      month: 54,
      y: 52,
      name: "+1sd",
    },
    {
      month: 55,
      y: 52,
      name: "+1sd",
    },
    {
      month: 56,
      y: 52.1,
      name: "+1sd",
    },
    {
      month: 57,
      y: 52.1,
      name: "+1sd",
    },
    {
      month: 58,
      y: 52.1,
      name: "+1sd",
    },
    {
      month: 59,
      y: 52.2,
      name: "+1sd",
    },
    {
      month: 60,
      y: 52.2,
      name: "+1sd",
    },
    {
      month: 0,
      y: 37,
      name: "+2sd",
    },
    {
      month: 1,
      y: 39.6,
      name: "+2sd",
    },
    {
      month: 2,
      y: 41.5,
      name: "+2sd",
    },
    {
      month: 3,
      y: 42.9,
      name: "+2sd",
    },
    {
      month: 4,
      y: 44,
      name: "+2sd",
    },
    {
      month: 5,
      y: 45,
      name: "+2sd",
    },
    {
      month: 6,
      y: 45.8,
      name: "+2sd",
    },
    {
      month: 7,
      y: 46.4,
      name: "+2sd",
    },
    {
      month: 8,
      y: 47,
      name: "+2sd",
    },
    {
      month: 9,
      y: 47.5,
      name: "+2sd",
    },
    {
      month: 10,
      y: 47.9,
      name: "+2sd",
    },
    {
      month: 11,
      y: 48.3,
      name: "+2sd",
    },
    {
      month: 12,
      y: 48.6,
      name: "+2sd",
    },
    {
      month: 13,
      y: 48.9,
      name: "+2sd",
    },
    {
      month: 14,
      y: 49.2,
      name: "+2sd",
    },
    {
      month: 15,
      y: 49.4,
      name: "+2sd",
    },
    {
      month: 16,
      y: 49.6,
      name: "+2sd",
    },
    {
      month: 17,
      y: 49.8,
      name: "+2sd",
    },
    {
      month: 18,
      y: 50,
      name: "+2sd",
    },
    {
      month: 19,
      y: 50.2,
      name: "+2sd",
    },
    {
      month: 20,
      y: 50.4,
      name: "+2sd",
    },
    {
      month: 21,
      y: 50.5,
      name: "+2sd",
    },
    {
      month: 22,
      y: 50.7,
      name: "+2sd",
    },
    {
      month: 23,
      y: 50.8,
      name: "+2sd",
    },
    {
      month: 24,
      y: 51,
      name: "+2sd",
    },
    {
      month: 25,
      y: 51.1,
      name: "+2sd",
    },
    {
      month: 26,
      y: 51.2,
      name: "+2sd",
    },
    {
      month: 27,
      y: 51.4,
      name: "+2sd",
    },
    {
      month: 28,
      y: 51.5,
      name: "+2sd",
    },
    {
      month: 29,
      y: 51.6,
      name: "+2sd",
    },
    {
      month: 30,
      y: 51.7,
      name: "+2sd",
    },
    {
      month: 31,
      y: 51.8,
      name: "+2sd",
    },
    {
      month: 32,
      y: 51.9,
      name: "+2sd",
    },
    {
      month: 33,
      y: 52,
      name: "+2sd",
    },
    {
      month: 34,
      y: 52.1,
      name: "+2sd",
    },
    {
      month: 35,
      y: 52.2,
      name: "+2sd",
    },
    {
      month: 36,
      y: 52.3,
      name: "+2sd",
    },
    {
      month: 37,
      y: 52.4,
      name: "+2sd",
    },
    {
      month: 38,
      y: 52.5,
      name: "+2sd",
    },
    {
      month: 39,
      y: 52.5,
      name: "+2sd",
    },
    {
      month: 40,
      y: 52.6,
      name: "+2sd",
    },
    {
      month: 41,
      y: 52.7,
      name: "+2sd",
    },
    {
      month: 42,
      y: 52.8,
      name: "+2sd",
    },
    {
      month: 43,
      y: 52.8,
      name: "+2sd",
    },
    {
      month: 44,
      y: 52.9,
      name: "+2sd",
    },
    {
      month: 45,
      y: 53,
      name: "+2sd",
    },
    {
      month: 46,
      y: 53,
      name: "+2sd",
    },
    {
      month: 47,
      y: 53.1,
      name: "+2sd",
    },
    {
      month: 48,
      y: 53.1,
      name: "+2sd",
    },
    {
      month: 49,
      y: 53.2,
      name: "+2sd",
    },
    {
      month: 50,
      y: 53.2,
      name: "+2sd",
    },
    {
      month: 51,
      y: 53.3,
      name: "+2sd",
    },
    {
      month: 52,
      y: 53.4,
      name: "+2sd",
    },
    {
      month: 53,
      y: 53.4,
      name: "+2sd",
    },
    {
      month: 54,
      y: 53.5,
      name: "+2sd",
    },
    {
      month: 55,
      y: 53.5,
      name: "+2sd",
    },
    {
      month: 56,
      y: 53.5,
      name: "+2sd",
    },
    {
      month: 57,
      y: 53.6,
      name: "+2sd",
    },
    {
      month: 58,
      y: 53.6,
      name: "+2sd",
    },
    {
      month: 59,
      y: 53.7,
      name: "+2sd",
    },
    {
      month: 60,
      y: 53.7,
      name: "+2sd",
    },
    {
      month: 0,
      y: 38.3,
      name: "+3sd",
    },
    {
      month: 1,
      y: 40.8,
      name: "+3sd",
    },
    {
      month: 2,
      y: 42.6,
      name: "+3sd",
    },
    {
      month: 3,
      y: 44.1,
      name: "+3sd",
    },
    {
      month: 4,
      y: 45.2,
      name: "+3sd",
    },
    {
      month: 5,
      y: 46.2,
      name: "+3sd",
    },
    {
      month: 6,
      y: 47,
      name: "+3sd",
    },
    {
      month: 7,
      y: 47.7,
      name: "+3sd",
    },
    {
      month: 8,
      y: 48.3,
      name: "+3sd",
    },
    {
      month: 9,
      y: 48.8,
      name: "+3sd",
    },
    {
      month: 10,
      y: 49.2,
      name: "+3sd",
    },
    {
      month: 11,
      y: 49.6,
      name: "+3sd",
    },
    {
      month: 12,
      y: 49.9,
      name: "+3sd",
    },
    {
      month: 13,
      y: 50.2,
      name: "+3sd",
    },
    {
      month: 14,
      y: 50.5,
      name: "+3sd",
    },
    {
      month: 15,
      y: 50.7,
      name: "+3sd",
    },
    {
      month: 16,
      y: 51,
      name: "+3sd",
    },
    {
      month: 17,
      y: 51.2,
      name: "+3sd",
    },
    {
      month: 18,
      y: 51.4,
      name: "+3sd",
    },
    {
      month: 19,
      y: 51.5,
      name: "+3sd",
    },
    {
      month: 20,
      y: 51.7,
      name: "+3sd",
    },
    {
      month: 21,
      y: 51.9,
      name: "+3sd",
    },
    {
      month: 22,
      y: 52,
      name: "+3sd",
    },
    {
      month: 23,
      y: 52.2,
      name: "+3sd",
    },
    {
      month: 24,
      y: 52.3,
      name: "+3sd",
    },
    {
      month: 25,
      y: 52.5,
      name: "+3sd",
    },
    {
      month: 26,
      y: 52.6,
      name: "+3sd",
    },
    {
      month: 27,
      y: 52.7,
      name: "+3sd",
    },
    {
      month: 28,
      y: 52.9,
      name: "+3sd",
    },
    {
      month: 29,
      y: 53,
      name: "+3sd",
    },
    {
      month: 30,
      y: 53.1,
      name: "+3sd",
    },
    {
      month: 31,
      y: 53.2,
      name: "+3sd",
    },
    {
      month: 32,
      y: 53.3,
      name: "+3sd",
    },
    {
      month: 33,
      y: 53.4,
      name: "+3sd",
    },
    {
      month: 34,
      y: 53.5,
      name: "+3sd",
    },
    {
      month: 35,
      y: 53.6,
      name: "+3sd",
    },
    {
      month: 36,
      y: 53.7,
      name: "+3sd",
    },
    {
      month: 37,
      y: 53.8,
      name: "+3sd",
    },
    {
      month: 38,
      y: 53.9,
      name: "+3sd",
    },
    {
      month: 39,
      y: 54,
      name: "+3sd",
    },
    {
      month: 40,
      y: 54.1,
      name: "+3sd",
    },
    {
      month: 41,
      y: 54.1,
      name: "+3sd",
    },
    {
      month: 42,
      y: 54.2,
      name: "+3sd",
    },
    {
      month: 43,
      y: 54.3,
      name: "+3sd",
    },
    {
      month: 44,
      y: 54.3,
      name: "+3sd",
    },
    {
      month: 45,
      y: 54.4,
      name: "+3sd",
    },
    {
      month: 46,
      y: 54.5,
      name: "+3sd",
    },
    {
      month: 47,
      y: 54.5,
      name: "+3sd",
    },
    {
      month: 48,
      y: 54.6,
      name: "+3sd",
    },
    {
      month: 49,
      y: 54.7,
      name: "+3sd",
    },
    {
      month: 50,
      y: 54.7,
      name: "+3sd",
    },
    {
      month: 51,
      y: 54.8,
      name: "+3sd",
    },
    {
      month: 52,
      y: 54.8,
      name: "+3sd",
    },
    {
      month: 53,
      y: 54.9,
      name: "+3sd",
    },
    {
      month: 54,
      y: 54.9,
      name: "+3sd",
    },
    {
      month: 55,
      y: 55,
      name: "+3sd",
    },
    {
      month: 56,
      y: 55,
      name: "+3sd",
    },
    {
      month: 57,
      y: 55.1,
      name: "+3sd",
    },
    {
      month: 58,
      y: 55.1,
      name: "+3sd",
    },
    {
      month: 59,
      y: 55.2,
      name: "+3sd",
    },
    {
      month: 60,
      y: 55.2,
      name: "+3sd",
    },
  ],
};

function groupChartData(
  chartData: {
    month: number;
    y: number;
    name: string;
  }[]
) {
  let grouped: {
    [key: string]: {
      month: number;
      y: number;
      name: string;
    }[];
  } = {};
  for (let item of chartData) {
    grouped[item.name] ||= [];
    grouped[item.name].push(item);
  }

  return Object.values(grouped).flatMap((a) => a);
}


export function getStandardDeviation({
  reference,
  patient,
  value,
  date,
}: {
  reference: Reference;
  patient: Patient;
  value: number;
  date: string | null | undefined;
}): number {
  let ageInMonths = moment(patient.birth).diff(date, "months");
  let norms = get_pediatrics_norms({ patient, reference });
  if (!norms) return 0;

  const closestMedian = getClosestNorm({
    norms,
    ageInMonths,
    type: "mediane",
  });

  const closestMinus3sd = getClosestNorm({
    norms,
    ageInMonths,
    type: "-3sd",
  });

  const closestPlus3sd = getClosestNorm({
    norms,
    ageInMonths,
    type: "+3sd",
  });

  if (!closestMedian?.y || !closestMinus3sd?.y || !closestPlus3sd?.y) return 0;

  let sd = (closestMedian?.y - closestMinus3sd?.y) / 3;
  console.log("sd", sd);
  let diff = value - closestMedian?.y;
  let zScore = diff / sd;
  return zScore;
}

function getClosestNorm({
  norms,
  ageInMonths,
  type,
}: {
  norms: {
    month: number;
    y: number;
    name: "mediane" | "-3sd" | "-2sd" | "-1sd" | "+1sd" | "+2sd" | "+3sd";
  }[];
  ageInMonths: number;
  type: "mediane" | "-3sd" | "-2sd" | "-1sd" | "+1sd" | "+2sd" | "+3sd";
}) {
  return norms.find((n) => ageInMonths >= n.month && n.name == type);
}

function get_pediatrics_norms({
  patient,
  reference,
}: {
  patient: Patient;
  reference: Reference;
}) {
  let age = moment().diff(patient.birth, "months");
  if (age > 200) return null;

  let name = reference.name
    ?.toLowerCase()
    .trim()
    .replace("é", "e")
    .replace("è", "e")
    .replace("â", "a");
  if (!name) return null;

  if (patient.sex == "femme") {
    if (name == "poids") return pediatricsChartData.girls_weight;
    if (name == "taille") return pediatricsChartData.girls_size;
    if (name == "perimetre cranien")
      return pediatricsChartData.girls_head_circumference;
  }

  if (name == "poids") return pediatricsChartData.boys_weight;
  if (name == "taille") return pediatricsChartData.boys_size;
  if (name == "perimetre cranien")
    return pediatricsChartData.boys_head_circumference;
  return null;
}
